export const LibData={
    "ListAllBrands": {
        "ABB": 109,
        "Adept": 8,
        "Agile Robots": 1,
        "Agilebot": 1,
        "Annin Robotics": 3,
        "AUBO": 19,
        "AUCTECH": 48,
        "Automata": 1,
        "autonox Robotics": 9,
        "BORUNTE": 5,
        "Brooks": 25,
        "Chiehey": 5,
        "CLOOS": 3,
        "Codian Robotics": 10,
        "Comau": 54,
        "cpcRobot": 1,
        "CPR": 1,
        "CROBOTP": 3,
        "CRS": 2,
        "Delta Electronics": 6,
        "Denso": 20,
        "Dobot": 22,
        "Doosan Robotics": 18,
        "DUCO": 12,
        "Efort": 20,
        "Elephant Robotics": 2,
        "Elite Robots": 12,
        "Epson": 26,
        "ESI": 2,
        "Estun": 52,
        "FAIRINO": 7,
        "Fanuc": 122,
        "Flexiv": 4,
        "Foxbot": 2,
        "Franka": 1,
        "Fruitcore": 1,
        "GMF": 1,
        "GSK": 11,
        "Hanwha": 5,
        "HIWIN": 7,
        "HSR": 2,
        "Huayan Han's": 11,
        "Hyundai Robotics": 27,
        "IAI": 3,
        "igus": 1,
        "IIMT": 9,
        "INOVANCE": 25,
        "Inovo Robotics": 1,
        "JAKA": 19,
        "Kassow Robots": 8,
        "Kawada": 2,
        "Kawasaki": 61,
        "Kinova": 5,
        "KUKA": 183,
        "LBBBD": 1,
        "Leantec": 20,
        "Ligent": 1,
        "MABI Robotic": 3,
        "MCI": 1,
        "Mecademic": 3,
        "MIP Robotics": 1,
        "Mitsubishi": 44,
        "Nachi": 25,
        "Neura": 14,
        "Neuromeka": 6,
        "NEWKer": 1,
        "Niryo": 3,
        "Omron": 28,
        "OTC Daihen": 16,
        "Panasonic": 6,
        "Peitian": 1,
        "Productive Robotics": 2,
        "PULOON": 3,
        "PUMA": 1,
        "QJAR": 6,
        "Rainbow Robotics": 8,
        "RealMan": 8,
        "Reis": 2,
        "RoboDK": 6,
        "Robostar": 3,
        "Robotphoenix": 13,
        "Rokae": 25,
        "Rozum": 3,
        "RRRobotica": 1,
        "Schneider Electric": 11,
        "Servotronix": 1,
        "Shibaura Machine": 17,
        "Siasun": 15,
        "Standard Bots": 2,
        "Staubli": 44,
        "TANGCHENG": 1,
        "Techman Robot": 30,
        "Toney": 1,
        "Turin": 1,
        "uFactory": 6,
        "Universal Robots": 14,
        "Wlkata": 3,
        "Yamaha": 4,
        "Yaskawa Motoman": 108
    },
    "ListAllAxes": {
        "3": 12,
        "4": 226,
        "5": 18,
        "6": 1227,
        "7": 48
    },
    "ListAllTypes": {
        "3 DOF": 2,
        "4 DOF": 2,
        "5 DOF": 16,
        "6 DOF": 1227,
        "7 DOF": 48,
        "Delta": 34,
        "Palletizing": 37,
        "SCARA": 165
    },
    "ListAllApplications": {
        "Additive Manufacturing": 925,
        "Assembly": 1474,
        "Collaborative": 352,
        "Cutting": 80,
        "Dispensing": 1175,
        "Drilling": 80,
        "Engraving": 80,
        "Finishing": 385,
        "Inspection": 28,
        "Machining": 80,
        "Material Handling": 1493,
        "Painting": 12,
        "Palletizing": 503,
        "Remote TCP": 1275,
        "Welding": 414
    },
    "payloadMin": 0.2,
    "payloadMax": 2300,
    "reachMin": 100,
    "reachMax": 4683,
    "weightMin": 1.5,
    "weightMax": 12500,
    "repeatabilityMin": 0,
    "repeatabilityMax": 1,
    "payloadMinRobot": 0.2,
    "payloadMaxRobot": 2300,
    "reachMinRobot": 100,
    "reachMaxRobot": 4683,
    "weightMinRobot": 1.5,
    "weightMaxRobot": 12500,
    "repeatabilityMinRobot": 0,
    "repeatabilityMaxRobot": 1,
    "DATA_ALL": {
        "ABB-CRB-1300-7-1-4": {
            "MT": "R",
            "N": "ABB CRB 1300-7/1.4",
            "F": "ABB-CRB-1300-7-1-4.robot",
            "I": "ABB-CRB-1300-7-1-4-robot.png",
            "IS": "ABB-CRB-1300-7-1-4.png",
            "B": "ABB",
            "M": "CRB 1300-7/1.4",
            "T": "6 DOF",
            "A": 6,
            "R": 1400,
            "P": 7.0,
            "W": 79,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-CRB-1300-10-1-15": {
            "MT": "R",
            "N": "ABB CRB 1300-10/1.15",
            "F": "ABB-CRB-1300-10-1-15.robot",
            "I": "ABB-CRB-1300-10-1-15-robot.png",
            "IS": "ABB-CRB-1300-10-1-15.png",
            "B": "ABB",
            "M": "CRB 1300-10/1.15",
            "T": "6 DOF",
            "A": 6,
            "R": 1150,
            "P": 10.0,
            "W": 77,
            "E": 0.023,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-CRB-1300-11-0-9": {
            "MT": "R",
            "N": "ABB CRB 1300-11/0.9",
            "F": "ABB-CRB-1300-11-0-9.robot",
            "I": "ABB-CRB-1300-11-0-9-robot.png",
            "IS": "ABB-CRB-1300-11-0-9.png",
            "B": "ABB",
            "M": "CRB 1300-11/0.9",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 11.0,
            "W": 75,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-CRB-15000-10": {
            "MT": "R",
            "N": "ABB CRB 15000 10",
            "F": "ABB-CRB-15000-10.robot",
            "I": "ABB-CRB-15000-10-robot.png",
            "IS": "ABB-CRB-15000-10.png",
            "B": "ABB",
            "M": "CRB 15000 10",
            "T": "6 DOF",
            "A": 6,
            "R": 1620,
            "P": 10,
            "W": 51,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-CRB-15000-10-152": {
            "MT": "R",
            "N": "ABB CRB 15000 10-152",
            "F": "ABB-CRB-15000-10-152.robot",
            "I": "ABB-CRB-15000-10-152-robot.png",
            "IS": "ABB-CRB-15000-10-152.png",
            "B": "ABB",
            "M": "CRB 15000 10-152",
            "T": "6 DOF",
            "A": 6,
            "R": 1520,
            "P": 10.0,
            "W": 51,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-CRB-15000-GoFa-12": {
            "MT": "R",
            "N": "ABB CRB 15000 GoFa 12",
            "F": "ABB-CRB-15000-GoFa-12.robot",
            "I": "ABB-CRB-15000-GoFa-12-robot.png",
            "IS": "ABB-CRB-15000-GoFa-12.png",
            "B": "ABB",
            "M": "CRB 15000 GoFa 12",
            "T": "6 DOF",
            "A": 6,
            "R": 1370,
            "P": 12.0,
            "W": 48,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-CRB-15000": {
            "MT": "R",
            "N": "ABB CRB 15000",
            "F": "ABB-CRB-15000.robot",
            "I": "ABB-CRB-15000-robot.png",
            "IS": "ABB-CRB-15000.png",
            "B": "ABB",
            "M": "CRB 15000",
            "T": "6 DOF",
            "A": 6,
            "R": 950,
            "P": 5,
            "W": 27,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-120-3-0-6": {
            "MT": "R",
            "N": "ABB IRB 120-3/0.6",
            "F": "ABB-IRB-120-3-0-6.robot",
            "I": "ABB-IRB-120-3-0-6-robot.png",
            "IS": "ABB-IRB-120-3-0-6.png",
            "B": "ABB",
            "M": "IRB 120-3/0.6",
            "T": "6 DOF",
            "A": 6,
            "R": 580,
            "P": 3,
            "W": 25,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-140-6-0-8": {
            "MT": "R",
            "N": "ABB IRB 140-6/0.8",
            "F": "ABB-IRB-140-6-0-8.robot",
            "I": "ABB-IRB-140-6-0-8-robot.png",
            "IS": "ABB-IRB-140-6-0-8.png",
            "B": "ABB",
            "M": "IRB 140-6/0.8",
            "T": "6 DOF",
            "A": 6,
            "R": 810,
            "P": 6,
            "W": 98,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-580-12S": {
            "MT": "R",
            "N": "ABB IRB 580/12S",
            "F": "ABB-IRB-580-12S.robot",
            "I": "ABB-IRB-580-12S-robot.png",
            "IS": "ABB-IRB-580-12S.png",
            "B": "ABB",
            "M": "IRB 580/12S",
            "T": "6 DOF",
            "A": 6,
            "R": 2200,
            "P": 12,
            "W": 630,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Inspection",
                "Material Handling",
                "Painting",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-580-16": {
            "MT": "R",
            "N": "ABB IRB 580/16",
            "F": "ABB-IRB-580-16.robot",
            "I": "ABB-IRB-580-16-robot.png",
            "IS": "ABB-IRB-580-16.png",
            "B": "ABB",
            "M": "IRB 580/16",
            "T": "6 DOF",
            "A": 6,
            "R": 2200,
            "P": 16,
            "W": 630,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Inspection",
                "Material Handling",
                "Painting",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-1010-1-5-0-37": {
            "MT": "R",
            "N": "ABB IRB 1010-1.5/0.37",
            "F": "ABB-IRB-1010-1-5-0-37.robot",
            "I": "ABB-IRB-1010-1-5-0-37-robot.png",
            "IS": "ABB-IRB-1010-1-5-0-37.png",
            "B": "ABB",
            "M": "IRB 1010-1.5/0.37",
            "T": "6 DOF",
            "A": 6,
            "R": 370,
            "P": 1.5,
            "W": 13.5,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-1100-4-0-58": {
            "MT": "R",
            "N": "ABB IRB 1100-4/0.58",
            "F": "ABB-IRB-1100-4-0-58.robot",
            "I": "ABB-IRB-1100-4-0-58-robot.png",
            "IS": "ABB-IRB-1100-4-0-58.png",
            "B": "ABB",
            "M": "IRB 1100-4/0.58",
            "T": "6 DOF",
            "A": 6,
            "R": 580,
            "P": 4,
            "W": 21,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-1100-4-0-475": {
            "MT": "R",
            "N": "ABB IRB 1100-4/0.475",
            "F": "ABB-IRB-1100-4-0-475.robot",
            "I": "ABB-IRB-1100-4-0-475-robot.png",
            "IS": "ABB-IRB-1100-4-0-475.png",
            "B": "ABB",
            "M": "IRB 1100-4/0.475",
            "T": "6 DOF",
            "A": 6,
            "R": 475,
            "P": 4,
            "W": 21,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-1200-5-0-9-Gen2": {
            "MT": "R",
            "N": "ABB IRB 1200-5/0.9 Gen2",
            "F": "ABB-IRB-1200-5-0-9-Gen2.robot",
            "I": "ABB-IRB-1200-5-0-9-Gen2-robot.png",
            "IS": "ABB-IRB-1200-5-0-9-Gen2.png",
            "B": "ABB",
            "M": "IRB 1200-5/0.9 Gen2",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 5.0,
            "W": 44,
            "E": 0.015,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-1200-5-0-9": {
            "MT": "R",
            "N": "ABB IRB 1200-5/0.9",
            "F": "ABB-IRB-1200-5-0-9.robot",
            "I": "ABB-IRB-1200-5-0-9-robot.png",
            "IS": "ABB-IRB-1200-5-0-9.png",
            "B": "ABB",
            "M": "IRB 1200-5/0.9",
            "T": "6 DOF",
            "A": 6,
            "R": 901,
            "P": 5,
            "W": 52,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-1200-7-0-7": {
            "MT": "R",
            "N": "ABB IRB 1200-7/0.7",
            "F": "ABB-IRB-1200-7-0-7.robot",
            "I": "ABB-IRB-1200-7-0-7-robot.png",
            "IS": "ABB-IRB-1200-7-0-7.png",
            "B": "ABB",
            "M": "IRB 1200-7/0.7",
            "T": "6 DOF",
            "A": 6,
            "R": 703,
            "P": 7,
            "W": 54,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-1300-7-1-4": {
            "MT": "R",
            "N": "ABB IRB 1300-7/1.4",
            "F": "ABB-IRB-1300-7-1-4.robot",
            "I": "ABB-IRB-1300-7-1-4-robot.png",
            "IS": "ABB-IRB-1300-7-1-4.png",
            "B": "ABB",
            "M": "IRB 1300-7/1.4",
            "T": "6 DOF",
            "A": 6,
            "R": 1400,
            "P": 7,
            "W": 78.5,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-1300-10-1-15": {
            "MT": "R",
            "N": "ABB IRB 1300-10/1.15",
            "F": "ABB-IRB-1300-10-1-15.robot",
            "I": "ABB-IRB-1300-10-1-15-robot.png",
            "IS": "ABB-IRB-1300-10-1-15.png",
            "B": "ABB",
            "M": "IRB 1300-10/1.15",
            "T": "6 DOF",
            "A": 6,
            "R": 1150,
            "P": 10,
            "W": 78,
            "E": 0.023,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-1300-11-0-9": {
            "MT": "R",
            "N": "ABB IRB 1300-11/0.9",
            "F": "ABB-IRB-1300-11-0-9.robot",
            "I": "ABB-IRB-1300-11-0-9-robot.png",
            "IS": "ABB-IRB-1300-11-0-9.png",
            "B": "ABB",
            "M": "IRB 1300-11/0.9",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 11.0,
            "W": 75,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-1410-4-1-45": {
            "MT": "R",
            "N": "ABB IRB 1410-4/1.45",
            "F": "ABB-IRB-1410-4-1-45.robot",
            "I": "ABB-IRB-1410-4-1-45-robot.png",
            "IS": "ABB-IRB-1410-4-1-45.png",
            "B": "ABB",
            "M": "IRB 1410-4/1.45",
            "T": "6 DOF",
            "A": 6,
            "R": 1450,
            "P": 5,
            "W": 225,
            "E": 0.025,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-1520ID": {
            "MT": "R",
            "N": "ABB IRB 1520ID",
            "F": "ABB-IRB-1520ID.robot",
            "I": "ABB-IRB-1520ID-robot.png",
            "IS": "ABB-IRB-1520ID.png",
            "B": "ABB",
            "M": "IRB 1520ID",
            "T": "6 DOF",
            "A": 6,
            "R": 1450,
            "P": 5,
            "W": 170,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-1600-6-1-2": {
            "MT": "R",
            "N": "ABB IRB 1600-6/1.2",
            "F": "ABB-IRB-1600-6-1-2.robot",
            "I": "ABB-IRB-1600-6-1-2-robot.png",
            "IS": "ABB-IRB-1600-6-1-2.png",
            "B": "ABB",
            "M": "IRB 1600-6/1.2",
            "T": "6 DOF",
            "A": 6,
            "R": 1200,
            "P": 6,
            "W": 250,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-1600-6-1-45": {
            "MT": "R",
            "N": "ABB IRB 1600-6/1.45",
            "F": "ABB-IRB-1600-6-1-45.robot",
            "I": "ABB-IRB-1600-6-1-45-robot.png",
            "IS": "ABB-IRB-1600-6-1-45.png",
            "B": "ABB",
            "M": "IRB 1600-6/1.45",
            "T": "6 DOF",
            "A": 6,
            "R": 1450,
            "P": 6,
            "W": 250,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-1600-8-1-2": {
            "MT": "R",
            "N": "ABB IRB 1600-8/1.2",
            "F": "ABB-IRB-1600-8-1-2.robot",
            "I": "ABB-IRB-1600-8-1-2-robot.png",
            "IS": "ABB-IRB-1600-8-1-2.png",
            "B": "ABB",
            "M": "IRB 1600-8/1.2",
            "T": "6 DOF",
            "A": 6,
            "R": 1200,
            "P": 8.5,
            "W": 250,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-1600-8-1-45": {
            "MT": "R",
            "N": "ABB IRB 1600-8/1.45",
            "F": "ABB-IRB-1600-8-1-45.robot",
            "I": "ABB-IRB-1600-8-1-45-robot.png",
            "IS": "ABB-IRB-1600-8-1-45.png",
            "B": "ABB",
            "M": "IRB 1600-8/1.45",
            "T": "6 DOF",
            "A": 6,
            "R": 1450,
            "P": 8.5,
            "W": 250,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-1600-10-1-45": {
            "MT": "R",
            "N": "ABB IRB 1600-10/1.45",
            "F": "ABB-IRB-1600-10-1-45.robot",
            "I": "ABB-IRB-1600-10-1-45-robot.png",
            "IS": "ABB-IRB-1600-10-1-45.png",
            "B": "ABB",
            "M": "IRB 1600-10/1.45",
            "T": "6 DOF",
            "A": 6,
            "R": 1450,
            "P": 10.0,
            "W": 250,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-1600ID-4-1-5": {
            "MT": "R",
            "N": "ABB IRB 1600ID-4/1.5",
            "F": "ABB-IRB-1600ID-4-1-5.robot",
            "I": "ABB-IRB-1600ID-4-1-5-robot.png",
            "IS": "ABB-IRB-1600ID-4-1-5.png",
            "B": "ABB",
            "M": "IRB 1600ID-4/1.5",
            "T": "6 DOF",
            "A": 6,
            "R": 1500,
            "P": 4,
            "W": 250,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-1660-4-1-55": {
            "MT": "R",
            "N": "ABB IRB 1660-4/1.55",
            "F": "ABB-IRB-1660-4-1-55.robot",
            "I": "ABB-IRB-1660-4-1-55-robot.png",
            "IS": "ABB-IRB-1660-4-1-55.png",
            "B": "ABB",
            "M": "IRB 1660-4/1.55",
            "T": "6 DOF",
            "A": 6,
            "R": 1550,
            "P": 4,
            "W": 257,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-1660ID-4-1-55": {
            "MT": "R",
            "N": "ABB IRB 1660ID-4/1.55",
            "F": "ABB-IRB-1660ID-4-1-55.robot",
            "I": "ABB-IRB-1660ID-4-1-55-robot.png",
            "IS": "ABB-IRB-1660ID-4-1-55.png",
            "B": "ABB",
            "M": "IRB 1660ID-4/1.55",
            "T": "6 DOF",
            "A": 6,
            "R": 1550,
            "P": 4,
            "W": 260,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-2400-10": {
            "MT": "R",
            "N": "ABB IRB 2400/10",
            "F": "ABB-IRB-2400-10.robot",
            "I": "ABB-IRB-2400-10-robot.png",
            "IS": "ABB-IRB-2400-10.png",
            "B": "ABB",
            "M": "IRB 2400/10",
            "T": "6 DOF",
            "A": 6,
            "R": 1550,
            "P": 10,
            "W": 380,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-2400-16": {
            "MT": "R",
            "N": "ABB IRB 2400/16",
            "F": "ABB-IRB-2400-16.robot",
            "I": "ABB-IRB-2400-16-robot.png",
            "IS": "ABB-IRB-2400-16.png",
            "B": "ABB",
            "M": "IRB 2400/16",
            "T": "6 DOF",
            "A": 6,
            "R": 1550,
            "P": 16,
            "W": 380,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-2400-L": {
            "MT": "R",
            "N": "ABB IRB 2400/L",
            "F": "ABB-IRB-2400-L.robot",
            "I": "ABB-IRB-2400-L-robot.png",
            "IS": "ABB-IRB-2400-L.png",
            "B": "ABB",
            "M": "IRB 2400/L",
            "T": "6 DOF",
            "A": 6,
            "R": 1800,
            "P": 7,
            "W": 380,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-2600-12-1-65": {
            "MT": "R",
            "N": "ABB IRB 2600-12/1.65",
            "F": "ABB-IRB-2600-12-1-65.robot",
            "I": "ABB-IRB-2600-12-1-65-robot.png",
            "IS": "ABB-IRB-2600-12-1-65.png",
            "B": "ABB",
            "M": "IRB 2600-12/1.65",
            "T": "6 DOF",
            "A": 6,
            "R": 1650,
            "P": 12,
            "W": 272,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-2600-12-1-85": {
            "MT": "R",
            "N": "ABB IRB 2600-12/1.85",
            "F": "ABB-IRB-2600-12-1-85.robot",
            "I": "ABB-IRB-2600-12-1-85-robot.png",
            "IS": "ABB-IRB-2600-12-1-85.png",
            "B": "ABB",
            "M": "IRB 2600-12/1.85",
            "T": "6 DOF",
            "A": 6,
            "R": 1850,
            "P": 12,
            "W": 284,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-2600-20-1-65": {
            "MT": "R",
            "N": "ABB IRB 2600-20/1.65",
            "F": "ABB-IRB-2600-20-1-65.robot",
            "I": "ABB-IRB-2600-20-1-65-robot.png",
            "IS": "ABB-IRB-2600-20-1-65.png",
            "B": "ABB",
            "M": "IRB 2600-20/1.65",
            "T": "6 DOF",
            "A": 6,
            "R": 1650,
            "P": 20,
            "W": 272,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-2600ID-8-2-00": {
            "MT": "R",
            "N": "ABB IRB 2600ID-8/2.00",
            "F": "ABB-IRB-2600ID-8-2-00.robot",
            "I": "ABB-IRB-2600ID-8-2-00-robot.png",
            "IS": "ABB-IRB-2600ID-8-2-00.png",
            "B": "ABB",
            "M": "IRB 2600ID-8/2.00",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 8,
            "W": 276,
            "E": 0.023,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-2600ID-15-1-85": {
            "MT": "R",
            "N": "ABB IRB 2600ID-15/1.85",
            "F": "ABB-IRB-2600ID-15-1-85.robot",
            "I": "ABB-IRB-2600ID-15-1-85-robot.png",
            "IS": "ABB-IRB-2600ID-15-1-85.png",
            "B": "ABB",
            "M": "IRB 2600ID-15/1.85",
            "T": "6 DOF",
            "A": 6,
            "R": 1850,
            "P": 15,
            "W": 276,
            "E": 0.026,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-4400-45-M94A": {
            "MT": "R",
            "N": "ABB IRB 4400/45 M94A",
            "F": "ABB-IRB-4400-45-M94A.robot",
            "I": "ABB-IRB-4400-45-M94A-robot.png",
            "IS": "ABB-IRB-4400-45-M94A.png",
            "B": "ABB",
            "M": "IRB 4400/45 M94A",
            "T": "6 DOF",
            "A": 6,
            "R": 1960,
            "P": 45,
            "W": 1040,
            "E": 0.19,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-4400-60": {
            "MT": "R",
            "N": "ABB IRB 4400/60",
            "F": "ABB-IRB-4400-60.robot",
            "I": "ABB-IRB-4400-60-robot.png",
            "IS": "ABB-IRB-4400-60.png",
            "B": "ABB",
            "M": "IRB 4400/60",
            "T": "6 DOF",
            "A": 6,
            "R": 1960,
            "P": 60,
            "W": 1040,
            "E": 0.19,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-4400-L30-M2000": {
            "MT": "R",
            "N": "ABB IRB 4400/L30 M2000",
            "F": "ABB-IRB-4400-L30-M2000.robot",
            "I": "ABB-IRB-4400-L30-M2000-robot.png",
            "IS": "ABB-IRB-4400-L30-M2000.png",
            "B": "ABB",
            "M": "IRB 4400/L30 M2000",
            "T": "6 DOF",
            "A": 6,
            "R": 2432,
            "P": 30,
            "W": 1040,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-4600-20-2-50": {
            "MT": "R",
            "N": "ABB IRB 4600-20/2.50",
            "F": "ABB-IRB-4600-20-2-50.robot",
            "I": "ABB-IRB-4600-20-2-50-robot.png",
            "IS": "ABB-IRB-4600-20-2-50.png",
            "B": "ABB",
            "M": "IRB 4600-20/2.50",
            "T": "6 DOF",
            "A": 6,
            "R": 2500,
            "P": 20,
            "W": 412,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-4600-40-2-55": {
            "MT": "R",
            "N": "ABB IRB 4600-40/2.55",
            "F": "ABB-IRB-4600-40-2-55.robot",
            "I": "ABB-IRB-4600-40-2-55-robot.png",
            "IS": "ABB-IRB-4600-40-2-55.png",
            "B": "ABB",
            "M": "IRB 4600-40/2.55",
            "T": "6 DOF",
            "A": 6,
            "R": 2550,
            "P": 40,
            "W": 435,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-4600-45-2-05": {
            "MT": "R",
            "N": "ABB IRB 4600-45/2.05",
            "F": "ABB-IRB-4600-45-2-05.robot",
            "I": "ABB-IRB-4600-45-2-05-robot.png",
            "IS": "ABB-IRB-4600-45-2-05.png",
            "B": "ABB",
            "M": "IRB 4600-45/2.05",
            "T": "6 DOF",
            "A": 6,
            "R": 2050,
            "P": 45,
            "W": 425,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-4600-60-2-05": {
            "MT": "R",
            "N": "ABB IRB 4600-60/2.05",
            "F": "ABB-IRB-4600-60-2-05.robot",
            "I": "ABB-IRB-4600-60-2-05-robot.png",
            "IS": "ABB-IRB-4600-60-2-05.png",
            "B": "ABB",
            "M": "IRB 4600-60/2.05",
            "T": "6 DOF",
            "A": 6,
            "R": 2050,
            "P": 60,
            "W": 425,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-5400-22": {
            "MT": "R",
            "N": "ABB IRB 5400-22",
            "F": "ABB-IRB-5400-22.robot",
            "I": "ABB-IRB-5400-22-robot.png",
            "IS": "ABB-IRB-5400-22.png",
            "B": "ABB",
            "M": "IRB 5400-22",
            "T": "6 DOF",
            "A": 6,
            "R": 2829,
            "P": 25,
            "W": 1060,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-5500-23": {
            "MT": "R",
            "N": "ABB IRB 5500-23",
            "F": "ABB-IRB-5500-23.robot",
            "I": "ABB-IRB-5500-23-robot.png",
            "IS": "ABB-IRB-5500-23.png",
            "B": "ABB",
            "M": "IRB 5500-23",
            "T": "6 DOF",
            "A": 6,
            "R": 2200,
            "P": 16,
            "W": 600,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-5500-27": {
            "MT": "R",
            "N": "ABB IRB 5500-27",
            "F": "ABB-IRB-5500-27.robot",
            "I": "ABB-IRB-5500-27-robot.png",
            "IS": "ABB-IRB-5500-27.png",
            "B": "ABB",
            "M": "IRB 5500-27",
            "T": "6 DOF",
            "A": 6,
            "R": 2200,
            "P": 16,
            "W": 600,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-5510": {
            "MT": "R",
            "N": "ABB IRB 5510",
            "F": "ABB-IRB-5510.robot",
            "I": "ABB-IRB-5510-robot.png",
            "IS": "ABB-IRB-5510.png",
            "B": "ABB",
            "M": "IRB 5510",
            "T": "6 DOF",
            "A": 6,
            "R": 2561,
            "P": 13,
            "W": 587,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-IRB-5710-90-2-7": {
            "MT": "R",
            "N": "ABB IRB 5710-90/2.7",
            "F": "ABB-IRB-5710-90-2-7.robot",
            "I": "ABB-IRB-5710-90-2-7-robot.png",
            "IS": "ABB-IRB-5710-90-2-7.png",
            "B": "ABB",
            "M": "IRB 5710-90/2.7",
            "T": "6 DOF",
            "A": 6,
            "R": 2700,
            "P": 90,
            "W": 830,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-5710-110-2-3": {
            "MT": "R",
            "N": "ABB IRB 5710-110/2.3",
            "F": "ABB-IRB-5710-110-2-3.robot",
            "I": "ABB-IRB-5710-110-2-3-robot.png",
            "IS": "ABB-IRB-5710-110-2-3.png",
            "B": "ABB",
            "M": "IRB 5710-110/2.3",
            "T": "6 DOF",
            "A": 6,
            "R": 2300,
            "P": 110,
            "W": 830,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-5720-125-3-0": {
            "MT": "R",
            "N": "ABB IRB 5720-125/3.0",
            "F": "ABB-IRB-5720-125-3-0.robot",
            "I": "ABB-IRB-5720-125-3-0-robot.png",
            "IS": "ABB-IRB-5720-125-3-0.png",
            "B": "ABB",
            "M": "IRB 5720-125/3.0",
            "T": "6 DOF",
            "A": 6,
            "R": 3000,
            "P": 125,
            "W": 985,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-5720-180-2-6": {
            "MT": "R",
            "N": "ABB IRB 5720-180/2.6",
            "F": "ABB-IRB-5720-180-2-6.robot",
            "I": "ABB-IRB-5720-180-2-6-robot.png",
            "IS": "ABB-IRB-5720-180-2-6.png",
            "B": "ABB",
            "M": "IRB 5720-180/2.6",
            "T": "6 DOF",
            "A": 6,
            "R": 2600,
            "P": 180,
            "W": 990,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6400-2-4-120": {
            "MT": "R",
            "N": "ABB IRB 6400 2.4 120",
            "F": "ABB-IRB-6400-2-4-120.robot",
            "I": "ABB-IRB-6400-2-4-120-robot.png",
            "IS": "ABB-IRB-6400-2-4-120.png",
            "B": "ABB",
            "M": "IRB 6400 2.4 120",
            "T": "6 DOF",
            "A": 6,
            "R": 2400,
            "P": 120,
            "W": 2230,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6400-2-8-120": {
            "MT": "R",
            "N": "ABB IRB 6400 2.8 120",
            "F": "ABB-IRB-6400-2-8-120.robot",
            "I": "ABB-IRB-6400-2-8-120-robot.png",
            "IS": "ABB-IRB-6400-2-8-120.png",
            "B": "ABB",
            "M": "IRB 6400 2.8 120",
            "T": "6 DOF",
            "A": 6,
            "R": 2800,
            "P": 120,
            "W": 2230,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6400R-2-8-200": {
            "MT": "R",
            "N": "ABB IRB 6400R 2.8 200",
            "F": "ABB-IRB-6400R-2-8-200.robot",
            "I": "ABB-IRB-6400R-2-8-200-robot.png",
            "IS": "ABB-IRB-6400R-2-8-200.png",
            "B": "ABB",
            "M": "IRB 6400R 2.8 200",
            "T": "6 DOF",
            "A": 6,
            "R": 2800,
            "P": 200,
            "W": 2230,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6400R-25-150": {
            "MT": "R",
            "N": "ABB IRB 6400R 25 150",
            "F": "ABB-IRB-6400R-25-150.robot",
            "I": "ABB-IRB-6400R-25-150-robot.png",
            "IS": "ABB-IRB-6400R-25-150.png",
            "B": "ABB",
            "M": "IRB 6400R 25 150",
            "T": "6 DOF",
            "A": 6,
            "R": 2500,
            "P": 200,
            "W": 2230,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6600-175-2-8": {
            "MT": "R",
            "N": "ABB IRB 6600-175/2.8",
            "F": "ABB-IRB-6600-175-2-8.robot",
            "I": "ABB-IRB-6600-175-2-8-robot.png",
            "IS": "ABB-IRB-6600-175-2-8.png",
            "B": "ABB",
            "M": "IRB 6600-175/2.8",
            "T": "6 DOF",
            "A": 6,
            "R": 2800,
            "P": 175,
            "W": 1780,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6600-225-2-55": {
            "MT": "R",
            "N": "ABB IRB 6600-225/2.55",
            "F": "ABB-IRB-6600-225-2-55.robot",
            "I": "ABB-IRB-6600-225-2-55-robot.png",
            "IS": "ABB-IRB-6600-225-2-55.png",
            "B": "ABB",
            "M": "IRB 6600-225/2.55",
            "T": "6 DOF",
            "A": 6,
            "R": 2550,
            "P": 225,
            "W": 1700,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6620-150-2-2": {
            "MT": "R",
            "N": "ABB IRB 6620-150/2.2",
            "F": "ABB-IRB-6620-150-2-2.robot",
            "I": "ABB-IRB-6620-150-2-2-robot.png",
            "IS": "ABB-IRB-6620-150-2-2.png",
            "B": "ABB",
            "M": "IRB 6620-150/2.2",
            "T": "6 DOF",
            "A": 6,
            "R": 2200,
            "P": 150,
            "W": 880,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6640-130-3-2": {
            "MT": "R",
            "N": "ABB IRB 6640-130/3.2",
            "F": "ABB-IRB-6640-130-3-2.robot",
            "I": "ABB-IRB-6640-130-3-2-robot.png",
            "IS": "ABB-IRB-6640-130-3-2.png",
            "B": "ABB",
            "M": "IRB 6640-130/3.2",
            "T": "6 DOF",
            "A": 6,
            "R": 3200,
            "P": 130,
            "W": 1340,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6640-180-2-55": {
            "MT": "R",
            "N": "ABB IRB 6640-180/2.55",
            "F": "ABB-IRB-6640-180-2-55.robot",
            "I": "ABB-IRB-6640-180-2-55-robot.png",
            "IS": "ABB-IRB-6640-180-2-55.png",
            "B": "ABB",
            "M": "IRB 6640-180/2.55",
            "T": "6 DOF",
            "A": 6,
            "R": 2550,
            "P": 180,
            "W": 1310,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6640-185-2-8": {
            "MT": "R",
            "N": "ABB IRB 6640-185/2.8",
            "F": "ABB-IRB-6640-185-2-8.robot",
            "I": "ABB-IRB-6640-185-2-8-robot.png",
            "IS": "ABB-IRB-6640-185-2-8.png",
            "B": "ABB",
            "M": "IRB 6640-185/2.8",
            "T": "6 DOF",
            "A": 6,
            "R": 2800,
            "P": 185,
            "W": 1320,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6640-205-2-75": {
            "MT": "R",
            "N": "ABB IRB 6640-205/2.75",
            "F": "ABB-IRB-6640-205-2-75.robot",
            "I": "ABB-IRB-6640-205-2-75-robot.png",
            "IS": "ABB-IRB-6640-205-2-75.png",
            "B": "ABB",
            "M": "IRB 6640-205/2.75",
            "T": "6 DOF",
            "A": 6,
            "R": 2750,
            "P": 205,
            "W": 1320,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6640-235-2-55": {
            "MT": "R",
            "N": "ABB IRB 6640-235/2.55",
            "F": "ABB-IRB-6640-235-2-55.robot",
            "I": "ABB-IRB-6640-235-2-55-robot.png",
            "IS": "ABB-IRB-6640-235-2-55.png",
            "B": "ABB",
            "M": "IRB 6640-235/2.55",
            "T": "6 DOF",
            "A": 6,
            "R": 2550,
            "P": 235,
            "W": 1310,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6640ID-170-2-75": {
            "MT": "R",
            "N": "ABB IRB 6640ID-170/2.75",
            "F": "ABB-IRB-6640ID-170-2-75.robot",
            "I": "ABB-IRB-6640ID-170-2-75-robot.png",
            "IS": "ABB-IRB-6640ID-170-2-75.png",
            "B": "ABB",
            "M": "IRB 6640ID-170/2.75",
            "T": "6 DOF",
            "A": 6,
            "R": 2750,
            "P": 170,
            "W": 1405,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6640ID-200-2-55": {
            "MT": "R",
            "N": "ABB IRB 6640ID-200/2.55",
            "F": "ABB-IRB-6640ID-200-2-55.robot",
            "I": "ABB-IRB-6640ID-200-2-55-robot.png",
            "IS": "ABB-IRB-6640ID-200-2-55.png",
            "B": "ABB",
            "M": "IRB 6640ID-200/2.55",
            "T": "6 DOF",
            "A": 6,
            "R": 2550,
            "P": 200,
            "W": 1400,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6650-125-3-2": {
            "MT": "R",
            "N": "ABB IRB 6650-125/3.2",
            "F": "ABB-IRB-6650-125-3-2.robot",
            "I": "ABB-IRB-6650-125-3-2-robot.png",
            "IS": "ABB-IRB-6650-125-3-2.png",
            "B": "ABB",
            "M": "IRB 6650-125/3.2",
            "T": "6 DOF",
            "A": 6,
            "R": 3200,
            "P": 125,
            "W": 1780,
            "E": 0.27,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6650S-90-3-9": {
            "MT": "R",
            "N": "ABB IRB 6650S-90/3.9",
            "F": "ABB-IRB-6650S-90-3-9.robot",
            "I": "ABB-IRB-6650S-90-3-9-robot.png",
            "IS": "ABB-IRB-6650S-90-3-9.png",
            "B": "ABB",
            "M": "IRB 6650S-90/3.9",
            "T": "6 DOF",
            "A": 6,
            "R": 3900,
            "P": 90,
            "W": 2275,
            "E": 0.14,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6650S-125-3-5": {
            "MT": "R",
            "N": "ABB IRB 6650S-125/3.5",
            "F": "ABB-IRB-6650S-125-3-5.robot",
            "I": "ABB-IRB-6650S-125-3-5-robot.png",
            "IS": "ABB-IRB-6650S-125-3-5.png",
            "B": "ABB",
            "M": "IRB 6650S-125/3.5",
            "T": "6 DOF",
            "A": 6,
            "R": 3500,
            "P": 125,
            "W": 2250,
            "E": 0.14,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6650S-200-3-0": {
            "MT": "R",
            "N": "ABB IRB 6650S-200/3.0",
            "F": "ABB-IRB-6650S-200-3-0.robot",
            "I": "ABB-IRB-6650S-200-3-0-robot.png",
            "IS": "ABB-IRB-6650S-200-3-0.png",
            "B": "ABB",
            "M": "IRB 6650S-200/3.0",
            "T": "6 DOF",
            "A": 6,
            "R": 3000,
            "P": 200,
            "W": 2250,
            "E": 0.14,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6660-130-3-1": {
            "MT": "R",
            "N": "ABB IRB 6660-130/3.1",
            "F": "ABB-IRB-6660-130-3-1.robot",
            "I": "ABB-IRB-6660-130-3-1-robot.png",
            "IS": "ABB-IRB-6660-130-3-1.png",
            "B": "ABB",
            "M": "IRB 6660-130/3.1",
            "T": "6 DOF",
            "A": 6,
            "R": 3100,
            "P": 130,
            "W": 1910,
            "E": 0.11,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6660-205-1-9": {
            "MT": "R",
            "N": "ABB IRB 6660-205/1.9",
            "F": "ABB-IRB-6660-205-1-9.robot",
            "I": "ABB-IRB-6660-205-1-9-robot.png",
            "IS": "ABB-IRB-6660-205-1-9.png",
            "B": "ABB",
            "M": "IRB 6660-205/1.9",
            "T": "6 DOF",
            "A": 6,
            "R": 1900,
            "P": 205,
            "W": 1730,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6700-150-3-20-LeanID": {
            "MT": "R",
            "N": "ABB IRB 6700-150/3.20 LeanID",
            "F": "ABB-IRB-6700-150-3-20-LeanID.robot",
            "I": "ABB-IRB-6700-150-3-20-LeanID-robot.png",
            "IS": "ABB-IRB-6700-150-3-20-LeanID.png",
            "B": "ABB",
            "M": "IRB 6700-150/3.20 LeanID",
            "T": "6 DOF",
            "A": 6,
            "R": 3200,
            "P": 150,
            "W": 1280,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6700-150-3-20": {
            "MT": "R",
            "N": "ABB IRB 6700-150/3.20",
            "F": "ABB-IRB-6700-150-3-20.robot",
            "I": "ABB-IRB-6700-150-3-20-robot.png",
            "IS": "ABB-IRB-6700-150-3-20.png",
            "B": "ABB",
            "M": "IRB 6700-150/3.20",
            "T": "6 DOF",
            "A": 6,
            "R": 3200,
            "P": 150,
            "W": 1280,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6700-155-2-85": {
            "MT": "R",
            "N": "ABB IRB 6700-155/2.85",
            "F": "ABB-IRB-6700-155-2-85.robot",
            "I": "ABB-IRB-6700-155-2-85-robot.png",
            "IS": "ABB-IRB-6700-155-2-85.png",
            "B": "ABB",
            "M": "IRB 6700-155/2.85",
            "T": "6 DOF",
            "A": 6,
            "R": 2850,
            "P": 155,
            "W": 1280,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6700-175-3-05": {
            "MT": "R",
            "N": "ABB IRB 6700-175/3.05",
            "F": "ABB-IRB-6700-175-3-05.robot",
            "I": "ABB-IRB-6700-175-3-05-robot.png",
            "IS": "ABB-IRB-6700-175-3-05.png",
            "B": "ABB",
            "M": "IRB 6700-175/3.05",
            "T": "6 DOF",
            "A": 6,
            "R": 3050,
            "P": 175,
            "W": 1280,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6700-200-2-60": {
            "MT": "R",
            "N": "ABB IRB 6700-200/2.60",
            "F": "ABB-IRB-6700-200-2-60.robot",
            "I": "ABB-IRB-6700-200-2-60-robot.png",
            "IS": "ABB-IRB-6700-200-2-60.png",
            "B": "ABB",
            "M": "IRB 6700-200/2.60",
            "T": "6 DOF",
            "A": 6,
            "R": 2600,
            "P": 200,
            "W": 1280,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6700-205-2-80": {
            "MT": "R",
            "N": "ABB IRB 6700-205/2.80",
            "F": "ABB-IRB-6700-205-2-80.robot",
            "I": "ABB-IRB-6700-205-2-80-robot.png",
            "IS": "ABB-IRB-6700-205-2-80.png",
            "B": "ABB",
            "M": "IRB 6700-205/2.80",
            "T": "6 DOF",
            "A": 6,
            "R": 2800,
            "P": 205,
            "W": 1280,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6700-235-2-65": {
            "MT": "R",
            "N": "ABB IRB 6700-235/2.65",
            "F": "ABB-IRB-6700-235-2-65.robot",
            "I": "ABB-IRB-6700-235-2-65-robot.png",
            "IS": "ABB-IRB-6700-235-2-65.png",
            "B": "ABB",
            "M": "IRB 6700-235/2.65",
            "T": "6 DOF",
            "A": 6,
            "R": 2650,
            "P": 235,
            "W": 1280,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6700-245-3-00-SpotPack": {
            "MT": "R",
            "N": "ABB IRB 6700-245/3.00 SpotPack",
            "F": "ABB-IRB-6700-245-3-00-SpotPack.robot",
            "I": "ABB-IRB-6700-245-3-00-SpotPack-robot.png",
            "IS": "ABB-IRB-6700-245-3-00-SpotPack.png",
            "B": "ABB",
            "M": "IRB 6700-245/3.00 SpotPack",
            "T": "6 DOF",
            "A": 6,
            "R": 3000,
            "P": 245,
            "W": 1280,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6700-245-3-00": {
            "MT": "R",
            "N": "ABB IRB 6700-245/3.00",
            "F": "ABB-IRB-6700-245-3-00.robot",
            "I": "ABB-IRB-6700-245-3-00-robot.png",
            "IS": "ABB-IRB-6700-245-3-00.png",
            "B": "ABB",
            "M": "IRB 6700-245/3.00",
            "T": "6 DOF",
            "A": 6,
            "R": 3000,
            "P": 245,
            "W": 1280,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6700-300-2-70": {
            "MT": "R",
            "N": "ABB IRB 6700-300/2.70",
            "F": "ABB-IRB-6700-300-2-70.robot",
            "I": "ABB-IRB-6700-300-2-70-robot.png",
            "IS": "ABB-IRB-6700-300-2-70.png",
            "B": "ABB",
            "M": "IRB 6700-300/2.70",
            "T": "6 DOF",
            "A": 6,
            "R": 2700,
            "P": 300,
            "W": 1280,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-6730S-150-4-0": {
            "MT": "R",
            "N": "ABB IRB 6730S-150/4.0",
            "F": "ABB-IRB-6730S-150-4-0.robot",
            "I": "ABB-IRB-6730S-150-4-0-robot.png",
            "IS": "ABB-IRB-6730S-150-4-0.png",
            "B": "ABB",
            "M": "IRB 6730S-150/4.0",
            "T": "6 DOF",
            "A": 6,
            "R": 4000,
            "P": 150,
            "W": 1590,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-7600-150-3-5": {
            "MT": "R",
            "N": "ABB IRB 7600-150/3.5",
            "F": "ABB-IRB-7600-150-3-5.robot",
            "I": "ABB-IRB-7600-150-3-5-robot.png",
            "IS": "ABB-IRB-7600-150-3-5.png",
            "B": "ABB",
            "M": "IRB 7600-150/3.5",
            "T": "6 DOF",
            "A": 6,
            "R": 3500,
            "P": 150,
            "W": 2450,
            "E": 0.19,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-7600-325-3-1": {
            "MT": "R",
            "N": "ABB IRB 7600-325/3.1",
            "F": "ABB-IRB-7600-325-3-1.robot",
            "I": "ABB-IRB-7600-325-3-1-robot.png",
            "IS": "ABB-IRB-7600-325-3-1.png",
            "B": "ABB",
            "M": "IRB 7600-325/3.1",
            "T": "6 DOF",
            "A": 6,
            "R": 3100,
            "P": 325,
            "W": 2440,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-7600-340-2-8": {
            "MT": "R",
            "N": "ABB IRB 7600-340/2.8",
            "F": "ABB-IRB-7600-340-2-8.robot",
            "I": "ABB-IRB-7600-340-2-8-robot.png",
            "IS": "ABB-IRB-7600-340-2-8.png",
            "B": "ABB",
            "M": "IRB 7600-340/2.8",
            "T": "6 DOF",
            "A": 6,
            "R": 2800,
            "P": 340,
            "W": 2425,
            "E": 0.27,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-7600-400-2-55": {
            "MT": "R",
            "N": "ABB IRB 7600-400/2.55",
            "F": "ABB-IRB-7600-400-2-55.robot",
            "I": "ABB-IRB-7600-400-2-55-robot.png",
            "IS": "ABB-IRB-7600-400-2-55.png",
            "B": "ABB",
            "M": "IRB 7600-400/2.55",
            "T": "6 DOF",
            "A": 6,
            "R": 2550,
            "P": 400,
            "W": 2400,
            "E": 0.19,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-7600-500-2-30": {
            "MT": "R",
            "N": "ABB IRB 7600-500/2.30",
            "F": "ABB-IRB-7600-500-2-30.robot",
            "I": "ABB-IRB-7600-500-2-30-robot.png",
            "IS": "ABB-IRB-7600-500-2-30.png",
            "B": "ABB",
            "M": "IRB 7600-500/2.30",
            "T": "6 DOF",
            "A": 6,
            "R": 2300,
            "P": 500,
            "W": 2400,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-7600-500-2-55": {
            "MT": "R",
            "N": "ABB IRB 7600-500/2.55",
            "F": "ABB-IRB-7600-500-2-55.robot",
            "I": "ABB-IRB-7600-500-2-55-robot.png",
            "IS": "ABB-IRB-7600-500-2-55.png",
            "B": "ABB",
            "M": "IRB 7600-500/2.55",
            "T": "6 DOF",
            "A": 6,
            "R": 2550,
            "P": 500,
            "W": 2400,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-8700-550-4-20": {
            "MT": "R",
            "N": "ABB IRB 8700-550/4.20",
            "F": "ABB-IRB-8700-550-4-20.robot",
            "I": "ABB-IRB-8700-550-4-20-robot.png",
            "IS": "ABB-IRB-8700-550-4-20.png",
            "B": "ABB",
            "M": "IRB 8700-550/4.20",
            "T": "6 DOF",
            "A": 6,
            "R": 4200,
            "P": 500,
            "W": 4575,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-IRB-8700-800-3-50": {
            "MT": "R",
            "N": "ABB IRB 8700-800/3.50",
            "F": "ABB-IRB-8700-800-3-50.robot",
            "I": "ABB-IRB-8700-800-3-50-robot.png",
            "IS": "ABB-IRB-8700-800-3-50.png",
            "B": "ABB",
            "M": "IRB 8700-800/3.50",
            "T": "6 DOF",
            "A": 6,
            "R": 3500,
            "P": 800,
            "W": 4525,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "ABB-PoWa-CRB-1910-10-1-52": {
            "MT": "R",
            "N": "ABB PoWa CRB 1910-10/1.52",
            "F": "ABB-PoWa-CRB-1910-10-1-52.robot",
            "I": "ABB-PoWa-CRB-1910-10-1-52-robot.png",
            "IS": "ABB-PoWa-CRB-1910-10-1-52.png",
            "B": "ABB",
            "M": "PoWa CRB 1910-10/1.52",
            "T": "6 DOF",
            "A": 6,
            "R": 1523,
            "P": 11,
            "W": 42,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "ABB-YuMi-IRB-14000-Dual-Arm": {
            "MT": "R",
            "N": "ABB YuMi IRB 14000 Dual-Arm",
            "F": "ABB-YuMi-IRB-14000-Dual-Arm.rdka",
            "I": "ABB-YuMi-IRB-14000-Dual-Arm-robot.png",
            "IS": "ABB-YuMi-IRB-14000-Dual-Arm.png",
            "B": "ABB",
            "M": "YuMi IRB 14000 Dual-Arm",
            "T": "7 DOF",
            "A": 7,
            "R": 559,
            "P": 0.5,
            "W": 38,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-YuMi-IRB-14050": {
            "MT": "R",
            "N": "ABB YuMi IRB 14050",
            "F": "ABB-YuMi-IRB-14050.robot",
            "I": "ABB-YuMi-IRB-14050-robot.png",
            "IS": "ABB-YuMi-IRB-14050.png",
            "B": "ABB",
            "M": "YuMi IRB 14050",
            "T": "7 DOF",
            "A": 7,
            "R": 559,
            "P": 0.5,
            "W": 38,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "YuMi-IRB-14050": {
            "MT": "R",
            "N": "YuMi IRB 14050",
            "F": "YuMi-IRB-14050.robot",
            "I": "YuMi-IRB-14050-robot.png",
            "IS": "YuMi-IRB-14050.png",
            "B": "ABB",
            "M": "IRB 14050",
            "T": "7 DOF",
            "A": 7,
            "R": 559,
            "P": 0.5,
            "W": 38,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ABB-IRB-360-1-800-4D": {
            "MT": "R",
            "N": "ABB IRB 360-1/800 4D",
            "F": "ABB-IRB-360-1-800-4D.robot",
            "I": "ABB-IRB-360-1-800-4D-robot.png",
            "IS": "ABB-IRB-360-1-800-4D.png",
            "B": "ABB",
            "M": "IRB 360-1/800 4D",
            "T": "Delta",
            "A": 4,
            "R": 400,
            "P": 1,
            "W": 120,
            "E": 0.04,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "ABB-IRB-360-1-1130-4D": {
            "MT": "R",
            "N": "ABB IRB 360-1/1130 4D",
            "F": "ABB-IRB-360-1-1130-4D.robot",
            "I": "ABB-IRB-360-1-1130-4D-robot.png",
            "IS": "ABB-IRB-360-1-1130-4D.png",
            "B": "ABB",
            "M": "IRB 360-1/1130 4D",
            "T": "Delta",
            "A": 4,
            "R": 565,
            "P": 3,
            "W": 120,
            "E": 0.04,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "ABB-IRB-360-1-1600-4D": {
            "MT": "R",
            "N": "ABB IRB 360-1/1600 4D",
            "F": "ABB-IRB-360-1-1600-4D.robot",
            "I": "ABB-IRB-360-1-1600-4D-robot.png",
            "IS": "ABB-IRB-360-1-1600-4D.png",
            "B": "ABB",
            "M": "IRB 360-1/1600 4D",
            "T": "Delta",
            "A": 4,
            "R": 800,
            "P": 1,
            "W": 120,
            "E": 0.04,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "ABB-IRB-360-3-800-3D": {
            "MT": "R",
            "N": "ABB IRB 360-3/800 3D",
            "F": "ABB-IRB-360-3-800-3D.robot",
            "I": "ABB-IRB-360-3-800-3D-robot.png",
            "IS": "ABB-IRB-360-3-800-3D.png",
            "B": "ABB",
            "M": "IRB 360-3/800 3D",
            "T": "Delta",
            "A": 3,
            "R": 400,
            "P": 1,
            "W": 120,
            "E": 0.04,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "ABB-IRB-360-3-1130-3D": {
            "MT": "R",
            "N": "ABB IRB 360-3/1130 3D",
            "F": "ABB-IRB-360-3-1130-3D.robot",
            "I": "ABB-IRB-360-3-1130-3D-robot.png",
            "IS": "ABB-IRB-360-3-1130-3D.png",
            "B": "ABB",
            "M": "IRB 360-3/1130 3D",
            "T": "Delta",
            "A": 3,
            "R": 565,
            "P": 3,
            "W": 120,
            "E": 0.04,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "ABB-IRB-260": {
            "MT": "R",
            "N": "ABB IRB 260",
            "F": "ABB-IRB-260.robot",
            "I": "ABB-IRB-260-robot.png",
            "IS": "ABB-IRB-260.png",
            "B": "ABB",
            "M": "IRB 260",
            "T": "Palletizing",
            "A": 4,
            "R": 1560,
            "P": 30,
            "W": 340,
            "E": 0.1,
            "AP": [
                "Palletizing"
            ]
        },
        "ABB-IRB-460": {
            "MT": "R",
            "N": "ABB IRB 460",
            "F": "ABB-IRB-460.robot",
            "I": "ABB-IRB-460-robot.png",
            "IS": "ABB-IRB-460.png",
            "B": "ABB",
            "M": "IRB 460",
            "T": "Palletizing",
            "A": 4,
            "R": 2400,
            "P": 110,
            "W": 925,
            "E": 0.2,
            "AP": [
                "Palletizing"
            ]
        },
        "ABB-IRB-660-180-3-15": {
            "MT": "R",
            "N": "ABB IRB 660-180/3.15",
            "F": "ABB-IRB-660-180-3-15.robot",
            "I": "ABB-IRB-660-180-3-15-robot.png",
            "IS": "ABB-IRB-660-180-3-15.png",
            "B": "ABB",
            "M": "IRB 660-180/3.15",
            "T": "Palletizing",
            "A": 4,
            "R": 3150,
            "P": 180,
            "W": 1650,
            "E": 0.1,
            "AP": [
                "Palletizing"
            ]
        },
        "ABB-IRB-660-250-3-15": {
            "MT": "R",
            "N": "ABB IRB 660-250/3.15",
            "F": "ABB-IRB-660-250-3-15.robot",
            "I": "ABB-IRB-660-250-3-15-robot.png",
            "IS": "ABB-IRB-660-250-3-15.png",
            "B": "ABB",
            "M": "IRB 660-250/3.15",
            "T": "Palletizing",
            "A": 4,
            "R": 3150,
            "P": 250,
            "W": 1650,
            "E": 0.1,
            "AP": [
                "Palletizing"
            ]
        },
        "ABB-IRB-760": {
            "MT": "R",
            "N": "ABB IRB 760",
            "F": "ABB-IRB-760.robot",
            "I": "ABB-IRB-760-robot.png",
            "IS": "ABB-IRB-760.png",
            "B": "ABB",
            "M": "IRB 760",
            "T": "Palletizing",
            "A": 4,
            "R": 3180,
            "P": 450,
            "W": 2310,
            "E": 0.05,
            "AP": [
                "Palletizing"
            ]
        },
        "ABB-IRB-910SC-3-0-65": {
            "MT": "R",
            "N": "ABB IRB 910SC-3/0.65",
            "F": "ABB-IRB-910SC-3-0-65.robot",
            "I": "ABB-IRB-910SC-3-0-65-robot.png",
            "IS": "ABB-IRB-910SC-3-0-65.png",
            "B": "ABB",
            "M": "IRB 910SC-3/0.65",
            "T": "SCARA",
            "A": 4,
            "R": 650,
            "P": 3,
            "W": 25.5,
            "E": 0.018,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "ABB-IRB-920T-6-0-55": {
            "MT": "R",
            "N": "ABB IRB 920T-6/0.55",
            "F": "ABB-IRB-920T-6-0-55.robot",
            "I": "ABB-IRB-920T-6-0-55-robot.png",
            "IS": "ABB-IRB-920T-6-0-55.png",
            "B": "ABB",
            "M": "IRB 920T-6/0.55",
            "T": "SCARA",
            "A": 4,
            "R": 550,
            "P": 6,
            "W": 23,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "ABB-IRB-920T-6-0-65": {
            "MT": "R",
            "N": "ABB IRB 920T-6/0.65",
            "F": "ABB-IRB-920T-6-0-65.robot",
            "I": "ABB-IRB-920T-6-0-65-robot.png",
            "IS": "ABB-IRB-920T-6-0-65.png",
            "B": "ABB",
            "M": "IRB 920T-6/0.65",
            "T": "SCARA",
            "A": 4,
            "R": 650,
            "P": 6,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Adept-Six-300": {
            "MT": "R",
            "N": "Adept Six 300",
            "F": "Adept-Six-300.robot",
            "I": "Adept-Six-300-robot.png",
            "IS": "Adept-Six-300.png",
            "B": "Adept",
            "M": "Six 300",
            "T": "6 DOF",
            "A": 6,
            "R": 677,
            "P": 3,
            "W": 30,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Adept-Viper-s650": {
            "MT": "R",
            "N": "Adept Viper s650",
            "F": "Adept-Viper-s650.robot",
            "I": "Adept-Viper-s650-robot.png",
            "IS": "Adept-Viper-s650.png",
            "B": "Adept",
            "M": "Viper s650",
            "T": "6 DOF",
            "A": 6,
            "R": 653,
            "P": 5,
            "W": 28,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Adept-Viper-s850": {
            "MT": "R",
            "N": "Adept Viper s850",
            "F": "Adept-Viper-s850.robot",
            "I": "Adept-Viper-s850-robot.png",
            "IS": "Adept-Viper-s850.png",
            "B": "Adept",
            "M": "Viper s850",
            "T": "6 DOF",
            "A": 6,
            "R": 855,
            "P": 5,
            "W": 29,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Adept-Viper-s1700": {
            "MT": "R",
            "N": "Adept Viper s1700",
            "F": "Adept-Viper-s1700.robot",
            "I": "Adept-Viper-s1700-robot.png",
            "IS": "Adept-Viper-s1700.png",
            "B": "Adept",
            "M": "Viper s1700",
            "T": "6 DOF",
            "A": 6,
            "R": 1717,
            "P": 20,
            "W": 280,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Adept-Cobra-s350": {
            "MT": "R",
            "N": "Adept Cobra s350",
            "F": "Adept-Cobra-s350.robot",
            "I": "Adept-Cobra-s350-robot.png",
            "IS": "Adept-Cobra-s350.png",
            "B": "Adept",
            "M": "Cobra s350",
            "T": "SCARA",
            "A": 4,
            "R": 350,
            "P": 2,
            "W": 20,
            "E": 0.018,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Adept-Cobra-s600": {
            "MT": "R",
            "N": "Adept Cobra s600",
            "F": "Adept-Cobra-s600.robot",
            "I": "Adept-Cobra-s600-robot.png",
            "IS": "Adept-Cobra-s600.png",
            "B": "Adept",
            "M": "Cobra s600",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 2,
            "W": 41,
            "E": 0.018,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Adept-Cobra-s800": {
            "MT": "R",
            "N": "Adept Cobra s800",
            "F": "Adept-Cobra-s800.robot",
            "I": "Adept-Cobra-s800-robot.png",
            "IS": "Adept-Cobra-s800.png",
            "B": "Adept",
            "M": "Cobra s800",
            "T": "SCARA",
            "A": 4,
            "R": 800,
            "P": 2,
            "W": 43,
            "E": 0.018,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Adept-eCobra-800-Inverted": {
            "MT": "R",
            "N": "Adept eCobra 800 Inverted",
            "F": "Adept-eCobra-800-Inverted.robot",
            "I": "Adept-eCobra-800-Inverted-robot.png",
            "IS": "Adept-eCobra-800-Inverted.png",
            "B": "Adept",
            "M": "eCobra 800 Inverted",
            "T": "SCARA",
            "A": 4,
            "R": 800,
            "P": 2,
            "W": 43,
            "E": 0.018,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Agile-Robots-Diana-7": {
            "MT": "R",
            "N": "Agile Robots Diana 7",
            "F": "Agile-Robots-Diana-7.robot",
            "I": "Agile-Robots-Diana-7-robot.png",
            "IS": "Agile-Robots-Diana-7.png",
            "B": "Agile Robots",
            "M": "Diana 7",
            "T": "7 DOF",
            "A": 7,
            "R": 923,
            "P": 7,
            "W": 26,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Agilebot-GBT-P7A": {
            "MT": "R",
            "N": "Agilebot GBT-P7A",
            "F": "Agilebot-GBT-P7A.robot",
            "I": "Agilebot-GBT-P7A-robot.png",
            "IS": "Agilebot-GBT-P7A.png",
            "B": "Agilebot",
            "M": "GBT-P7A",
            "T": "6 DOF",
            "A": 6,
            "R": 721,
            "P": 7,
            "W": 43,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Annin-Robotics-AR2": {
            "MT": "R",
            "N": "Annin Robotics AR2",
            "F": "Annin-Robotics-AR2.robot",
            "I": "Annin-Robotics-AR2-robot.png",
            "IS": "Annin-Robotics-AR2.png",
            "B": "Annin Robotics",
            "M": "AR2",
            "T": "6 DOF",
            "A": 6,
            "R": 600,
            "P": 1,
            "W": 10,
            "E": 0.2,
            "AP": [
                "Assembly",
                "Inspection",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Annin-Robotics-AR3": {
            "MT": "R",
            "N": "Annin Robotics AR3",
            "F": "Annin-Robotics-AR3.robot",
            "I": "Annin-Robotics-AR3-robot.png",
            "IS": "Annin-Robotics-AR3.png",
            "B": "Annin Robotics",
            "M": "AR3",
            "T": "6 DOF",
            "A": 6,
            "R": 600,
            "P": 1,
            "W": 10,
            "E": 0.2,
            "AP": [
                "Assembly",
                "Inspection",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Annin-Robotics-AR4": {
            "MT": "R",
            "N": "Annin Robotics AR4",
            "F": "Annin-Robotics-AR4.robot",
            "I": "Annin-Robotics-AR4-robot.png",
            "IS": "Annin-Robotics-AR4.png",
            "B": "Annin Robotics",
            "M": "AR4",
            "T": "6 DOF",
            "A": 6,
            "R": 600,
            "P": 1,
            "W": 10,
            "E": 0.2,
            "AP": [
                "Assembly",
                "Inspection",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUBO-ES3": {
            "MT": "R",
            "N": "AUBO-ES3",
            "F": "AUBO-ES3.robot",
            "I": "AUBO-ES3-robot.png",
            "IS": "AUBO-ES3.png",
            "B": "AUBO",
            "M": "AUBO-ES3",
            "T": "6 DOF",
            "A": 6,
            "R": 625,
            "P": 3,
            "W": 17,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUBO-ES5": {
            "MT": "R",
            "N": "AUBO-ES5",
            "F": "AUBO-ES5.robot",
            "I": "AUBO-ES5-robot.png",
            "IS": "AUBO-ES5.png",
            "B": "AUBO",
            "M": "AUBO-ES5",
            "T": "6 DOF",
            "A": 6,
            "R": 886.5,
            "P": 5,
            "W": 24.5,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUBO-i3": {
            "MT": "R",
            "N": "AUBO-i3",
            "F": "AUBO-i3.robot",
            "I": "AUBO-i3-robot.png",
            "IS": "AUBO-i3.png",
            "B": "AUBO",
            "M": "AUBO-i3",
            "T": "6 DOF",
            "A": 6,
            "R": 625,
            "P": 3,
            "W": 16,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUBO-i5": {
            "MT": "R",
            "N": "AUBO-i5",
            "F": "AUBO-i5.robot",
            "I": "AUBO-i5-robot.png",
            "IS": "AUBO-i5.png",
            "B": "AUBO",
            "M": "AUBO-i5",
            "T": "6 DOF",
            "A": 6,
            "R": 886.5,
            "P": 5.0,
            "W": 24,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUBO-i5H": {
            "MT": "R",
            "N": "AUBO-i5H",
            "F": "AUBO-i5H.robot",
            "I": "AUBO-i5H-robot.png",
            "IS": "AUBO-i5H.png",
            "B": "AUBO",
            "M": "AUBO-i5H",
            "T": "6 DOF",
            "A": 6,
            "R": 886.5,
            "P": 5.0,
            "W": 24,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUBO-i7": {
            "MT": "R",
            "N": "AUBO-i7",
            "F": "AUBO-i7.robot",
            "I": "AUBO-i7-robot.png",
            "IS": "AUBO-i7.png",
            "B": "AUBO",
            "M": "AUBO-i7",
            "T": "6 DOF",
            "A": 6,
            "R": 786.5,
            "P": 7.0,
            "W": 24,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUBO-i10": {
            "MT": "R",
            "N": "AUBO-i10",
            "F": "AUBO-i10.robot",
            "I": "AUBO-i10-robot.png",
            "IS": "AUBO-i10.png",
            "B": "AUBO",
            "M": "AUBO-i10",
            "T": "6 DOF",
            "A": 6,
            "R": 1350,
            "P": 10.0,
            "W": 38.5,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUBO-i10H": {
            "MT": "R",
            "N": "AUBO-i10H",
            "F": "AUBO-i10H.robot",
            "I": "AUBO-i10H-robot.png",
            "IS": "AUBO-i10H.png",
            "B": "AUBO",
            "M": "AUBO-i10H",
            "T": "6 DOF",
            "A": 6,
            "R": 1350,
            "P": 10.0,
            "W": 38.5,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUBO-i12": {
            "MT": "R",
            "N": "AUBO-i12",
            "F": "AUBO-i12.robot",
            "I": "AUBO-i12-robot.png",
            "IS": "AUBO-i12.png",
            "B": "AUBO",
            "M": "AUBO-i12",
            "T": "6 DOF",
            "A": 6,
            "R": 1250,
            "P": 12.0,
            "W": 40.0,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUBO-i16": {
            "MT": "R",
            "N": "AUBO-i16",
            "F": "AUBO-i16.robot",
            "I": "AUBO-i16-robot.png",
            "IS": "AUBO-i16.png",
            "B": "AUBO",
            "M": "AUBO-i16",
            "T": "6 DOF",
            "A": 6,
            "R": 967.5,
            "P": 16.0,
            "W": 38,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUBO-i20": {
            "MT": "R",
            "N": "AUBO-i20",
            "F": "AUBO-i20.robot",
            "I": "AUBO-i20-robot.png",
            "IS": "AUBO-i20.png",
            "B": "AUBO",
            "M": "AUBO-i20",
            "T": "6 DOF",
            "A": 6,
            "R": 1650,
            "P": 20.0,
            "W": 63,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUBO-iS7": {
            "MT": "R",
            "N": "AUBO-iS7",
            "F": "AUBO-iS7.robot",
            "I": "AUBO-iS7-robot.png",
            "IS": "AUBO-iS7.png",
            "B": "AUBO",
            "M": "AUBO-iS7",
            "T": "6 DOF",
            "A": 6,
            "R": 886.5,
            "P": 7,
            "W": 21.5,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUBO-iS10": {
            "MT": "R",
            "N": "AUBO-iS10",
            "F": "AUBO-iS10.robot",
            "I": "AUBO-iS10-robot.png",
            "IS": "AUBO-iS10.png",
            "B": "AUBO",
            "M": "AUBO-iS10",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 10,
            "W": 36,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUBO-iS20": {
            "MT": "R",
            "N": "AUBO-iS20",
            "F": "AUBO-iS20.robot",
            "I": "AUBO-iS20-robot.png",
            "IS": "AUBO-iS20.png",
            "B": "AUBO",
            "M": "AUBO-iS20",
            "T": "6 DOF",
            "A": 6,
            "R": 1647,
            "P": 20,
            "W": 64,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUBO-iS20L": {
            "MT": "R",
            "N": "AUBO-iS20L",
            "F": "AUBO-iS20L.robot",
            "I": "AUBO-iS20L-robot.png",
            "IS": "AUBO-iS20L.png",
            "B": "AUBO",
            "M": "AUBO-iS20L",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 20,
            "W": 65,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUBO-iS25": {
            "MT": "R",
            "N": "AUBO-iS25",
            "F": "AUBO-iS25.robot",
            "I": "AUBO-iS25-robot.png",
            "IS": "AUBO-iS25.png",
            "B": "AUBO",
            "M": "AUBO-iS25",
            "T": "6 DOF",
            "A": 6,
            "R": 1700,
            "P": 25,
            "W": 64,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUBO-iS35": {
            "MT": "R",
            "N": "AUBO-iS35",
            "F": "AUBO-iS35.robot",
            "I": "AUBO-iS35-robot.png",
            "IS": "AUBO-iS35.png",
            "B": "AUBO",
            "M": "AUBO-iS35",
            "T": "6 DOF",
            "A": 6,
            "R": 2100,
            "P": 35,
            "W": 150,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "AUBO-S3": {
            "MT": "R",
            "N": "AUBO-S3",
            "F": "AUBO-S3.robot",
            "I": "AUBO-S3-robot.png",
            "IS": "AUBO-S3.png",
            "B": "AUBO",
            "M": "AUBO-S3",
            "T": "6 DOF",
            "A": 6,
            "R": 650,
            "P": 3,
            "W": 11.2,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUBO-S5": {
            "MT": "R",
            "N": "AUBO-S5",
            "F": "AUBO-S5.robot",
            "I": "AUBO-S5-robot.png",
            "IS": "AUBO-S5.png",
            "B": "AUBO",
            "M": "AUBO-S5",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 5,
            "W": 15.5,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUCTECH-AN-12-16-0-95-3": {
            "MT": "R",
            "N": "AUCTECH AN-12-16-0.95-3",
            "F": "AUCTECH-AN-12-16-0-95-3.robot",
            "I": "AUCTECH-AN-12-16-0-95-3-robot.png",
            "IS": "AUCTECH-AN-12-16-0-95-3.png",
            "B": "AUCTECH",
            "M": "AN-12-16-0.95-3",
            "T": "3 DOF",
            "A": 3,
            "R": 953,
            "P": 16,
            "W": 67,
            "E": 0.03,
            "AP": [
                "Material Handling"
            ]
        },
        "AUCTECH-AX-12-R906-3": {
            "MT": "R",
            "N": "AUCTECH AX-12-R906-3",
            "F": "AUCTECH-AX-12-R906-3.robot",
            "I": "AUCTECH-AX-12-R906-3-robot.png",
            "IS": "AUCTECH-AX-12-R906-3.png",
            "B": "AUCTECH",
            "M": "AX-12-R906-3",
            "T": "3 DOF",
            "A": 3,
            "R": 906,
            "P": 12.0,
            "W": 44,
            "E": 0.03,
            "AP": [
                "Material Handling"
            ]
        },
        "AUCTECH-AN-12-16-0-95-4": {
            "MT": "R",
            "N": "AUCTECH AN-12-16-0.95-4",
            "F": "AUCTECH-AN-12-16-0-95-4.robot",
            "I": "AUCTECH-AN-12-16-0-95-4-robot.png",
            "IS": "AUCTECH-AN-12-16-0-95-4.png",
            "B": "AUCTECH",
            "M": "AN-12-16-0.95-4",
            "T": "4 DOF",
            "A": 4,
            "R": 953,
            "P": 16.0,
            "W": 69,
            "E": 0.03,
            "AP": [
                "Material Handling"
            ]
        },
        "AUCTECH-AX-12-R906-4": {
            "MT": "R",
            "N": "AUCTECH AX-12-R906-4",
            "F": "AUCTECH-AX-12-R906-4.robot",
            "I": "AUCTECH-AX-12-R906-4-robot.png",
            "IS": "AUCTECH-AX-12-R906-4.png",
            "B": "AUCTECH",
            "M": "AX-12-R906-4",
            "T": "4 DOF",
            "A": 4,
            "R": 906,
            "P": 12.0,
            "W": 46,
            "E": 0.03,
            "AP": [
                "Material Handling"
            ]
        },
        "AUCTECH-ACR-7": {
            "MT": "R",
            "N": "AUCTECH ACR-7",
            "F": "AUCTECH-ACR-7.robot",
            "I": "AUCTECH-ACR-7-robot.png",
            "IS": "AUCTECH-ACR-7.png",
            "B": "AUCTECH",
            "M": "ACR-7",
            "T": "6 DOF",
            "A": 6,
            "R": 850,
            "P": 7.0,
            "W": 27,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUCTECH-ACR-12": {
            "MT": "R",
            "N": "AUCTECH ACR-12",
            "F": "AUCTECH-ACR-12.robot",
            "I": "AUCTECH-ACR-12-robot.png",
            "IS": "AUCTECH-ACR-12.png",
            "B": "AUCTECH",
            "M": "ACR-12",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 12.0,
            "W": 43,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUCTECH-ACR-18": {
            "MT": "R",
            "N": "AUCTECH ACR-18",
            "F": "AUCTECH-ACR-18.robot",
            "I": "AUCTECH-ACR-18-robot.png",
            "IS": "AUCTECH-ACR-18.png",
            "B": "AUCTECH",
            "M": "ACR-18",
            "T": "6 DOF",
            "A": 6,
            "R": 925,
            "P": 18.0,
            "W": 40,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUCTECH-ACR-20": {
            "MT": "R",
            "N": "AUCTECH ACR-20",
            "F": "AUCTECH-ACR-20.robot",
            "I": "AUCTECH-ACR-20-robot.png",
            "IS": "AUCTECH-ACR-20.png",
            "B": "AUCTECH",
            "M": "ACR-20",
            "T": "6 DOF",
            "A": 6,
            "R": 1650,
            "P": 20.0,
            "W": 75,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUCTECH-AN-12-10-1-6-1": {
            "MT": "R",
            "N": "AUCTECH AN-12-10-1.6-1",
            "F": "AUCTECH-AN-12-10-1-6-1.robot",
            "I": "AUCTECH-AN-12-10-1-6-1-robot.png",
            "IS": "AUCTECH-AN-12-10-1-6-1.png",
            "B": "AUCTECH",
            "M": "AN-12-10-1.6-1",
            "T": "6 DOF",
            "A": 6,
            "R": 1620,
            "P": 10.0,
            "W": 117,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUCTECH-AN-12-12-1-4": {
            "MT": "R",
            "N": "AUCTECH AN-12-12-1.4",
            "F": "AUCTECH-AN-12-12-1-4.robot",
            "I": "AUCTECH-AN-12-12-1-4-robot.png",
            "IS": "AUCTECH-AN-12-12-1-4.png",
            "B": "AUCTECH",
            "M": "AN-12-12-1.4",
            "T": "6 DOF",
            "A": 6,
            "R": 1442,
            "P": 12.0,
            "W": 115,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUCTECH-AN-12-16-1-1": {
            "MT": "R",
            "N": "AUCTECH AN-12-16-1.1",
            "F": "AUCTECH-AN-12-16-1-1.robot",
            "I": "AUCTECH-AN-12-16-1-1-robot.png",
            "IS": "AUCTECH-AN-12-16-1-1.png",
            "B": "AUCTECH",
            "M": "AN-12-16-1.1",
            "T": "6 DOF",
            "A": 6,
            "R": 1102,
            "P": 16.0,
            "W": 112,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUCTECH-AN-25-12-2-1": {
            "MT": "R",
            "N": "AUCTECH AN-25-12-2.1",
            "F": "AUCTECH-AN-25-12-2-1.robot",
            "I": "AUCTECH-AN-25-12-2-1-robot.png",
            "IS": "AUCTECH-AN-25-12-2-1.png",
            "B": "AUCTECH",
            "M": "AN-25-12-2.1",
            "T": "6 DOF",
            "A": 6,
            "R": 2110,
            "P": 25.0,
            "W": 262,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "AUCTECH-AN-25-20-2-0": {
            "MT": "R",
            "N": "AUCTECH AN-25-20-2.0",
            "F": "AUCTECH-AN-25-20-2-0.robot",
            "I": "AUCTECH-AN-25-20-2-0-robot.png",
            "IS": "AUCTECH-AN-25-20-2-0.png",
            "B": "AUCTECH",
            "M": "AN-25-20-2.0",
            "T": "6 DOF",
            "A": 6,
            "R": 2013,
            "P": 25.0,
            "W": 264,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "AUCTECH-AN-25-25-1-8": {
            "MT": "R",
            "N": "AUCTECH AN-25-25-1.8",
            "F": "AUCTECH-AN-25-25-1-8.robot",
            "I": "AUCTECH-AN-25-25-1-8-robot.png",
            "IS": "AUCTECH-AN-25-25-1-8.png",
            "B": "AUCTECH",
            "M": "AN-25-25-1.8",
            "T": "6 DOF",
            "A": 6,
            "R": 1813,
            "P": 25.0,
            "W": 256,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUCTECH-AN-25-30-1-6": {
            "MT": "R",
            "N": "AUCTECH AN-25-30-1.6",
            "F": "AUCTECH-AN-25-30-1-6.robot",
            "I": "AUCTECH-AN-25-30-1-6-robot.png",
            "IS": "AUCTECH-AN-25-30-1-6.png",
            "B": "AUCTECH",
            "M": "AN-25-30-1.6",
            "T": "6 DOF",
            "A": 6,
            "R": 1617,
            "P": 30.0,
            "W": 252,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUCTECH-AN-25-35-1-8": {
            "MT": "R",
            "N": "AUCTECH AN-25-35-1.8",
            "F": "AUCTECH-AN-25-35-1-8.robot",
            "I": "AUCTECH-AN-25-35-1-8-robot.png",
            "IS": "AUCTECH-AN-25-35-1-8.png",
            "B": "AUCTECH",
            "M": "AN-25-35-1.8",
            "T": "6 DOF",
            "A": 6,
            "R": 1813,
            "P": 35.0,
            "W": 256,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUCTECH-AN-80-50-2-6": {
            "MT": "R",
            "N": "AUCTECH AN-80-50-2.6",
            "F": "AUCTECH-AN-80-50-2-6.robot",
            "I": "AUCTECH-AN-80-50-2-6-robot.png",
            "IS": "AUCTECH-AN-80-50-2-6.png",
            "B": "AUCTECH",
            "M": "AN-80-50-2.6",
            "T": "6 DOF",
            "A": 6,
            "R": 2603,
            "P": 50.0,
            "W": 645,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "AUCTECH-AN-80-80-2-2": {
            "MT": "R",
            "N": "AUCTECH AN-80-80-2.2",
            "F": "AUCTECH-AN-80-80-2-2.robot",
            "I": "AUCTECH-AN-80-80-2-2-robot.png",
            "IS": "AUCTECH-AN-80-80-2-2.png",
            "B": "AUCTECH",
            "M": "AN-80-80-2.2",
            "T": "6 DOF",
            "A": 6,
            "R": 2200,
            "P": 80.0,
            "W": 635,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "AUCTECH-AN-220-150-3-2": {
            "MT": "R",
            "N": "AUCTECH AN-220-150-3.2",
            "F": "AUCTECH-AN-220-150-3-2.robot",
            "I": "AUCTECH-AN-220-150-3-2-robot.png",
            "IS": "AUCTECH-AN-220-150-3-2.png",
            "B": "AUCTECH",
            "M": "AN-220-150-3.2",
            "T": "6 DOF",
            "A": 6,
            "R": 3201,
            "P": 150.0,
            "W": 1165,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "AUCTECH-AN-220-170-2-7": {
            "MT": "R",
            "N": "AUCTECH AN-220-170-2.7",
            "F": "AUCTECH-AN-220-170-2-7.robot",
            "I": "AUCTECH-AN-220-170-2-7-robot.png",
            "IS": "AUCTECH-AN-220-170-2-7.png",
            "B": "AUCTECH",
            "M": "AN-220-170-2.7",
            "T": "6 DOF",
            "A": 6,
            "R": 2705,
            "P": 170.0,
            "W": 1138,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "AUCTECH-AN-220-220-2-7": {
            "MT": "R",
            "N": "AUCTECH AN-220-220-2.7",
            "F": "AUCTECH-AN-220-220-2-7.robot",
            "I": "AUCTECH-AN-220-220-2-7-robot.png",
            "IS": "AUCTECH-AN-220-220-2-7.png",
            "B": "AUCTECH",
            "M": "AN-220-220-2.7",
            "T": "6 DOF",
            "A": 6,
            "R": 2705,
            "P": 220.0,
            "W": 1138,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "AUCTECH-AX-7": {
            "MT": "R",
            "N": "AUCTECH AX-7",
            "F": "AUCTECH-AX-7.robot",
            "I": "AUCTECH-AX-7-robot.png",
            "IS": "AUCTECH-AX-7.png",
            "B": "AUCTECH",
            "M": "AX-7",
            "T": "6 DOF",
            "A": 6,
            "R": 707,
            "P": 7.0,
            "W": 50,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUCTECH-AX-7L": {
            "MT": "R",
            "N": "AUCTECH AX-7L",
            "F": "AUCTECH-AX-7L.robot",
            "I": "AUCTECH-AX-7L-robot.png",
            "IS": "AUCTECH-AX-7L.png",
            "B": "AUCTECH",
            "M": "AX-7L",
            "T": "6 DOF",
            "A": 6,
            "R": 906,
            "P": 7.0,
            "W": 52,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUCTECH-AX-10-R1206": {
            "MT": "R",
            "N": "AUCTECH AX-10-R1206",
            "F": "AUCTECH-AX-10-R1206.robot",
            "I": "AUCTECH-AX-10-R1206-robot.png",
            "IS": "AUCTECH-AX-10-R1206.png",
            "B": "AUCTECH",
            "M": "AX-10-R1206",
            "T": "6 DOF",
            "A": 6,
            "R": 1206,
            "P": 10.0,
            "W": 76,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUCTECH-BM-35-1870": {
            "MT": "R",
            "N": "AUCTECH BM-35-1870",
            "F": "AUCTECH-BM-35-1870.robot",
            "I": "AUCTECH-BM-35-1870-robot.png",
            "IS": "AUCTECH-BM-35-1870.png",
            "B": "AUCTECH",
            "M": "BM-35-1870",
            "T": "6 DOF",
            "A": 6,
            "R": 1870,
            "P": 35.0,
            "W": 260,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUCTECH-BM-150-3200": {
            "MT": "R",
            "N": "AUCTECH BM-150-3200",
            "F": "AUCTECH-BM-150-3200.robot",
            "I": "AUCTECH-BM-150-3200-robot.png",
            "IS": "AUCTECH-BM-150-3200.png",
            "B": "AUCTECH",
            "M": "BM-150-3200",
            "T": "6 DOF",
            "A": 6,
            "R": 3200,
            "P": 150.0,
            "W": 1300,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "AUCTECH-BM-180-3200": {
            "MT": "R",
            "N": "AUCTECH BM-180-3200",
            "F": "AUCTECH-BM-180-3200.robot",
            "I": "AUCTECH-BM-180-3200-robot.png",
            "IS": "AUCTECH-BM-180-3200.png",
            "B": "AUCTECH",
            "M": "BM-180-3200",
            "T": "6 DOF",
            "A": 6,
            "R": 3200,
            "P": 180.0,
            "W": 1300,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "AUCTECH-BM-210-2650": {
            "MT": "R",
            "N": "AUCTECH BM-210-2650",
            "F": "AUCTECH-BM-210-2650.robot",
            "I": "AUCTECH-BM-210-2650-robot.png",
            "IS": "AUCTECH-BM-210-2650.png",
            "B": "AUCTECH",
            "M": "BM-210-2650",
            "T": "6 DOF",
            "A": 6,
            "R": 2650,
            "P": 210.0,
            "W": 1240,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "AUCTECH-BM-280-2650": {
            "MT": "R",
            "N": "AUCTECH BM-280-2650",
            "F": "AUCTECH-BM-280-2650.robot",
            "I": "AUCTECH-BM-280-2650-robot.png",
            "IS": "AUCTECH-BM-280-2650.png",
            "B": "AUCTECH",
            "M": "BM-280-2650",
            "T": "6 DOF",
            "A": 6,
            "R": 2650,
            "P": 280.0,
            "W": 1240,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "AUCTECH-BR-07S-930": {
            "MT": "R",
            "N": "AUCTECH BR-07S-930",
            "F": "AUCTECH-BR-07S-930.robot",
            "I": "AUCTECH-BR-07S-930-robot.png",
            "IS": "AUCTECH-BR-07S-930.png",
            "B": "AUCTECH",
            "M": "BR-07S-930",
            "T": "6 DOF",
            "A": 6,
            "R": 930,
            "P": 7.0,
            "W": 60,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUCTECH-BR-10-1440": {
            "MT": "R",
            "N": "AUCTECH BR-10-1440",
            "F": "AUCTECH-BR-10-1440.robot",
            "I": "AUCTECH-BR-10-1440-robot.png",
            "IS": "AUCTECH-BR-10-1440.png",
            "B": "AUCTECH",
            "M": "BR-10-1440",
            "T": "6 DOF",
            "A": 6,
            "R": 1410,
            "P": 10.0,
            "W": 210,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUCTECH-BR-10L-2050": {
            "MT": "R",
            "N": "AUCTECH BR-10L-2050",
            "F": "AUCTECH-BR-10L-2050.robot",
            "I": "AUCTECH-BR-10L-2050-robot.png",
            "IS": "AUCTECH-BR-10L-2050.png",
            "B": "AUCTECH",
            "M": "BR-10L-2050",
            "T": "6 DOF",
            "A": 6,
            "R": 2050,
            "P": 10.0,
            "W": 286,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUCTECH-BR-25E-1840": {
            "MT": "R",
            "N": "AUCTECH BR-25E-1840",
            "F": "AUCTECH-BR-25E-1840.robot",
            "I": "AUCTECH-BR-25E-1840-robot.png",
            "IS": "AUCTECH-BR-25E-1840.png",
            "B": "AUCTECH",
            "M": "BR-25E-1840",
            "T": "6 DOF",
            "A": 6,
            "R": 1840,
            "P": 25.0,
            "W": 186,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUCTECH-BR-45-1870": {
            "MT": "R",
            "N": "AUCTECH BR-45-1870",
            "F": "AUCTECH-BR-45-1870.robot",
            "I": "AUCTECH-BR-45-1870-robot.png",
            "IS": "AUCTECH-BR-45-1870.png",
            "B": "AUCTECH",
            "M": "BR-45-1870",
            "T": "6 DOF",
            "A": 6,
            "R": 1870,
            "P": 45.0,
            "W": 286,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUCTECH-BR-80E-2250": {
            "MT": "R",
            "N": "AUCTECH BR-80E-2250",
            "F": "AUCTECH-BR-80E-2250.robot",
            "I": "AUCTECH-BR-80E-2250-robot.png",
            "IS": "AUCTECH-BR-80E-2250.png",
            "B": "AUCTECH",
            "M": "BR-80E-2250",
            "T": "6 DOF",
            "A": 6,
            "R": 2250,
            "P": 80.0,
            "W": 678,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "AUCTECH-X3-618": {
            "MT": "R",
            "N": "AUCTECH X3-618",
            "F": "AUCTECH-X3-618.robot",
            "I": "AUCTECH-X3-618-robot.png",
            "IS": "AUCTECH-X3-618.png",
            "B": "AUCTECH",
            "M": "X3-618",
            "T": "6 DOF",
            "A": 6,
            "R": 618,
            "P": 3,
            "W": 13,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUCTECH-X5-910": {
            "MT": "R",
            "N": "AUCTECH X5-910",
            "F": "AUCTECH-X5-910.robot",
            "I": "AUCTECH-X5-910-robot.png",
            "IS": "AUCTECH-X5-910.png",
            "B": "AUCTECH",
            "M": "X5-910",
            "T": "6 DOF",
            "A": 6,
            "R": 910,
            "P": 5,
            "W": 22,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUCTECH-X7-910": {
            "MT": "R",
            "N": "AUCTECH X7-910",
            "F": "AUCTECH-X7-910.robot",
            "I": "AUCTECH-X7-910-robot.png",
            "IS": "AUCTECH-X7-910.png",
            "B": "AUCTECH",
            "M": "X7-910",
            "T": "6 DOF",
            "A": 6,
            "R": 910,
            "P": 7,
            "W": 22,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUCTECH-X10-1300": {
            "MT": "R",
            "N": "AUCTECH X10-1300",
            "F": "AUCTECH-X10-1300.robot",
            "I": "AUCTECH-X10-1300-robot.png",
            "IS": "AUCTECH-X10-1300.png",
            "B": "AUCTECH",
            "M": "X10-1300",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 10,
            "W": 37.8,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUCTECH-X12-1300": {
            "MT": "R",
            "N": "AUCTECH X12-1300",
            "F": "AUCTECH-X12-1300.robot",
            "I": "AUCTECH-X12-1300-robot.png",
            "IS": "AUCTECH-X12-1300.png",
            "B": "AUCTECH",
            "M": "X12-1300",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 12,
            "W": 37.8,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUCTECH-X16-960": {
            "MT": "R",
            "N": "AUCTECH X16-960",
            "F": "AUCTECH-X16-960.robot",
            "I": "AUCTECH-X16-960-robot.png",
            "IS": "AUCTECH-X16-960.png",
            "B": "AUCTECH",
            "M": "X16-960",
            "T": "6 DOF",
            "A": 6,
            "R": 960,
            "P": 16,
            "W": 37,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUCTECH-X16-2000": {
            "MT": "R",
            "N": "AUCTECH X16-2000",
            "F": "AUCTECH-X16-2000.robot",
            "I": "AUCTECH-X16-2000-robot.png",
            "IS": "AUCTECH-X16-2000.png",
            "B": "AUCTECH",
            "M": "X16-2000",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 16,
            "W": 60,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUCTECH-X20-1400": {
            "MT": "R",
            "N": "AUCTECH X20-1400",
            "F": "AUCTECH-X20-1400.robot",
            "I": "AUCTECH-X20-1400-robot.png",
            "IS": "AUCTECH-X20-1400.png",
            "B": "AUCTECH",
            "M": "X20-1400",
            "T": "6 DOF",
            "A": 6,
            "R": 1400,
            "P": 20,
            "W": 66,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "AUCTECH-X25-1800": {
            "MT": "R",
            "N": "AUCTECH X25-1800",
            "F": "AUCTECH-X25-1800.robot",
            "I": "AUCTECH-X25-1800-robot.png",
            "IS": "AUCTECH-X25-1800.png",
            "B": "AUCTECH",
            "M": "X25-1800",
            "T": "6 DOF",
            "A": 6,
            "R": 1800,
            "P": 25,
            "W": 61.6,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUCTECH-X30-1100": {
            "MT": "R",
            "N": "AUCTECH X30-1100",
            "F": "AUCTECH-X30-1100.robot",
            "I": "AUCTECH-X30-1100-robot.png",
            "IS": "AUCTECH-X30-1100.png",
            "B": "AUCTECH",
            "M": "X30-1100",
            "T": "6 DOF",
            "A": 6,
            "R": 1100,
            "P": 30,
            "W": 64,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "AUCTECH-BR-06SC-500": {
            "MT": "R",
            "N": "AUCTECH BR-06SC-500",
            "F": "AUCTECH-BR-06SC-500.robot",
            "I": "AUCTECH-BR-06SC-500-robot.png",
            "IS": "AUCTECH-BR-06SC-500.png",
            "B": "AUCTECH",
            "M": "BR-06SC-500",
            "T": "SCARA",
            "A": 4,
            "R": 500,
            "P": 6.0,
            "W": 30,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "AUCTECH-BR-06SC-600": {
            "MT": "R",
            "N": "AUCTECH BR-06SC-600",
            "F": "AUCTECH-BR-06SC-600.robot",
            "I": "AUCTECH-BR-06SC-600-robot.png",
            "IS": "AUCTECH-BR-06SC-600.png",
            "B": "AUCTECH",
            "M": "BR-06SC-600",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 6.0,
            "W": 30,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "AUCTECH-BR-06SC-700": {
            "MT": "R",
            "N": "AUCTECH BR-06SC-700",
            "F": "AUCTECH-BR-06SC-700.robot",
            "I": "AUCTECH-BR-06SC-700-robot.png",
            "IS": "AUCTECH-BR-06SC-700.png",
            "B": "AUCTECH",
            "M": "BR-06SC-700",
            "T": "SCARA",
            "A": 4,
            "R": 700,
            "P": 6.0,
            "W": 30,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Automata-EVA": {
            "MT": "R",
            "N": "Automata EVA",
            "F": "Automata-EVA.robot",
            "I": "Automata-EVA-robot.png",
            "IS": "Automata-EVA.png",
            "B": "Automata",
            "M": "EVA",
            "T": "6 DOF",
            "A": 6,
            "R": 600,
            "P": 1.25,
            "W": 9.5,
            "E": 0.5,
            "AP": [
                "Assembly",
                "Collaborative",
                "Inspection",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "autonox-Robotics-articc-m6-1704-30kg-AT-00026-SE01": {
            "MT": "R",
            "N": "autonox Robotics articc.m6-1704-30kg (AT_00026-SE01)",
            "F": "autonox-Robotics-articc-m6-1704-30kg-AT-00026-SE01.robot",
            "I": "autonox-Robotics-articc-m6-1704-30kg-AT-00026-SE01-robot.png",
            "IS": "autonox-Robotics-articc-m6-1704-30kg-AT-00026-SE01.png",
            "B": "autonox Robotics",
            "M": "articc.m6-1704-30kg (AT_00026-SE01)",
            "T": "6 DOF",
            "A": 6,
            "R": 1704,
            "P": 30.0,
            "W": 273,
            "E": 0,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "autonox-Robotics-articc6-1557-3kg-AT-00004": {
            "MT": "R",
            "N": "autonox Robotics articc6-1557-3kg (AT_00004)",
            "F": "autonox-Robotics-articc6-1557-3kg-AT-00004.robot",
            "I": "autonox-Robotics-articc6-1557-3kg-AT-00004-robot.png",
            "IS": "autonox-Robotics-articc6-1557-3kg-AT-00004.png",
            "B": "autonox Robotics",
            "M": "articc6-1557-3kg (AT_00004)",
            "T": "6 DOF",
            "A": 6,
            "R": 1557,
            "P": 3,
            "W": 120,
            "E": 0,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "autonox-Robotics-articc6-1959-60kg-AT-00005": {
            "MT": "R",
            "N": "autonox Robotics articc6-1959-60kg (AT_00005)",
            "F": "autonox-Robotics-articc6-1959-60kg-AT-00005.robot",
            "I": "autonox-Robotics-articc6-1959-60kg-AT-00005-robot.png",
            "IS": "autonox-Robotics-articc6-1959-60kg-AT-00005.png",
            "B": "autonox Robotics",
            "M": "articc6-1959-60kg (AT_00005)",
            "T": "6 DOF",
            "A": 6,
            "R": 1959,
            "P": 60,
            "W": 414,
            "E": 0,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Machining",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "autonox-Robotics-articc6-2118-45kg-AT-00010": {
            "MT": "R",
            "N": "autonox Robotics articc6-2118-45kg (AT_00010)",
            "F": "autonox-Robotics-articc6-2118-45kg-AT-00010.robot",
            "I": "autonox-Robotics-articc6-2118-45kg-AT-00010-robot.png",
            "IS": "autonox-Robotics-articc6-2118-45kg-AT-00010.png",
            "B": "autonox Robotics",
            "M": "articc6-2118-45kg (AT_00010)",
            "T": "6 DOF",
            "A": 6,
            "R": 2118,
            "P": 45,
            "W": 417,
            "E": 0,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "autonox-Robotics-articc6-2257-30kg-AT-00006": {
            "MT": "R",
            "N": "autonox Robotics articc6-2257-30kg (AT_00006)",
            "F": "autonox-Robotics-articc6-2257-30kg-AT-00006.robot",
            "I": "autonox-Robotics-articc6-2257-30kg-AT-00006-robot.png",
            "IS": "autonox-Robotics-articc6-2257-30kg-AT-00006.png",
            "B": "autonox Robotics",
            "M": "articc6-2257-30kg (AT_00006)",
            "T": "6 DOF",
            "A": 6,
            "R": 2257,
            "P": 30,
            "W": 417,
            "E": 0,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "autonox-Robotics-articc6-2757-20kg-AT-00028": {
            "MT": "R",
            "N": "autonox Robotics articc6-2757-20kg (AT_00028)",
            "F": "autonox-Robotics-articc6-2757-20kg-AT-00028.robot",
            "I": "autonox-Robotics-articc6-2757-20kg-AT-00028-robot.png",
            "IS": "autonox-Robotics-articc6-2757-20kg-AT-00028.png",
            "B": "autonox Robotics",
            "M": "articc6-2757-20kg (AT_00028)",
            "T": "6 DOF",
            "A": 6,
            "R": 2757,
            "P": 20.0,
            "E": 0,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "autonox-Robotics-DELTA-RL3-600-1kg-A-00072-02": {
            "MT": "R",
            "N": "autonox Robotics DELTA RL3-600-1kg (A_00072-02)",
            "F": "autonox-Robotics-DELTA-RL3-600-1kg-A-00072-02.robot",
            "I": "autonox-Robotics-DELTA-RL3-600-1kg-A-00072-02-robot.png",
            "IS": "autonox-Robotics-DELTA-RL3-600-1kg-A-00072-02.png",
            "B": "autonox Robotics",
            "M": "DELTA RL3-600-1kg (A_00072-02)",
            "T": "Delta",
            "A": 3,
            "R": 600,
            "P": 1,
            "W": 23,
            "E": 0,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "autonox-Robotics-DELTA-RL3-600-3kg-A-00811-01": {
            "MT": "R",
            "N": "autonox Robotics DELTA RL3-600-3kg (A_00811-01)",
            "F": "autonox-Robotics-DELTA-RL3-600-3kg-A-00811-01.robot",
            "I": "autonox-Robotics-DELTA-RL3-600-3kg-A-00811-01-robot.png",
            "IS": "autonox-Robotics-DELTA-RL3-600-3kg-A-00811-01.png",
            "B": "autonox Robotics",
            "M": "DELTA RL3-600-3kg (A_00811-01)",
            "T": "Delta",
            "A": 3,
            "R": 600,
            "P": 3,
            "W": 29,
            "E": 0,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "autonox-Robotics-DELTA-RL3-600-3kg-AL-00001": {
            "MT": "R",
            "N": "autonox Robotics DELTA RL3-600-3kg (AL_00001)",
            "F": "autonox-Robotics-DELTA-RL3-600-3kg-AL-00001.robot",
            "I": "autonox-Robotics-DELTA-RL3-600-3kg-AL-00001-robot.png",
            "IS": "autonox-Robotics-DELTA-RL3-600-3kg-AL-00001.png",
            "B": "autonox Robotics",
            "M": "DELTA RL3-600-3kg (AL_00001)",
            "T": "Delta",
            "A": 3,
            "R": 600,
            "P": 3,
            "W": 24,
            "E": 0,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "BORUNTE-BRTIRUS-0707A-v21": {
            "MT": "R",
            "N": "BORUNTE BRTIRUS 0707A-v21",
            "F": "BORUNTE-BRTIRUS-0707A-v21.robot",
            "I": "BORUNTE-BRTIRUS-0707A-v21-robot.png",
            "IS": "BORUNTE-BRTIRUS-0707A-v21.png",
            "B": "BORUNTE",
            "M": "BRTIRUS 0707A-v21",
            "T": "6 DOF",
            "A": 6,
            "R": 700,
            "P": 7,
            "W": 55,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "BORUNTE-BRTIRUS-0805A": {
            "MT": "R",
            "N": "BORUNTE BRTIRUS 0805A",
            "F": "BORUNTE-BRTIRUS-0805A.robot",
            "I": "BORUNTE-BRTIRUS-0805A-robot.png",
            "IS": "BORUNTE-BRTIRUS-0805A.png",
            "B": "BORUNTE",
            "M": "BRTIRUS 0805A",
            "T": "6 DOF",
            "A": 6,
            "R": 990,
            "P": 5.0,
            "W": 53,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "BORUNTE-BRTIRUS-2110A": {
            "MT": "R",
            "N": "BORUNTE BRTIRUS 2110A",
            "F": "BORUNTE-BRTIRUS-2110A.robot",
            "I": "BORUNTE-BRTIRUS-2110A-robot.png",
            "IS": "BORUNTE-BRTIRUS-2110A.png",
            "B": "BORUNTE",
            "M": "BRTIRUS 2110A",
            "T": "6 DOF",
            "A": 6,
            "R": 2100,
            "P": 10.0,
            "W": 230,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "BORUNTE-BRTIRUS-18020A": {
            "MT": "R",
            "N": "BORUNTE BRTIRUS 18020A",
            "F": "BORUNTE-BRTIRUS-18020A.robot",
            "I": "BORUNTE-BRTIRUS-18020A-robot.png",
            "IS": "BORUNTE-BRTIRUS-18020A.png",
            "B": "BORUNTE",
            "M": "BRTIRUS 18020A",
            "T": "6 DOF",
            "A": 6,
            "R": 1850,
            "P": 20,
            "W": 220,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "BORUNTE-BRTIRUS2030A": {
            "MT": "R",
            "N": "BORUNTE BRTIRUS2030A",
            "F": "BORUNTE-BRTIRUS2030A.robot",
            "I": "BORUNTE-BRTIRUS2030A-robot.png",
            "IS": "BORUNTE-BRTIRUS2030A.png",
            "B": "BORUNTE",
            "M": "BRTIRUS2030A",
            "T": "6 DOF",
            "A": 6,
            "R": 2058,
            "P": 30.0,
            "W": 310,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Brooks-PAVP6": {
            "MT": "R",
            "N": "Brooks PAVP6",
            "F": "Brooks-PAVP6.robot",
            "I": "Brooks-PAVP6-robot.png",
            "IS": "Brooks-PAVP6.png",
            "B": "Brooks",
            "M": "PAVP6",
            "T": "6 DOF",
            "A": 6,
            "R": 432,
            "P": 2,
            "W": 28,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Brooks-PreciseFlex-400-400": {
            "MT": "R",
            "N": "Brooks PreciseFlex 400-400",
            "F": "Brooks-PreciseFlex-400-400.robot",
            "I": "Brooks-PreciseFlex-400-400-robot.png",
            "IS": "Brooks-PreciseFlex-400-400.png",
            "B": "Brooks",
            "M": "PreciseFlex 400-400",
            "T": "SCARA",
            "A": 4,
            "R": 433,
            "P": 1,
            "W": 20,
            "E": 0.09,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-400-750": {
            "MT": "R",
            "N": "Brooks PreciseFlex 400-750",
            "F": "Brooks-PreciseFlex-400-750.robot",
            "I": "Brooks-PreciseFlex-400-750-robot.png",
            "IS": "Brooks-PreciseFlex-400-750.png",
            "B": "Brooks",
            "M": "PreciseFlex 400-750",
            "T": "SCARA",
            "A": 4,
            "R": 433,
            "P": 1,
            "W": 25,
            "E": 0.09,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-400-1160": {
            "MT": "R",
            "N": "Brooks PreciseFlex 400-1160",
            "F": "Brooks-PreciseFlex-400-1160.robot",
            "I": "Brooks-PreciseFlex-400-1160-robot.png",
            "IS": "Brooks-PreciseFlex-400-1160.png",
            "B": "Brooks",
            "M": "PreciseFlex 400-1160",
            "T": "SCARA",
            "A": 4,
            "R": 433,
            "P": 1,
            "W": 60,
            "E": 0.09,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-3400-400": {
            "MT": "R",
            "N": "Brooks PreciseFlex 3400-400",
            "F": "Brooks-PreciseFlex-3400-400.robot",
            "I": "Brooks-PreciseFlex-3400-400-robot.png",
            "IS": "Brooks-PreciseFlex-3400-400.png",
            "B": "Brooks",
            "M": "PreciseFlex 3400-400",
            "T": "SCARA",
            "A": 4,
            "R": 587,
            "P": 3,
            "W": 20,
            "E": 0.09,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-3400-750": {
            "MT": "R",
            "N": "Brooks PreciseFlex 3400-750",
            "F": "Brooks-PreciseFlex-3400-750.robot",
            "I": "Brooks-PreciseFlex-3400-750-robot.png",
            "IS": "Brooks-PreciseFlex-3400-750.png",
            "B": "Brooks",
            "M": "PreciseFlex 3400-750",
            "T": "SCARA",
            "A": 4,
            "R": 587,
            "P": 3,
            "W": 25,
            "E": 0.09,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-3400-1160": {
            "MT": "R",
            "N": "Brooks PreciseFlex 3400-1160",
            "F": "Brooks-PreciseFlex-3400-1160.robot",
            "I": "Brooks-PreciseFlex-3400-1160-robot.png",
            "IS": "Brooks-PreciseFlex-3400-1160.png",
            "B": "Brooks",
            "M": "PreciseFlex 3400-1160",
            "T": "SCARA",
            "A": 4,
            "R": 587,
            "P": 3,
            "W": 30,
            "E": 0.09,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-c3-400": {
            "MT": "R",
            "N": "Brooks PreciseFlex c3-400",
            "F": "Brooks-PreciseFlex-c3-400.robot",
            "I": "Brooks-PreciseFlex-c3-400-robot.png",
            "IS": "Brooks-PreciseFlex-c3-400.png",
            "B": "Brooks",
            "M": "PreciseFlex c3-400",
            "T": "SCARA",
            "A": 4,
            "R": 432.6,
            "P": 3,
            "W": 22,
            "E": 0.09,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-c3-750": {
            "MT": "R",
            "N": "Brooks PreciseFlex c3-750",
            "F": "Brooks-PreciseFlex-c3-750.robot",
            "I": "Brooks-PreciseFlex-c3-750-robot.png",
            "IS": "Brooks-PreciseFlex-c3-750.png",
            "B": "Brooks",
            "M": "PreciseFlex c3-750",
            "T": "SCARA",
            "A": 4,
            "R": 432.6,
            "P": 3,
            "W": 27,
            "E": 0.09,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-c3-1160": {
            "MT": "R",
            "N": "Brooks PreciseFlex c3-1160",
            "F": "Brooks-PreciseFlex-c3-1160.robot",
            "I": "Brooks-PreciseFlex-c3-1160-robot.png",
            "IS": "Brooks-PreciseFlex-c3-1160.png",
            "B": "Brooks",
            "M": "PreciseFlex c3-1160",
            "T": "SCARA",
            "A": 4,
            "R": 432.6,
            "P": 3,
            "W": 37,
            "E": 0.09,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-c3x-400": {
            "MT": "R",
            "N": "Brooks PreciseFlex c3x-400",
            "F": "Brooks-PreciseFlex-c3x-400.robot",
            "I": "Brooks-PreciseFlex-c3x-400-robot.png",
            "IS": "Brooks-PreciseFlex-c3x-400.png",
            "B": "Brooks",
            "M": "PreciseFlex c3x-400",
            "T": "SCARA",
            "A": 4,
            "R": 587.8,
            "P": 3,
            "W": 27,
            "E": 0.09,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-c3x-750": {
            "MT": "R",
            "N": "Brooks PreciseFlex c3x-750",
            "F": "Brooks-PreciseFlex-c3x-750.robot",
            "I": "Brooks-PreciseFlex-c3x-750-robot.png",
            "IS": "Brooks-PreciseFlex-c3x-750.png",
            "B": "Brooks",
            "M": "PreciseFlex c3x-750",
            "T": "SCARA",
            "A": 4,
            "R": 587.8,
            "P": 3,
            "W": 32,
            "E": 0.09,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-c3x-1160": {
            "MT": "R",
            "N": "Brooks PreciseFlex c3x-1160",
            "F": "Brooks-PreciseFlex-c3x-1160.robot",
            "I": "Brooks-PreciseFlex-c3x-1160-robot.png",
            "IS": "Brooks-PreciseFlex-c3x-1160.png",
            "B": "Brooks",
            "M": "PreciseFlex c3x-1160",
            "T": "SCARA",
            "A": 4,
            "R": 587,
            "P": 3,
            "W": 30,
            "E": 0.09,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-c5-400": {
            "MT": "R",
            "N": "Brooks PreciseFlex c5-400",
            "F": "Brooks-PreciseFlex-c5-400.robot",
            "I": "Brooks-PreciseFlex-c5-400-robot.png",
            "IS": "Brooks-PreciseFlex-c5-400.png",
            "B": "Brooks",
            "M": "PreciseFlex c5-400",
            "T": "SCARA",
            "A": 4,
            "R": 721.2,
            "P": 5,
            "W": 28.8,
            "E": 0.09,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-c5-750": {
            "MT": "R",
            "N": "Brooks PreciseFlex c5-750",
            "F": "Brooks-PreciseFlex-c5-750.robot",
            "I": "Brooks-PreciseFlex-c5-750-robot.png",
            "IS": "Brooks-PreciseFlex-c5-750.png",
            "B": "Brooks",
            "M": "PreciseFlex c5-750",
            "T": "SCARA",
            "A": 4,
            "R": 721.2,
            "P": 5,
            "W": 34.5,
            "E": 0.09,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-c5-1160": {
            "MT": "R",
            "N": "Brooks PreciseFlex c5-1160",
            "F": "Brooks-PreciseFlex-c5-1160.robot",
            "I": "Brooks-PreciseFlex-c5-1160-robot.png",
            "IS": "Brooks-PreciseFlex-c5-1160.png",
            "B": "Brooks",
            "M": "PreciseFlex c5-1160",
            "T": "SCARA",
            "A": 4,
            "R": 721.2,
            "P": 5,
            "W": 41.9,
            "E": 0.09,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-c8A-500": {
            "MT": "R",
            "N": "Brooks PreciseFlex c8A-500",
            "F": "Brooks-PreciseFlex-c8A-500.rdka",
            "I": "Brooks-PreciseFlex-c8A-500-robot.png",
            "IS": "Brooks-PreciseFlex-c8A-500.png",
            "B": "Brooks",
            "M": "PreciseFlex c8A-500",
            "T": "SCARA",
            "A": 4,
            "R": 1963,
            "P": 8,
            "W": 46.0,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-c8A-1000": {
            "MT": "R",
            "N": "Brooks PreciseFlex c8A-1000",
            "F": "Brooks-PreciseFlex-c8A-1000.rdka",
            "I": "Brooks-PreciseFlex-c8A-1000-robot.png",
            "IS": "Brooks-PreciseFlex-c8A-1000.png",
            "B": "Brooks",
            "M": "PreciseFlex c8A-1000",
            "T": "SCARA",
            "A": 4,
            "R": 1963,
            "P": 8,
            "W": 55.0,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-c8A-1420": {
            "MT": "R",
            "N": "Brooks PreciseFlex c8A-1420",
            "F": "Brooks-PreciseFlex-c8A-1420.rdka",
            "I": "Brooks-PreciseFlex-c8A-1420-robot.png",
            "IS": "Brooks-PreciseFlex-c8A-1420.png",
            "B": "Brooks",
            "M": "PreciseFlex c8A-1420",
            "T": "SCARA",
            "A": 4,
            "R": 1963,
            "P": 8,
            "W": 65.0,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-c10-500": {
            "MT": "R",
            "N": "Brooks PreciseFlex c10-500",
            "F": "Brooks-PreciseFlex-c10-500.robot",
            "I": "Brooks-PreciseFlex-c10-500-robot.png",
            "IS": "Brooks-PreciseFlex-c10-500.png",
            "B": "Brooks",
            "M": "PreciseFlex c10-500",
            "T": "SCARA",
            "A": 4,
            "R": 1789,
            "P": 10,
            "W": 44,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-c10-1000": {
            "MT": "R",
            "N": "Brooks PreciseFlex c10-1000",
            "F": "Brooks-PreciseFlex-c10-1000.robot",
            "I": "Brooks-PreciseFlex-c10-1000-robot.png",
            "IS": "Brooks-PreciseFlex-c10-1000.png",
            "B": "Brooks",
            "M": "PreciseFlex c10-1000",
            "T": "SCARA",
            "A": 4,
            "R": 1789,
            "P": 10,
            "W": 53,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-c10-1420": {
            "MT": "R",
            "N": "Brooks PreciseFlex c10-1420",
            "F": "Brooks-PreciseFlex-c10-1420.robot",
            "I": "Brooks-PreciseFlex-c10-1420-robot.png",
            "IS": "Brooks-PreciseFlex-c10-1420.png",
            "B": "Brooks",
            "M": "PreciseFlex c10-1420",
            "T": "SCARA",
            "A": 4,
            "R": 1789,
            "P": 10,
            "W": 63,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-DD-4-axis-500": {
            "MT": "R",
            "N": "Brooks PreciseFlex DD 4-axis 500",
            "F": "Brooks-PreciseFlex-DD-4-axis-500.robot",
            "I": "Brooks-PreciseFlex-DD-4-axis-500-robot.png",
            "IS": "Brooks-PreciseFlex-DD-4-axis-500.png",
            "B": "Brooks",
            "M": "PreciseFlex DD 4-axis 500",
            "T": "SCARA",
            "A": 4,
            "R": 1793,
            "P": 8,
            "W": 44,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-DD-4-axis-1000": {
            "MT": "R",
            "N": "Brooks PreciseFlex DD 4-axis 1000",
            "F": "Brooks-PreciseFlex-DD-4-axis-1000.robot",
            "I": "Brooks-PreciseFlex-DD-4-axis-1000-robot.png",
            "IS": "Brooks-PreciseFlex-DD-4-axis-1000.png",
            "B": "Brooks",
            "M": "PreciseFlex DD 4-axis 1000",
            "T": "SCARA",
            "A": 4,
            "R": 1793,
            "P": 8,
            "W": 53,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Brooks-PreciseFlex-DD-4-axis-1420": {
            "MT": "R",
            "N": "Brooks PreciseFlex DD 4-axis 1420",
            "F": "Brooks-PreciseFlex-DD-4-axis-1420.robot",
            "I": "Brooks-PreciseFlex-DD-4-axis-1420-robot.png",
            "IS": "Brooks-PreciseFlex-DD-4-axis-1420.png",
            "B": "Brooks",
            "M": "PreciseFlex DD 4-axis 1420",
            "T": "SCARA",
            "A": 4,
            "R": 1793,
            "P": 8,
            "W": 63,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Chiehey-SR5-1600": {
            "MT": "R",
            "N": "Chiehey SR5-1600",
            "F": "Chiehey-SR5-1600.robot",
            "I": "Chiehey-SR5-1600-robot.png",
            "IS": "Chiehey-SR5-1600.png",
            "B": "Chiehey",
            "M": "SR5-1600",
            "T": "6 DOF",
            "A": 6,
            "R": 1600,
            "P": 5,
            "W": 150,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Chiehey-SR8-2600": {
            "MT": "R",
            "N": "Chiehey SR8-2600",
            "F": "Chiehey-SR8-2600.robot",
            "I": "Chiehey-SR8-2600-robot.png",
            "IS": "Chiehey-SR8-2600.png",
            "B": "Chiehey",
            "M": "SR8-2600",
            "T": "6 DOF",
            "A": 6,
            "R": 2600,
            "P": 8,
            "W": 350,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Chiehey-SR10-3800": {
            "MT": "R",
            "N": "Chiehey SR10-3800",
            "F": "Chiehey-SR10-3800.robot",
            "I": "Chiehey-SR10-3800-robot.png",
            "IS": "Chiehey-SR10-3800.png",
            "B": "Chiehey",
            "M": "SR10-3800",
            "T": "6 DOF",
            "A": 6,
            "R": 3800,
            "P": 10,
            "W": 650,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Chiehey-SR12-2000": {
            "MT": "R",
            "N": "Chiehey SR12-2000",
            "F": "Chiehey-SR12-2000.robot",
            "I": "Chiehey-SR12-2000-robot.png",
            "IS": "Chiehey-SR12-2000.png",
            "B": "Chiehey",
            "M": "SR12-2000",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 15,
            "W": 330,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Chiehey-SR12-3200": {
            "MT": "R",
            "N": "Chiehey SR12-3200",
            "F": "Chiehey-SR12-3200.robot",
            "I": "Chiehey-SR12-3200-robot.png",
            "IS": "Chiehey-SR12-3200.png",
            "B": "Chiehey",
            "M": "SR12-3200",
            "T": "6 DOF",
            "A": 6,
            "R": 3200,
            "P": 15,
            "W": 620,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "CLOOS-QIROX-QRC-350": {
            "MT": "R",
            "N": "CLOOS QIROX QRC-350",
            "F": "CLOOS-QIROX-QRC-350.robot",
            "I": "CLOOS-QIROX-QRC-350-robot.png",
            "IS": "CLOOS-QIROX-QRC-350.png",
            "B": "CLOOS",
            "M": "QIROX QRC-350",
            "T": "6 DOF",
            "A": 6,
            "R": 1711,
            "P": 15,
            "W": 220,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "CLOOS-Romat-310": {
            "MT": "R",
            "N": "CLOOS Romat 310",
            "F": "CLOOS-Romat-310.robot",
            "I": "CLOOS-Romat-310-robot.png",
            "IS": "CLOOS-Romat-310.png",
            "B": "CLOOS",
            "M": "Romat 310",
            "T": "6 DOF",
            "A": 6,
            "R": 1540,
            "P": 10,
            "W": 245,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "CLOOS-QIROX-QRC-350-E": {
            "MT": "R",
            "N": "CLOOS QIROX QRC-350-E",
            "F": "CLOOS-QIROX-QRC-350-E.rdka",
            "I": "CLOOS-QIROX-QRC-350-E-robot.png",
            "IS": "CLOOS-QIROX-QRC-350-E.png",
            "B": "CLOOS",
            "M": "QIROX QRC-350-E",
            "T": "7 DOF",
            "A": 7,
            "R": 2261,
            "P": 15,
            "W": 340,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Codian-D2-1000": {
            "MT": "R",
            "N": "Codian D2-1000",
            "F": "Codian-D2-1000.robot",
            "I": "Codian-D2-1000-robot.png",
            "IS": "Codian-D2-1000.png",
            "B": "Codian Robotics",
            "M": "D2-1000",
            "T": "Delta",
            "A": 3,
            "R": 500,
            "P": 30,
            "W": 75,
            "E": 0.3,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Codian-D2-1500-S030": {
            "MT": "R",
            "N": "Codian D2-1500-S030",
            "F": "Codian-D2-1500-S030.robot",
            "I": "Codian-D2-1500-S030-robot.png",
            "IS": "Codian-D2-1500-S030.png",
            "B": "Codian Robotics",
            "M": "D2-1500-S030",
            "T": "Delta",
            "A": 3,
            "R": 1500,
            "P": 30,
            "W": 75,
            "E": 0.2,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Codian-D2-1500-S060": {
            "MT": "R",
            "N": "Codian D2-1500-S060",
            "F": "Codian-D2-1500-S060.robot",
            "I": "Codian-D2-1500-S060-robot.png",
            "IS": "Codian-D2-1500-S060.png",
            "B": "Codian Robotics",
            "M": "D2-1500-S060",
            "T": "Delta",
            "A": 3,
            "R": 1500,
            "P": 60,
            "W": 75,
            "E": 0.2,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Codian-D4-500-S010": {
            "MT": "R",
            "N": "Codian D4-500-S010",
            "F": "Codian-D4-500-S010.robot",
            "I": "Codian-D4-500-S010-robot.png",
            "IS": "Codian-D4-500-S010.png",
            "B": "Codian Robotics",
            "M": "D4-500-S010",
            "T": "Delta",
            "A": 4,
            "R": 500,
            "P": 2,
            "W": 100,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Codian-D4-800-S020": {
            "MT": "R",
            "N": "Codian D4-800-S020",
            "F": "Codian-D4-800-S020.robot",
            "I": "Codian-D4-800-S020-robot.png",
            "IS": "Codian-D4-800-S020.png",
            "B": "Codian Robotics",
            "M": "D4-800-S020",
            "T": "Delta",
            "A": 4,
            "R": 800,
            "P": 3,
            "W": 100,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Codian-D4-1100-S020": {
            "MT": "R",
            "N": "Codian D4-1100-S020",
            "F": "Codian-D4-1100-S020.robot",
            "I": "Codian-D4-1100-S020-robot.png",
            "IS": "Codian-D4-1100-S020.png",
            "B": "Codian Robotics",
            "M": "D4-1100-S020",
            "T": "Delta",
            "A": 4,
            "R": 1100,
            "P": 3,
            "W": 100,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Codian-D4-1300-S050": {
            "MT": "R",
            "N": "Codian D4-1300-S050",
            "F": "Codian-D4-1300-S050.robot",
            "I": "Codian-D4-1300-S050-robot.png",
            "IS": "Codian-D4-1300-S050.png",
            "B": "Codian Robotics",
            "M": "D4-1300-S050",
            "T": "Delta",
            "A": 4,
            "R": 1300,
            "P": 35,
            "W": 100,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Codian-D4-1600-S040L": {
            "MT": "R",
            "N": "Codian D4-1600-S040L",
            "F": "Codian-D4-1600-S040L.robot",
            "I": "Codian-D4-1600-S040L-robot.png",
            "IS": "Codian-D4-1600-S040L.png",
            "B": "Codian Robotics",
            "M": "D4-1600-S040L",
            "T": "Delta",
            "A": 4,
            "R": 1600,
            "P": 8,
            "W": 100,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Codian-D5-800": {
            "MT": "R",
            "N": "Codian D5-800",
            "F": "Codian-D5-800.robot",
            "I": "Codian-D5-800-robot.png",
            "IS": "Codian-D5-800.png",
            "B": "Codian Robotics",
            "M": "D5-800",
            "T": "Delta",
            "A": 5,
            "R": 500,
            "P": 3,
            "W": 100,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Codian-D5-1100": {
            "MT": "R",
            "N": "Codian D5-1100",
            "F": "Codian-D5-1100.robot",
            "I": "Codian-D5-1100-robot.png",
            "IS": "Codian-D5-1100.png",
            "B": "Codian Robotics",
            "M": "D5-1100",
            "T": "Delta",
            "A": 5,
            "R": 500,
            "P": 3,
            "W": 100,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Comau-Aura-170-2-8": {
            "MT": "R",
            "N": "Comau Aura 170-2.8",
            "F": "Comau-Aura-170-2-8.robot",
            "I": "Comau-Aura-170-2-8-robot.png",
            "IS": "Comau-Aura-170-2-8.png",
            "B": "Comau",
            "M": "Aura 170-2.8",
            "T": "6 DOF",
            "A": 6,
            "R": 2790,
            "P": 170,
            "W": 1615,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-e-DO": {
            "MT": "R",
            "N": "Comau e.DO",
            "F": "Comau-e-DO.robot",
            "I": "Comau-e-DO-robot.png",
            "IS": "Comau-e-DO.png",
            "B": "Comau",
            "M": "e.DO",
            "T": "6 DOF",
            "A": 6,
            "R": 478,
            "P": 6.0,
            "W": 11.1,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Comau-e-DO-alternate-version": {
            "MT": "R",
            "N": "Comau e.DO alternate version",
            "F": "Comau-e-DO-alternate-version.robot",
            "I": "Comau-e-DO-alternate-version-robot.png",
            "IS": "Comau-e-DO-alternate-version.png",
            "B": "Comau",
            "M": "e.DO alternate version",
            "T": "6 DOF",
            "A": 6,
            "R": 478,
            "P": 6.0,
            "W": 11.1,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Comau-MyCo-3-5-0-95": {
            "MT": "R",
            "N": "Comau MyCo-3.5-0.95",
            "F": "Comau-MyCo-3-5-0-95.robot",
            "I": "Comau-MyCo-3-5-0-95-robot.png",
            "IS": "Comau-MyCo-3-5-0-95.png",
            "B": "Comau",
            "M": "MyCo-3.5-0.95",
            "T": "6 DOF",
            "A": 6,
            "R": 950,
            "P": 3.5,
            "W": 26,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Comau-MyCo-3-0-59": {
            "MT": "R",
            "N": "Comau MyCo-3-0.59",
            "F": "Comau-MyCo-3-0-59.robot",
            "I": "Comau-MyCo-3-0-59-robot.png",
            "IS": "Comau-MyCo-3-0-59.png",
            "B": "Comau",
            "M": "MyCo-3-0.59",
            "T": "6 DOF",
            "A": 6,
            "R": 590,
            "P": 3,
            "W": 18,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Comau-MyCo-5-0-80": {
            "MT": "R",
            "N": "Comau MyCo-5-0.80",
            "F": "Comau-MyCo-5-0-80.robot",
            "I": "Comau-MyCo-5-0-80-robot.png",
            "IS": "Comau-MyCo-5-0-80.png",
            "B": "Comau",
            "M": "MyCo-5-0.80",
            "T": "6 DOF",
            "A": 6,
            "R": 800,
            "P": 5,
            "W": 25,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Comau-MyCo-8-1-30": {
            "MT": "R",
            "N": "Comau MyCo-8-1.30",
            "F": "Comau-MyCo-8-1-30.robot",
            "I": "Comau-MyCo-8-1-30-robot.png",
            "IS": "Comau-MyCo-8-1-30.png",
            "B": "Comau",
            "M": "MyCo-8-1.30",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 8,
            "W": 45,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Comau-MyCo-10-1-00": {
            "MT": "R",
            "N": "Comau MyCo-10-1.00",
            "F": "Comau-MyCo-10-1-00.robot",
            "I": "Comau-MyCo-10-1-00-robot.png",
            "IS": "Comau-MyCo-10-1-00.png",
            "B": "Comau",
            "M": "MyCo-10-1.00",
            "T": "6 DOF",
            "A": 6,
            "R": 1000,
            "P": 10,
            "W": 43,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Comau-MyCo-15-1-30": {
            "MT": "R",
            "N": "Comau MyCo-15-1.30",
            "F": "Comau-MyCo-15-1-30.robot",
            "I": "Comau-MyCo-15-1-30-robot.png",
            "IS": "Comau-MyCo-15-1-30.png",
            "B": "Comau",
            "M": "MyCo-15-1.30",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 15,
            "W": 60,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Comau-N-170-3-0": {
            "MT": "R",
            "N": "Comau N-170-3.0",
            "F": "Comau-N-170-3-0.robot",
            "I": "Comau-N-170-3-0-robot.png",
            "IS": "Comau-N-170-3-0.png",
            "B": "Comau",
            "M": "N-170-3.0",
            "T": "6 DOF",
            "A": 6,
            "R": 3000,
            "P": 170,
            "W": 1277,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-N-220-2-6-ceiling": {
            "MT": "R",
            "N": "Comau N-220-2.6-ceiling",
            "F": "Comau-N-220-2-6-ceiling.robot",
            "I": "Comau-N-220-2-6-ceiling-robot.png",
            "IS": "Comau-N-220-2-6-ceiling.png",
            "B": "Comau",
            "M": "N-220-2.6-ceiling",
            "T": "6 DOF",
            "A": 6,
            "R": 2595,
            "P": 220,
            "W": 1250,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-N-220-2-7": {
            "MT": "R",
            "N": "Comau N-220-2.7",
            "F": "Comau-N-220-2-7.robot",
            "I": "Comau-N-220-2-7-robot.png",
            "IS": "Comau-N-220-2-7.png",
            "B": "Comau",
            "M": "N-220-2.7",
            "T": "6 DOF",
            "A": 6,
            "R": 2670,
            "P": 220,
            "W": 1193,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-NJ-370-3-0": {
            "MT": "R",
            "N": "Comau NJ 370-3.0",
            "F": "Comau-NJ-370-3-0.robot",
            "I": "Comau-NJ-370-3-0-robot.png",
            "IS": "Comau-NJ-370-3-0.png",
            "B": "Comau",
            "M": "NJ 370-3.0",
            "T": "6 DOF",
            "A": 6,
            "R": 3020,
            "P": 370,
            "W": 2450,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-NJ-650-2-7": {
            "MT": "R",
            "N": "Comau NJ 650-2.7",
            "F": "Comau-NJ-650-2-7.robot",
            "I": "Comau-NJ-650-2-7-robot.png",
            "IS": "Comau-NJ-650-2-7.png",
            "B": "Comau",
            "M": "NJ 650-2.7",
            "T": "6 DOF",
            "A": 6,
            "R": 2715,
            "P": 650,
            "W": 2703,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-NS-12-1-85": {
            "MT": "R",
            "N": "Comau NS 12-1.85",
            "F": "Comau-NS-12-1-85.robot",
            "I": "Comau-NS-12-1-85-robot.png",
            "IS": "Comau-NS-12-1-85.png",
            "B": "Comau",
            "M": "NS 12-1.85",
            "T": "6 DOF",
            "A": 6,
            "R": 1850,
            "P": 12,
            "W": 335,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Comau-NS-16-1-65": {
            "MT": "R",
            "N": "Comau NS 16-1.65",
            "F": "Comau-NS-16-1-65.robot",
            "I": "Comau-NS-16-1-65-robot.png",
            "IS": "Comau-NS-16-1-65.png",
            "B": "Comau",
            "M": "NS 16-1.65",
            "T": "6 DOF",
            "A": 6,
            "R": 1650,
            "P": 16,
            "W": 335,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Comau-Racer-3": {
            "MT": "R",
            "N": "Comau Racer 3",
            "F": "Comau-Racer-3.robot",
            "I": "Comau-Racer-3-robot.png",
            "IS": "Comau-Racer-3.png",
            "B": "Comau",
            "M": "Racer 3",
            "T": "6 DOF",
            "A": 6,
            "R": 630,
            "P": 3,
            "W": 30,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Comau-Racer-5-0-63": {
            "MT": "R",
            "N": "Comau Racer 5-0.63",
            "F": "Comau-Racer-5-0-63.robot",
            "I": "Comau-Racer-5-0-63-robot.png",
            "IS": "Comau-Racer-5-0-63.png",
            "B": "Comau",
            "M": "Racer 5-0.63",
            "T": "6 DOF",
            "A": 6,
            "R": 630,
            "P": 5.0,
            "W": 30,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Comau-Racer-5-0-80-COBOT": {
            "MT": "R",
            "N": "Comau Racer 5-0.80 COBOT",
            "F": "Comau-Racer-5-0-80-COBOT.robot",
            "I": "Comau-Racer-5-0-80-COBOT-robot.png",
            "IS": "Comau-Racer-5-0-80-COBOT.png",
            "B": "Comau",
            "M": "Racer 5-0.80 COBOT",
            "T": "6 DOF",
            "A": 6,
            "R": 809,
            "P": 5,
            "W": 34,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Comau-Racer-5-0-80": {
            "MT": "R",
            "N": "Comau Racer 5-0.80",
            "F": "Comau-Racer-5-0-80.robot",
            "I": "Comau-Racer-5-0-80-robot.png",
            "IS": "Comau-Racer-5-0-80.png",
            "B": "Comau",
            "M": "Racer 5-0.80",
            "T": "6 DOF",
            "A": 6,
            "R": 809.17,
            "P": 5,
            "W": 32,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Comau-Racer-7-1-4": {
            "MT": "R",
            "N": "Comau Racer 7-1.4",
            "F": "Comau-Racer-7-1-4.robot",
            "I": "Comau-Racer-7-1-4-robot.png",
            "IS": "Comau-Racer-7-1-4.png",
            "B": "Comau",
            "M": "Racer 7-1.4",
            "T": "6 DOF",
            "A": 6,
            "R": 1436,
            "P": 7,
            "W": 180,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Comau-S-13": {
            "MT": "R",
            "N": "Comau S-13",
            "F": "Comau-S-13.robot",
            "I": "Comau-S-13-robot.png",
            "IS": "Comau-S-13.png",
            "B": "Comau",
            "M": "S-13",
            "T": "6 DOF",
            "A": 6,
            "R": 1960,
            "P": 13.0,
            "W": 270,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Comau-S-18": {
            "MT": "R",
            "N": "Comau S-18",
            "F": "Comau-S-18.robot",
            "I": "Comau-S-18-robot.png",
            "IS": "Comau-S-18.png",
            "B": "Comau",
            "M": "S-18",
            "T": "6 DOF",
            "A": 6,
            "R": 1730,
            "P": 18.0,
            "W": 265,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Comau-Smart-NJ-40-2-5": {
            "MT": "R",
            "N": "Comau Smart NJ 40-2.5",
            "F": "Comau-Smart-NJ-40-2-5.robot",
            "I": "Comau-Smart-NJ-40-2-5-robot.png",
            "IS": "Comau-Smart-NJ-40-2-5.png",
            "B": "Comau",
            "M": "Smart NJ 40-2.5",
            "T": "6 DOF",
            "A": 6,
            "R": 2503,
            "P": 40,
            "W": 655,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart-NM-16-3-1": {
            "MT": "R",
            "N": "Comau Smart NM 16-3.1",
            "F": "Comau-Smart-NM-16-3-1.robot",
            "I": "Comau-Smart-NM-16-3-1-robot.png",
            "IS": "Comau-Smart-NM-16-3-1.png",
            "B": "Comau",
            "M": "Smart NM 16-3.1",
            "T": "6 DOF",
            "A": 6,
            "R": 3108,
            "P": 16,
            "W": 680,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Comau-Smart-NM-45-2-0": {
            "MT": "R",
            "N": "Comau Smart NM 45-2.0",
            "F": "Comau-Smart-NM-45-2-0.robot",
            "I": "Comau-Smart-NM-45-2-0-robot.png",
            "IS": "Comau-Smart-NM-45-2-0.png",
            "B": "Comau",
            "M": "Smart NM 45-2.0",
            "T": "6 DOF",
            "A": 6,
            "R": 2240,
            "P": 45,
            "W": 680,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart-SiX-6-1-4": {
            "MT": "R",
            "N": "Comau Smart SiX 6-1.4",
            "F": "Comau-Smart-SiX-6-1-4.robot",
            "I": "Comau-Smart-SiX-6-1-4-robot.png",
            "IS": "Comau-Smart-SiX-6-1-4.png",
            "B": "Comau",
            "M": "Smart SiX 6-1.4",
            "T": "6 DOF",
            "A": 6,
            "R": 1400,
            "P": 6,
            "W": 160,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Comau-Smart5-NJ-16-3-1": {
            "MT": "R",
            "N": "Comau Smart5 NJ 16-3.1",
            "F": "Comau-Smart5-NJ-16-3-1.robot",
            "I": "Comau-Smart5-NJ-16-3-1-robot.png",
            "IS": "Comau-Smart5-NJ-16-3-1.png",
            "B": "Comau",
            "M": "Smart5 NJ 16-3.1",
            "T": "6 DOF",
            "A": 6,
            "R": 3108,
            "P": 16,
            "W": 680,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Comau-Smart5-NJ-40-2-5": {
            "MT": "R",
            "N": "Comau Smart5 NJ 40-2.5",
            "F": "Comau-Smart5-NJ-40-2-5.robot",
            "I": "Comau-Smart5-NJ-40-2-5-robot.png",
            "IS": "Comau-Smart5-NJ-40-2-5.png",
            "B": "Comau",
            "M": "Smart5 NJ 40-2.5",
            "T": "6 DOF",
            "A": 6,
            "R": 2503,
            "P": 40,
            "W": 655,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart5-NJ-60-2-2-Off-set-Bending": {
            "MT": "R",
            "N": "Comau Smart5 NJ 60-2.2 Off-set Bending",
            "F": "Comau-Smart5-NJ-60-2-2-Off-set-Bending.robot",
            "I": "Comau-Smart5-NJ-60-2-2-Off-set-Bending-robot.png",
            "IS": "Comau-Smart5-NJ-60-2-2-Off-set-Bending.png",
            "B": "Comau",
            "M": "Smart5 NJ 60-2.2 Off-set Bending",
            "T": "6 DOF",
            "A": 6,
            "R": 2503,
            "P": 60,
            "W": 645,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart5-NJ-60-2-2": {
            "MT": "R",
            "N": "Comau Smart5 NJ 60-2.2",
            "F": "Comau-Smart5-NJ-60-2-2.robot",
            "I": "Comau-Smart5-NJ-60-2-2-robot.png",
            "IS": "Comau-Smart5-NJ-60-2-2.png",
            "B": "Comau",
            "M": "Smart5 NJ 60-2.2",
            "T": "6 DOF",
            "A": 6,
            "R": 2503,
            "P": 60,
            "W": 645,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart5-NJ-100-3-2-PRESS": {
            "MT": "R",
            "N": "Comau Smart5 NJ 100-3.2 PRESS",
            "F": "Comau-Smart5-NJ-100-3-2-PRESS.robot",
            "I": "Comau-Smart5-NJ-100-3-2-PRESS-robot.png",
            "IS": "Comau-Smart5-NJ-100-3-2-PRESS.png",
            "B": "Comau",
            "M": "Smart5 NJ 100-3.2 PRESS",
            "T": "6 DOF",
            "A": 6,
            "R": 3209,
            "P": 100,
            "W": 1250,
            "E": 0.17,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart5-NJ-110-3-0": {
            "MT": "R",
            "N": "Comau Smart5 NJ 110-3.0",
            "F": "Comau-Smart5-NJ-110-3-0.robot",
            "I": "Comau-Smart5-NJ-110-3-0-robot.png",
            "IS": "Comau-Smart5-NJ-110-3-0.png",
            "B": "Comau",
            "M": "Smart5 NJ 110-3.0",
            "T": "6 DOF",
            "A": 6,
            "R": 2980,
            "P": 110,
            "W": 1070,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart5-NJ-130-2-0": {
            "MT": "R",
            "N": "Comau Smart5 NJ 130-2.0",
            "F": "Comau-Smart5-NJ-130-2-0.robot",
            "I": "Comau-Smart5-NJ-130-2-0-robot.png",
            "IS": "Comau-Smart5-NJ-130-2-0.png",
            "B": "Comau",
            "M": "Smart5 NJ 130-2.0",
            "T": "6 DOF",
            "A": 6,
            "R": 2050,
            "P": 130,
            "W": 1050,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart5-NJ-130-2-6": {
            "MT": "R",
            "N": "Comau Smart5 NJ 130-2.6",
            "F": "Comau-Smart5-NJ-130-2-6.robot",
            "I": "Comau-Smart5-NJ-130-2-6-robot.png",
            "IS": "Comau-Smart5-NJ-130-2-6.png",
            "B": "Comau",
            "M": "Smart5 NJ 130-2.6",
            "T": "6 DOF",
            "A": 6,
            "R": 2616,
            "P": 130,
            "W": 1050,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart5-NJ-130-3-7-SH": {
            "MT": "R",
            "N": "Comau Smart5 NJ 130-3.7 SH",
            "F": "Comau-Smart5-NJ-130-3-7-SH.robot",
            "I": "Comau-Smart5-NJ-130-3-7-SH-robot.png",
            "IS": "Comau-Smart5-NJ-130-3-7-SH.png",
            "B": "Comau",
            "M": "Smart5 NJ 130-3.7 SH",
            "T": "6 DOF",
            "A": 6,
            "R": 3741,
            "P": 130,
            "W": 1520,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart5-NJ-165-3-0": {
            "MT": "R",
            "N": "Comau Smart5 NJ 165-3.0",
            "F": "Comau-Smart5-NJ-165-3-0.robot",
            "I": "Comau-Smart5-NJ-165-3-0-robot.png",
            "IS": "Comau-Smart5-NJ-165-3-0.png",
            "B": "Comau",
            "M": "Smart5 NJ 165-3.0",
            "T": "6 DOF",
            "A": 6,
            "R": 3000,
            "P": 165,
            "W": 1240,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart5-NJ-165-3-4-SH": {
            "MT": "R",
            "N": "Comau Smart5 NJ 165-3.4 SH",
            "F": "Comau-Smart5-NJ-165-3-4-SH.robot",
            "I": "Comau-Smart5-NJ-165-3-4-SH-robot.png",
            "IS": "Comau-Smart5-NJ-165-3-4-SH.png",
            "B": "Comau",
            "M": "Smart5 NJ 165-3.4 SH",
            "T": "6 DOF",
            "A": 6,
            "R": 3450,
            "P": 165,
            "W": 1430,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart5-NJ-210-3-1-SH": {
            "MT": "R",
            "N": "Comau Smart5 NJ 210-3.1 SH",
            "F": "Comau-Smart5-NJ-210-3-1-SH.robot",
            "I": "Comau-Smart5-NJ-210-3-1-SH-robot.png",
            "IS": "Comau-Smart5-NJ-210-3-1-SH.png",
            "B": "Comau",
            "M": "Smart5 NJ 210-3.1 SH",
            "T": "6 DOF",
            "A": 6,
            "R": 3151,
            "P": 210,
            "W": 1415,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart5-NJ-220-2-7": {
            "MT": "R",
            "N": "Comau Smart5 NJ 220-2.7",
            "F": "Comau-Smart5-NJ-220-2-7.robot",
            "I": "Comau-Smart5-NJ-220-2-7-robot.png",
            "IS": "Comau-Smart5-NJ-220-2-7.png",
            "B": "Comau",
            "M": "Smart5 NJ 220-2.7",
            "T": "6 DOF",
            "A": 6,
            "R": 2700,
            "P": 220,
            "W": 1220,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart5-NJ-290-3-0": {
            "MT": "R",
            "N": "Comau Smart5 NJ 290-3.0",
            "F": "Comau-Smart5-NJ-290-3-0.robot",
            "I": "Comau-Smart5-NJ-290-3-0-robot.png",
            "IS": "Comau-Smart5-NJ-290-3-0.png",
            "B": "Comau",
            "M": "Smart5 NJ 290-3.0",
            "T": "6 DOF",
            "A": 6,
            "R": 2997,
            "P": 290,
            "W": 2150,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart5-NJ-370-2-7": {
            "MT": "R",
            "N": "Comau Smart5 NJ 370-2.7",
            "F": "Comau-Smart5-NJ-370-2-7.robot",
            "I": "Comau-Smart5-NJ-370-2-7-robot.png",
            "IS": "Comau-Smart5-NJ-370-2-7.png",
            "B": "Comau",
            "M": "Smart5 NJ 370-2.7",
            "T": "6 DOF",
            "A": 6,
            "R": 2703,
            "P": 370,
            "W": 2100,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart5-NJ-420-3-0": {
            "MT": "R",
            "N": "Comau Smart5 NJ 420-3.0",
            "F": "Comau-Smart5-NJ-420-3-0.robot",
            "I": "Comau-Smart5-NJ-420-3-0-robot.png",
            "IS": "Comau-Smart5-NJ-420-3-0.png",
            "B": "Comau",
            "M": "Smart5 NJ 420-3.0",
            "T": "6 DOF",
            "A": 6,
            "R": 3020,
            "P": 370,
            "W": 2450,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart5-NJ4-175-2-2": {
            "MT": "R",
            "N": "Comau Smart5 NJ4 175-2.2",
            "F": "Comau-Smart5-NJ4-175-2-2.robot",
            "I": "Comau-Smart5-NJ4-175-2-2-robot.png",
            "IS": "Comau-Smart5-NJ4-175-2-2.png",
            "B": "Comau",
            "M": "Smart5 NJ4 175-2.2",
            "T": "6 DOF",
            "A": 6,
            "R": 2204,
            "P": 175,
            "W": 1080,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart5-NJ4-175-2-2-I": {
            "MT": "R",
            "N": "Comau Smart5 NJ4 175-2.2-I",
            "F": "Comau-Smart5-NJ4-175-2-2-I.robot",
            "I": "Comau-Smart5-NJ4-175-2-2-I-robot.png",
            "IS": "Comau-Smart5-NJ4-175-2-2-I.png",
            "B": "Comau",
            "M": "Smart5 NJ4 175-2.2-I",
            "T": "6 DOF",
            "A": 6,
            "R": 2204,
            "P": 175,
            "W": 1080,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart5-NJ4-220-2-7": {
            "MT": "R",
            "N": "Comau Smart5 NJ4 220-2.7",
            "F": "Comau-Smart5-NJ4-220-2-7.robot",
            "I": "Comau-Smart5-NJ4-220-2-7-robot.png",
            "IS": "Comau-Smart5-NJ4-220-2-7.png",
            "B": "Comau",
            "M": "Smart5 NJ4 220-2.7",
            "T": "6 DOF",
            "A": 6,
            "R": 2738,
            "P": 220,
            "W": 1290,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Comau-Smart5-PAL-180": {
            "MT": "R",
            "N": "Comau Smart5 PAL 180",
            "F": "Comau-Smart5-PAL-180.robot",
            "I": "Comau-Smart5-PAL-180-robot.png",
            "IS": "Comau-Smart5-PAL-180.png",
            "B": "Comau",
            "M": "Smart5 PAL 180",
            "T": "Palletizing",
            "A": 4,
            "R": 3099,
            "P": 180,
            "W": 160,
            "E": 0.25,
            "AP": [
                "Palletizing"
            ]
        },
        "Comau-Smart5-PAL-260": {
            "MT": "R",
            "N": "Comau Smart5 PAL 260",
            "F": "Comau-Smart5-PAL-260.robot",
            "I": "Comau-Smart5-PAL-260-robot.png",
            "IS": "Comau-Smart5-PAL-260.png",
            "B": "Comau",
            "M": "Smart5 PAL 260",
            "T": "Palletizing",
            "A": 4,
            "R": 3099,
            "P": 260,
            "W": 160,
            "E": 0.25,
            "AP": [
                "Palletizing"
            ]
        },
        "Comau-Smart5-PAL-470-3-1": {
            "MT": "R",
            "N": "Comau Smart5 PAL 470-3.1",
            "F": "Comau-Smart5-PAL-470-3-1.robot",
            "I": "Comau-Smart5-PAL-470-3-1-robot.png",
            "IS": "Comau-Smart5-PAL-470-3-1.png",
            "B": "Comau",
            "M": "Smart5 PAL 470-3.1",
            "T": "Palletizing",
            "A": 4,
            "R": 3100,
            "P": 470,
            "W": 2310,
            "E": 0.15,
            "AP": [
                "Palletizing"
            ]
        },
        "Comau-Rebel-S6-0-45": {
            "MT": "R",
            "N": "Comau Rebel S6-0.45",
            "F": "Comau-Rebel-S6-0-45.robot",
            "I": "Comau-Rebel-S6-0-45-robot.png",
            "IS": "Comau-Rebel-S6-0-45.png",
            "B": "Comau",
            "M": "Rebel S6-0.45",
            "T": "SCARA",
            "A": 4,
            "R": 450,
            "P": 6,
            "W": 20,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Comau-Rebel-S6-0-60": {
            "MT": "R",
            "N": "Comau Rebel S6-0.60",
            "F": "Comau-Rebel-S6-0-60.robot",
            "I": "Comau-Rebel-S6-0-60-robot.png",
            "IS": "Comau-Rebel-S6-0-60.png",
            "B": "Comau",
            "M": "Rebel S6-0.60",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 6,
            "W": 20,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Comau-Rebel-S6-0-60c": {
            "MT": "R",
            "N": "Comau Rebel S6-0.60c",
            "F": "Comau-Rebel-S6-0-60c.robot",
            "I": "Comau-Rebel-S6-0-60c-robot.png",
            "IS": "Comau-Rebel-S6-0-60c.png",
            "B": "Comau",
            "M": "Rebel S6-0.60c",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 6.0,
            "W": 20,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Comau-Rebel-S6-0-75": {
            "MT": "R",
            "N": "Comau Rebel S6-0.75",
            "F": "Comau-Rebel-S6-0-75.robot",
            "I": "Comau-Rebel-S6-0-75-robot.png",
            "IS": "Comau-Rebel-S6-0-75.png",
            "B": "Comau",
            "M": "Rebel S6-0.75",
            "T": "SCARA",
            "A": 4,
            "R": 750,
            "P": 6,
            "W": 20,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Comau-Rebel-S6-0-75c": {
            "MT": "R",
            "N": "Comau Rebel S6-0.75c",
            "F": "Comau-Rebel-S6-0-75c.robot",
            "I": "Comau-Rebel-S6-0-75c-robot.png",
            "IS": "Comau-Rebel-S6-0-75c.png",
            "B": "Comau",
            "M": "Rebel S6-0.75c",
            "T": "SCARA",
            "A": 4,
            "R": 750,
            "P": 6.0,
            "W": 20,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "cpcRobot-S0": {
            "MT": "R",
            "N": "cpcRobot S0",
            "F": "cpcRobot-S0.robot",
            "I": "cpcRobot-S0-robot.png",
            "IS": "cpcRobot-S0.png",
            "B": "cpcRobot",
            "M": "S0",
            "T": "6 DOF",
            "A": 6,
            "R": 370.8,
            "P": 0.5,
            "W": 3.513,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "CPR-Mover6": {
            "MT": "R",
            "N": "CPR Mover6",
            "F": "CPR-Mover6.robot",
            "I": "CPR-Mover6-robot.png",
            "IS": "CPR-Mover6.png",
            "B": "CPR",
            "M": "Mover6",
            "T": "6 DOF",
            "A": 6,
            "R": 455,
            "P": 0.2,
            "W": 6,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "CRP-RH14-10": {
            "MT": "R",
            "N": "CRP-RH14-10",
            "F": "CRP-RH14-10.robot",
            "I": "CRP-RH14-10-robot.png",
            "IS": "CRP-RH14-10.png",
            "B": "CROBOTP",
            "M": "-RH14-10",
            "T": "6 DOF",
            "A": 6,
            "R": 1454,
            "P": 10.0,
            "W": 170,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "CRP-RH21-06-W": {
            "MT": "R",
            "N": "CRP-RH21-06-W",
            "F": "CRP-RH21-06-W.robot",
            "I": "CRP-RH21-06-W-robot.png",
            "IS": "CRP-RH21-06-W.png",
            "B": "CROBOTP",
            "M": "-RH21-06-W",
            "T": "6 DOF",
            "A": 6,
            "R": 2093,
            "P": 6.0,
            "W": 260,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "CROBOTP-CRP-RP24-130": {
            "MT": "R",
            "N": "CROBOTP CRP-RP24-130",
            "F": "CROBOTP-CRP-RP24-130.robot",
            "I": "CROBOTP-CRP-RP24-130-robot.png",
            "IS": "CROBOTP-CRP-RP24-130.png",
            "B": "CROBOTP",
            "M": "CRP-RP24-130",
            "T": "Palletizing",
            "A": 4,
            "R": 2485,
            "P": 130,
            "W": 820,
            "E": 0.2,
            "AP": [
                "Palletizing"
            ]
        },
        "CRS-A465": {
            "MT": "R",
            "N": "CRS A465",
            "F": "CRS-A465.robot",
            "I": "CRS-A465-robot.png",
            "IS": "CRS-A465.png",
            "B": "CRS",
            "M": "A465",
            "T": "6 DOF",
            "A": 6,
            "R": 711,
            "P": 2,
            "W": 31,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "CRS-F3": {
            "MT": "R",
            "N": "CRS F3",
            "F": "CRS-F3.robot",
            "I": "CRS-F3-robot.png",
            "IS": "CRS-F3.png",
            "B": "CRS",
            "M": "F3",
            "T": "6 DOF",
            "A": 6,
            "R": 635,
            "P": 3,
            "W": 53,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Delta-Electronics-DC06": {
            "MT": "R",
            "N": "Delta Electronics DC06",
            "F": "Delta-Electronics-DC06.robot",
            "I": "Delta-Electronics-DC06-robot.png",
            "IS": "Delta-Electronics-DC06.png",
            "B": "Delta Electronics",
            "M": "DC06",
            "T": "6 DOF",
            "A": 6,
            "R": 800,
            "P": 6.0,
            "W": 24,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Delta-Electronics-DC08": {
            "MT": "R",
            "N": "Delta Electronics DC08",
            "F": "Delta-Electronics-DC08.robot",
            "I": "Delta-Electronics-DC08-robot.png",
            "IS": "Delta-Electronics-DC08.png",
            "B": "Delta Electronics",
            "M": "DC08",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 8.0,
            "W": 40,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Delta-Electronics-DC10": {
            "MT": "R",
            "N": "Delta Electronics DC10",
            "F": "Delta-Electronics-DC10.robot",
            "I": "Delta-Electronics-DC10-robot.png",
            "IS": "Delta-Electronics-DC10.png",
            "B": "Delta Electronics",
            "M": "DC10",
            "T": "6 DOF",
            "A": 6,
            "R": 1200,
            "P": 10.0,
            "W": 39,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Delta-Electronics-DC16": {
            "MT": "R",
            "N": "Delta Electronics DC16",
            "F": "Delta-Electronics-DC16.robot",
            "I": "Delta-Electronics-DC16-robot.png",
            "IS": "Delta-Electronics-DC16.png",
            "B": "Delta Electronics",
            "M": "DC16",
            "T": "6 DOF",
            "A": 6,
            "R": 1600,
            "P": 16.0,
            "W": 70,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Delta-Electronics-DC20": {
            "MT": "R",
            "N": "Delta Electronics DC20",
            "F": "Delta-Electronics-DC20.robot",
            "I": "Delta-Electronics-DC20-robot.png",
            "IS": "Delta-Electronics-DC20.png",
            "B": "Delta Electronics",
            "M": "DC20",
            "T": "6 DOF",
            "A": 6,
            "R": 1800,
            "P": 20.0,
            "W": 101,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Delta-Electronics-DC30": {
            "MT": "R",
            "N": "Delta Electronics DC30",
            "F": "Delta-Electronics-DC30.robot",
            "I": "Delta-Electronics-DC30-robot.png",
            "IS": "Delta-Electronics-DC30.png",
            "B": "Delta Electronics",
            "M": "DC30",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 30.0,
            "W": 98,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Denso-Cobotta-PRO-900": {
            "MT": "R",
            "N": "Denso Cobotta PRO 900",
            "F": "Denso-Cobotta-PRO-900.robot",
            "I": "Denso-Cobotta-PRO-900-robot.png",
            "IS": "Denso-Cobotta-PRO-900.png",
            "B": "Denso",
            "M": "Cobotta PRO 900",
            "T": "6 DOF",
            "A": 6,
            "R": 1066,
            "P": 6.0,
            "W": 29,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Denso-Cobotta-PRO-1300-Touch-sensing-soft-cover": {
            "MT": "R",
            "N": "Denso Cobotta PRO 1300 Touch sensing soft cover",
            "F": "Denso-Cobotta-PRO-1300-Touch-sensing-soft-cover.robot",
            "I": "Denso-Cobotta-PRO-1300-Touch-sensing-soft-cover-robot.png",
            "IS": "Denso-Cobotta-PRO-1300-Touch-sensing-soft-cover.png",
            "B": "Denso",
            "M": "Cobotta PRO 1300 Touch sensing soft cover",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 12,
            "W": 41,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Denso-Cobotta-PRO-1300": {
            "MT": "R",
            "N": "Denso Cobotta PRO 1300",
            "F": "Denso-Cobotta-PRO-1300.robot",
            "I": "Denso-Cobotta-PRO-1300-robot.png",
            "IS": "Denso-Cobotta-PRO-1300.png",
            "B": "Denso",
            "M": "Cobotta PRO 1300",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 12,
            "W": 41,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Denso-Cobotta": {
            "MT": "R",
            "N": "Denso Cobotta",
            "F": "Denso-Cobotta.robot",
            "I": "Denso-Cobotta-robot.png",
            "IS": "Denso-Cobotta.png",
            "B": "Denso",
            "M": "Cobotta",
            "T": "6 DOF",
            "A": 6,
            "R": 342.5,
            "P": 4,
            "W": 29,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Denso-VLA-4025W5": {
            "MT": "R",
            "N": "Denso VLA-4025W5",
            "F": "Denso-VLA-4025W5.robot",
            "I": "Denso-VLA-4025W5-robot.png",
            "IS": "Denso-VLA-4025W5.png",
            "B": "Denso",
            "M": "VLA-4025W5",
            "T": "6 DOF",
            "A": 6,
            "R": 2503,
            "P": 40.0,
            "W": 655,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Denso-VLA-6022W5": {
            "MT": "R",
            "N": "Denso VLA-6022W5",
            "F": "Denso-VLA-6022W5.robot",
            "I": "Denso-VLA-6022W5-robot.png",
            "IS": "Denso-VLA-6022W5.png",
            "B": "Denso",
            "M": "VLA-6022W5",
            "T": "6 DOF",
            "A": 6,
            "R": 2257,
            "P": 60.0,
            "W": 645,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Denso-VM-60B1": {
            "MT": "R",
            "N": "Denso VM-60B1",
            "F": "Denso-VM-60B1.robot",
            "I": "Denso-VM-60B1-robot.png",
            "IS": "Denso-VM-60B1.png",
            "B": "Denso",
            "M": "VM-60B1",
            "T": "6 DOF",
            "A": 6,
            "R": 1298,
            "P": 13,
            "W": 82,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Denso-VMB-2515": {
            "MT": "R",
            "N": "Denso VMB-2515",
            "F": "Denso-VMB-2515.robot",
            "I": "Denso-VMB-2515-robot.png",
            "IS": "Denso-VMB-2515.png",
            "B": "Denso",
            "M": "VMB-2515",
            "T": "6 DOF",
            "A": 6,
            "R": 1506,
            "P": 25.0,
            "W": 230,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Denso-VMB-2518": {
            "MT": "R",
            "N": "Denso VMB-2518",
            "F": "Denso-VMB-2518.robot",
            "I": "Denso-VMB-2518-robot.png",
            "IS": "Denso-VMB-2518.png",
            "B": "Denso",
            "M": "VMB-2518",
            "T": "6 DOF",
            "A": 6,
            "R": 1804,
            "P": 25.0,
            "W": 250,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Denso-VP-6242": {
            "MT": "R",
            "N": "Denso VP-6242",
            "F": "Denso-VP-6242.robot",
            "I": "Denso-VP-6242-robot.png",
            "IS": "Denso-VP-6242.png",
            "B": "Denso",
            "M": "VP-6242",
            "T": "6 DOF",
            "A": 6,
            "R": 432,
            "P": 2,
            "W": 15,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Denso-VS-050": {
            "MT": "R",
            "N": "Denso VS-050",
            "F": "Denso-VS-050.robot",
            "I": "Denso-VS-050-robot.png",
            "IS": "Denso-VS-050.png",
            "B": "Denso",
            "M": "VS-050",
            "T": "6 DOF",
            "A": 6,
            "R": 605,
            "P": 4,
            "W": 29,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Denso-VS-060": {
            "MT": "R",
            "N": "Denso VS-060",
            "F": "Denso-VS-060.robot",
            "I": "Denso-VS-060-robot.png",
            "IS": "Denso-VS-060.png",
            "B": "Denso",
            "M": "VS-060",
            "T": "6 DOF",
            "A": 6,
            "R": 605,
            "P": 4,
            "W": 30,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Denso-VS-068": {
            "MT": "R",
            "N": "Denso VS-068",
            "F": "Denso-VS-068.robot",
            "I": "Denso-VS-068-robot.png",
            "IS": "Denso-VS-068.png",
            "B": "Denso",
            "M": "VS-068",
            "T": "6 DOF",
            "A": 6,
            "R": 710,
            "P": 7,
            "W": 49,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Denso-VS-087": {
            "MT": "R",
            "N": "Denso VS-087",
            "F": "Denso-VS-087.robot",
            "I": "Denso-VS-087-robot.png",
            "IS": "Denso-VS-087.png",
            "B": "Denso",
            "M": "VS-087",
            "T": "6 DOF",
            "A": 6,
            "R": 875,
            "P": 7,
            "W": 51,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Denso-VS-6556": {
            "MT": "R",
            "N": "Denso VS-6556",
            "F": "Denso-VS-6556.robot",
            "I": "Denso-VS-6556-robot.png",
            "IS": "Denso-VS-6556.png",
            "B": "Denso",
            "M": "VS-6556",
            "T": "6 DOF",
            "A": 6,
            "R": 565,
            "P": 7,
            "W": 35,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Denso-VS-6577G-B": {
            "MT": "R",
            "N": "Denso VS-6577G-B",
            "F": "Denso-VS-6577G-B.robot",
            "I": "Denso-VS-6577G-B-robot.png",
            "IS": "Denso-VS-6577G-B.png",
            "B": "Denso",
            "M": "VS-6577G-B",
            "T": "6 DOF",
            "A": 6,
            "R": 854,
            "P": 7,
            "W": 36,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Denso-HM-4A73": {
            "MT": "R",
            "N": "Denso HM-4A73",
            "F": "Denso-HM-4A73.robot",
            "I": "Denso-HM-4A73-robot.png",
            "IS": "Denso-HM-4A73.png",
            "B": "Denso",
            "M": "HM-4A73",
            "T": "SCARA",
            "A": 4,
            "R": 700,
            "P": 20,
            "W": 56,
            "E": 0.022,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Denso-HS045A1": {
            "MT": "R",
            "N": "Denso HS045A1",
            "F": "Denso-HS045A1.robot",
            "I": "Denso-HS045A1-robot.png",
            "IS": "Denso-HS045A1.png",
            "B": "Denso",
            "M": "HS045A1",
            "T": "SCARA",
            "A": 4,
            "R": 450,
            "P": 5,
            "W": 25,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Denso-HS055A1": {
            "MT": "R",
            "N": "Denso HS055A1",
            "F": "Denso-HS055A1.robot",
            "I": "Denso-HS055A1-robot.png",
            "IS": "Denso-HS055A1.png",
            "B": "Denso",
            "M": "HS055A1",
            "T": "SCARA",
            "A": 4,
            "R": 550,
            "P": 5.0,
            "W": 25,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Denso-HSR065A1-N17-W5N": {
            "MT": "R",
            "N": "Denso HSR065A1-N17-W5N",
            "F": "Denso-HSR065A1-N17-W5N.robot",
            "I": "Denso-HSR065A1-N17-W5N-robot.png",
            "IS": "Denso-HSR065A1-N17-W5N.png",
            "B": "Denso",
            "M": "HSR065A1-N17-W5N",
            "T": "SCARA",
            "A": 4,
            "R": 650,
            "P": 8,
            "W": 32,
            "E": 0.012,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Dobot-CR3": {
            "MT": "R",
            "N": "Dobot CR3",
            "F": "Dobot-CR3.robot",
            "I": "Dobot-CR3-robot.png",
            "IS": "Dobot-CR3.png",
            "B": "Dobot",
            "M": "CR3",
            "T": "6 DOF",
            "A": 6,
            "R": 620,
            "P": 3,
            "W": 16.5,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Dobot-CR3A": {
            "MT": "R",
            "N": "Dobot CR3A",
            "F": "Dobot-CR3A.robot",
            "I": "Dobot-CR3A-robot.png",
            "IS": "Dobot-CR3A.png",
            "B": "Dobot",
            "M": "CR3A",
            "T": "6 DOF",
            "A": 6,
            "R": 620,
            "P": 3,
            "W": 16.5,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Dobot-CR3L": {
            "MT": "R",
            "N": "Dobot CR3L",
            "F": "Dobot-CR3L.robot",
            "I": "Dobot-CR3L-robot.png",
            "IS": "Dobot-CR3L.png",
            "B": "Dobot",
            "M": "CR3L",
            "T": "6 DOF",
            "A": 6,
            "R": 795,
            "P": 3,
            "W": 16.5,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Dobot-CR5": {
            "MT": "R",
            "N": "Dobot CR5",
            "F": "Dobot-CR5.robot",
            "I": "Dobot-CR5-robot.png",
            "IS": "Dobot-CR5.png",
            "B": "Dobot",
            "M": "CR5",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 5,
            "W": 25,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Dobot-CR5A": {
            "MT": "R",
            "N": "Dobot CR5A",
            "F": "Dobot-CR5A.robot",
            "I": "Dobot-CR5A-robot.png",
            "IS": "Dobot-CR5A.png",
            "B": "Dobot",
            "M": "CR5A",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 5,
            "W": 25,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Dobot-CR7": {
            "MT": "R",
            "N": "Dobot CR7",
            "F": "Dobot-CR7.robot",
            "I": "Dobot-CR7-robot.png",
            "IS": "Dobot-CR7.png",
            "B": "Dobot",
            "M": "CR7",
            "T": "6 DOF",
            "A": 6,
            "R": 800,
            "P": 7,
            "W": 24.5,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Dobot-CR7A": {
            "MT": "R",
            "N": "Dobot CR7A",
            "F": "Dobot-CR7A.robot",
            "I": "Dobot-CR7A-robot.png",
            "IS": "Dobot-CR7A.png",
            "B": "Dobot",
            "M": "CR7A",
            "T": "6 DOF",
            "A": 6,
            "R": 800,
            "P": 7,
            "W": 24.5,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Dobot-CR10": {
            "MT": "R",
            "N": "Dobot CR10",
            "F": "Dobot-CR10.robot",
            "I": "Dobot-CR10-robot.png",
            "IS": "Dobot-CR10.png",
            "B": "Dobot",
            "M": "CR10",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 10,
            "W": 40,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Dobot-CR10A": {
            "MT": "R",
            "N": "Dobot CR10A",
            "F": "Dobot-CR10A.robot",
            "I": "Dobot-CR10A-robot.png",
            "IS": "Dobot-CR10A.png",
            "B": "Dobot",
            "M": "CR10A",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 10,
            "W": 40,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Dobot-CR12": {
            "MT": "R",
            "N": "Dobot CR12",
            "F": "Dobot-CR12.robot",
            "I": "Dobot-CR12-robot.png",
            "IS": "Dobot-CR12.png",
            "B": "Dobot",
            "M": "CR12",
            "T": "6 DOF",
            "A": 6,
            "R": 1200,
            "P": 12,
            "W": 39.5,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Dobot-CR12A": {
            "MT": "R",
            "N": "Dobot CR12A",
            "F": "Dobot-CR12A.robot",
            "I": "Dobot-CR12A-robot.png",
            "IS": "Dobot-CR12A.png",
            "B": "Dobot",
            "M": "CR12A",
            "T": "6 DOF",
            "A": 6,
            "R": 1200,
            "P": 12,
            "W": 39.5,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Dobot-CR16": {
            "MT": "R",
            "N": "Dobot CR16",
            "F": "Dobot-CR16.robot",
            "I": "Dobot-CR16-robot.png",
            "IS": "Dobot-CR16.png",
            "B": "Dobot",
            "M": "CR16",
            "T": "6 DOF",
            "A": 6,
            "R": 1000,
            "P": 16,
            "W": 40,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Dobot-CR16A": {
            "MT": "R",
            "N": "Dobot CR16A",
            "F": "Dobot-CR16A.robot",
            "I": "Dobot-CR16A-robot.png",
            "IS": "Dobot-CR16A.png",
            "B": "Dobot",
            "M": "CR16A",
            "T": "6 DOF",
            "A": 6,
            "R": 1000,
            "P": 16,
            "W": 40,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Dobot-CR20A": {
            "MT": "R",
            "N": "Dobot CR20A",
            "F": "Dobot-CR20A.robot",
            "I": "Dobot-CR20A-robot.png",
            "IS": "Dobot-CR20A.png",
            "B": "Dobot",
            "M": "CR20A",
            "T": "6 DOF",
            "A": 6,
            "R": 1700,
            "P": 20,
            "W": 70,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Dobot-CR30H": {
            "MT": "R",
            "N": "Dobot CR30H",
            "F": "Dobot-CR30H.robot",
            "I": "Dobot-CR30H-robot.png",
            "IS": "Dobot-CR30H.png",
            "B": "Dobot",
            "M": "CR30H",
            "T": "6 DOF",
            "A": 6,
            "R": 1800,
            "P": 30,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Dobot-Magician-E6": {
            "MT": "R",
            "N": "Dobot Magician E6",
            "F": "Dobot-Magician-E6.robot",
            "I": "Dobot-Magician-E6-robot.png",
            "IS": "Dobot-Magician-E6.png",
            "B": "Dobot",
            "M": "Magician E6",
            "T": "6 DOF",
            "A": 6,
            "R": 450,
            "P": 0.5,
            "W": 7.2,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Dobot-Nova-2": {
            "MT": "R",
            "N": "Dobot Nova 2",
            "F": "Dobot-Nova-2.robot",
            "I": "Dobot-Nova-2-robot.png",
            "IS": "Dobot-Nova-2.png",
            "B": "Dobot",
            "M": "Nova 2",
            "T": "6 DOF",
            "A": 6,
            "R": 625,
            "P": 2.0,
            "W": 11.0,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Dobot-Nova-5": {
            "MT": "R",
            "N": "Dobot Nova 5",
            "F": "Dobot-Nova-5.robot",
            "I": "Dobot-Nova-5-robot.png",
            "IS": "Dobot-Nova-5.png",
            "B": "Dobot",
            "M": "Nova 5",
            "T": "6 DOF",
            "A": 6,
            "R": 850,
            "P": 5.0,
            "W": 14.0,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Dobot-Magician-Lite": {
            "MT": "R",
            "N": "Dobot Magician Lite",
            "F": "Dobot-Magician-Lite.robot",
            "I": "Dobot-Magician-Lite-robot.png",
            "IS": "Dobot-Magician-Lite.png",
            "B": "Dobot",
            "M": "Magician Lite",
            "T": "Palletizing",
            "A": 4,
            "R": 340,
            "P": 0.25,
            "W": 2.4,
            "E": 0.2,
            "AP": [
                "Palletizing"
            ]
        },
        "Dobot-Magician": {
            "MT": "R",
            "N": "Dobot Magician",
            "F": "Dobot-Magician.robot",
            "I": "Dobot-Magician-robot.png",
            "IS": "Dobot-Magician.png",
            "B": "Dobot",
            "M": "Magician",
            "T": "Palletizing",
            "A": 4,
            "R": 320,
            "P": 0.5,
            "W": 4,
            "E": 0.2,
            "AP": [
                "Palletizing"
            ]
        },
        "Dobot-MG400": {
            "MT": "R",
            "N": "Dobot MG400",
            "F": "Dobot-MG400.robot",
            "I": "Dobot-MG400-robot.png",
            "IS": "Dobot-MG400.png",
            "B": "Dobot",
            "M": "MG400",
            "T": "Palletizing",
            "A": 4,
            "R": 393.5,
            "P": 0.5,
            "W": 4,
            "E": 0.2,
            "AP": [
                "Palletizing"
            ]
        },
        "Dobot-M1": {
            "MT": "R",
            "N": "Dobot M1",
            "F": "Dobot-M1.robot",
            "I": "Dobot-M1-robot.png",
            "IS": "Dobot-M1.png",
            "B": "Dobot",
            "M": "M1",
            "T": "SCARA",
            "A": 4,
            "R": 446,
            "P": 1.5,
            "W": 14,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Doosan-Robotics-P3020": {
            "MT": "R",
            "N": "Doosan Robotics P3020",
            "F": "Doosan-Robotics-P3020.robot",
            "I": "Doosan-Robotics-P3020-robot.png",
            "IS": "Doosan-Robotics-P3020.png",
            "B": "Doosan Robotics",
            "M": "P3020",
            "T": "5 DOF",
            "A": 5,
            "R": 1900,
            "P": 30.0,
            "W": 83,
            "E": 0.1,
            "AP": [
                "Material Handling"
            ]
        },
        "Doosan-Robotics-A0509-White": {
            "MT": "R",
            "N": "Doosan Robotics A0509 White",
            "F": "Doosan-Robotics-A0509-White.robot",
            "I": "Doosan-Robotics-A0509-White-robot.png",
            "IS": "Doosan-Robotics-A0509-White.png",
            "B": "Doosan Robotics",
            "M": "A0509 White",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 5,
            "W": 21,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Doosan-Robotics-A0509": {
            "MT": "R",
            "N": "Doosan Robotics A0509",
            "F": "Doosan-Robotics-A0509.robot",
            "I": "Doosan-Robotics-A0509-robot.png",
            "IS": "Doosan-Robotics-A0509.png",
            "B": "Doosan Robotics",
            "M": "A0509",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 5,
            "W": 21,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Doosan-Robotics-A0912-White": {
            "MT": "R",
            "N": "Doosan Robotics A0912 White",
            "F": "Doosan-Robotics-A0912-White.robot",
            "I": "Doosan-Robotics-A0912-White-robot.png",
            "IS": "Doosan-Robotics-A0912-White.png",
            "B": "Doosan Robotics",
            "M": "A0912 White",
            "T": "6 DOF",
            "A": 6,
            "R": 1200,
            "P": 9,
            "W": 27,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Doosan-Robotics-A0912": {
            "MT": "R",
            "N": "Doosan Robotics A0912",
            "F": "Doosan-Robotics-A0912.robot",
            "I": "Doosan-Robotics-A0912-robot.png",
            "IS": "Doosan-Robotics-A0912.png",
            "B": "Doosan Robotics",
            "M": "A0912",
            "T": "6 DOF",
            "A": 6,
            "R": 1200,
            "P": 9,
            "W": 27,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Doosan-Robotics-E0509": {
            "MT": "R",
            "N": "Doosan Robotics E0509",
            "F": "Doosan-Robotics-E0509.robot",
            "I": "Doosan-Robotics-E0509-robot.png",
            "IS": "Doosan-Robotics-E0509.png",
            "B": "Doosan Robotics",
            "M": "E0509",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 5.0,
            "W": 22.5,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Doosan-Robotics-H2017-White": {
            "MT": "R",
            "N": "Doosan Robotics H2017 White",
            "F": "Doosan-Robotics-H2017-White.robot",
            "I": "Doosan-Robotics-H2017-White-robot.png",
            "IS": "Doosan-Robotics-H2017-White.png",
            "B": "Doosan Robotics",
            "M": "H2017 White",
            "T": "6 DOF",
            "A": 6,
            "R": 1700,
            "P": 20,
            "W": 74,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Doosan-Robotics-H2017": {
            "MT": "R",
            "N": "Doosan Robotics H2017",
            "F": "Doosan-Robotics-H2017.robot",
            "I": "Doosan-Robotics-H2017-robot.png",
            "IS": "Doosan-Robotics-H2017.png",
            "B": "Doosan Robotics",
            "M": "H2017",
            "T": "6 DOF",
            "A": 6,
            "R": 1700,
            "P": 20,
            "W": 74,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Doosan-Robotics-H2515-White": {
            "MT": "R",
            "N": "Doosan Robotics H2515 White",
            "F": "Doosan-Robotics-H2515-White.robot",
            "I": "Doosan-Robotics-H2515-White-robot.png",
            "IS": "Doosan-Robotics-H2515-White.png",
            "B": "Doosan Robotics",
            "M": "H2515 White",
            "T": "6 DOF",
            "A": 6,
            "R": 1500,
            "P": 25,
            "W": 72,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Doosan-Robotics-H2515": {
            "MT": "R",
            "N": "Doosan Robotics H2515",
            "F": "Doosan-Robotics-H2515.robot",
            "I": "Doosan-Robotics-H2515-robot.png",
            "IS": "Doosan-Robotics-H2515.png",
            "B": "Doosan Robotics",
            "M": "H2515",
            "T": "6 DOF",
            "A": 6,
            "R": 1500,
            "P": 25,
            "W": 72,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Doosan-Robotics-M0609-White": {
            "MT": "R",
            "N": "Doosan Robotics M0609 White",
            "F": "Doosan-Robotics-M0609-White.robot",
            "I": "Doosan-Robotics-M0609-White-robot.png",
            "IS": "Doosan-Robotics-M0609-White.png",
            "B": "Doosan Robotics",
            "M": "M0609 White",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 6,
            "W": 27,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Doosan-Robotics-M0609": {
            "MT": "R",
            "N": "Doosan Robotics M0609",
            "F": "Doosan-Robotics-M0609.robot",
            "I": "Doosan-Robotics-M0609-robot.png",
            "IS": "Doosan-Robotics-M0609.png",
            "B": "Doosan Robotics",
            "M": "M0609",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 6,
            "W": 27,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Doosan-Robotics-M0617-White": {
            "MT": "R",
            "N": "Doosan Robotics M0617 White",
            "F": "Doosan-Robotics-M0617-White.robot",
            "I": "Doosan-Robotics-M0617-White-robot.png",
            "IS": "Doosan-Robotics-M0617-White.png",
            "B": "Doosan Robotics",
            "M": "M0617 White",
            "T": "6 DOF",
            "A": 6,
            "R": 1700,
            "P": 6,
            "W": 33,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Doosan-Robotics-M0617": {
            "MT": "R",
            "N": "Doosan Robotics M0617",
            "F": "Doosan-Robotics-M0617.robot",
            "I": "Doosan-Robotics-M0617-robot.png",
            "IS": "Doosan-Robotics-M0617.png",
            "B": "Doosan Robotics",
            "M": "M0617",
            "T": "6 DOF",
            "A": 6,
            "R": 1700,
            "P": 6,
            "W": 33,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Doosan-Robotics-M1013-White": {
            "MT": "R",
            "N": "Doosan Robotics M1013 White",
            "F": "Doosan-Robotics-M1013-White.robot",
            "I": "Doosan-Robotics-M1013-White-robot.png",
            "IS": "Doosan-Robotics-M1013-White.png",
            "B": "Doosan Robotics",
            "M": "M1013 White",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 10,
            "W": 33,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Doosan-Robotics-M1013": {
            "MT": "R",
            "N": "Doosan Robotics M1013",
            "F": "Doosan-Robotics-M1013.robot",
            "I": "Doosan-Robotics-M1013-robot.png",
            "IS": "Doosan-Robotics-M1013.png",
            "B": "Doosan Robotics",
            "M": "M1013",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 10,
            "W": 33,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Doosan-Robotics-M1509-White": {
            "MT": "R",
            "N": "Doosan Robotics M1509 White",
            "F": "Doosan-Robotics-M1509-White.robot",
            "I": "Doosan-Robotics-M1509-White-robot.png",
            "IS": "Doosan-Robotics-M1509-White.png",
            "B": "Doosan Robotics",
            "M": "M1509 White",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 15,
            "W": 32,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Doosan-Robotics-M1509": {
            "MT": "R",
            "N": "Doosan Robotics M1509",
            "F": "Doosan-Robotics-M1509.robot",
            "I": "Doosan-Robotics-M1509-robot.png",
            "IS": "Doosan-Robotics-M1509.png",
            "B": "Doosan Robotics",
            "M": "M1509",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 15,
            "W": 32,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "DUCO-GCR3-618": {
            "MT": "R",
            "N": "DUCO GCR3-618",
            "F": "DUCO-GCR3-618.robot",
            "I": "DUCO-GCR3-618-robot.png",
            "IS": "DUCO-GCR3-618.png",
            "B": "DUCO",
            "M": "GCR3-618",
            "T": "6 DOF",
            "A": 6,
            "R": 618,
            "P": 3.0,
            "W": 13,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "DUCO-GCR5-910": {
            "MT": "R",
            "N": "DUCO GCR5-910",
            "F": "DUCO-GCR5-910.robot",
            "I": "DUCO-GCR5-910-robot.png",
            "IS": "DUCO-GCR5-910.png",
            "B": "DUCO",
            "M": "GCR5-910",
            "T": "6 DOF",
            "A": 6,
            "R": 917,
            "P": 5.0,
            "W": 22,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "DUCO-GCR7-910": {
            "MT": "R",
            "N": "DUCO GCR7-910",
            "F": "DUCO-GCR7-910.robot",
            "I": "DUCO-GCR7-910-robot.png",
            "IS": "DUCO-GCR7-910.png",
            "B": "DUCO",
            "M": "GCR7-910",
            "T": "6 DOF",
            "A": 6,
            "R": 917,
            "P": 7.0,
            "W": 22,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "DUCO-GCR10-1300": {
            "MT": "R",
            "N": "DUCO GCR10-1300",
            "F": "DUCO-GCR10-1300.robot",
            "I": "DUCO-GCR10-1300-robot.png",
            "IS": "DUCO-GCR10-1300.png",
            "B": "DUCO",
            "M": "GCR10-1300",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 10.0,
            "W": 37.8,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "DUCO-GCR12-1300": {
            "MT": "R",
            "N": "DUCO GCR12-1300",
            "F": "DUCO-GCR12-1300.robot",
            "I": "DUCO-GCR12-1300-robot.png",
            "IS": "DUCO-GCR12-1300.png",
            "B": "DUCO",
            "M": "GCR12-1300",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 12.0,
            "W": 37.8,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "DUCO-GCR14-1400": {
            "MT": "R",
            "N": "DUCO GCR14-1400",
            "F": "DUCO-GCR14-1400.robot",
            "I": "DUCO-GCR14-1400-robot.png",
            "IS": "DUCO-GCR14-1400.png",
            "B": "DUCO",
            "M": "GCR14-1400",
            "T": "6 DOF",
            "A": 6,
            "R": 1400,
            "P": 14,
            "W": 50,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "DUCO-GCR16-960": {
            "MT": "R",
            "N": "DUCO GCR16-960",
            "F": "DUCO-GCR16-960.robot",
            "I": "DUCO-GCR16-960-robot.png",
            "IS": "DUCO-GCR16-960.png",
            "B": "DUCO",
            "M": "GCR16-960",
            "T": "6 DOF",
            "A": 6,
            "R": 960,
            "P": 16.0,
            "W": 37,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "DUCO-GCR16-2000": {
            "MT": "R",
            "N": "DUCO GCR16-2000",
            "F": "DUCO-GCR16-2000.robot",
            "I": "DUCO-GCR16-2000-robot.png",
            "IS": "DUCO-GCR16-2000.png",
            "B": "DUCO",
            "M": "GCR16-2000",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 16.0,
            "W": 68,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "DUCO-GCR20-1100": {
            "MT": "R",
            "N": "DUCO GCR20-1100",
            "F": "DUCO-GCR20-1100.robot",
            "I": "DUCO-GCR20-1100-robot.png",
            "IS": "DUCO-GCR20-1100.png",
            "B": "DUCO",
            "M": "GCR20-1100",
            "T": "6 DOF",
            "A": 6,
            "R": 1100,
            "P": 20,
            "W": 50,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "DUCO-GCR20-1400": {
            "MT": "R",
            "N": "DUCO GCR20-1400",
            "F": "DUCO-GCR20-1400.robot",
            "I": "DUCO-GCR20-1400-robot.png",
            "IS": "DUCO-GCR20-1400.png",
            "B": "DUCO",
            "M": "GCR20-1400",
            "T": "6 DOF",
            "A": 6,
            "R": 1400,
            "P": 20.0,
            "W": 66,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "DUCO-GCR25-1800": {
            "MT": "R",
            "N": "DUCO GCR25-1800",
            "F": "DUCO-GCR25-1800.robot",
            "I": "DUCO-GCR25-1800-robot.png",
            "IS": "DUCO-GCR25-1800.png",
            "B": "DUCO",
            "M": "GCR25-1800",
            "T": "6 DOF",
            "A": 6,
            "R": 1800,
            "P": 25.0,
            "W": 61.6,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "DUCO-GCR30-1100": {
            "MT": "R",
            "N": "DUCO GCR30-1100",
            "F": "DUCO-GCR30-1100.robot",
            "I": "DUCO-GCR30-1100-robot.png",
            "IS": "DUCO-GCR30-1100.png",
            "B": "DUCO",
            "M": "GCR30-1100",
            "T": "6 DOF",
            "A": 6,
            "R": 1100,
            "P": 30.0,
            "W": 64,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Efort-ARC12-1400": {
            "MT": "R",
            "N": "Efort ARC12-1400",
            "F": "Efort-ARC12-1400.robot",
            "I": "Efort-ARC12-1400-robot.png",
            "IS": "Efort-ARC12-1400.png",
            "B": "Efort",
            "M": "ARC12-1400",
            "T": "6 DOF",
            "A": 6,
            "R": 1479,
            "P": 12.0,
            "W": 165,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Efort-ARC12-2000": {
            "MT": "R",
            "N": "Efort ARC12-2000",
            "F": "Efort-ARC12-2000.robot",
            "I": "Efort-ARC12-2000-robot.png",
            "IS": "Efort-ARC12-2000.png",
            "B": "Efort",
            "M": "ARC12-2000",
            "T": "6 DOF",
            "A": 6,
            "R": 2025,
            "P": 12.0,
            "W": 207,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Efort-ER10-900": {
            "MT": "R",
            "N": "Efort ER10-900",
            "F": "Efort-ER10-900.robot",
            "I": "Efort-ER10-900-robot.png",
            "IS": "Efort-ER10-900.png",
            "B": "Efort",
            "M": "ER10-900",
            "T": "6 DOF",
            "A": 6,
            "R": 910,
            "P": 10.0,
            "W": 43,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Efort-ER10-1100": {
            "MT": "R",
            "N": "Efort ER10-1100",
            "F": "Efort-ER10-1100.robot",
            "I": "Efort-ER10-1100-robot.png",
            "IS": "Efort-ER10-1100.png",
            "B": "Efort",
            "M": "ER10-1100",
            "T": "6 DOF",
            "A": 6,
            "R": 1142,
            "P": 10.0,
            "W": 78,
            "E": 0.025,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Efort-ER12-2100": {
            "MT": "R",
            "N": "Efort ER12-2100",
            "F": "Efort-ER12-2100.robot",
            "I": "Efort-ER12-2100-robot.png",
            "IS": "Efort-ER12-2100.png",
            "B": "Efort",
            "M": "ER12-2100",
            "T": "6 DOF",
            "A": 6,
            "R": 2051,
            "P": 12.0,
            "W": 200,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Efort-ER12H-2000": {
            "MT": "R",
            "N": "Efort ER12H-2000",
            "F": "Efort-ER12H-2000.robot",
            "I": "Efort-ER12H-2000-robot.png",
            "IS": "Efort-ER12H-2000.png",
            "B": "Efort",
            "M": "ER12H-2000",
            "T": "6 DOF",
            "A": 6,
            "R": 2025,
            "P": 12.0,
            "W": 207,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Efort-ER20": {
            "MT": "R",
            "N": "Efort ER20",
            "F": "Efort-ER20.robot",
            "I": "Efort-ER20-robot.png",
            "IS": "Efort-ER20.png",
            "B": "Efort",
            "M": "ER20",
            "T": "6 DOF",
            "A": 6,
            "R": 1722,
            "P": 20,
            "W": 220,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Efort-ER20-1100": {
            "MT": "R",
            "N": "Efort ER20-1100",
            "F": "Efort-ER20-1100.robot",
            "I": "Efort-ER20-1100-robot.png",
            "IS": "Efort-ER20-1100.png",
            "B": "Efort",
            "M": "ER20-1100",
            "T": "6 DOF",
            "A": 6,
            "R": 1143,
            "P": 20.0,
            "W": 145,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Efort-ER25-1600": {
            "MT": "R",
            "N": "Efort ER25-1600",
            "F": "Efort-ER25-1600.robot",
            "I": "Efort-ER25-1600-robot.png",
            "IS": "Efort-ER25-1600.png",
            "B": "Efort",
            "M": "ER25-1600",
            "T": "6 DOF",
            "A": 6,
            "R": 1665,
            "P": 25.0,
            "W": 215,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Efort-ER25-1800": {
            "MT": "R",
            "N": "Efort ER25-1800",
            "F": "Efort-ER25-1800.robot",
            "I": "Efort-ER25-1800-robot.png",
            "IS": "Efort-ER25-1800.png",
            "B": "Efort",
            "M": "ER25-1800",
            "T": "6 DOF",
            "A": 6,
            "R": 1850,
            "P": 25.0,
            "W": 217,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Efort-ER25-2300": {
            "MT": "R",
            "N": "Efort ER25-2300",
            "F": "Efort-ER25-2300.robot",
            "I": "Efort-ER25-2300-robot.png",
            "IS": "Efort-ER25-2300.png",
            "B": "Efort",
            "M": "ER25-2300",
            "T": "6 DOF",
            "A": 6,
            "R": 2295,
            "P": 25.0,
            "W": 220,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Efort-ER35-1900": {
            "MT": "R",
            "N": "Efort ER35-1900",
            "F": "Efort-ER35-1900.robot",
            "I": "Efort-ER35-1900-robot.png",
            "IS": "Efort-ER35-1900.png",
            "B": "Efort",
            "M": "ER35-1900",
            "T": "6 DOF",
            "A": 6,
            "R": 1875,
            "P": 35.0,
            "W": 275,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Efort-ER50-2100": {
            "MT": "R",
            "N": "Efort ER50-2100",
            "F": "Efort-ER50-2100.robot",
            "I": "Efort-ER50-2100-robot.png",
            "IS": "Efort-ER50-2100.png",
            "B": "Efort",
            "M": "ER50-2100",
            "T": "6 DOF",
            "A": 6,
            "R": 2146,
            "P": 50.0,
            "W": 610,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Efort-ER50-2700": {
            "MT": "R",
            "N": "Efort ER50-2700",
            "F": "Efort-ER50-2700.robot",
            "I": "Efort-ER50-2700-robot.png",
            "IS": "Efort-ER50-2700.png",
            "B": "Efort",
            "M": "ER50-2700",
            "T": "6 DOF",
            "A": 6,
            "R": 2750,
            "P": 50.0,
            "W": 615,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Efort-ER70-2100": {
            "MT": "R",
            "N": "Efort ER70-2100",
            "F": "Efort-ER70-2100.robot",
            "I": "Efort-ER70-2100-robot.png",
            "IS": "Efort-ER70-2100.png",
            "B": "Efort",
            "M": "ER70-2100",
            "T": "6 DOF",
            "A": 6,
            "R": 2146,
            "P": 70.0,
            "W": 550,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Efort-ER150-2700": {
            "MT": "R",
            "N": "Efort ER150-2700",
            "F": "Efort-ER150-2700.robot",
            "I": "Efort-ER150-2700-robot.png",
            "IS": "Efort-ER150-2700.png",
            "B": "Efort",
            "M": "ER150-2700",
            "T": "6 DOF",
            "A": 6,
            "R": 2674,
            "P": 150.0,
            "W": 1110,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Efort-ER150-3200": {
            "MT": "R",
            "N": "Efort ER150-3200",
            "F": "Efort-ER150-3200.robot",
            "I": "Efort-ER150-3200-robot.png",
            "IS": "Efort-ER150-3200.png",
            "B": "Efort",
            "M": "ER150-3200",
            "T": "6 DOF",
            "A": 6,
            "R": 3192,
            "P": 150.0,
            "W": 1160,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Efort-ER210-2700": {
            "MT": "R",
            "N": "Efort ER210-2700",
            "F": "Efort-ER210-2700.robot",
            "I": "Efort-ER210-2700-robot.png",
            "IS": "Efort-ER210-2700.png",
            "B": "Efort",
            "M": "ER210-2700",
            "T": "6 DOF",
            "A": 6,
            "R": 2674,
            "P": 210,
            "W": 1110,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Efort-GR680": {
            "MT": "R",
            "N": "Efort GR680",
            "F": "Efort-GR680.robot",
            "I": "Efort-GR680-robot.png",
            "IS": "Efort-GR680.png",
            "B": "Efort",
            "M": "GR680",
            "T": "6 DOF",
            "A": 6,
            "R": 1722,
            "P": 20,
            "W": 220,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Efort-GR6150-2900": {
            "MT": "R",
            "N": "Efort GR6150-2900",
            "F": "Efort-GR6150-2900.robot",
            "I": "Efort-GR6150-2900-robot.png",
            "IS": "Efort-GR6150-2900.png",
            "B": "Efort",
            "M": "GR6150-2900",
            "T": "6 DOF",
            "A": 6,
            "R": 2903,
            "P": 15.0,
            "W": 650,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Elephant-Robotics-myCobot-Pro-600": {
            "MT": "R",
            "N": "Elephant Robotics myCobot Pro-600",
            "F": "Elephant-Robotics-myCobot-Pro-600.robot",
            "I": "Elephant-Robotics-myCobot-Pro-600-robot.png",
            "IS": "Elephant-Robotics-myCobot-Pro-600.png",
            "B": "Elephant Robotics",
            "M": "myCobot Pro-600",
            "T": "6 DOF",
            "A": 6,
            "R": 600,
            "P": 2.0,
            "W": 8.8,
            "E": 0.5,
            "AP": [
                "Assembly",
                "Collaborative",
                "Inspection",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Elephant-Robotics-myCobot-280-M5": {
            "MT": "R",
            "N": "Elephant Robotics myCobot-280-M5",
            "F": "Elephant-Robotics-myCobot-280-M5.robot",
            "I": "Elephant-Robotics-myCobot-280-M5-robot.png",
            "IS": "Elephant-Robotics-myCobot-280-M5.png",
            "B": "Elephant Robotics",
            "M": "myCobot-280-M5",
            "T": "6 DOF",
            "A": 6,
            "R": 280,
            "P": 0.25,
            "E": 0.5,
            "AP": [
                "Assembly",
                "Collaborative",
                "Inspection",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Elite-Robots-CS530H": {
            "MT": "R",
            "N": "Elite Robots CS530H",
            "F": "Elite-Robots-CS530H.robot",
            "I": "Elite-Robots-CS530H-robot.png",
            "IS": "Elite-Robots-CS530H.png",
            "B": "Elite Robots",
            "M": "CS530H",
            "T": "5 DOF",
            "A": 5,
            "R": 1522,
            "P": 30.0,
            "W": 58,
            "E": 0.01,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Elite-Robots-CS63": {
            "MT": "R",
            "N": "Elite Robots CS63",
            "F": "Elite-Robots-CS63.robot",
            "I": "Elite-Robots-CS63-robot.png",
            "IS": "Elite-Robots-CS63.png",
            "B": "Elite Robots",
            "M": "CS63",
            "T": "6 DOF",
            "A": 6,
            "R": 624,
            "P": 3,
            "W": 15,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Elite-Robots-CS66": {
            "MT": "R",
            "N": "Elite Robots CS66",
            "F": "Elite-Robots-CS66.robot",
            "I": "Elite-Robots-CS66-robot.png",
            "IS": "Elite-Robots-CS66.png",
            "B": "Elite Robots",
            "M": "CS66",
            "T": "6 DOF",
            "A": 6,
            "R": 914,
            "P": 6,
            "W": 20,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Elite-Robots-CS612": {
            "MT": "R",
            "N": "Elite Robots CS612",
            "F": "Elite-Robots-CS612.robot",
            "I": "Elite-Robots-CS612-robot.png",
            "IS": "Elite-Robots-CS612.png",
            "B": "Elite Robots",
            "M": "CS612",
            "T": "6 DOF",
            "A": 6,
            "R": 1304,
            "P": 12,
            "W": 34,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Elite-Robots-CS620": {
            "MT": "R",
            "N": "Elite Robots CS620",
            "F": "Elite-Robots-CS620.robot",
            "I": "Elite-Robots-CS620-robot.png",
            "IS": "Elite-Robots-CS620.png",
            "B": "Elite Robots",
            "M": "CS620",
            "T": "6 DOF",
            "A": 6,
            "R": 1800,
            "P": 20,
            "W": 60,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Elite-Robots-CS625": {
            "MT": "R",
            "N": "Elite Robots CS625",
            "F": "Elite-Robots-CS625.robot",
            "I": "Elite-Robots-CS625-robot.png",
            "IS": "Elite-Robots-CS625.png",
            "B": "Elite Robots",
            "M": "CS625",
            "T": "6 DOF",
            "A": 6,
            "R": 1500,
            "P": 25,
            "W": 58,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Elite-Robots-EC63": {
            "MT": "R",
            "N": "Elite Robots EC63",
            "F": "Elite-Robots-EC63.robot",
            "I": "Elite-Robots-EC63-robot.png",
            "IS": "Elite-Robots-EC63.png",
            "B": "Elite Robots",
            "M": "EC63",
            "T": "6 DOF",
            "A": 6,
            "R": 624,
            "P": 3,
            "W": 28.9,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Elite-Robots-EC64-19": {
            "MT": "R",
            "N": "Elite Robots EC64-19",
            "F": "Elite-Robots-EC64-19.robot",
            "I": "Elite-Robots-EC64-19-robot.png",
            "IS": "Elite-Robots-EC64-19.png",
            "B": "Elite Robots",
            "M": "EC64-19",
            "T": "6 DOF",
            "A": 6,
            "R": 1900,
            "P": 4,
            "W": 33.5,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Elite-Robots-EC66": {
            "MT": "R",
            "N": "Elite Robots EC66",
            "F": "Elite-Robots-EC66.robot",
            "I": "Elite-Robots-EC66-robot.png",
            "IS": "Elite-Robots-EC66.png",
            "B": "Elite Robots",
            "M": "EC66",
            "T": "6 DOF",
            "A": 6,
            "R": 914,
            "P": 6,
            "W": 28.9,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Elite-Robots-EC68-08": {
            "MT": "R",
            "N": "Elite Robots EC68-08",
            "F": "Elite-Robots-EC68-08.robot",
            "I": "Elite-Robots-EC68-08-robot.png",
            "IS": "Elite-Robots-EC68-08.png",
            "B": "Elite Robots",
            "M": "EC68-08",
            "T": "6 DOF",
            "A": 6,
            "R": 820,
            "P": 8.0,
            "W": 17.0,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Elite-Robots-EC612": {
            "MT": "R",
            "N": "Elite Robots EC612",
            "F": "Elite-Robots-EC612.robot",
            "I": "Elite-Robots-EC612-robot.png",
            "IS": "Elite-Robots-EC612.png",
            "B": "Elite Robots",
            "M": "EC612",
            "T": "6 DOF",
            "A": 6,
            "R": 1200,
            "P": 12,
            "W": 60,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Elite-Robots-EC616": {
            "MT": "R",
            "N": "Elite Robots EC616",
            "F": "Elite-Robots-EC616.robot",
            "I": "Elite-Robots-EC616-robot.png",
            "IS": "Elite-Robots-EC616.png",
            "B": "Elite Robots",
            "M": "EC616",
            "T": "6 DOF",
            "A": 6,
            "R": 954,
            "P": 16,
            "W": 32.5,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Epson-C3": {
            "MT": "R",
            "N": "Epson C3",
            "F": "Epson-C3.robot",
            "I": "Epson-C3-robot.png",
            "IS": "Epson-C3.png",
            "B": "Epson",
            "M": "C3",
            "T": "6 DOF",
            "A": 6,
            "R": 600,
            "P": 3,
            "W": 27,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Epson-C4-A601S": {
            "MT": "R",
            "N": "Epson C4-A601S",
            "F": "Epson-C4-A601S.robot",
            "I": "Epson-C4-A601S-robot.png",
            "IS": "Epson-C4-A601S.png",
            "B": "Epson",
            "M": "C4-A601S",
            "T": "6 DOF",
            "A": 6,
            "R": 600,
            "P": 4,
            "W": 27,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Epson-C4-A901": {
            "MT": "R",
            "N": "Epson C4-A901",
            "F": "Epson-C4-A901.robot",
            "I": "Epson-C4-A901-robot.png",
            "IS": "Epson-C4-A901.png",
            "B": "Epson",
            "M": "C4-A901",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 4,
            "W": 29,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Epson-C8": {
            "MT": "R",
            "N": "Epson C8",
            "F": "Epson-C8.robot",
            "I": "Epson-C8-robot.png",
            "IS": "Epson-C8.png",
            "B": "Epson",
            "M": "C8",
            "T": "6 DOF",
            "A": 6,
            "R": 711,
            "P": 8,
            "W": 49,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Epson-C8L": {
            "MT": "R",
            "N": "Epson C8L",
            "F": "Epson-C8L.robot",
            "I": "Epson-C8L-robot.png",
            "IS": "Epson-C8L.png",
            "B": "Epson",
            "M": "C8L",
            "T": "6 DOF",
            "A": 6,
            "R": 901,
            "P": 8,
            "W": 49,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Epson-C8XL": {
            "MT": "R",
            "N": "Epson C8XL",
            "F": "Epson-C8XL.robot",
            "I": "Epson-C8XL-robot.png",
            "IS": "Epson-C8XL.png",
            "B": "Epson",
            "M": "C8XL",
            "T": "6 DOF",
            "A": 6,
            "R": 1400,
            "P": 8,
            "W": 62,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Epson-C12XL-A1401": {
            "MT": "R",
            "N": "Epson C12XL-A1401",
            "F": "Epson-C12XL-A1401.robot",
            "I": "Epson-C12XL-A1401-robot.png",
            "IS": "Epson-C12XL-A1401.png",
            "B": "Epson",
            "M": "C12XL-A1401",
            "T": "6 DOF",
            "A": 6,
            "R": 1400,
            "P": 12,
            "W": 63,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Epson-N2-A450": {
            "MT": "R",
            "N": "Epson N2-A450",
            "F": "Epson-N2-A450.robot",
            "I": "Epson-N2-A450-robot.png",
            "IS": "Epson-N2-A450.png",
            "B": "Epson",
            "M": "N2-A450",
            "T": "6 DOF",
            "A": 6,
            "R": 450,
            "P": 2.5,
            "W": 19,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Epson-N6-A850": {
            "MT": "R",
            "N": "Epson N6-A850",
            "F": "Epson-N6-A850.robot",
            "I": "Epson-N6-A850-robot.png",
            "IS": "Epson-N6-A850.png",
            "B": "Epson",
            "M": "N6-A850",
            "T": "6 DOF",
            "A": 6,
            "R": 850,
            "P": 6,
            "W": 64,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Epson-N6-A1000": {
            "MT": "R",
            "N": "Epson N6-A1000",
            "F": "Epson-N6-A1000.robot",
            "I": "Epson-N6-A1000-robot.png",
            "IS": "Epson-N6-A1000.png",
            "B": "Epson",
            "M": "N6-A1000",
            "T": "6 DOF",
            "A": 6,
            "R": 1010,
            "P": 6,
            "W": 69,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Epson-ProSix-PS3": {
            "MT": "R",
            "N": "Epson ProSix PS3",
            "F": "Epson-ProSix-PS3.robot",
            "I": "Epson-ProSix-PS3-robot.png",
            "IS": "Epson-ProSix-PS3.png",
            "B": "Epson",
            "M": "ProSix PS3",
            "T": "6 DOF",
            "A": 6,
            "R": 949,
            "P": 4,
            "W": 45,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Epson-VT6": {
            "MT": "R",
            "N": "Epson VT6",
            "F": "Epson-VT6.robot",
            "I": "Epson-VT6-robot.png",
            "IS": "Epson-VT6.png",
            "B": "Epson",
            "M": "VT6",
            "T": "6 DOF",
            "A": 6,
            "R": 920,
            "P": 6,
            "W": 40,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Epson-G1-171S": {
            "MT": "R",
            "N": "Epson G1-171S",
            "F": "Epson-G1-171S.robot",
            "I": "Epson-G1-171S-robot.png",
            "IS": "Epson-G1-171S.png",
            "B": "Epson",
            "M": "G1-171S",
            "T": "SCARA",
            "A": 4,
            "R": 175,
            "P": 1,
            "W": 8,
            "E": 0.005,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Epson-G1-221S": {
            "MT": "R",
            "N": "Epson G1-221S",
            "F": "Epson-G1-221S.robot",
            "I": "Epson-G1-221S-robot.png",
            "IS": "Epson-G1-221S.png",
            "B": "Epson",
            "M": "G1-221S",
            "T": "SCARA",
            "A": 4,
            "R": 225,
            "P": 1,
            "W": 8,
            "E": 0.005,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Epson-G6-651S": {
            "MT": "R",
            "N": "Epson G6-651S",
            "F": "Epson-G6-651S.robot",
            "I": "Epson-G6-651S-robot.png",
            "IS": "Epson-G6-651S.png",
            "B": "Epson",
            "M": "G6-651S",
            "T": "SCARA",
            "A": 4,
            "R": 650,
            "P": 6,
            "W": 28,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Epson-G6-653S": {
            "MT": "R",
            "N": "Epson G6-653S",
            "F": "Epson-G6-653S.robot",
            "I": "Epson-G6-653S-robot.png",
            "IS": "Epson-G6-653S.png",
            "B": "Epson",
            "M": "G6-653S",
            "T": "SCARA",
            "A": 4,
            "R": 650,
            "P": 6,
            "W": 28,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Epson-GX8-A552C": {
            "MT": "R",
            "N": "Epson GX8-A552C",
            "F": "Epson-GX8-A552C.robot",
            "I": "Epson-GX8-A552C-robot.png",
            "IS": "Epson-GX8-A552C.png",
            "B": "Epson",
            "M": "GX8-A552C",
            "T": "SCARA",
            "A": 4,
            "R": 550,
            "P": 4.0,
            "W": 34,
            "E": 0.015,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Epson-LS3-401S": {
            "MT": "R",
            "N": "Epson LS3-401S",
            "F": "Epson-LS3-401S.robot",
            "I": "Epson-LS3-401S-robot.png",
            "IS": "Epson-LS3-401S.png",
            "B": "Epson",
            "M": "LS3-401S",
            "T": "SCARA",
            "A": 4,
            "R": 400,
            "P": 3,
            "W": 14,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Epson-LS6-502S": {
            "MT": "R",
            "N": "Epson LS6-502S",
            "F": "Epson-LS6-502S.robot",
            "I": "Epson-LS6-502S-robot.png",
            "IS": "Epson-LS6-502S.png",
            "B": "Epson",
            "M": "LS6-502S",
            "T": "SCARA",
            "A": 4,
            "R": 500,
            "P": 6,
            "W": 17,
            "E": 0.022,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Epson-LS6-602S": {
            "MT": "R",
            "N": "Epson LS6-602S",
            "F": "Epson-LS6-602S.robot",
            "I": "Epson-LS6-602S-robot.png",
            "IS": "Epson-LS6-602S.png",
            "B": "Epson",
            "M": "LS6-602S",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 6,
            "W": 17,
            "E": 0.022,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Epson-LS20-B804S": {
            "MT": "R",
            "N": "Epson LS20-B804S",
            "F": "Epson-LS20-B804S.robot",
            "I": "Epson-LS20-B804S-robot.png",
            "IS": "Epson-LS20-B804S.png",
            "B": "Epson",
            "M": "LS20-B804S",
            "T": "SCARA",
            "A": 4,
            "R": 800,
            "P": 20,
            "W": 48,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Epson-LS20-BA04S": {
            "MT": "R",
            "N": "Epson LS20-BA04S",
            "F": "Epson-LS20-BA04S.robot",
            "I": "Epson-LS20-BA04S-robot.png",
            "IS": "Epson-LS20-BA04S.png",
            "B": "Epson",
            "M": "LS20-BA04S",
            "T": "SCARA",
            "A": 4,
            "R": 1000,
            "P": 20,
            "W": 51,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Epson-RS3": {
            "MT": "R",
            "N": "Epson RS3",
            "F": "Epson-RS3.robot",
            "I": "Epson-RS3-robot.png",
            "IS": "Epson-RS3.png",
            "B": "Epson",
            "M": "RS3",
            "T": "SCARA",
            "A": 4,
            "R": 350,
            "P": 1.0,
            "W": 17,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Epson-RS4": {
            "MT": "R",
            "N": "Epson RS4",
            "F": "Epson-RS4.robot",
            "I": "Epson-RS4-robot.png",
            "IS": "Epson-RS4.png",
            "B": "Epson",
            "M": "RS4",
            "T": "SCARA",
            "A": 4,
            "R": 550,
            "P": 1.0,
            "W": 19,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Epson-T3-401S": {
            "MT": "R",
            "N": "Epson T3-401S",
            "F": "Epson-T3-401S.robot",
            "I": "Epson-T3-401S-robot.png",
            "IS": "Epson-T3-401S.png",
            "B": "Epson",
            "M": "T3-401S",
            "T": "SCARA",
            "A": 4,
            "R": 400,
            "P": 3,
            "W": 16,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Epson-T6-602S": {
            "MT": "R",
            "N": "Epson T6-602S",
            "F": "Epson-T6-602S.robot",
            "I": "Epson-T6-602S-robot.png",
            "IS": "Epson-T6-602S.png",
            "B": "Epson",
            "M": "T6-602S",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 2,
            "W": 22,
            "E": 0.04,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "ESI-C7": {
            "MT": "R",
            "N": "ESI C7",
            "F": "ESI-C7.robot",
            "I": "ESI-C7-robot.png",
            "IS": "ESI-C7.png",
            "B": "ESI",
            "M": "C7",
            "T": "6 DOF",
            "A": 6,
            "R": 740,
            "P": 7,
            "W": 50,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "ESI-C15": {
            "MT": "R",
            "N": "ESI C15",
            "F": "ESI-C15.robot",
            "I": "ESI-C15-robot.png",
            "IS": "ESI-C15.png",
            "B": "ESI",
            "M": "C15",
            "T": "6 DOF",
            "A": 6,
            "R": 1382,
            "P": 15,
            "W": 85,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Estun-ER4-550-MI": {
            "MT": "R",
            "N": "Estun ER4-550-MI",
            "F": "Estun-ER4-550-MI.robot",
            "I": "Estun-ER4-550-MI-robot.png",
            "IS": "Estun-ER4-550-MI.png",
            "B": "Estun",
            "M": "ER4-550-MI",
            "T": "6 DOF",
            "A": 6,
            "R": 550,
            "P": 4.0,
            "W": 25,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Estun-ER7-910-MI": {
            "MT": "R",
            "N": "Estun ER7-910-MI",
            "F": "Estun-ER7-910-MI.robot",
            "I": "Estun-ER7-910-MI-robot.png",
            "IS": "Estun-ER7-910-MI.png",
            "B": "Estun",
            "M": "ER7-910-MI",
            "T": "6 DOF",
            "A": 6,
            "R": 917,
            "P": 7.0,
            "W": 48,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Estun-ER7-910-MI-PI-C": {
            "MT": "R",
            "N": "Estun ER7-910-MI-PI-C",
            "F": "Estun-ER7-910-MI-PI-C.robot",
            "I": "Estun-ER7-910-MI-PI-C-robot.png",
            "IS": "Estun-ER7-910-MI-PI-C.png",
            "B": "Estun",
            "M": "ER7-910-MI-PI-C",
            "T": "6 DOF",
            "A": 6,
            "R": 910,
            "P": 7.0,
            "W": 48,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Estun-ER8-720-MI": {
            "MT": "R",
            "N": "Estun ER8-720-MI",
            "F": "Estun-ER8-720-MI.robot",
            "I": "Estun-ER8-720-MI-robot.png",
            "IS": "Estun-ER8-720-MI.png",
            "B": "Estun",
            "M": "ER8-720-MI",
            "T": "6 DOF",
            "A": 6,
            "R": 727,
            "P": 8.0,
            "W": 46,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Estun-ER8-1450-H": {
            "MT": "R",
            "N": "Estun ER8-1450-H",
            "F": "Estun-ER8-1450-H.robot",
            "I": "Estun-ER8-1450-H-robot.png",
            "IS": "Estun-ER8-1450-H.png",
            "B": "Estun",
            "M": "ER8-1450-H",
            "T": "6 DOF",
            "A": 6,
            "R": 1450,
            "P": 8,
            "W": 170,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Estun-ER8-1450-HW": {
            "MT": "R",
            "N": "Estun ER8-1450-HW",
            "F": "Estun-ER8-1450-HW.robot",
            "I": "Estun-ER8-1450-HW-robot.png",
            "IS": "Estun-ER8-1450-HW.png",
            "B": "Estun",
            "M": "ER8-1450-HW",
            "T": "6 DOF",
            "A": 6,
            "R": 1445,
            "P": 8.0,
            "W": 170,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Estun-ER8-2000-HW": {
            "MT": "R",
            "N": "Estun ER8-2000-HW",
            "F": "Estun-ER8-2000-HW.robot",
            "I": "Estun-ER8-2000-HW-robot.png",
            "IS": "Estun-ER8-2000-HW.png",
            "B": "Estun",
            "M": "ER8-2000-HW",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 8.0,
            "W": 286,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Estun-ER10B-900-MI": {
            "MT": "R",
            "N": "Estun ER10B-900-MI",
            "F": "Estun-ER10B-900-MI.robot",
            "I": "Estun-ER10B-900-MI-robot.png",
            "IS": "Estun-ER10B-900-MI.png",
            "B": "Estun",
            "M": "ER10B-900-MI",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 10.0,
            "W": 75,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Estun-ER15-1430-MI": {
            "MT": "R",
            "N": "Estun ER15-1430-MI",
            "F": "Estun-ER15-1430-MI.robot",
            "I": "Estun-ER15-1430-MI-robot.png",
            "IS": "Estun-ER15-1430-MI.png",
            "B": "Estun",
            "M": "ER15-1430-MI",
            "T": "6 DOF",
            "A": 6,
            "R": 1430,
            "P": 15.0,
            "W": 155,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Estun-ER16-1600": {
            "MT": "R",
            "N": "Estun ER16-1600",
            "F": "Estun-ER16-1600.robot",
            "I": "Estun-ER16-1600-robot.png",
            "IS": "Estun-ER16-1600.png",
            "B": "Estun",
            "M": "ER16-1600",
            "T": "6 DOF",
            "A": 6,
            "R": 1590,
            "P": 16,
            "W": 170,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Estun-ER20-1200-MI": {
            "MT": "R",
            "N": "Estun ER20-1200-MI",
            "F": "Estun-ER20-1200-MI.robot",
            "I": "Estun-ER20-1200-MI-robot.png",
            "IS": "Estun-ER20-1200-MI.png",
            "B": "Estun",
            "M": "ER20-1200-MI",
            "T": "6 DOF",
            "A": 6,
            "R": 1200,
            "P": 20.0,
            "W": 148,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Estun-ER20-1780": {
            "MT": "R",
            "N": "Estun ER20-1780",
            "F": "Estun-ER20-1780.robot",
            "I": "Estun-ER20-1780-robot.png",
            "IS": "Estun-ER20-1780.png",
            "B": "Estun",
            "M": "ER20-1780",
            "T": "6 DOF",
            "A": 6,
            "R": 1780,
            "P": 16,
            "W": 170,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Estun-ER20-2000": {
            "MT": "R",
            "N": "Estun ER20-2000",
            "F": "Estun-ER20-2000.robot",
            "I": "Estun-ER20-2000-robot.png",
            "IS": "Estun-ER20-2000.png",
            "B": "Estun",
            "M": "ER20-2000",
            "T": "6 DOF",
            "A": 6,
            "R": 1780,
            "P": 20,
            "W": 170,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Estun-ER20-2000-HI": {
            "MT": "R",
            "N": "Estun ER20-2000-HI",
            "F": "Estun-ER20-2000-HI.robot",
            "I": "Estun-ER20-2000-HI-robot.png",
            "IS": "Estun-ER20-2000-HI.png",
            "B": "Estun",
            "M": "ER20-2000-HI",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 10,
            "W": 248,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Estun-ER20B-1760": {
            "MT": "R",
            "N": "Estun ER20B-1760",
            "F": "Estun-ER20B-1760.robot",
            "I": "Estun-ER20B-1760-robot.png",
            "IS": "Estun-ER20B-1760.png",
            "B": "Estun",
            "M": "ER20B-1760",
            "T": "6 DOF",
            "A": 6,
            "R": 1756,
            "P": 20.0,
            "W": 273,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Estun-ER30B-1810-F": {
            "MT": "R",
            "N": "Estun ER30B-1810-F",
            "F": "Estun-ER30B-1810-F.robot",
            "I": "Estun-ER30B-1810-F-robot.png",
            "IS": "Estun-ER30B-1810-F.png",
            "B": "Estun",
            "M": "ER30B-1810-F",
            "T": "6 DOF",
            "A": 6,
            "R": 1813,
            "P": 30.0,
            "W": 284,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Estun-ER30B-2700": {
            "MT": "R",
            "N": "Estun ER30B-2700",
            "F": "Estun-ER30B-2700.robot",
            "I": "Estun-ER30B-2700-robot.png",
            "IS": "Estun-ER30B-2700.png",
            "B": "Estun",
            "M": "ER30B-2700",
            "T": "6 DOF",
            "A": 6,
            "R": 2700,
            "P": 30.0,
            "W": 520,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Estun-ER35B-1810": {
            "MT": "R",
            "N": "Estun ER35B-1810",
            "F": "Estun-ER35B-1810.robot",
            "I": "Estun-ER35B-1810-robot.png",
            "IS": "Estun-ER35B-1810.png",
            "B": "Estun",
            "M": "ER35B-1810",
            "T": "6 DOF",
            "A": 6,
            "R": 1813,
            "P": 35.0,
            "W": 277,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Estun-ER45-2200-BD": {
            "MT": "R",
            "N": "Estun ER45-2200-BD",
            "F": "Estun-ER45-2200-BD.robot",
            "I": "Estun-ER45-2200-BD-robot.png",
            "IS": "Estun-ER45-2200-BD.png",
            "B": "Estun",
            "M": "ER45-2200-BD",
            "T": "6 DOF",
            "A": 6,
            "R": 2200,
            "P": 45.0,
            "W": 520,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Estun-ER50B-2100": {
            "MT": "R",
            "N": "Estun ER50B-2100",
            "F": "Estun-ER50B-2100.robot",
            "I": "Estun-ER50B-2100-robot.png",
            "IS": "Estun-ER50B-2100.png",
            "B": "Estun",
            "M": "ER50B-2100",
            "T": "6 DOF",
            "A": 6,
            "R": 2110,
            "P": 50.0,
            "W": 522,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Estun-ER80B-2565-BD": {
            "MT": "R",
            "N": "Estun ER80B-2565-BD",
            "F": "Estun-ER80B-2565-BD.robot",
            "I": "Estun-ER80B-2565-BD-robot.png",
            "IS": "Estun-ER80B-2565-BD.png",
            "B": "Estun",
            "M": "ER80B-2565-BD",
            "T": "6 DOF",
            "A": 6,
            "R": 2565,
            "P": 8.0,
            "W": 730,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Estun-ER100B-3000": {
            "MT": "R",
            "N": "Estun ER100B-3000",
            "F": "Estun-ER100B-3000.robot",
            "I": "Estun-ER100B-3000-robot.png",
            "IS": "Estun-ER100B-3000.png",
            "B": "Estun",
            "M": "ER100B-3000",
            "T": "6 DOF",
            "A": 6,
            "R": 3000,
            "P": 100,
            "W": 1053,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Estun-ER100B-3500-DW": {
            "MT": "R",
            "N": "Estun ER100B-3500-DW",
            "F": "Estun-ER100B-3500-DW.robot",
            "I": "Estun-ER100B-3500-DW-robot.png",
            "IS": "Estun-ER100B-3500-DW.png",
            "B": "Estun",
            "M": "ER100B-3500-DW",
            "T": "6 DOF",
            "A": 6,
            "R": 3500,
            "P": 100.0,
            "W": 1050,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Estun-ER130B-2865-BD": {
            "MT": "R",
            "N": "Estun ER130B-2865-BD",
            "F": "Estun-ER130B-2865-BD.robot",
            "I": "Estun-ER130B-2865-BD-robot.png",
            "IS": "Estun-ER130B-2865-BD.png",
            "B": "Estun",
            "M": "ER130B-2865-BD",
            "T": "6 DOF",
            "A": 6,
            "R": 2865,
            "P": 130,
            "W": 522,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Estun-ER130B-3200": {
            "MT": "R",
            "N": "Estun ER130B-3200",
            "F": "Estun-ER130B-3200.robot",
            "I": "Estun-ER130B-3200-robot.png",
            "IS": "Estun-ER130B-3200.png",
            "B": "Estun",
            "M": "ER130B-3200",
            "T": "6 DOF",
            "A": 6,
            "R": 3200,
            "P": 130.0,
            "W": 1120,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Estun-ER160B-3200": {
            "MT": "R",
            "N": "Estun ER160B-3200",
            "F": "Estun-ER160B-3200.robot",
            "I": "Estun-ER160B-3200-robot.png",
            "IS": "Estun-ER160B-3200.png",
            "B": "Estun",
            "M": "ER160B-3200",
            "T": "6 DOF",
            "A": 6,
            "R": 3200,
            "P": 160.0,
            "W": 1150,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Estun-ER170B-2650-P": {
            "MT": "R",
            "N": "Estun ER170B-2650-P",
            "F": "Estun-ER170B-2650-P.robot",
            "I": "Estun-ER170B-2650-P-robot.png",
            "IS": "Estun-ER170B-2650-P.png",
            "B": "Estun",
            "M": "ER170B-2650-P",
            "T": "6 DOF",
            "A": 6,
            "R": 2650,
            "P": 170.0,
            "W": 1092,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Estun-ER220-2700": {
            "MT": "R",
            "N": "Estun ER220-2700",
            "F": "Estun-ER220-2700.robot",
            "I": "Estun-ER220-2700-robot.png",
            "IS": "Estun-ER220-2700.png",
            "B": "Estun",
            "M": "ER220-2700",
            "T": "6 DOF",
            "A": 6,
            "R": 2700,
            "P": 270.0,
            "W": 1340,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Estun-ER220-3100": {
            "MT": "R",
            "N": "Estun ER220-3100",
            "F": "Estun-ER220-3100.robot",
            "I": "Estun-ER220-3100-robot.png",
            "IS": "Estun-ER220-3100.png",
            "B": "Estun",
            "M": "ER220-3100",
            "T": "6 DOF",
            "A": 6,
            "R": 3100,
            "P": 220.0,
            "W": 1345,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Estun-ER220B-2650": {
            "MT": "R",
            "N": "Estun ER220B-2650",
            "F": "Estun-ER220B-2650.robot",
            "I": "Estun-ER220B-2650-robot.png",
            "IS": "Estun-ER220B-2650.png",
            "B": "Estun",
            "M": "ER220B-2650",
            "T": "6 DOF",
            "A": 6,
            "R": 2650,
            "P": 220.0,
            "W": 1120,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Estun-ER270-2700": {
            "MT": "R",
            "N": "Estun ER270-2700",
            "F": "Estun-ER270-2700.robot",
            "I": "Estun-ER270-2700-robot.png",
            "IS": "Estun-ER270-2700.png",
            "B": "Estun",
            "M": "ER270-2700",
            "T": "6 DOF",
            "A": 6,
            "R": 2700,
            "P": 270.0,
            "W": 1350,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Estun-ER350-3300": {
            "MT": "R",
            "N": "Estun ER350-3300",
            "F": "Estun-ER350-3300.robot",
            "I": "Estun-ER350-3300-robot.png",
            "IS": "Estun-ER350-3300.png",
            "B": "Estun",
            "M": "ER350-3300",
            "T": "6 DOF",
            "A": 6,
            "R": 3300,
            "P": 350,
            "W": 3040,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Estun-ER500-2800": {
            "MT": "R",
            "N": "Estun ER500-2800",
            "F": "Estun-ER500-2800.robot",
            "I": "Estun-ER500-2800-robot.png",
            "IS": "Estun-ER500-2800.png",
            "B": "Estun",
            "M": "ER500-2800",
            "T": "6 DOF",
            "A": 6,
            "R": 2800,
            "P": 500,
            "W": 3000,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Estun-H35-210": {
            "MT": "R",
            "N": "Estun H35-210",
            "F": "Estun-H35-210.robot",
            "I": "Estun-H35-210-robot.png",
            "IS": "Estun-H35-210.png",
            "B": "Estun",
            "M": "H35-210",
            "T": "6 DOF",
            "A": 6,
            "R": 2100,
            "P": 35.0,
            "W": 170,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Estun-S3-60-Eco": {
            "MT": "R",
            "N": "Estun S3-60 Eco",
            "F": "Estun-S3-60-Eco.robot",
            "I": "Estun-S3-60-Eco-robot.png",
            "IS": "Estun-S3-60-Eco.png",
            "B": "Estun",
            "M": "S3-60 Eco",
            "T": "6 DOF",
            "A": 6,
            "R": 575.8,
            "P": 3.0,
            "W": 14,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Estun-S3-60-G2": {
            "MT": "R",
            "N": "Estun S3-60 G2",
            "F": "Estun-S3-60-G2.robot",
            "I": "Estun-S3-60-G2-robot.png",
            "IS": "Estun-S3-60-G2.png",
            "B": "Estun",
            "M": "S3-60 G2",
            "T": "6 DOF",
            "A": 6,
            "R": 575.8,
            "P": 3.0,
            "W": 14,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Estun-S3-60-Pro": {
            "MT": "R",
            "N": "Estun S3-60 Pro",
            "F": "Estun-S3-60-Pro.robot",
            "I": "Estun-S3-60-Pro-robot.png",
            "IS": "Estun-S3-60-Pro.png",
            "B": "Estun",
            "M": "S3-60 Pro",
            "T": "6 DOF",
            "A": 6,
            "R": 575.8,
            "P": 3.0,
            "W": 14,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Estun-S5-90-G2": {
            "MT": "R",
            "N": "Estun S5-90 G2",
            "F": "Estun-S5-90-G2.robot",
            "I": "Estun-S5-90-G2-robot.png",
            "IS": "Estun-S5-90-G2.png",
            "B": "Estun",
            "M": "S5-90 G2",
            "T": "6 DOF",
            "A": 6,
            "R": 919,
            "P": 5.0,
            "W": 21,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Estun-S10-140-Eco": {
            "MT": "R",
            "N": "Estun S10-140 Eco",
            "F": "Estun-S10-140-Eco.robot",
            "I": "Estun-S10-140-Eco-robot.png",
            "IS": "Estun-S10-140-Eco.png",
            "B": "Estun",
            "M": "S10-140 Eco",
            "T": "6 DOF",
            "A": 6,
            "R": 1400,
            "P": 10.0,
            "W": 37,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Estun-S10-140-G2": {
            "MT": "R",
            "N": "Estun S10-140 G2",
            "F": "Estun-S10-140-G2.robot",
            "I": "Estun-S10-140-G2-robot.png",
            "IS": "Estun-S10-140-G2.png",
            "B": "Estun",
            "M": "S10-140 G2",
            "T": "6 DOF",
            "A": 6,
            "R": 1400,
            "P": 10.0,
            "W": 37,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Estun-S10-140-Pro": {
            "MT": "R",
            "N": "Estun S10-140 Pro",
            "F": "Estun-S10-140-Pro.robot",
            "I": "Estun-S10-140-Pro-robot.png",
            "IS": "Estun-S10-140-Pro.png",
            "B": "Estun",
            "M": "S10-140 Pro",
            "T": "6 DOF",
            "A": 6,
            "R": 1400,
            "P": 10.0,
            "W": 37,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Estun-S12-125-G2": {
            "MT": "R",
            "N": "Estun S12-125 G2",
            "F": "Estun-S12-125-G2.robot",
            "I": "Estun-S12-125-G2-robot.png",
            "IS": "Estun-S12-125-G2.png",
            "B": "Estun",
            "M": "S12-125 G2",
            "T": "6 DOF",
            "A": 6,
            "R": 1250,
            "P": 12.0,
            "W": 38,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Estun-S16-98-G2": {
            "MT": "R",
            "N": "Estun S16-98 G2",
            "F": "Estun-S16-98-G2.robot",
            "I": "Estun-S16-98-G2-robot.png",
            "IS": "Estun-S16-98-G2.png",
            "B": "Estun",
            "M": "S16-98 G2",
            "T": "6 DOF",
            "A": 6,
            "R": 980,
            "P": 16.0,
            "W": 39,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Estun-S20-180-Eco": {
            "MT": "R",
            "N": "Estun S20-180 Eco",
            "F": "Estun-S20-180-Eco.robot",
            "I": "Estun-S20-180-Eco-robot.png",
            "IS": "Estun-S20-180-Eco.png",
            "B": "Estun",
            "M": "S20-180 Eco",
            "T": "6 DOF",
            "A": 6,
            "R": 1777.5,
            "P": 20.0,
            "W": 58,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Estun-S20-180-G2": {
            "MT": "R",
            "N": "Estun S20-180 G2",
            "F": "Estun-S20-180-G2.robot",
            "I": "Estun-S20-180-G2-robot.png",
            "IS": "Estun-S20-180-G2.png",
            "B": "Estun",
            "M": "S20-180 G2",
            "T": "6 DOF",
            "A": 6,
            "R": 1777.5,
            "P": 20.0,
            "W": 58,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Estun-ER3-400-SR": {
            "MT": "R",
            "N": "Estun ER3-400-SR",
            "F": "Estun-ER3-400-SR.robot",
            "I": "Estun-ER3-400-SR-robot.png",
            "IS": "Estun-ER3-400-SR.png",
            "B": "Estun",
            "M": "ER3-400-SR",
            "T": "SCARA",
            "A": 4,
            "R": 400,
            "P": 3.0,
            "W": 13,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Estun-ER3-500-SR": {
            "MT": "R",
            "N": "Estun ER3-500-SR",
            "F": "Estun-ER3-500-SR.robot",
            "I": "Estun-ER3-500-SR-robot.png",
            "IS": "Estun-ER3-500-SR.png",
            "B": "Estun",
            "M": "ER3-500-SR",
            "T": "SCARA",
            "A": 4,
            "R": 500,
            "P": 3.0,
            "W": 14,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Estun-ER4-550-SR-U": {
            "MT": "R",
            "N": "Estun ER4-550-SR-U",
            "F": "Estun-ER4-550-SR-U.robot",
            "I": "Estun-ER4-550-SR-U-robot.png",
            "IS": "Estun-ER4-550-SR-U.png",
            "B": "Estun",
            "M": "ER4-550-SR-U",
            "T": "SCARA",
            "A": 4,
            "R": 550,
            "P": 4.0,
            "W": 21,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Estun-ER4-650-SR-U": {
            "MT": "R",
            "N": "Estun ER4-650-SR-U",
            "F": "Estun-ER4-650-SR-U.robot",
            "I": "Estun-ER4-650-SR-U-robot.png",
            "IS": "Estun-ER4-650-SR-U.png",
            "B": "Estun",
            "M": "ER4-650-SR-U",
            "T": "SCARA",
            "A": 4,
            "R": 650,
            "P": 4,
            "W": 22,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Estun-ER6-500-SR": {
            "MT": "R",
            "N": "Estun ER6-500-SR",
            "F": "Estun-ER6-500-SR.robot",
            "I": "Estun-ER6-500-SR-robot.png",
            "IS": "Estun-ER6-500-SR.png",
            "B": "Estun",
            "M": "ER6-500-SR",
            "T": "SCARA",
            "A": 4,
            "R": 500,
            "P": 6,
            "W": 18,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Estun-ER6-600-SR": {
            "MT": "R",
            "N": "Estun ER6-600-SR",
            "F": "Estun-ER6-600-SR.robot",
            "I": "Estun-ER6-600-SR-robot.png",
            "IS": "Estun-ER6-600-SR.png",
            "B": "Estun",
            "M": "ER6-600-SR",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 6.0,
            "W": 18,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Estun-ER10-500-SR": {
            "MT": "R",
            "N": "Estun ER10-500-SR",
            "F": "Estun-ER10-500-SR.robot",
            "I": "Estun-ER10-500-SR-robot.png",
            "IS": "Estun-ER10-500-SR.png",
            "B": "Estun",
            "M": "ER10-500-SR",
            "T": "SCARA",
            "A": 4,
            "R": 500,
            "P": 10,
            "W": 22,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "FAIRINO-FR3": {
            "MT": "R",
            "N": "FAIRINO FR3",
            "F": "FAIRINO-FR3.robot",
            "I": "FAIRINO-FR3-robot.png",
            "IS": "FAIRINO-FR3.png",
            "B": "FAIRINO",
            "M": "FR3",
            "T": "6 DOF",
            "A": 6,
            "R": 622,
            "P": 3.0,
            "W": 15,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "FAIRINO-FR3MT": {
            "MT": "R",
            "N": "FAIRINO FR3MT",
            "F": "FAIRINO-FR3MT.robot",
            "I": "FAIRINO-FR3MT-robot.png",
            "IS": "FAIRINO-FR3MT.png",
            "B": "FAIRINO",
            "M": "FR3MT",
            "T": "6 DOF",
            "A": 6,
            "R": 622,
            "P": 3.0,
            "W": 10,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "FAIRINO-FR5": {
            "MT": "R",
            "N": "FAIRINO FR5",
            "F": "FAIRINO-FR5.robot",
            "I": "FAIRINO-FR5-robot.png",
            "IS": "FAIRINO-FR5.png",
            "B": "FAIRINO",
            "M": "FR5",
            "T": "6 DOF",
            "A": 6,
            "R": 922,
            "P": 5.0,
            "W": 22,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "FAIRINO-FR10": {
            "MT": "R",
            "N": "FAIRINO FR10",
            "F": "FAIRINO-FR10.robot",
            "I": "FAIRINO-FR10-robot.png",
            "IS": "FAIRINO-FR10.png",
            "B": "FAIRINO",
            "M": "FR10",
            "T": "6 DOF",
            "A": 6,
            "R": 1400,
            "P": 10.0,
            "W": 40,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "FAIRINO-FR16": {
            "MT": "R",
            "N": "FAIRINO FR16",
            "F": "FAIRINO-FR16.robot",
            "I": "FAIRINO-FR16-robot.png",
            "IS": "FAIRINO-FR16.png",
            "B": "FAIRINO",
            "M": "FR16",
            "T": "6 DOF",
            "A": 6,
            "R": 1034,
            "P": 16.0,
            "W": 40,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "FAIRINO-FR20": {
            "MT": "R",
            "N": "FAIRINO FR20",
            "F": "FAIRINO-FR20.robot",
            "I": "FAIRINO-FR20-robot.png",
            "IS": "FAIRINO-FR20.png",
            "B": "FAIRINO",
            "M": "FR20",
            "T": "6 DOF",
            "A": 6,
            "R": 1854,
            "P": 20.0,
            "W": 85,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "FAIRINO-FR30": {
            "MT": "R",
            "N": "FAIRINO FR30",
            "F": "FAIRINO-FR30.robot",
            "I": "FAIRINO-FR30-robot.png",
            "IS": "FAIRINO-FR30.png",
            "B": "FAIRINO",
            "M": "FR30",
            "T": "6 DOF",
            "A": 6,
            "R": 1403,
            "P": 30.0,
            "W": 85,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-LR-Mate-100iB": {
            "MT": "R",
            "N": "Fanuc LR Mate 100iB",
            "F": "Fanuc-LR-Mate-100iB.robot",
            "I": "Fanuc-LR-Mate-100iB-robot.png",
            "IS": "Fanuc-LR-Mate-100iB.png",
            "B": "Fanuc",
            "M": "LR Mate 100iB",
            "T": "5 DOF",
            "A": 5,
            "R": 620,
            "P": 5,
            "W": 38,
            "E": 0.04,
            "AP": [
                "Material Handling"
            ]
        },
        "Fanuc-LR-Mate-200iC-5H": {
            "MT": "R",
            "N": "Fanuc LR Mate 200iC/5H",
            "F": "Fanuc-LR-Mate-200iC-5H.robot",
            "I": "Fanuc-LR-Mate-200iC-5H-robot.png",
            "IS": "Fanuc-LR-Mate-200iC-5H.png",
            "B": "Fanuc",
            "M": "LR Mate 200iC/5H",
            "T": "5 DOF",
            "A": 5,
            "R": 704,
            "P": 5,
            "W": 28,
            "E": 0.02,
            "AP": [
                "Material Handling"
            ]
        },
        "Fanuc-LR-Mate-200iD-4SH": {
            "MT": "R",
            "N": "Fanuc LR Mate 200iD/4SH",
            "F": "Fanuc-LR-Mate-200iD-4SH.robot",
            "I": "Fanuc-LR-Mate-200iD-4SH-robot.png",
            "IS": "Fanuc-LR-Mate-200iD-4SH.png",
            "B": "Fanuc",
            "M": "LR Mate 200iD/4SH",
            "T": "5 DOF",
            "A": 5,
            "R": 550,
            "P": 4,
            "W": 19,
            "E": 0.01,
            "AP": [
                "Material Handling"
            ]
        },
        "Fanuc-M-410iB-140H": {
            "MT": "R",
            "N": "Fanuc M-410iB/140H",
            "F": "Fanuc-M-410iB-140H.robot",
            "I": "Fanuc-M-410iB-140H-robot.png",
            "IS": "Fanuc-M-410iB-140H.png",
            "B": "Fanuc",
            "M": "M-410iB/140H",
            "T": "5 DOF",
            "A": 5,
            "R": 2850,
            "P": 140,
            "W": 1200,
            "E": 0.2,
            "AP": [
                "Material Handling"
            ]
        },
        "Fanuc-ARC-Mate-100iD-8L": {
            "MT": "R",
            "N": "Fanuc ARC Mate 100iD/8L",
            "F": "Fanuc-ARC-Mate-100iD-8L.robot",
            "I": "Fanuc-ARC-Mate-100iD-8L-robot.png",
            "IS": "Fanuc-ARC-Mate-100iD-8L.png",
            "B": "Fanuc",
            "M": "ARC Mate 100iD/8L",
            "T": "6 DOF",
            "A": 6,
            "R": 2032,
            "P": 8.0,
            "W": 180.0,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-ARC-Mate-100iD": {
            "MT": "R",
            "N": "Fanuc ARC Mate 100iD",
            "F": "Fanuc-ARC-Mate-100iD.robot",
            "I": "Fanuc-ARC-Mate-100iD-robot.png",
            "IS": "Fanuc-ARC-Mate-100iD.png",
            "B": "Fanuc",
            "M": "ARC Mate 100iD",
            "T": "6 DOF",
            "A": 6,
            "R": 1441,
            "P": 12,
            "W": 250,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-ARC-Mate-120iB-10L": {
            "MT": "R",
            "N": "Fanuc ARC Mate 120iB/10L",
            "F": "Fanuc-ARC-Mate-120iB-10L.robot",
            "I": "Fanuc-ARC-Mate-120iB-10L-robot.png",
            "IS": "Fanuc-ARC-Mate-120iB-10L.png",
            "B": "Fanuc",
            "M": "ARC Mate 120iB/10L",
            "T": "6 DOF",
            "A": 6,
            "R": 1885,
            "P": 10,
            "W": 225,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-ARC-Mate-120iB": {
            "MT": "R",
            "N": "Fanuc ARC Mate 120iB",
            "F": "Fanuc-ARC-Mate-120iB.robot",
            "I": "Fanuc-ARC-Mate-120iB-robot.png",
            "IS": "Fanuc-ARC-Mate-120iB.png",
            "B": "Fanuc",
            "M": "ARC Mate 120iB",
            "T": "6 DOF",
            "A": 6,
            "R": 1667,
            "P": 20,
            "W": 220,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-ARC-Mate-120iC-12L": {
            "MT": "R",
            "N": "Fanuc ARC Mate 120iC/12L",
            "F": "Fanuc-ARC-Mate-120iC-12L.robot",
            "I": "Fanuc-ARC-Mate-120iC-12L-robot.png",
            "IS": "Fanuc-ARC-Mate-120iC-12L.png",
            "B": "Fanuc",
            "M": "ARC Mate 120iC/12L",
            "T": "6 DOF",
            "A": 6,
            "R": 2009,
            "P": 12,
            "W": 250,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-ARC-Mate-120iC": {
            "MT": "R",
            "N": "Fanuc ARC Mate 120iC",
            "F": "Fanuc-ARC-Mate-120iC.robot",
            "I": "Fanuc-ARC-Mate-120iC-robot.png",
            "IS": "Fanuc-ARC-Mate-120iC.png",
            "B": "Fanuc",
            "M": "ARC Mate 120iC",
            "T": "6 DOF",
            "A": 6,
            "R": 1811,
            "P": 3,
            "W": 250,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-ARC-Mate-120iD-12L": {
            "MT": "R",
            "N": "Fanuc ARC Mate 120iD/12L",
            "F": "Fanuc-ARC-Mate-120iD-12L.robot",
            "I": "Fanuc-ARC-Mate-120iD-12L-robot.png",
            "IS": "Fanuc-ARC-Mate-120iD-12L.png",
            "B": "Fanuc",
            "M": "ARC Mate 120iD/12L",
            "T": "6 DOF",
            "A": 6,
            "R": 2272,
            "P": 12,
            "W": 250,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-ARC-Mate-120iD-35": {
            "MT": "R",
            "N": "Fanuc ARC Mate 120iD/35",
            "F": "Fanuc-ARC-Mate-120iD-35.robot",
            "I": "Fanuc-ARC-Mate-120iD-35-robot.png",
            "IS": "Fanuc-ARC-Mate-120iD-35.png",
            "B": "Fanuc",
            "M": "ARC Mate 120iD/35",
            "T": "6 DOF",
            "A": 6,
            "R": 1831,
            "P": 35,
            "W": 250,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-CR-7iA-L": {
            "MT": "R",
            "N": "Fanuc CR-7iA/L",
            "F": "Fanuc-CR-7iA-L.robot",
            "I": "Fanuc-CR-7iA-L-robot.png",
            "IS": "Fanuc-CR-7iA-L.png",
            "B": "Fanuc",
            "M": "CR-7iA/L",
            "T": "6 DOF",
            "A": 6,
            "R": 911,
            "P": 7,
            "W": 55,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-CR-15iA": {
            "MT": "R",
            "N": "Fanuc CR-15iA",
            "F": "Fanuc-CR-15iA.robot",
            "I": "Fanuc-CR-15iA-robot.png",
            "IS": "Fanuc-CR-15iA.png",
            "B": "Fanuc",
            "M": "CR-15iA",
            "T": "6 DOF",
            "A": 6,
            "R": 1441,
            "P": 15,
            "W": 255,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-CR-35iA": {
            "MT": "R",
            "N": "Fanuc CR-35iA",
            "F": "Fanuc-CR-35iA.robot",
            "I": "Fanuc-CR-35iA-robot.png",
            "IS": "Fanuc-CR-35iA.png",
            "B": "Fanuc",
            "M": "CR-35iA",
            "T": "6 DOF",
            "A": 6,
            "R": 1813,
            "P": 35,
            "W": 990,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-CR-35iB": {
            "MT": "R",
            "N": "Fanuc CR-35iB",
            "F": "Fanuc-CR-35iB.robot",
            "I": "Fanuc-CR-35iB-robot.png",
            "IS": "Fanuc-CR-35iB.png",
            "B": "Fanuc",
            "M": "CR-35iB",
            "T": "6 DOF",
            "A": 6,
            "R": 1831,
            "P": 35.0,
            "W": 375,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-CRX-5iA": {
            "MT": "R",
            "N": "Fanuc CRX-5iA",
            "F": "Fanuc-CRX-5iA.robot",
            "I": "Fanuc-CRX-5iA-robot.png",
            "IS": "Fanuc-CRX-5iA.png",
            "B": "Fanuc",
            "M": "CRX-5iA",
            "T": "6 DOF",
            "A": 6,
            "R": 994,
            "P": 5.0,
            "W": 25,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-CRX-10iA-L": {
            "MT": "R",
            "N": "Fanuc CRX-10iA/L",
            "F": "Fanuc-CRX-10iA-L.robot",
            "I": "Fanuc-CRX-10iA-L-robot.png",
            "IS": "Fanuc-CRX-10iA-L.png",
            "B": "Fanuc",
            "M": "CRX-10iA/L",
            "T": "6 DOF",
            "A": 6,
            "R": 1418,
            "P": 10,
            "W": 40,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-CRX-10iA": {
            "MT": "R",
            "N": "Fanuc CRX-10iA",
            "F": "Fanuc-CRX-10iA.robot",
            "I": "Fanuc-CRX-10iA-robot.png",
            "IS": "Fanuc-CRX-10iA.png",
            "B": "Fanuc",
            "M": "CRX-10iA",
            "T": "6 DOF",
            "A": 6,
            "R": 1249,
            "P": 10,
            "W": 40,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-CRX-20iA-L": {
            "MT": "R",
            "N": "Fanuc CRX-20iA/L",
            "F": "Fanuc-CRX-20iA-L.robot",
            "I": "Fanuc-CRX-20iA-L-robot.png",
            "IS": "Fanuc-CRX-20iA-L.png",
            "B": "Fanuc",
            "M": "CRX-20iA/L",
            "T": "6 DOF",
            "A": 6,
            "R": 1418,
            "P": 20,
            "W": 41,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-CRX-25iA": {
            "MT": "R",
            "N": "Fanuc CRX-25iA",
            "F": "Fanuc-CRX-25iA.robot",
            "I": "Fanuc-CRX-25iA-robot.png",
            "IS": "Fanuc-CRX-25iA.png",
            "B": "Fanuc",
            "M": "CRX-25iA",
            "T": "6 DOF",
            "A": 6,
            "R": 1889,
            "P": 25,
            "W": 135,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-CRX-30iA": {
            "MT": "R",
            "N": "Fanuc CRX-30iA",
            "F": "Fanuc-CRX-30iA.robot",
            "I": "Fanuc-CRX-30iA-robot.png",
            "IS": "Fanuc-CRX-30iA.png",
            "B": "Fanuc",
            "M": "CRX-30iA",
            "T": "6 DOF",
            "A": 6,
            "R": 1756,
            "P": 30,
            "W": 135,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-LR-Mate-200iC": {
            "MT": "R",
            "N": "Fanuc LR Mate 200iC",
            "F": "Fanuc-LR-Mate-200iC.robot",
            "I": "Fanuc-LR-Mate-200iC-robot.png",
            "IS": "Fanuc-LR-Mate-200iC.png",
            "B": "Fanuc",
            "M": "LR Mate 200iC",
            "T": "6 DOF",
            "A": 6,
            "R": 704,
            "P": 5,
            "W": 28,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-LR-Mate-200iD-4S": {
            "MT": "R",
            "N": "Fanuc LR Mate 200iD/4S",
            "F": "Fanuc-LR-Mate-200iD-4S.robot",
            "I": "Fanuc-LR-Mate-200iD-4S-robot.png",
            "IS": "Fanuc-LR-Mate-200iD-4S.png",
            "B": "Fanuc",
            "M": "LR Mate 200iD/4S",
            "T": "6 DOF",
            "A": 6,
            "R": 550,
            "P": 4,
            "W": 20,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-LR-Mate-200iD-7L": {
            "MT": "R",
            "N": "Fanuc LR Mate 200iD/7L",
            "F": "Fanuc-LR-Mate-200iD-7L.robot",
            "I": "Fanuc-LR-Mate-200iD-7L-robot.png",
            "IS": "Fanuc-LR-Mate-200iD-7L.png",
            "B": "Fanuc",
            "M": "LR Mate 200iD/7L",
            "T": "6 DOF",
            "A": 6,
            "R": 911,
            "P": 7,
            "W": 27,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-LR-Mate-200iD-14L": {
            "MT": "R",
            "N": "Fanuc LR Mate 200iD/14L",
            "F": "Fanuc-LR-Mate-200iD-14L.robot",
            "I": "Fanuc-LR-Mate-200iD-14L-robot.png",
            "IS": "Fanuc-LR-Mate-200iD-14L.png",
            "B": "Fanuc",
            "M": "LR Mate 200iD/14L",
            "T": "6 DOF",
            "A": 6,
            "R": 911,
            "P": 14,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-LR-Mate-200iD-ER-4iA": {
            "MT": "R",
            "N": "Fanuc LR Mate 200iD/ER-4iA",
            "F": "Fanuc-LR-Mate-200iD-ER-4iA.robot",
            "I": "Fanuc-LR-Mate-200iD-ER-4iA-robot.png",
            "IS": "Fanuc-LR-Mate-200iD-ER-4iA.png",
            "B": "Fanuc",
            "M": "LR Mate 200iD/ER-4iA",
            "T": "6 DOF",
            "A": 6,
            "R": 550,
            "P": 7,
            "W": 20,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-LR-Mate-200iD": {
            "MT": "R",
            "N": "Fanuc LR Mate 200iD",
            "F": "Fanuc-LR-Mate-200iD.robot",
            "I": "Fanuc-LR-Mate-200iD-robot.png",
            "IS": "Fanuc-LR-Mate-200iD.png",
            "B": "Fanuc",
            "M": "LR Mate 200iD",
            "T": "6 DOF",
            "A": 6,
            "R": 717,
            "P": 7,
            "W": 25,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-LR-10iA-10": {
            "MT": "R",
            "N": "Fanuc LR-10iA/10",
            "F": "Fanuc-LR-10iA-10.robot",
            "I": "Fanuc-LR-10iA-10-robot.png",
            "IS": "Fanuc-LR-10iA-10.png",
            "B": "Fanuc",
            "M": "LR-10iA/10",
            "T": "6 DOF",
            "A": 6,
            "R": 1101,
            "P": 10,
            "W": 46,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-6iB": {
            "MT": "R",
            "N": "Fanuc M-6iB",
            "F": "Fanuc-M-6iB.robot",
            "I": "Fanuc-M-6iB-robot.png",
            "IS": "Fanuc-M-6iB.png",
            "B": "Fanuc",
            "M": "M-6iB",
            "T": "6 DOF",
            "A": 6,
            "R": 1373,
            "P": 6,
            "W": 138,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-10iA-6L": {
            "MT": "R",
            "N": "Fanuc M-10iA/6L",
            "F": "Fanuc-M-10iA-6L.robot",
            "I": "Fanuc-M-10iA-6L-robot.png",
            "IS": "Fanuc-M-10iA-6L.png",
            "B": "Fanuc",
            "M": "M-10iA/6L",
            "T": "6 DOF",
            "A": 6,
            "R": 1633,
            "P": 6,
            "W": 135,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-10iA-7L": {
            "MT": "R",
            "N": "Fanuc M-10iA/7L",
            "F": "Fanuc-M-10iA-7L.robot",
            "I": "Fanuc-M-10iA-7L-robot.png",
            "IS": "Fanuc-M-10iA-7L.png",
            "B": "Fanuc",
            "M": "M-10iA/7L",
            "T": "6 DOF",
            "A": 6,
            "R": 1633,
            "P": 7,
            "W": 135,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-10iA-8L": {
            "MT": "R",
            "N": "Fanuc M-10iA/8L",
            "F": "Fanuc-M-10iA-8L.robot",
            "I": "Fanuc-M-10iA-8L-robot.png",
            "IS": "Fanuc-M-10iA-8L.png",
            "B": "Fanuc",
            "M": "M-10iA/8L",
            "T": "6 DOF",
            "A": 6,
            "R": 2028,
            "P": 8,
            "W": 150,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-10iA-10S": {
            "MT": "R",
            "N": "Fanuc M-10iA/10S",
            "F": "Fanuc-M-10iA-10S.robot",
            "I": "Fanuc-M-10iA-10S-robot.png",
            "IS": "Fanuc-M-10iA-10S.png",
            "B": "Fanuc",
            "M": "M-10iA/10S",
            "T": "6 DOF",
            "A": 6,
            "R": 1098,
            "P": 10,
            "W": 130,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-10iA-12": {
            "MT": "R",
            "N": "Fanuc M-10iA/12",
            "F": "Fanuc-M-10iA-12.robot",
            "I": "Fanuc-M-10iA-12-robot.png",
            "IS": "Fanuc-M-10iA-12.png",
            "B": "Fanuc",
            "M": "M-10iA/12",
            "T": "6 DOF",
            "A": 6,
            "R": 1420,
            "P": 12.0,
            "W": 130,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-10iA": {
            "MT": "R",
            "N": "Fanuc M-10iA",
            "F": "Fanuc-M-10iA.robot",
            "I": "Fanuc-M-10iA-robot.png",
            "IS": "Fanuc-M-10iA.png",
            "B": "Fanuc",
            "M": "M-10iA",
            "T": "6 DOF",
            "A": 6,
            "R": 1420,
            "P": 10,
            "W": 130,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-10iD-10L": {
            "MT": "R",
            "N": "Fanuc M-10iD/10L",
            "F": "Fanuc-M-10iD-10L.robot",
            "I": "Fanuc-M-10iD-10L-robot.png",
            "IS": "Fanuc-M-10iD-10L.png",
            "B": "Fanuc",
            "M": "M-10iD/10L",
            "T": "6 DOF",
            "A": 6,
            "R": 1636,
            "P": 10,
            "W": 150,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-10iD-12": {
            "MT": "R",
            "N": "Fanuc M-10iD/12",
            "F": "Fanuc-M-10iD-12.robot",
            "I": "Fanuc-M-10iD-12-robot.png",
            "IS": "Fanuc-M-10iD-12.png",
            "B": "Fanuc",
            "M": "M-10iD/12",
            "T": "6 DOF",
            "A": 6,
            "R": 1441,
            "P": 12,
            "W": 145,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-10iD-16S": {
            "MT": "R",
            "N": "Fanuc M-10iD/16S",
            "F": "Fanuc-M-10iD-16S.robot",
            "I": "Fanuc-M-10iD-16S-robot.png",
            "IS": "Fanuc-M-10iD-16S.png",
            "B": "Fanuc",
            "M": "M-10iD/16S",
            "T": "6 DOF",
            "A": 6,
            "R": 1103,
            "P": 16,
            "W": 140,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-16iB-20": {
            "MT": "R",
            "N": "Fanuc M-16iB/20",
            "F": "Fanuc-M-16iB-20.robot",
            "I": "Fanuc-M-16iB-20-robot.png",
            "IS": "Fanuc-M-16iB-20.png",
            "B": "Fanuc",
            "M": "M-16iB/20",
            "T": "6 DOF",
            "A": 6,
            "R": 1667,
            "P": 20,
            "W": 270,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-20iA-10L": {
            "MT": "R",
            "N": "Fanuc M-20iA/10L",
            "F": "Fanuc-M-20iA-10L.robot",
            "I": "Fanuc-M-20iA-10L-robot.png",
            "IS": "Fanuc-M-20iA-10L.png",
            "B": "Fanuc",
            "M": "M-20iA/10L",
            "T": "6 DOF",
            "A": 6,
            "R": 2009,
            "P": 10,
            "W": 250,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-20iA-12L": {
            "MT": "R",
            "N": "Fanuc M-20iA/12L",
            "F": "Fanuc-M-20iA-12L.robot",
            "I": "Fanuc-M-20iA-12L-robot.png",
            "IS": "Fanuc-M-20iA-12L.png",
            "B": "Fanuc",
            "M": "M-20iA/12L",
            "T": "6 DOF",
            "A": 6,
            "R": 2009,
            "P": 12,
            "W": 250,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-20iA-20M": {
            "MT": "R",
            "N": "Fanuc M-20iA/20M",
            "F": "Fanuc-M-20iA-20M.robot",
            "I": "Fanuc-M-20iA-20M-robot.png",
            "IS": "Fanuc-M-20iA-20M.png",
            "B": "Fanuc",
            "M": "M-20iA/20M",
            "T": "6 DOF",
            "A": 6,
            "R": 1811,
            "P": 20,
            "W": 250,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-20iA-35M": {
            "MT": "R",
            "N": "Fanuc M-20iA/35M",
            "F": "Fanuc-M-20iA-35M.robot",
            "I": "Fanuc-M-20iA-35M-robot.png",
            "IS": "Fanuc-M-20iA-35M.png",
            "B": "Fanuc",
            "M": "M-20iA/35M",
            "T": "6 DOF",
            "A": 6,
            "R": 1813,
            "P": 35,
            "W": 252,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-M-20iA": {
            "MT": "R",
            "N": "Fanuc M-20iA",
            "F": "Fanuc-M-20iA.robot",
            "I": "Fanuc-M-20iA-robot.png",
            "IS": "Fanuc-M-20iA.png",
            "B": "Fanuc",
            "M": "M-20iA",
            "T": "6 DOF",
            "A": 6,
            "R": 1811,
            "P": 20,
            "W": 250,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-20iB-25": {
            "MT": "R",
            "N": "Fanuc M-20iB/25",
            "F": "Fanuc-M-20iB-25.robot",
            "I": "Fanuc-M-20iB-25-robot.png",
            "IS": "Fanuc-M-20iB-25.png",
            "B": "Fanuc",
            "M": "M-20iB/25",
            "T": "6 DOF",
            "A": 6,
            "R": 1853,
            "P": 25,
            "W": 210,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-M-20iB-35S": {
            "MT": "R",
            "N": "Fanuc M-20iB/35S",
            "F": "Fanuc-M-20iB-35S.robot",
            "I": "Fanuc-M-20iB-35S-robot.png",
            "IS": "Fanuc-M-20iB-35S.png",
            "B": "Fanuc",
            "M": "M-20iB/35S",
            "T": "6 DOF",
            "A": 6,
            "R": 1445,
            "P": 35,
            "W": 205,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-M-20iD-12L": {
            "MT": "R",
            "N": "Fanuc M-20iD/12L",
            "F": "Fanuc-M-20iD-12L.robot",
            "I": "Fanuc-M-20iD-12L-robot.png",
            "IS": "Fanuc-M-20iD-12L.png",
            "B": "Fanuc",
            "M": "M-20iD/12L",
            "T": "6 DOF",
            "A": 6,
            "R": 2272,
            "P": 12,
            "W": 250,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-20iD-25": {
            "MT": "R",
            "N": "Fanuc M-20iD/25",
            "F": "Fanuc-M-20iD-25.robot",
            "I": "Fanuc-M-20iD-25-robot.png",
            "IS": "Fanuc-M-20iD-25.png",
            "B": "Fanuc",
            "M": "M-20iD/25",
            "T": "6 DOF",
            "A": 6,
            "R": 1831,
            "P": 25,
            "W": 250,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-M-20iD-35": {
            "MT": "R",
            "N": "Fanuc M-20iD/35",
            "F": "Fanuc-M-20iD-35.robot",
            "I": "Fanuc-M-20iD-35-robot.png",
            "IS": "Fanuc-M-20iD-35.png",
            "B": "Fanuc",
            "M": "M-20iD/35",
            "T": "6 DOF",
            "A": 6,
            "R": 1831,
            "P": 35.0,
            "W": 250,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-M-710iB-45": {
            "MT": "R",
            "N": "Fanuc M-710iB/45",
            "F": "Fanuc-M-710iB-45.robot",
            "I": "Fanuc-M-710iB-45-robot.png",
            "IS": "Fanuc-M-710iB-45.png",
            "B": "Fanuc",
            "M": "M-710iB/45",
            "T": "6 DOF",
            "A": 6,
            "R": 1706,
            "P": 45.0,
            "W": 530,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-M-710iC-12L": {
            "MT": "R",
            "N": "Fanuc M-710iC/12L",
            "F": "Fanuc-M-710iC-12L.robot",
            "I": "Fanuc-M-710iC-12L-robot.png",
            "IS": "Fanuc-M-710iC-12L.png",
            "B": "Fanuc",
            "M": "M-710iC/12L",
            "T": "6 DOF",
            "A": 6,
            "R": 3123,
            "P": 12,
            "W": 540,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-710iC-20L": {
            "MT": "R",
            "N": "Fanuc M-710iC/20L",
            "F": "Fanuc-M-710iC-20L.robot",
            "I": "Fanuc-M-710iC-20L-robot.png",
            "IS": "Fanuc-M-710iC-20L.png",
            "B": "Fanuc",
            "M": "M-710iC/20L",
            "T": "6 DOF",
            "A": 6,
            "R": 3110,
            "P": 20,
            "W": 540,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-710iC-20M": {
            "MT": "R",
            "N": "Fanuc M-710iC/20M",
            "F": "Fanuc-M-710iC-20M.robot",
            "I": "Fanuc-M-710iC-20M-robot.png",
            "IS": "Fanuc-M-710iC-20M.png",
            "B": "Fanuc",
            "M": "M-710iC/20M",
            "T": "6 DOF",
            "A": 6,
            "R": 2582,
            "P": 20,
            "W": 530,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-M-710iC-45M": {
            "MT": "R",
            "N": "Fanuc M-710iC/45M",
            "F": "Fanuc-M-710iC-45M.robot",
            "I": "Fanuc-M-710iC-45M-robot.png",
            "IS": "Fanuc-M-710iC-45M.png",
            "B": "Fanuc",
            "M": "M-710iC/45M",
            "T": "6 DOF",
            "A": 6,
            "R": 2606,
            "P": 45,
            "W": 570,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-710iC-50": {
            "MT": "R",
            "N": "Fanuc M-710iC/50",
            "F": "Fanuc-M-710iC-50.robot",
            "I": "Fanuc-M-710iC-50-robot.png",
            "IS": "Fanuc-M-710iC-50.png",
            "B": "Fanuc",
            "M": "M-710iC/50",
            "T": "6 DOF",
            "A": 6,
            "R": 2050,
            "P": 50,
            "W": 545,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-710iC-50E": {
            "MT": "R",
            "N": "Fanuc M-710iC/50E",
            "F": "Fanuc-M-710iC-50E.robot",
            "I": "Fanuc-M-710iC-50E-robot.png",
            "IS": "Fanuc-M-710iC-50E.png",
            "B": "Fanuc",
            "M": "M-710iC/50E",
            "T": "6 DOF",
            "A": 6,
            "R": 2050,
            "P": 50.0,
            "W": 560,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-710iC-50H": {
            "MT": "R",
            "N": "Fanuc M-710iC/50H",
            "F": "Fanuc-M-710iC-50H.robot",
            "I": "Fanuc-M-710iC-50H-robot.png",
            "IS": "Fanuc-M-710iC-50H.png",
            "B": "Fanuc",
            "M": "M-710iC/50H",
            "T": "6 DOF",
            "A": 6,
            "R": 2003,
            "P": 50.0,
            "W": 540,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-710iC-50S": {
            "MT": "R",
            "N": "Fanuc M-710iC/50S",
            "F": "Fanuc-M-710iC-50S.robot",
            "I": "Fanuc-M-710iC-50S-robot.png",
            "IS": "Fanuc-M-710iC-50S.png",
            "B": "Fanuc",
            "M": "M-710iC/50S",
            "T": "6 DOF",
            "A": 6,
            "R": 1359,
            "P": 50,
            "W": 545,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Machining",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-M-710iC-70": {
            "MT": "R",
            "N": "Fanuc M-710iC/70",
            "F": "Fanuc-M-710iC-70.robot",
            "I": "Fanuc-M-710iC-70-robot.png",
            "IS": "Fanuc-M-710iC-70.png",
            "B": "Fanuc",
            "M": "M-710iC/70",
            "T": "6 DOF",
            "A": 6,
            "R": 2050,
            "P": 70,
            "W": 560,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-710iD-50M": {
            "MT": "R",
            "N": "Fanuc M-710iD/50M",
            "F": "Fanuc-M-710iD-50M.robot",
            "I": "Fanuc-M-710iD-50M-robot.png",
            "IS": "Fanuc-M-710iD-50M.png",
            "B": "Fanuc",
            "M": "M-710iD/50M",
            "T": "6 DOF",
            "A": 6,
            "R": 2606,
            "P": 50,
            "W": 600,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-710iD-70": {
            "MT": "R",
            "N": "Fanuc M-710iD/70",
            "F": "Fanuc-M-710iD-70.robot",
            "I": "Fanuc-M-710iD-70-robot.png",
            "IS": "Fanuc-M-710iD-70.png",
            "B": "Fanuc",
            "M": "M-710iD/70",
            "T": "6 DOF",
            "A": 6,
            "R": 2104,
            "P": 70,
            "W": 580,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-800iA-60": {
            "MT": "R",
            "N": "Fanuc M-800iA/60",
            "F": "Fanuc-M-800iA-60.robot",
            "I": "Fanuc-M-800iA-60-robot.png",
            "IS": "Fanuc-M-800iA-60.png",
            "B": "Fanuc",
            "M": "M-800iA/60",
            "T": "6 DOF",
            "A": 6,
            "R": 2040,
            "P": 60,
            "W": 820,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-900iA-350": {
            "MT": "R",
            "N": "Fanuc M-900iA/350",
            "F": "Fanuc-M-900iA-350.robot",
            "I": "Fanuc-M-900iA-350-robot.png",
            "IS": "Fanuc-M-900iA-350.png",
            "B": "Fanuc",
            "M": "M-900iA/350",
            "T": "6 DOF",
            "A": 6,
            "R": 2655,
            "P": 350,
            "W": 1540,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-900iA-600": {
            "MT": "R",
            "N": "Fanuc M-900iA/600",
            "F": "Fanuc-M-900iA-600.robot",
            "I": "Fanuc-M-900iA-600-robot.png",
            "IS": "Fanuc-M-900iA-600.png",
            "B": "Fanuc",
            "M": "M-900iA/600",
            "T": "6 DOF",
            "A": 6,
            "R": 2832,
            "P": 600,
            "W": 2832,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-900iB-260L": {
            "MT": "R",
            "N": "Fanuc M-900iB/260L",
            "F": "Fanuc-M-900iB-260L.robot",
            "I": "Fanuc-M-900iB-260L-robot.png",
            "IS": "Fanuc-M-900iB-260L.png",
            "B": "Fanuc",
            "M": "M-900iB/260L",
            "T": "6 DOF",
            "A": 6,
            "R": 3100,
            "P": 260,
            "W": 1800,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-900iB-280": {
            "MT": "R",
            "N": "Fanuc M-900iB/280",
            "F": "Fanuc-M-900iB-280.robot",
            "I": "Fanuc-M-900iB-280-robot.png",
            "IS": "Fanuc-M-900iB-280.png",
            "B": "Fanuc",
            "M": "M-900iB/280",
            "T": "6 DOF",
            "A": 6,
            "R": 2655,
            "P": 360,
            "W": 1540,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-900iB-280L": {
            "MT": "R",
            "N": "Fanuc M-900iB/280L",
            "F": "Fanuc-M-900iB-280L.robot",
            "I": "Fanuc-M-900iB-280L-robot.png",
            "IS": "Fanuc-M-900iB-280L.png",
            "B": "Fanuc",
            "M": "M-900iB/280L",
            "T": "6 DOF",
            "A": 6,
            "R": 3103,
            "P": 280,
            "W": 1600,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-900iB-360": {
            "MT": "R",
            "N": "Fanuc M-900iB/360",
            "F": "Fanuc-M-900iB-360.robot",
            "I": "Fanuc-M-900iB-360-robot.png",
            "IS": "Fanuc-M-900iB-360.png",
            "B": "Fanuc",
            "M": "M-900iB/360",
            "T": "6 DOF",
            "A": 6,
            "R": 2655,
            "P": 360,
            "W": 1540,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-900iB-400L": {
            "MT": "R",
            "N": "Fanuc M-900iB/400L",
            "F": "Fanuc-M-900iB-400L.robot",
            "I": "Fanuc-M-900iB-400L-robot.png",
            "IS": "Fanuc-M-900iB-400L.png",
            "B": "Fanuc",
            "M": "M-900iB/400L",
            "T": "6 DOF",
            "A": 6,
            "R": 3704,
            "P": 400,
            "W": 3150,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-900iB-700": {
            "MT": "R",
            "N": "Fanuc M-900iB/700",
            "F": "Fanuc-M-900iB-700.robot",
            "I": "Fanuc-M-900iB-700-robot.png",
            "IS": "Fanuc-M-900iB-700.png",
            "B": "Fanuc",
            "M": "M-900iB/700",
            "T": "6 DOF",
            "A": 6,
            "R": 2832,
            "P": 700,
            "W": 2800,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-950iA-500": {
            "MT": "R",
            "N": "Fanuc M-950iA/500",
            "F": "Fanuc-M-950iA-500.robot",
            "I": "Fanuc-M-950iA-500-robot.png",
            "IS": "Fanuc-M-950iA-500.png",
            "B": "Fanuc",
            "M": "M-950iA/500",
            "T": "6 DOF",
            "A": 6,
            "R": 2830,
            "P": 500,
            "W": 2500,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-1000iA": {
            "MT": "R",
            "N": "Fanuc M-1000iA",
            "F": "Fanuc-M-1000iA.robot",
            "I": "Fanuc-M-1000iA-robot.png",
            "IS": "Fanuc-M-1000iA.png",
            "B": "Fanuc",
            "M": "M-1000iA",
            "T": "6 DOF",
            "A": 6,
            "R": 3253,
            "P": 1000,
            "W": 5300,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-2000iA-900L": {
            "MT": "R",
            "N": "Fanuc M-2000iA/900L",
            "F": "Fanuc-M-2000iA-900L.robot",
            "I": "Fanuc-M-2000iA-900L-robot.png",
            "IS": "Fanuc-M-2000iA-900L.png",
            "B": "Fanuc",
            "M": "M-2000iA/900L",
            "T": "6 DOF",
            "A": 6,
            "R": 4683,
            "P": 900,
            "W": 9600,
            "E": 0.18,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-2000iA-1700L": {
            "MT": "R",
            "N": "Fanuc M-2000iA/1700L",
            "F": "Fanuc-M-2000iA-1700L.robot",
            "I": "Fanuc-M-2000iA-1700L-robot.png",
            "IS": "Fanuc-M-2000iA-1700L.png",
            "B": "Fanuc",
            "M": "M-2000iA/1700L",
            "T": "6 DOF",
            "A": 6,
            "R": 4683,
            "P": 1700,
            "W": 12500,
            "E": 0.27,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-2000iA-2300": {
            "MT": "R",
            "N": "Fanuc M-2000iA/2300",
            "F": "Fanuc-M-2000iA-2300.robot",
            "I": "Fanuc-M-2000iA-2300-robot.png",
            "IS": "Fanuc-M-2000iA-2300.png",
            "B": "Fanuc",
            "M": "M-2000iA/2300",
            "T": "6 DOF",
            "A": 6,
            "R": 3734,
            "P": 2300,
            "W": 11000,
            "E": 0.18,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-2000iC-210R": {
            "MT": "R",
            "N": "Fanuc M-2000iC/210R",
            "F": "Fanuc-M-2000iC-210R.robot",
            "I": "Fanuc-M-2000iC-210R-robot.png",
            "IS": "Fanuc-M-2000iC-210R.png",
            "B": "Fanuc",
            "M": "M-2000iC/210R",
            "T": "6 DOF",
            "A": 6,
            "R": 2655,
            "P": 210,
            "W": 1370,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-P-50iB-10L": {
            "MT": "R",
            "N": "Fanuc P-50iB/10L",
            "F": "Fanuc-P-50iB-10L.robot",
            "I": "Fanuc-P-50iB-10L-robot.png",
            "IS": "Fanuc-P-50iB-10L.png",
            "B": "Fanuc",
            "M": "P-50iB/10L",
            "T": "6 DOF",
            "A": 6,
            "R": 1800,
            "P": 10,
            "W": 331,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Inspection",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-P-200-LA-HB": {
            "MT": "R",
            "N": "Fanuc P-200 LA HB",
            "F": "Fanuc-P-200-LA-HB.robot",
            "I": "Fanuc-P-200-LA-HB-robot.png",
            "IS": "Fanuc-P-200-LA-HB.png",
            "B": "Fanuc",
            "M": "P-200 LA HB",
            "T": "6 DOF",
            "A": 6,
            "R": 2779,
            "P": 15,
            "W": 523,
            "E": 0.5,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Inspection",
                "Material Handling",
                "Painting",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-P-200-LA-OL-HB": {
            "MT": "R",
            "N": "Fanuc P-200 LA OL HB",
            "F": "Fanuc-P-200-LA-OL-HB.robot",
            "I": "Fanuc-P-200-LA-OL-HB-robot.png",
            "IS": "Fanuc-P-200-LA-OL-HB.png",
            "B": "Fanuc",
            "M": "P-200 LA OL HB",
            "T": "6 DOF",
            "A": 6,
            "R": 2779,
            "P": 15,
            "W": 523,
            "E": 0.5,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Inspection",
                "Material Handling",
                "Painting",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-P-200-LA-OR-HB": {
            "MT": "R",
            "N": "Fanuc P-200 LA OR HB",
            "F": "Fanuc-P-200-LA-OR-HB.robot",
            "I": "Fanuc-P-200-LA-OR-HB-robot.png",
            "IS": "Fanuc-P-200-LA-OR-HB.png",
            "B": "Fanuc",
            "M": "P-200 LA OR HB",
            "T": "6 DOF",
            "A": 6,
            "R": 2779,
            "P": 15,
            "W": 523,
            "E": 0.5,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Inspection",
                "Material Handling",
                "Painting",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-P-250iB-LH": {
            "MT": "R",
            "N": "Fanuc P-250iB LH",
            "F": "Fanuc-P-250iB-LH.robot",
            "I": "Fanuc-P-250iB-LH-robot.png",
            "IS": "Fanuc-P-250iB-LH.png",
            "B": "Fanuc",
            "M": "P-250iB LH",
            "T": "6 DOF",
            "A": 6,
            "R": 2800,
            "P": 15,
            "W": 530,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-P-250iB-RH": {
            "MT": "R",
            "N": "Fanuc P-250iB RH",
            "F": "Fanuc-P-250iB-RH.robot",
            "I": "Fanuc-P-250iB-RH-robot.png",
            "IS": "Fanuc-P-250iB-RH.png",
            "B": "Fanuc",
            "M": "P-250iB RH",
            "T": "6 DOF",
            "A": 6,
            "R": 2800,
            "P": 15,
            "W": 530,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Fanuc-P-350iA-45-RH": {
            "MT": "R",
            "N": "Fanuc P-350iA/45 RH",
            "F": "Fanuc-P-350iA-45-RH.robot",
            "I": "Fanuc-P-350iA-45-RH-robot.png",
            "IS": "Fanuc-P-350iA-45-RH.png",
            "B": "Fanuc",
            "M": "P-350iA/45 RH",
            "T": "6 DOF",
            "A": 6,
            "R": 2606,
            "P": 45,
            "W": 570,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-Paint-Mate-200iA-5L": {
            "MT": "R",
            "N": "Fanuc Paint Mate 200iA/5L",
            "F": "Fanuc-Paint-Mate-200iA-5L.robot",
            "I": "Fanuc-Paint-Mate-200iA-5L-robot.png",
            "IS": "Fanuc-Paint-Mate-200iA-5L.png",
            "B": "Fanuc",
            "M": "Paint Mate 200iA/5L",
            "T": "6 DOF",
            "A": 6,
            "R": 892,
            "P": 5.0,
            "W": 37,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-R-1000iA-80F": {
            "MT": "R",
            "N": "Fanuc R-1000iA/80F",
            "F": "Fanuc-R-1000iA-80F.robot",
            "I": "Fanuc-R-1000iA-80F-robot.png",
            "IS": "Fanuc-R-1000iA-80F.png",
            "B": "Fanuc",
            "M": "R-1000iA/80F",
            "T": "6 DOF",
            "A": 6,
            "R": 2230,
            "P": 80,
            "W": 620,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-1000iA-100F": {
            "MT": "R",
            "N": "Fanuc R-1000iA/100F",
            "F": "Fanuc-R-1000iA-100F.robot",
            "I": "Fanuc-R-1000iA-100F-robot.png",
            "IS": "Fanuc-R-1000iA-100F.png",
            "B": "Fanuc",
            "M": "R-1000iA/100F",
            "T": "6 DOF",
            "A": 6,
            "R": 2230,
            "P": 100,
            "W": 665,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-1000iA-130F": {
            "MT": "R",
            "N": "Fanuc R-1000iA/130F",
            "F": "Fanuc-R-1000iA-130F.robot",
            "I": "Fanuc-R-1000iA-130F-robot.png",
            "IS": "Fanuc-R-1000iA-130F.png",
            "B": "Fanuc",
            "M": "R-1000iA/130F",
            "T": "6 DOF",
            "A": 6,
            "R": 2230,
            "P": 130,
            "W": 675,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iA-165F": {
            "MT": "R",
            "N": "Fanuc R-2000iA/165F",
            "F": "Fanuc-R-2000iA-165F.robot",
            "I": "Fanuc-R-2000iA-165F-robot.png",
            "IS": "Fanuc-R-2000iA-165F.png",
            "B": "Fanuc",
            "M": "R-2000iA/165F",
            "T": "6 DOF",
            "A": 6,
            "R": 2650,
            "P": 200,
            "W": 1240,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iA-200F": {
            "MT": "R",
            "N": "Fanuc R-2000iA/200F",
            "F": "Fanuc-R-2000iA-200F.robot",
            "I": "Fanuc-R-2000iA-200F-robot.png",
            "IS": "Fanuc-R-2000iA-200F.png",
            "B": "Fanuc",
            "M": "R-2000iA/200F",
            "T": "6 DOF",
            "A": 6,
            "R": 2483,
            "P": 200,
            "W": 1240,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iA-200FO": {
            "MT": "R",
            "N": "Fanuc R-2000iA/200FO",
            "F": "Fanuc-R-2000iA-200FO.robot",
            "I": "Fanuc-R-2000iA-200FO-robot.png",
            "IS": "Fanuc-R-2000iA-200FO.png",
            "B": "Fanuc",
            "M": "R-2000iA/200FO",
            "T": "6 DOF",
            "A": 6,
            "R": 2650,
            "P": 200,
            "W": 1310,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iA-210F": {
            "MT": "R",
            "N": "Fanuc R-2000iA/210F",
            "F": "Fanuc-R-2000iA-210F.robot",
            "I": "Fanuc-R-2000iA-210F-robot.png",
            "IS": "Fanuc-R-2000iA-210F.png",
            "B": "Fanuc",
            "M": "R-2000iA/210F",
            "T": "6 DOF",
            "A": 6,
            "R": 2655,
            "P": 210,
            "W": 1240,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iB-100P": {
            "MT": "R",
            "N": "Fanuc R-2000iB/100P",
            "F": "Fanuc-R-2000iB-100P.robot",
            "I": "Fanuc-R-2000iB-100P-robot.png",
            "IS": "Fanuc-R-2000iB-100P.png",
            "B": "Fanuc",
            "M": "R-2000iB/100P",
            "T": "6 DOF",
            "A": 6,
            "R": 3500,
            "P": 100,
            "W": 1570,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iB-125L": {
            "MT": "R",
            "N": "Fanuc R-2000iB/125L",
            "F": "Fanuc-R-2000iB-125L.robot",
            "I": "Fanuc-R-2000iB-125L-robot.png",
            "IS": "Fanuc-R-2000iB-125L.png",
            "B": "Fanuc",
            "M": "R-2000iB/125L",
            "T": "6 DOF",
            "A": 6,
            "R": 3005,
            "P": 125,
            "W": 1190,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iB-165F": {
            "MT": "R",
            "N": "Fanuc R-2000iB/165F",
            "F": "Fanuc-R-2000iB-165F.robot",
            "I": "Fanuc-R-2000iB-165F-robot.png",
            "IS": "Fanuc-R-2000iB-165F.png",
            "B": "Fanuc",
            "M": "R-2000iB/165F",
            "T": "6 DOF",
            "A": 6,
            "R": 2655,
            "P": 165,
            "W": 1170,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iB-170CF": {
            "MT": "R",
            "N": "Fanuc R-2000iB/170CF",
            "F": "Fanuc-R-2000iB-170CF.robot",
            "I": "Fanuc-R-2000iB-170CF-robot.png",
            "IS": "Fanuc-R-2000iB-170CF.png",
            "B": "Fanuc",
            "M": "R-2000iB/170CF",
            "T": "6 DOF",
            "A": 6,
            "R": 1520,
            "P": 170,
            "W": 800,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iB-175L": {
            "MT": "R",
            "N": "Fanuc R-2000iB/175L",
            "F": "Fanuc-R-2000iB-175L.robot",
            "I": "Fanuc-R-2000iB-175L-robot.png",
            "IS": "Fanuc-R-2000iB-175L.png",
            "B": "Fanuc",
            "M": "R-2000iB/175L",
            "T": "6 DOF",
            "A": 6,
            "R": 2852,
            "P": 175,
            "W": 1260,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iB-210F": {
            "MT": "R",
            "N": "Fanuc R-2000iB/210F",
            "F": "Fanuc-R-2000iB-210F.robot",
            "I": "Fanuc-R-2000iB-210F-robot.png",
            "IS": "Fanuc-R-2000iB-210F.png",
            "B": "Fanuc",
            "M": "R-2000iB/210F",
            "T": "6 DOF",
            "A": 6,
            "R": 2655,
            "P": 210,
            "W": 1240,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iB-250F": {
            "MT": "R",
            "N": "Fanuc R-2000iB/250F",
            "F": "Fanuc-R-2000iB-250F.robot",
            "I": "Fanuc-R-2000iB-250F-robot.png",
            "IS": "Fanuc-R-2000iB-250F.png",
            "B": "Fanuc",
            "M": "R-2000iB/250F",
            "T": "6 DOF",
            "A": 6,
            "R": 2655,
            "P": 250,
            "W": 1270,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iC-100P": {
            "MT": "R",
            "N": "Fanuc R-2000iC/100P",
            "F": "Fanuc-R-2000iC-100P.robot",
            "I": "Fanuc-R-2000iC-100P-robot.png",
            "IS": "Fanuc-R-2000iC-100P.png",
            "B": "Fanuc",
            "M": "R-2000iC/100P",
            "T": "6 DOF",
            "A": 6,
            "R": 3540,
            "P": 100,
            "W": 1470,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iC-125L": {
            "MT": "R",
            "N": "Fanuc R-2000iC/125L",
            "F": "Fanuc-R-2000iC-125L.robot",
            "I": "Fanuc-R-2000iC-125L-robot.png",
            "IS": "Fanuc-R-2000iC-125L.png",
            "B": "Fanuc",
            "M": "R-2000iC/125L",
            "T": "6 DOF",
            "A": 6,
            "R": 3100,
            "P": 125,
            "W": 1115,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iC-165F": {
            "MT": "R",
            "N": "Fanuc R-2000iC/165F",
            "F": "Fanuc-R-2000iC-165F.robot",
            "I": "Fanuc-R-2000iC-165F-robot.png",
            "IS": "Fanuc-R-2000iC-165F.png",
            "B": "Fanuc",
            "M": "R-2000iC/165F",
            "T": "6 DOF",
            "A": 6,
            "R": 2655,
            "P": 165,
            "W": 1170,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iC-190S": {
            "MT": "R",
            "N": "Fanuc R-2000iC/190S",
            "F": "Fanuc-R-2000iC-190S.robot",
            "I": "Fanuc-R-2000iC-190S-robot.png",
            "IS": "Fanuc-R-2000iC-190S.png",
            "B": "Fanuc",
            "M": "R-2000iC/190S",
            "T": "6 DOF",
            "A": 6,
            "R": 2040,
            "P": 190,
            "W": 1120,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iC-210F": {
            "MT": "R",
            "N": "Fanuc R-2000iC/210F",
            "F": "Fanuc-R-2000iC-210F.robot",
            "I": "Fanuc-R-2000iC-210F-robot.png",
            "IS": "Fanuc-R-2000iC-210F.png",
            "B": "Fanuc",
            "M": "R-2000iC/210F",
            "T": "6 DOF",
            "A": 6,
            "R": 2655,
            "P": 210,
            "W": 1370,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iC-210L": {
            "MT": "R",
            "N": "Fanuc R-2000iC/210L",
            "F": "Fanuc-R-2000iC-210L.robot",
            "I": "Fanuc-R-2000iC-210L-robot.png",
            "IS": "Fanuc-R-2000iC-210L.png",
            "B": "Fanuc",
            "M": "R-2000iC/210L",
            "T": "6 DOF",
            "A": 6,
            "R": 3100,
            "P": 210,
            "W": 1370,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iC-270F": {
            "MT": "R",
            "N": "Fanuc R-2000iC/270F",
            "F": "Fanuc-R-2000iC-270F.robot",
            "I": "Fanuc-R-2000iC-270F-robot.png",
            "IS": "Fanuc-R-2000iC-270F.png",
            "B": "Fanuc",
            "M": "R-2000iC/270F",
            "T": "6 DOF",
            "A": 6,
            "R": 2655,
            "P": 270,
            "W": 1370,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-R-2000iD-210FH": {
            "MT": "R",
            "N": "Fanuc R-2000iD/210FH",
            "F": "Fanuc-R-2000iD-210FH.robot",
            "I": "Fanuc-R-2000iD-210FH-robot.png",
            "IS": "Fanuc-R-2000iD-210FH.png",
            "B": "Fanuc",
            "M": "R-2000iD/210FH",
            "T": "6 DOF",
            "A": 6,
            "R": 2605,
            "P": 210,
            "W": 1130,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-S-420iW": {
            "MT": "R",
            "N": "Fanuc S-420iW",
            "F": "Fanuc-S-420iW.robot",
            "I": "Fanuc-S-420iW-robot.png",
            "IS": "Fanuc-S-420iW.png",
            "B": "Fanuc",
            "M": "S-420iW",
            "T": "6 DOF",
            "A": 6,
            "R": 2850,
            "P": 155,
            "W": 1600,
            "E": 0.4,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-S-430i": {
            "MT": "R",
            "N": "Fanuc S-430i",
            "F": "Fanuc-S-430i.robot",
            "I": "Fanuc-S-430i-robot.png",
            "IS": "Fanuc-S-430i.png",
            "B": "Fanuc",
            "M": "S-430i",
            "T": "6 DOF",
            "A": 6,
            "R": 2643,
            "P": 200,
            "W": 1300,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-S-430iL-80": {
            "MT": "R",
            "N": "Fanuc S-430iL/80",
            "F": "Fanuc-S-430iL-80.robot",
            "I": "Fanuc-S-430iL-80-robot.png",
            "IS": "Fanuc-S-430iL-80.png",
            "B": "Fanuc",
            "M": "S-430iL/80",
            "T": "6 DOF",
            "A": 6,
            "R": 3002,
            "P": 80,
            "W": 1300,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-S-430iL-125": {
            "MT": "R",
            "N": "Fanuc S-430iL/125",
            "F": "Fanuc-S-430iL-125.robot",
            "I": "Fanuc-S-430iL-125-robot.png",
            "IS": "Fanuc-S-430iL-125.png",
            "B": "Fanuc",
            "M": "S-430iL/125",
            "T": "6 DOF",
            "A": 6,
            "R": 3002,
            "P": 125,
            "W": 1300,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-S-430iW": {
            "MT": "R",
            "N": "Fanuc S-430iW",
            "F": "Fanuc-S-430iW.robot",
            "I": "Fanuc-S-430iW-robot.png",
            "IS": "Fanuc-S-430iW.png",
            "B": "Fanuc",
            "M": "S-430iW",
            "T": "6 DOF",
            "A": 6,
            "R": 2643,
            "P": 135,
            "W": 1300,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Fanuc-M-1iA-0-5S": {
            "MT": "R",
            "N": "Fanuc M-1iA/0.5S",
            "F": "Fanuc-M-1iA-0-5S.robot",
            "I": "Fanuc-M-1iA-0-5S-robot.png",
            "IS": "Fanuc-M-1iA-0-5S.png",
            "B": "Fanuc",
            "M": "M-1iA/0.5S",
            "T": "Delta",
            "A": 4,
            "R": 140,
            "P": 0.5,
            "W": 14,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Fanuc-M-1iA-0-5SL": {
            "MT": "R",
            "N": "Fanuc M-1iA/0.5SL",
            "F": "Fanuc-M-1iA-0-5SL.robot",
            "I": "Fanuc-M-1iA-0-5SL-robot.png",
            "IS": "Fanuc-M-1iA-0-5SL.png",
            "B": "Fanuc",
            "M": "M-1iA/0.5SL",
            "T": "Delta",
            "A": 4,
            "R": 420,
            "P": 0.5,
            "W": 23,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Fanuc-M-410iB-300": {
            "MT": "R",
            "N": "Fanuc M-410iB/300",
            "F": "Fanuc-M-410iB-300.robot",
            "I": "Fanuc-M-410iB-300-robot.png",
            "IS": "Fanuc-M-410iB-300.png",
            "B": "Fanuc",
            "M": "M-410iB/300",
            "T": "Palletizing",
            "A": 4,
            "R": 3143,
            "P": 300,
            "W": 1940,
            "E": 0.5,
            "AP": [
                "Palletizing"
            ]
        },
        "Fanuc-M-410iB-700": {
            "MT": "R",
            "N": "Fanuc M-410iB/700",
            "F": "Fanuc-M-410iB-700.robot",
            "I": "Fanuc-M-410iB-700-robot.png",
            "IS": "Fanuc-M-410iB-700.png",
            "B": "Fanuc",
            "M": "M-410iB/700",
            "T": "Palletizing",
            "A": 4,
            "R": 3143,
            "P": 700,
            "W": 2700,
            "E": 0.5,
            "AP": [
                "Palletizing"
            ]
        },
        "Fanuc-M-410iC-110": {
            "MT": "R",
            "N": "Fanuc M-410iC/110",
            "F": "Fanuc-M-410iC-110.robot",
            "I": "Fanuc-M-410iC-110-robot.png",
            "IS": "Fanuc-M-410iC-110.png",
            "B": "Fanuc",
            "M": "M-410iC/110",
            "T": "Palletizing",
            "A": 4,
            "R": 2403,
            "P": 110,
            "W": 1030,
            "E": 0.05,
            "AP": [
                "Palletizing"
            ]
        },
        "Fanuc-M-410iC-185": {
            "MT": "R",
            "N": "Fanuc M-410iC/185",
            "F": "Fanuc-M-410iC-185.robot",
            "I": "Fanuc-M-410iC-185-robot.png",
            "IS": "Fanuc-M-410iC-185.png",
            "B": "Fanuc",
            "M": "M-410iC/185",
            "T": "Palletizing",
            "A": 4,
            "R": 3143,
            "P": 185,
            "W": 1600,
            "E": 0.05,
            "AP": [
                "Palletizing"
            ]
        },
        "Fanuc-SR-3iA": {
            "MT": "R",
            "N": "Fanuc SR-3iA",
            "F": "Fanuc-SR-3iA.robot",
            "I": "Fanuc-SR-3iA-robot.png",
            "IS": "Fanuc-SR-3iA.png",
            "B": "Fanuc",
            "M": "SR-3iA",
            "T": "SCARA",
            "A": 4,
            "R": 400,
            "P": 3,
            "W": 19,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Fanuc-SR-6iA": {
            "MT": "R",
            "N": "Fanuc SR-6iA",
            "F": "Fanuc-SR-6iA.robot",
            "I": "Fanuc-SR-6iA-robot.png",
            "IS": "Fanuc-SR-6iA.png",
            "B": "Fanuc",
            "M": "SR-6iA",
            "T": "SCARA",
            "A": 4,
            "R": 650,
            "P": 6,
            "W": 30,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Fanuc-SR-12iA": {
            "MT": "R",
            "N": "Fanuc SR-12iA",
            "F": "Fanuc-SR-12iA.robot",
            "I": "Fanuc-SR-12iA-robot.png",
            "IS": "Fanuc-SR-12iA.png",
            "B": "Fanuc",
            "M": "SR-12iA",
            "T": "SCARA",
            "A": 4,
            "R": 900,
            "P": 12,
            "W": 53,
            "E": 0.015,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Fanuc-SR-20iA": {
            "MT": "R",
            "N": "Fanuc SR-20iA",
            "F": "Fanuc-SR-20iA.robot",
            "I": "Fanuc-SR-20iA-robot.png",
            "IS": "Fanuc-SR-20iA.png",
            "B": "Fanuc",
            "M": "SR-20iA",
            "T": "SCARA",
            "A": 4,
            "R": 1100,
            "P": 20,
            "W": 64,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Flexiv-Rizon-4": {
            "MT": "R",
            "N": "Flexiv Rizon 4",
            "F": "Flexiv-Rizon-4.robot",
            "I": "Flexiv-Rizon-4-robot.png",
            "IS": "Flexiv-Rizon-4.png",
            "B": "Flexiv",
            "M": "Rizon 4",
            "T": "7 DOF",
            "A": 7,
            "R": 780,
            "P": 4,
            "W": 20,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Flexiv-Rizon-4s": {
            "MT": "R",
            "N": "Flexiv Rizon 4s",
            "F": "Flexiv-Rizon-4s.robot",
            "I": "Flexiv-Rizon-4s-robot.png",
            "IS": "Flexiv-Rizon-4s.png",
            "B": "Flexiv",
            "M": "Rizon 4s",
            "T": "7 DOF",
            "A": 7,
            "R": 919,
            "P": 4,
            "W": 21,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Flexiv-Rizon-10": {
            "MT": "R",
            "N": "Flexiv Rizon 10",
            "F": "Flexiv-Rizon-10.robot",
            "I": "Flexiv-Rizon-10-robot.png",
            "IS": "Flexiv-Rizon-10.png",
            "B": "Flexiv",
            "M": "Rizon 10",
            "T": "7 DOF",
            "A": 7,
            "R": 941,
            "P": 10,
            "W": 38,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Flexiv-Rizon-10s": {
            "MT": "R",
            "N": "Flexiv Rizon 10s",
            "F": "Flexiv-Rizon-10s.robot",
            "I": "Flexiv-Rizon-10s-robot.png",
            "IS": "Flexiv-Rizon-10s.png",
            "B": "Flexiv",
            "M": "Rizon 10s",
            "T": "7 DOF",
            "A": 7,
            "R": 984,
            "P": 10,
            "W": 39,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Foxbot-A1200": {
            "MT": "R",
            "N": "Foxbot A1200",
            "F": "Foxbot-A1200.robot",
            "I": "Foxbot-A1200-robot.png",
            "IS": "Foxbot-A1200.png",
            "B": "Foxbot",
            "M": "A1200",
            "T": "6 DOF",
            "A": 6,
            "R": 1200,
            "P": 10,
            "W": 108,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Foxbot-A1700": {
            "MT": "R",
            "N": "Foxbot A1700",
            "F": "Foxbot-A1700.robot",
            "I": "Foxbot-A1700-robot.png",
            "IS": "Foxbot-A1700.png",
            "B": "Foxbot",
            "M": "A1700",
            "T": "6 DOF",
            "A": 6,
            "R": 1717,
            "P": 20,
            "W": 250,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Franka-Emika-Panda": {
            "MT": "R",
            "N": "Franka Emika Panda",
            "F": "Franka-Emika-Panda.robot",
            "I": "Franka-Emika-Panda-robot.png",
            "IS": "Franka-Emika-Panda.png",
            "B": "Franka",
            "M": "Emika Panda",
            "T": "7 DOF",
            "A": 7,
            "R": 850,
            "P": 3,
            "W": 18,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Fruitcore-HORST-600": {
            "MT": "R",
            "N": "Fruitcore HORST 600",
            "F": "Fruitcore-HORST-600.robot",
            "I": "Fruitcore-HORST-600-robot.png",
            "IS": "Fruitcore-HORST-600.png",
            "B": "Fruitcore",
            "M": "HORST 600",
            "T": "6 DOF",
            "A": 6,
            "R": 584,
            "P": 2,
            "W": 30,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "GMF-S-420": {
            "MT": "R",
            "N": "GMF S-420",
            "F": "GMF-S-420.robot",
            "I": "GMF-S-420-robot.png",
            "IS": "GMF-S-420.png",
            "B": "GMF",
            "M": "S-420",
            "T": "6 DOF",
            "A": 6,
            "R": 2413,
            "P": 120,
            "W": 1500,
            "E": 0.5,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "GSK-RB03A1": {
            "MT": "R",
            "N": "GSK RB03A1",
            "F": "GSK-RB03A1.robot",
            "I": "GSK-RB03A1-robot.png",
            "IS": "GSK-RB03A1.png",
            "B": "GSK",
            "M": "RB03A1",
            "T": "6 DOF",
            "A": 6,
            "R": 561,
            "P": 3,
            "W": 180,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "GSK-RB06L": {
            "MT": "R",
            "N": "GSK RB06L",
            "F": "GSK-RB06L.robot",
            "I": "GSK-RB06L-robot.png",
            "IS": "GSK-RB06L.png",
            "B": "GSK",
            "M": "RB06L",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 6,
            "W": 305,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "GSK-RB08": {
            "MT": "R",
            "N": "GSK RB08",
            "F": "GSK-RB08.robot",
            "I": "GSK-RB08-robot.png",
            "IS": "GSK-RB08.png",
            "B": "GSK",
            "M": "RB08",
            "T": "6 DOF",
            "A": 6,
            "R": 1389,
            "P": 8,
            "W": 180,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "GSK-RB08A1": {
            "MT": "R",
            "N": "GSK RB08A1",
            "F": "GSK-RB08A1.robot",
            "I": "GSK-RB08A1-robot.png",
            "IS": "GSK-RB08A1.png",
            "B": "GSK",
            "M": "RB08A1",
            "T": "6 DOF",
            "A": 6,
            "R": 1369,
            "P": 8,
            "W": 200,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "GSK-RB10": {
            "MT": "R",
            "N": "GSK RB10",
            "F": "GSK-RB10.robot",
            "I": "GSK-RB10-robot.png",
            "IS": "GSK-RB10.png",
            "B": "GSK",
            "M": "RB10",
            "T": "6 DOF",
            "A": 6,
            "R": 1550,
            "P": 8,
            "W": 180,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "GSK-RB15L": {
            "MT": "R",
            "N": "GSK RB15L",
            "F": "GSK-RB15L.robot",
            "I": "GSK-RB15L-robot.png",
            "IS": "GSK-RB15L.png",
            "B": "GSK",
            "M": "RB15L",
            "T": "6 DOF",
            "A": 6,
            "R": 1810,
            "P": 15,
            "W": 300,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "GSK-RB20": {
            "MT": "R",
            "N": "GSK RB20",
            "F": "GSK-RB20.robot",
            "I": "GSK-RB20-robot.png",
            "IS": "GSK-RB20.png",
            "B": "GSK",
            "M": "RB20",
            "T": "6 DOF",
            "A": 6,
            "R": 1595,
            "P": 20,
            "W": 290,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "GSK-RB50": {
            "MT": "R",
            "N": "GSK RB50",
            "F": "GSK-RB50.robot",
            "I": "GSK-RB50-robot.png",
            "IS": "GSK-RB50.png",
            "B": "GSK",
            "M": "RB50",
            "T": "6 DOF",
            "A": 6,
            "R": 1950,
            "P": 50,
            "W": 300,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Machining",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "GSK-RB165": {
            "MT": "R",
            "N": "GSK RB165",
            "F": "GSK-RB165.robot",
            "I": "GSK-RB165-robot.png",
            "IS": "GSK-RB165.png",
            "B": "GSK",
            "M": "RB165",
            "T": "6 DOF",
            "A": 6,
            "R": 2463,
            "P": 165,
            "W": 1400,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "GSK-RB165A1-2790": {
            "MT": "R",
            "N": "GSK RB165A1-2790",
            "F": "GSK-RB165A1-2790.robot",
            "I": "GSK-RB165A1-2790-robot.png",
            "IS": "GSK-RB165A1-2790.png",
            "B": "GSK",
            "M": "RB165A1-2790",
            "T": "6 DOF",
            "A": 6,
            "R": 2790,
            "P": 165,
            "W": 1200,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "GSK-RMD08": {
            "MT": "R",
            "N": "GSK RMD08",
            "F": "GSK-RMD08.robot",
            "I": "GSK-RMD08-robot.png",
            "IS": "GSK-RMD08.png",
            "B": "GSK",
            "M": "RMD08",
            "T": "Palletizing",
            "A": 4,
            "R": 1410,
            "P": 8,
            "W": 1650,
            "E": 0.1,
            "AP": [
                "Palletizing"
            ]
        },
        "Hanwha-HCR-3A": {
            "MT": "R",
            "N": "Hanwha HCR-3A",
            "F": "Hanwha-HCR-3A.robot",
            "I": "Hanwha-HCR-3A-robot.png",
            "IS": "Hanwha-HCR-3A.png",
            "B": "Hanwha",
            "M": "HCR-3A",
            "T": "6 DOF",
            "A": 6,
            "R": 630,
            "P": 3,
            "W": 13,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Hanwha-HCR-5A": {
            "MT": "R",
            "N": "Hanwha HCR-5A",
            "F": "Hanwha-HCR-5A.robot",
            "I": "Hanwha-HCR-5A-robot.png",
            "IS": "Hanwha-HCR-5A.png",
            "B": "Hanwha",
            "M": "HCR-5A",
            "T": "6 DOF",
            "A": 6,
            "R": 915,
            "P": 5,
            "W": 20,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Hanwha-HCR-10L": {
            "MT": "R",
            "N": "Hanwha HCR-10L",
            "F": "Hanwha-HCR-10L.robot",
            "I": "Hanwha-HCR-10L-robot.png",
            "IS": "Hanwha-HCR-10L.png",
            "B": "Hanwha",
            "M": "HCR-10L",
            "T": "6 DOF",
            "A": 6,
            "R": 1800,
            "P": 10.0,
            "W": 45,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Hanwha-HCR-12A": {
            "MT": "R",
            "N": "Hanwha HCR-12A",
            "F": "Hanwha-HCR-12A.robot",
            "I": "Hanwha-HCR-12A-robot.png",
            "IS": "Hanwha-HCR-12A.png",
            "B": "Hanwha",
            "M": "HCR-12A",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 12,
            "W": 51,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Hanwha-HCR-14": {
            "MT": "R",
            "N": "Hanwha HCR-14",
            "F": "Hanwha-HCR-14.robot",
            "I": "Hanwha-HCR-14-robot.png",
            "IS": "Hanwha-HCR-14.png",
            "B": "Hanwha",
            "M": "HCR-14",
            "T": "6 DOF",
            "A": 6,
            "R": 1420,
            "P": 14.0,
            "W": 42,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "HIWIN-RA605-710-GB": {
            "MT": "R",
            "N": "HIWIN RA605-710-GB",
            "F": "HIWIN-RA605-710-GB.robot",
            "I": "HIWIN-RA605-710-GB-robot.png",
            "IS": "HIWIN-RA605-710-GB.png",
            "B": "HIWIN",
            "M": "RA605-710-GB",
            "T": "6 DOF",
            "A": 6,
            "R": 710,
            "P": 5,
            "W": 40,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "HIWIN-RA610-1355-GA": {
            "MT": "R",
            "N": "HIWIN RA610-1355-GA",
            "F": "HIWIN-RA610-1355-GA.robot",
            "I": "HIWIN-RA610-1355-GA-robot.png",
            "IS": "HIWIN-RA610-1355-GA.png",
            "B": "HIWIN",
            "M": "RA610-1355-GA",
            "T": "6 DOF",
            "A": 6,
            "R": 1355,
            "P": 12,
            "W": 143,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "HIWIN-RA610-1476-GA": {
            "MT": "R",
            "N": "HIWIN RA610-1476-GA",
            "F": "HIWIN-RA610-1476-GA.robot",
            "I": "HIWIN-RA610-1476-GA-robot.png",
            "IS": "HIWIN-RA610-1476-GA.png",
            "B": "HIWIN",
            "M": "RA610-1476-GA",
            "T": "6 DOF",
            "A": 6,
            "R": 1476,
            "P": 10,
            "W": 147,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "HIWIN-RA610-1672-GA": {
            "MT": "R",
            "N": "HIWIN RA610-1672-GA",
            "F": "HIWIN-RA610-1672-GA.robot",
            "I": "HIWIN-RA610-1672-GA-robot.png",
            "IS": "HIWIN-RA610-1672-GA.png",
            "B": "HIWIN",
            "M": "RA610-1672-GA",
            "T": "6 DOF",
            "A": 6,
            "R": 1672,
            "P": 10,
            "W": 150,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "HIWIN-RA610-1869-GA": {
            "MT": "R",
            "N": "HIWIN RA610-1869-GA",
            "F": "HIWIN-RA610-1869-GA.robot",
            "I": "HIWIN-RA610-1869-GA-robot.png",
            "IS": "HIWIN-RA610-1869-GA.png",
            "B": "HIWIN",
            "M": "RA610-1869-GA",
            "T": "6 DOF",
            "A": 6,
            "R": 1869,
            "P": 7,
            "W": 152,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "HIWIN-RT605-710-GB": {
            "MT": "R",
            "N": "HIWIN RT605-710-GB",
            "F": "HIWIN-RT605-710-GB.robot",
            "I": "HIWIN-RT605-710-GB-robot.png",
            "IS": "HIWIN-RT605-710-GB.png",
            "B": "HIWIN",
            "M": "RT605-710-GB",
            "T": "6 DOF",
            "A": 6,
            "R": 710,
            "P": 5,
            "W": 40,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "HIWIN-RT605-909-GB": {
            "MT": "R",
            "N": "HIWIN RT605-909-GB",
            "F": "HIWIN-RT605-909-GB.robot",
            "I": "HIWIN-RT605-909-GB-robot.png",
            "IS": "HIWIN-RT605-909-GB.png",
            "B": "HIWIN",
            "M": "RT605-909-GB",
            "T": "6 DOF",
            "A": 6,
            "R": 909,
            "P": 5,
            "W": 45,
            "E": 0.04,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "HSR-BR609": {
            "MT": "R",
            "N": "HSR-BR609",
            "F": "HSR-BR609.robot",
            "I": "HSR-BR609-robot.png",
            "IS": "HSR-BR609.png",
            "B": "HSR",
            "M": "HSR-BR609",
            "T": "6 DOF",
            "A": 6,
            "R": 1042,
            "P": 9,
            "W": 48,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "HSR-BR616": {
            "MT": "R",
            "N": "HSR-BR616",
            "F": "HSR-BR616.robot",
            "I": "HSR-BR616-robot.png",
            "IS": "HSR-BR616.png",
            "B": "HSR",
            "M": "HSR-BR616",
            "T": "6 DOF",
            "A": 6,
            "R": 1599.6,
            "P": 16,
            "W": 48,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Huayan-E03": {
            "MT": "R",
            "N": "Huayan E03",
            "F": "Huayan-E03.robot",
            "I": "Huayan-E03-robot.png",
            "IS": "Huayan-E03.png",
            "B": "Huayan Han's",
            "M": "E03",
            "T": "6 DOF",
            "A": 6,
            "R": 590,
            "P": 3,
            "W": 18,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Huayan-E05": {
            "MT": "R",
            "N": "Huayan E05",
            "F": "Huayan-E05.robot",
            "I": "Huayan-E05-robot.png",
            "IS": "Huayan-E05.png",
            "B": "Huayan Han's",
            "M": "E05",
            "T": "6 DOF",
            "A": 6,
            "R": 800,
            "P": 5,
            "W": 25,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Huayan-E05C": {
            "MT": "R",
            "N": "Huayan E05C",
            "F": "Huayan-E05C.robot",
            "I": "Huayan-E05C-robot.png",
            "IS": "Huayan-E05C.png",
            "B": "Huayan Han's",
            "M": "E05C",
            "T": "6 DOF",
            "A": 6,
            "R": 800,
            "P": 5,
            "W": 25,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Huayan-E05-L": {
            "MT": "R",
            "N": "Huayan E05-L",
            "F": "Huayan-E05-L.robot",
            "I": "Huayan-E05-L-robot.png",
            "IS": "Huayan-E05-L.png",
            "B": "Huayan Han's",
            "M": "E05-L",
            "T": "6 DOF",
            "A": 6,
            "R": 950,
            "P": 3.5,
            "W": 26,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Huayan-E10": {
            "MT": "R",
            "N": "Huayan E10",
            "F": "Huayan-E10.robot",
            "I": "Huayan-E10-robot.png",
            "IS": "Huayan-E10.png",
            "B": "Huayan Han's",
            "M": "E10",
            "T": "6 DOF",
            "A": 6,
            "R": 1000,
            "P": 10,
            "W": 43,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Huayan-E10-L": {
            "MT": "R",
            "N": "Huayan E10-L",
            "F": "Huayan-E10-L.robot",
            "I": "Huayan-E10-L-robot.png",
            "IS": "Huayan-E10-L.png",
            "B": "Huayan Han's",
            "M": "E10-L",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 8,
            "W": 45,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Huayan-E12": {
            "MT": "R",
            "N": "Huayan E12",
            "F": "Huayan-E12.robot",
            "I": "Huayan-E12-robot.png",
            "IS": "Huayan-E12.png",
            "B": "Huayan Han's",
            "M": "E12",
            "T": "6 DOF",
            "A": 6,
            "R": 1800,
            "P": 12,
            "W": 70,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Huayan-E15": {
            "MT": "R",
            "N": "Huayan E15",
            "F": "Huayan-E15.robot",
            "I": "Huayan-E15-robot.png",
            "IS": "Huayan-E15.png",
            "B": "Huayan Han's",
            "M": "E15",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 15,
            "W": 60,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Huayan-S20-1700": {
            "MT": "R",
            "N": "Huayan S20 1700",
            "F": "Huayan-S20-1700.robot",
            "I": "Huayan-S20-1700-robot.png",
            "IS": "Huayan-S20-1700.png",
            "B": "Huayan Han's",
            "M": "S20 1700",
            "T": "6 DOF",
            "A": 6,
            "R": 1700,
            "P": 20,
            "W": 64,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Huayan-S30-1800": {
            "MT": "R",
            "N": "Huayan S30 1800",
            "F": "Huayan-S30-1800.robot",
            "I": "Huayan-S30-1800-robot.png",
            "IS": "Huayan-S30-1800.png",
            "B": "Huayan Han's",
            "M": "S30 1800",
            "T": "6 DOF",
            "A": 6,
            "R": 1800,
            "P": 30,
            "W": 93,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Huayan-S50-2000": {
            "MT": "R",
            "N": "Huayan S50 2000",
            "F": "Huayan-S50-2000.robot",
            "I": "Huayan-S50-2000-robot.png",
            "IS": "Huayan-S50-2000.png",
            "B": "Huayan Han's",
            "M": "S50 2000",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 50.0,
            "W": 165,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Hyundai-HA006B": {
            "MT": "R",
            "N": "Hyundai HA006B",
            "F": "Hyundai-HA006B.robot",
            "I": "Hyundai-HA006B-robot.png",
            "IS": "Hyundai-HA006B.png",
            "B": "Hyundai Robotics",
            "M": "HA006B",
            "T": "6 DOF",
            "A": 6,
            "R": 1424.9,
            "P": 6,
            "W": 145,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Hyundai-HA006L": {
            "MT": "R",
            "N": "Hyundai HA006L",
            "F": "Hyundai-HA006L.robot",
            "I": "Hyundai-HA006L-robot.png",
            "IS": "Hyundai-HA006L.png",
            "B": "Hyundai Robotics",
            "M": "HA006L",
            "T": "6 DOF",
            "A": 6,
            "R": 1994,
            "P": 6,
            "W": 224,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Hyundai-HDR35-20": {
            "MT": "R",
            "N": "Hyundai HDR35-20",
            "F": "Hyundai-HDR35-20.robot",
            "I": "Hyundai-HDR35-20-robot.png",
            "IS": "Hyundai-HDR35-20.png",
            "B": "Hyundai Robotics",
            "M": "HDR35-20",
            "T": "6 DOF",
            "A": 6,
            "R": 2060,
            "P": 35.0,
            "W": 485,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Hyundai-HH4": {
            "MT": "R",
            "N": "Hyundai HH4",
            "F": "Hyundai-HH4.robot",
            "I": "Hyundai-HH4-robot.png",
            "IS": "Hyundai-HH4.png",
            "B": "Hyundai Robotics",
            "M": "HH4",
            "T": "6 DOF",
            "A": 6,
            "R": 581,
            "P": 4.0,
            "W": 22,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Hyundai-HH4L": {
            "MT": "R",
            "N": "Hyundai HH4L",
            "F": "Hyundai-HH4L.robot",
            "I": "Hyundai-HH4L-robot.png",
            "IS": "Hyundai-HH4L.png",
            "B": "Hyundai Robotics",
            "M": "HH4L",
            "T": "6 DOF",
            "A": 6,
            "R": 1131,
            "P": 4.0,
            "W": 43,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Hyundai-HH7": {
            "MT": "R",
            "N": "Hyundai HH7",
            "F": "Hyundai-HH7.robot",
            "I": "Hyundai-HH7-robot.png",
            "IS": "Hyundai-HH7.png",
            "B": "Hyundai Robotics",
            "M": "HH7",
            "T": "6 DOF",
            "A": 6,
            "R": 932,
            "P": 7.0,
            "W": 48.4,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Hyundai-HH8": {
            "MT": "R",
            "N": "Hyundai HH8",
            "F": "Hyundai-HH8.robot",
            "I": "Hyundai-HH8-robot.png",
            "IS": "Hyundai-HH8.png",
            "B": "Hyundai Robotics",
            "M": "HH8",
            "T": "6 DOF",
            "A": 6,
            "R": 832,
            "P": 8.0,
            "W": 41,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Hyundai-HH010L": {
            "MT": "R",
            "N": "Hyundai HH010L",
            "F": "Hyundai-HH010L.robot",
            "I": "Hyundai-HH010L-robot.png",
            "IS": "Hyundai-HH010L.png",
            "B": "Hyundai Robotics",
            "M": "HH010L",
            "T": "6 DOF",
            "A": 6,
            "R": 1964,
            "P": 10.0,
            "W": 230,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Hyundai-HH012": {
            "MT": "R",
            "N": "Hyundai HH012",
            "F": "Hyundai-HH012.robot",
            "I": "Hyundai-HH012-robot.png",
            "IS": "Hyundai-HH012.png",
            "B": "Hyundai Robotics",
            "M": "HH012",
            "T": "6 DOF",
            "A": 6,
            "R": 1425,
            "P": 12,
            "W": 145,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Hyundai-HH012A": {
            "MT": "R",
            "N": "Hyundai HH012A",
            "F": "Hyundai-HH012A.robot",
            "I": "Hyundai-HH012A-robot.png",
            "IS": "Hyundai-HH012A.png",
            "B": "Hyundai Robotics",
            "M": "HH012A",
            "T": "6 DOF",
            "A": 6,
            "R": 1424.9,
            "P": 6,
            "W": 145,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Hyundai-HH020": {
            "MT": "R",
            "N": "Hyundai HH020",
            "F": "Hyundai-HH020.robot",
            "I": "Hyundai-HH020-robot.png",
            "IS": "Hyundai-HH020.png",
            "B": "Hyundai Robotics",
            "M": "HH020",
            "T": "6 DOF",
            "A": 6,
            "R": 1742,
            "P": 20,
            "W": 225,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Hyundai-HH020L": {
            "MT": "R",
            "N": "Hyundai HH020L",
            "F": "Hyundai-HH020L.robot",
            "I": "Hyundai-HH020L-robot.png",
            "IS": "Hyundai-HH020L.png",
            "B": "Hyundai Robotics",
            "M": "HH020L",
            "T": "6 DOF",
            "A": 6,
            "R": 3281,
            "P": 20,
            "W": 535,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Hyundai-HH030L": {
            "MT": "R",
            "N": "Hyundai HH030L",
            "F": "Hyundai-HH030L.robot",
            "I": "Hyundai-HH030L-robot.png",
            "IS": "Hyundai-HH030L.png",
            "B": "Hyundai Robotics",
            "M": "HH030L",
            "T": "6 DOF",
            "A": 6,
            "R": 2535,
            "P": 30.0,
            "W": 650,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Hyundai-HH050": {
            "MT": "R",
            "N": "Hyundai HH050",
            "F": "Hyundai-HH050.robot",
            "I": "Hyundai-HH050-robot.png",
            "IS": "Hyundai-HH050.png",
            "B": "Hyundai Robotics",
            "M": "HH050",
            "T": "6 DOF",
            "A": 6,
            "R": 2239,
            "P": 50,
            "W": 645,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Hyundai-HH130SL": {
            "MT": "R",
            "N": "Hyundai HH130SL",
            "F": "Hyundai-HH130SL.robot",
            "I": "Hyundai-HH130SL-robot.png",
            "IS": "Hyundai-HH130SL.png",
            "B": "Hyundai Robotics",
            "M": "HH130SL",
            "T": "6 DOF",
            "A": 6,
            "R": 3082,
            "P": 130.0,
            "W": 1400,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Hyundai-HH150L": {
            "MT": "R",
            "N": "Hyundai HH150L",
            "F": "Hyundai-HH150L.robot",
            "I": "Hyundai-HH150L-robot.png",
            "IS": "Hyundai-HH150L.png",
            "B": "Hyundai Robotics",
            "M": "HH150L",
            "T": "6 DOF",
            "A": 6,
            "R": 3100,
            "P": 150,
            "W": 1380,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Hyundai-HH300": {
            "MT": "R",
            "N": "Hyundai HH300",
            "F": "Hyundai-HH300.robot",
            "I": "Hyundai-HH300-robot.png",
            "IS": "Hyundai-HH300.png",
            "B": "Hyundai Robotics",
            "M": "HH300",
            "T": "6 DOF",
            "A": 6,
            "R": 2666,
            "P": 300,
            "W": 1250,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Hyundai-HS160L": {
            "MT": "R",
            "N": "Hyundai HS160L",
            "F": "Hyundai-HS160L.robot",
            "I": "Hyundai-HS160L-robot.png",
            "IS": "Hyundai-HS160L.png",
            "B": "Hyundai Robotics",
            "M": "HS160L",
            "T": "6 DOF",
            "A": 6,
            "R": 3036,
            "P": 160.0,
            "W": 985,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Hyundai-HS200L": {
            "MT": "R",
            "N": "Hyundai HS200L",
            "F": "Hyundai-HS200L.robot",
            "I": "Hyundai-HS200L-robot.png",
            "IS": "Hyundai-HS200L.png",
            "B": "Hyundai Robotics",
            "M": "HS200L",
            "T": "6 DOF",
            "A": 6,
            "R": 3070,
            "P": 200,
            "W": 1223,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Hyundai-HS220": {
            "MT": "R",
            "N": "Hyundai HS220",
            "F": "Hyundai-HS220.robot",
            "I": "Hyundai-HS220-robot.png",
            "IS": "Hyundai-HS220.png",
            "B": "Hyundai Robotics",
            "M": "HS220",
            "T": "6 DOF",
            "A": 6,
            "R": 2666,
            "P": 220.0,
            "W": 955,
            "E": 0.11,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Hyundai-HS220S": {
            "MT": "R",
            "N": "Hyundai HS220S",
            "F": "Hyundai-HS220S.robot",
            "I": "Hyundai-HS220S-robot.png",
            "IS": "Hyundai-HS220S.png",
            "B": "Hyundai Robotics",
            "M": "HS220S",
            "T": "6 DOF",
            "A": 6,
            "R": 3091,
            "P": 220,
            "W": 1397,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Hyundai-HS260": {
            "MT": "R",
            "N": "Hyundai HS260",
            "F": "Hyundai-HS260.robot",
            "I": "Hyundai-HS260-robot.png",
            "IS": "Hyundai-HS260.png",
            "B": "Hyundai Robotics",
            "M": "HS260",
            "T": "6 DOF",
            "A": 6,
            "R": 2666,
            "P": 260.0,
            "W": 1250,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Hyundai-HX300L": {
            "MT": "R",
            "N": "Hyundai HX300L",
            "F": "Hyundai-HX300L.robot",
            "I": "Hyundai-HX300L-robot.png",
            "IS": "Hyundai-HX300L.png",
            "B": "Hyundai Robotics",
            "M": "HX300L",
            "T": "6 DOF",
            "A": 6,
            "R": 3056,
            "P": 300,
            "W": 2740,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Hyundai-YL012": {
            "MT": "R",
            "N": "Hyundai YL012",
            "F": "Hyundai-YL012.robot",
            "I": "Hyundai-YL012-robot.png",
            "IS": "Hyundai-YL012.png",
            "B": "Hyundai Robotics",
            "M": "YL012",
            "T": "6 DOF",
            "A": 6,
            "R": 1305,
            "P": 12,
            "W": 43,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Hyundai-YS080": {
            "MT": "R",
            "N": "Hyundai YS080",
            "F": "Hyundai-YS080.robot",
            "I": "Hyundai-YS080-robot.png",
            "IS": "Hyundai-YS080.png",
            "B": "Hyundai Robotics",
            "M": "YS080",
            "T": "6 DOF",
            "A": 6,
            "R": 2239,
            "P": 80.0,
            "W": 645,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Hyundai-YS080L": {
            "MT": "R",
            "N": "Hyundai YS080L",
            "F": "Hyundai-YS080L.robot",
            "I": "Hyundai-YS080L-robot.png",
            "IS": "Hyundai-YS080L.png",
            "B": "Hyundai Robotics",
            "M": "YS080L",
            "T": "6 DOF",
            "A": 6,
            "R": 2635,
            "P": 80.0,
            "W": 684,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Hyundai-YS140D": {
            "MT": "R",
            "N": "Hyundai YS140D",
            "F": "Hyundai-YS140D.robot",
            "I": "Hyundai-YS140D-robot.png",
            "IS": "Hyundai-YS140D.png",
            "B": "Hyundai Robotics",
            "M": "YS140D",
            "T": "6 DOF",
            "A": 6,
            "R": 1350,
            "P": 140.0,
            "W": 562,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Machining",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "IAI-IXA-4NNN3015": {
            "MT": "R",
            "N": "IAI IXA 4NNN3015",
            "F": "IAI-IXA-4NNN3015.robot",
            "I": "IAI-IXA-4NNN3015-robot.png",
            "IS": "IAI-IXA-4NNN3015.png",
            "B": "IAI",
            "M": "IXA 4NNN3015",
            "T": "SCARA",
            "A": 4,
            "R": 400,
            "P": 3,
            "W": 22,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "IAI-IXA-4NNN4518": {
            "MT": "R",
            "N": "IAI IXA 4NNN4518",
            "F": "IAI-IXA-4NNN4518.robot",
            "I": "IAI-IXA-4NNN4518-robot.png",
            "IS": "IAI-IXA-4NNN4518.png",
            "B": "IAI",
            "M": "IXA 4NNN4518",
            "T": "SCARA",
            "A": 4,
            "R": 450,
            "P": 3,
            "W": 27,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "IAI-IXA-4NNN6018": {
            "MT": "R",
            "N": "IAI IXA 4NNN6018",
            "F": "IAI-IXA-4NNN6018.robot",
            "I": "IAI-IXA-4NNN6018-robot.png",
            "IS": "IAI-IXA-4NNN6018.png",
            "B": "IAI",
            "M": "IXA 4NNN6018",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 6,
            "W": 32,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "igus-ReBeL-6DOF": {
            "MT": "R",
            "N": "igus ReBeL 6DOF",
            "F": "igus-ReBeL-6DOF.robot",
            "I": "igus-ReBeL-6DOF-robot.png",
            "IS": "igus-ReBeL-6DOF.png",
            "B": "igus",
            "M": "ReBeL 6DOF",
            "T": "6 DOF",
            "A": 6,
            "R": 664,
            "P": 2,
            "W": 8,
            "E": 1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Inspection",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "IIMT-CI-03": {
            "MT": "R",
            "N": "IIMT CI-03",
            "F": "IIMT-CI-03.robot",
            "I": "IIMT-CI-03-robot.png",
            "IS": "IIMT-CI-03.png",
            "B": "IIMT",
            "M": "IIMT CI-03",
            "T": "6 DOF",
            "A": 6,
            "R": 600,
            "P": 3.0,
            "W": 13,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "IIMT-CI-16": {
            "MT": "R",
            "N": "IIMT CI-16",
            "F": "IIMT-CI-16.robot",
            "I": "IIMT-CI-16-robot.png",
            "IS": "IIMT-CI-16.png",
            "B": "IIMT",
            "M": "IIMT CI-16",
            "T": "6 DOF",
            "A": 6,
            "R": 1500,
            "P": 16.0,
            "W": 62,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "IIMT-CI-20": {
            "MT": "R",
            "N": "IIMT CI-20",
            "F": "IIMT-CI-20.robot",
            "I": "IIMT-CI-20-robot.png",
            "IS": "IIMT-CI-20.png",
            "B": "IIMT",
            "M": "IIMT CI-20",
            "T": "6 DOF",
            "A": 6,
            "R": 1650,
            "P": 20.0,
            "W": 63,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "IIMT-CA-05": {
            "MT": "R",
            "N": "IIMT-CA-05",
            "F": "IIMT-CA-05.robot",
            "I": "IIMT-CA-05-robot.png",
            "IS": "IIMT-CA-05.png",
            "B": "IIMT",
            "M": "IIMT-CA-05",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 5,
            "W": 20.4,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "IIMT-CI-05": {
            "MT": "R",
            "N": "IIMT-CI-05",
            "F": "IIMT-CI-05.robot",
            "I": "IIMT-CI-05-robot.png",
            "IS": "IIMT-CI-05.png",
            "B": "IIMT",
            "M": "IIMT-CI-05",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 5.0,
            "W": 21,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "IIMT-CI-10": {
            "MT": "R",
            "N": "IIMT-CI-10",
            "F": "IIMT-CI-10.robot",
            "I": "IIMT-CI-10-robot.png",
            "IS": "IIMT-CI-10.png",
            "B": "IIMT",
            "M": "IIMT-CI-10",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 10.0,
            "W": 38,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "IIMT-CR-03": {
            "MT": "R",
            "N": "IIMT-CR-03",
            "F": "IIMT-CR-03.robot",
            "I": "IIMT-CR-03-robot.png",
            "IS": "IIMT-CR-03.png",
            "B": "IIMT",
            "M": "IIMT-CR-03",
            "T": "6 DOF",
            "A": 6,
            "R": 600,
            "P": 3,
            "W": 13,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "IIMT-CR-10": {
            "MT": "R",
            "N": "IIMT-CR-10",
            "F": "IIMT-CR-10.robot",
            "I": "IIMT-CR-10-robot.png",
            "IS": "IIMT-CR-10.png",
            "B": "IIMT",
            "M": "IIMT-CR-10",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 10,
            "W": 32,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "IIMT-CR-16": {
            "MT": "R",
            "N": "IIMT-CR-16",
            "F": "IIMT-CR-16.robot",
            "I": "IIMT-CR-16-robot.png",
            "IS": "IIMT-CR-16.png",
            "B": "IIMT",
            "M": "IIMT-CR-16",
            "T": "6 DOF",
            "A": 6,
            "R": 1000,
            "P": 16,
            "W": 30.8,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "INOVANCE-IR311-7-90TS-INT": {
            "MT": "R",
            "N": "INOVANCE IR311-7-90TS-INT",
            "F": "INOVANCE-IR311-7-90TS-INT.robot",
            "I": "INOVANCE-IR311-7-90TS-INT-robot.png",
            "IS": "INOVANCE-IR311-7-90TS-INT.png",
            "B": "INOVANCE",
            "M": "IR311-7-90TS-INT",
            "T": "6 DOF",
            "A": 6,
            "R": 911,
            "P": 7,
            "W": 40,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "INOVANCE-IR-R4-56S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-R4-56S-INT",
            "F": "INOVANCE-IR-R4-56S-INT.robot",
            "I": "INOVANCE-IR-R4-56S-INT-robot.png",
            "IS": "INOVANCE-IR-R4-56S-INT.png",
            "B": "INOVANCE",
            "M": "IR-R4-56S-INT",
            "T": "6 DOF",
            "A": 6,
            "R": 560.6,
            "P": 4,
            "W": 24,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "INOVANCE-IR-R4H-54S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-R4H-54S-INT",
            "F": "INOVANCE-IR-R4H-54S-INT.robot",
            "I": "INOVANCE-IR-R4H-54S-INT-robot.png",
            "IS": "INOVANCE-IR-R4H-54S-INT.png",
            "B": "INOVANCE",
            "M": "IR-R4H-54S-INT",
            "T": "6 DOF",
            "A": 6,
            "R": 545.7,
            "P": 4,
            "W": 24.5,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "INOVANCE-IR-R10-110S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-R10-110S-INT",
            "F": "INOVANCE-IR-R10-110S-INT.robot",
            "I": "INOVANCE-IR-R10-110S-INT-robot.png",
            "IS": "INOVANCE-IR-R10-110S-INT.png",
            "B": "INOVANCE",
            "M": "IR-R10-110S-INT",
            "T": "6 DOF",
            "A": 6,
            "R": 1101.6,
            "P": 10,
            "W": 48,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "INOVANCE-IR-R10-140S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-R10-140S-INT",
            "F": "INOVANCE-IR-R10-140S-INT.robot",
            "I": "INOVANCE-IR-R10-140S-INT-robot.png",
            "IS": "INOVANCE-IR-R10-140S-INT.png",
            "B": "INOVANCE",
            "M": "IR-R10-140S-INT",
            "T": "6 DOF",
            "A": 6,
            "R": 1422,
            "P": 10,
            "W": 130,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "INOVANCE-IR-R10-200S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-R10-200S-INT",
            "F": "INOVANCE-IR-R10-200S-INT.robot",
            "I": "INOVANCE-IR-R10-200S-INT-robot.png",
            "IS": "INOVANCE-IR-R10-200S-INT.png",
            "B": "INOVANCE",
            "M": "IR-R10-200S-INT",
            "T": "6 DOF",
            "A": 6,
            "R": 2045,
            "P": 10,
            "W": 245,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "INOVANCE-IR-R11-90S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-R11-90S-INT",
            "F": "INOVANCE-IR-R11-90S-INT.robot",
            "I": "INOVANCE-IR-R11-90S-INT-robot.png",
            "IS": "INOVANCE-IR-R11-90S-INT.png",
            "B": "INOVANCE",
            "M": "IR-R11-90S-INT",
            "T": "6 DOF",
            "A": 6,
            "R": 901.9,
            "P": 11.3,
            "W": 45,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "INOVANCE-IR-R20-170S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-R20-170S-INT",
            "F": "INOVANCE-IR-R20-170S-INT.robot",
            "I": "INOVANCE-IR-R20-170S-INT-robot.png",
            "IS": "INOVANCE-IR-R20-170S-INT.png",
            "B": "INOVANCE",
            "M": "IR-R20-170S-INT",
            "T": "6 DOF",
            "A": 6,
            "R": 1723,
            "P": 20,
            "W": 240,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "INOVANCE-IR-R25-178S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-R25-178S-INT",
            "F": "INOVANCE-IR-R25-178S-INT.robot",
            "I": "INOVANCE-IR-R25-178S-INT-robot.png",
            "IS": "INOVANCE-IR-R25-178S-INT.png",
            "B": "INOVANCE",
            "M": "IR-R25-178S-INT",
            "T": "6 DOF",
            "A": 6,
            "R": 1783,
            "P": 25.0,
            "W": 255,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "INOVANCE-IRS311-7-70TS-INT": {
            "MT": "R",
            "N": "INOVANCE IRS311-7-70TS-INT",
            "F": "INOVANCE-IRS311-7-70TS-INT.robot",
            "I": "INOVANCE-IRS311-7-70TS-INT-robot.png",
            "IS": "INOVANCE-IRS311-7-70TS-INT.png",
            "B": "INOVANCE",
            "M": "IRS311-7-70TS-INT",
            "T": "6 DOF",
            "A": 6,
            "R": 717,
            "P": 7,
            "W": 38,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "INOVANCE-IRS311-7-90TS-INT": {
            "MT": "R",
            "N": "INOVANCE IRS311-7-90TS-INT",
            "F": "INOVANCE-IRS311-7-90TS-INT.robot",
            "I": "INOVANCE-IRS311-7-90TS-INT-robot.png",
            "IS": "INOVANCE-IRS311-7-90TS-INT.png",
            "B": "INOVANCE",
            "M": "IRS311-7-90TS-INT",
            "T": "6 DOF",
            "A": 6,
            "R": 911,
            "P": 7,
            "W": 40,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "INOVANCE-IR-GS20-80Z42S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-GS20-80Z42S-INT",
            "F": "INOVANCE-IR-GS20-80Z42S-INT.robot",
            "I": "INOVANCE-IR-GS20-80Z42S-INT-robot.png",
            "IS": "INOVANCE-IR-GS20-80Z42S-INT.png",
            "B": "INOVANCE",
            "M": "IR-GS20-80Z42S-INT",
            "T": "SCARA",
            "A": 4,
            "R": 800,
            "P": 10,
            "W": 54,
            "E": 0.04,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "INOVANCE-IR-GS20-100Z42S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-GS20-100Z42S-INT",
            "F": "INOVANCE-IR-GS20-100Z42S-INT.robot",
            "I": "INOVANCE-IR-GS20-100Z42S-INT-robot.png",
            "IS": "INOVANCE-IR-GS20-100Z42S-INT.png",
            "B": "INOVANCE",
            "M": "IR-GS20-100Z42S-INT",
            "T": "SCARA",
            "A": 4,
            "R": 1000,
            "P": 10,
            "W": 57,
            "E": 0.04,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "INOVANCE-IR-S4-40Z15S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-S4-40Z15S-INT",
            "F": "INOVANCE-IR-S4-40Z15S-INT.robot",
            "I": "INOVANCE-IR-S4-40Z15S-INT-robot.png",
            "IS": "INOVANCE-IR-S4-40Z15S-INT.png",
            "B": "INOVANCE",
            "M": "IR-S4-40Z15S-INT",
            "T": "SCARA",
            "A": 4,
            "R": 400,
            "P": 2,
            "W": 12,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "INOVANCE-IR-S7-50Z20S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-S7-50Z20S-INT",
            "F": "INOVANCE-IR-S7-50Z20S-INT.robot",
            "I": "INOVANCE-IR-S7-50Z20S-INT-robot.png",
            "IS": "INOVANCE-IR-S7-50Z20S-INT.png",
            "B": "INOVANCE",
            "M": "IR-S7-50Z20S-INT",
            "T": "SCARA",
            "A": 4,
            "R": 500,
            "P": 3,
            "W": 17,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "INOVANCE-IR-S7-60Z20S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-S7-60Z20S-INT",
            "F": "INOVANCE-IR-S7-60Z20S-INT.robot",
            "I": "INOVANCE-IR-S7-60Z20S-INT-robot.png",
            "IS": "INOVANCE-IR-S7-60Z20S-INT.png",
            "B": "INOVANCE",
            "M": "IR-S7-60Z20S-INT",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 3,
            "W": 17.5,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "INOVANCE-IR-S7-70Z20S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-S7-70Z20S-INT",
            "F": "INOVANCE-IR-S7-70Z20S-INT.robot",
            "I": "INOVANCE-IR-S7-70Z20S-INT-robot.png",
            "IS": "INOVANCE-IR-S7-70Z20S-INT.png",
            "B": "INOVANCE",
            "M": "IR-S7-70Z20S-INT",
            "T": "SCARA",
            "A": 4,
            "R": 700,
            "P": 3,
            "W": 19,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "INOVANCE-IR-S10-60Z20S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-S10-60Z20S-INT",
            "F": "INOVANCE-IR-S10-60Z20S-INT.robot",
            "I": "INOVANCE-IR-S10-60Z20S-INT-robot.png",
            "IS": "INOVANCE-IR-S10-60Z20S-INT.png",
            "B": "INOVANCE",
            "M": "IR-S10-60Z20S-INT",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 5,
            "W": 18.5,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "INOVANCE-IR-S10-70Z20S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-S10-70Z20S-INT",
            "F": "INOVANCE-IR-S10-70Z20S-INT.robot",
            "I": "INOVANCE-IR-S10-70Z20S-INT-robot.png",
            "IS": "INOVANCE-IR-S10-70Z20S-INT.png",
            "B": "INOVANCE",
            "M": "IR-S10-70Z20S-INT",
            "T": "SCARA",
            "A": 4,
            "R": 700,
            "P": 5,
            "W": 19,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "INOVANCE-IR-S10-80Z20S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-S10-80Z20S-INT",
            "F": "INOVANCE-IR-S10-80Z20S-INT.robot",
            "I": "INOVANCE-IR-S10-80Z20S-INT-robot.png",
            "IS": "INOVANCE-IR-S10-80Z20S-INT.png",
            "B": "INOVANCE",
            "M": "IR-S10-80Z20S-INT",
            "T": "SCARA",
            "A": 4,
            "R": 800,
            "P": 5,
            "W": 20.5,
            "E": 0.025,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "INOVANCE-IR-S20-80Z42S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-S20-80Z42S-INT",
            "F": "INOVANCE-IR-S20-80Z42S-INT.robot",
            "I": "INOVANCE-IR-S20-80Z42S-INT-robot.png",
            "IS": "INOVANCE-IR-S20-80Z42S-INT.png",
            "B": "INOVANCE",
            "M": "IR-S20-80Z42S-INT",
            "T": "SCARA",
            "A": 4,
            "R": 800,
            "P": 10,
            "W": 53,
            "E": 0.04,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "INOVANCE-IR-S20-100Z42S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-S20-100Z42S-INT",
            "F": "INOVANCE-IR-S20-100Z42S-INT.robot",
            "I": "INOVANCE-IR-S20-100Z42S-INT-robot.png",
            "IS": "INOVANCE-IR-S20-100Z42S-INT.png",
            "B": "INOVANCE",
            "M": "IR-S20-100Z42S-INT",
            "T": "SCARA",
            "A": 4,
            "R": 1000,
            "P": 10,
            "W": 56,
            "E": 0.04,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "INOVANCE-IR-S50-120Z40S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-S50-120Z40S-INT",
            "F": "INOVANCE-IR-S50-120Z40S-INT.robot",
            "I": "INOVANCE-IR-S50-120Z40S-INT-robot.png",
            "IS": "INOVANCE-IR-S50-120Z40S-INT.png",
            "B": "INOVANCE",
            "M": "IR-S50-120Z40S-INT",
            "T": "SCARA",
            "A": 4,
            "R": 1200,
            "P": 50,
            "W": 136,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "INOVANCE-IR-TS4-35Z15S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-TS4-35Z15S-INT",
            "F": "INOVANCE-IR-TS4-35Z15S-INT.robot",
            "I": "INOVANCE-IR-TS4-35Z15S-INT-robot.png",
            "IS": "INOVANCE-IR-TS4-35Z15S-INT.png",
            "B": "INOVANCE",
            "M": "IR-TS4-35Z15S-INT",
            "T": "SCARA",
            "A": 4,
            "R": 350,
            "P": 2,
            "W": 18.5,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "INOVANCE-IR-TS5-55Z15S-INT": {
            "MT": "R",
            "N": "INOVANCE IR-TS5-55Z15S-INT",
            "F": "INOVANCE-IR-TS5-55Z15S-INT.robot",
            "I": "INOVANCE-IR-TS5-55Z15S-INT-robot.png",
            "IS": "INOVANCE-IR-TS5-55Z15S-INT.png",
            "B": "INOVANCE",
            "M": "IR-TS5-55Z15S-INT",
            "T": "SCARA",
            "A": 4,
            "R": 550,
            "P": 2,
            "W": 20,
            "E": 0.015,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Inovo-Robotics-PRD-ArmLong-1340": {
            "MT": "R",
            "N": "Inovo Robotics PRD ArmLong 1340",
            "F": "Inovo-Robotics-PRD-ArmLong-1340.robot",
            "I": "Inovo-Robotics-PRD-ArmLong-1340-robot.png",
            "IS": "Inovo-Robotics-PRD-ArmLong-1340.png",
            "B": "Inovo Robotics",
            "M": "PRD ArmLong 1340",
            "T": "6 DOF",
            "A": 6,
            "R": 1340,
            "P": 3,
            "E": 0,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "JAKA-12L": {
            "MT": "R",
            "N": "JAKA 12L",
            "F": "JAKA-12L.robot",
            "I": "JAKA-12L-robot.png",
            "IS": "JAKA-12L.png",
            "B": "JAKA",
            "M": "12L",
            "T": "6 DOF",
            "A": 6,
            "R": 1455,
            "P": 12.0,
            "W": 41,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "JAKA-A5": {
            "MT": "R",
            "N": "JAKA A5",
            "F": "JAKA-A5.robot",
            "I": "JAKA-A5-robot.png",
            "IS": "JAKA-A5.png",
            "B": "JAKA",
            "M": "A5",
            "T": "6 DOF",
            "A": 6,
            "R": 954,
            "P": 5,
            "W": 23,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "JAKA-A12": {
            "MT": "R",
            "N": "JAKA A12",
            "F": "JAKA-A12.robot",
            "I": "JAKA-A12-robot.png",
            "IS": "JAKA-A12.png",
            "B": "JAKA",
            "M": "A12",
            "T": "6 DOF",
            "A": 6,
            "R": 1327,
            "P": 12.0,
            "W": 41,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "JAKA-C-5": {
            "MT": "R",
            "N": "JAKA C 5",
            "F": "JAKA-C-5.robot",
            "I": "JAKA-C-5-robot.png",
            "IS": "JAKA-C-5.png",
            "B": "JAKA",
            "M": "C 5",
            "T": "6 DOF",
            "A": 6,
            "R": 954,
            "P": 5.0,
            "W": 23,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "JAKA-C-7": {
            "MT": "R",
            "N": "JAKA C 7",
            "F": "JAKA-C-7.robot",
            "I": "JAKA-C-7-robot.png",
            "IS": "JAKA-C-7.png",
            "B": "JAKA",
            "M": "C 7",
            "T": "6 DOF",
            "A": 6,
            "R": 819,
            "P": 7.0,
            "W": 22,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "JAKA-C-12": {
            "MT": "R",
            "N": "JAKA C 12",
            "F": "JAKA-C-12.robot",
            "I": "JAKA-C-12-robot.png",
            "IS": "JAKA-C-12.png",
            "B": "JAKA",
            "M": "C 12",
            "T": "6 DOF",
            "A": 6,
            "R": 1327,
            "P": 12.0,
            "W": 41,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "JAKA-MAX40": {
            "MT": "R",
            "N": "JAKA MAX40",
            "F": "JAKA-MAX40.robot",
            "I": "JAKA-MAX40-robot.png",
            "IS": "JAKA-MAX40.png",
            "B": "JAKA",
            "M": "MAX40",
            "T": "6 DOF",
            "A": 6,
            "R": 1800,
            "P": 40.0,
            "W": 220,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "JAKA-MiniCobo": {
            "MT": "R",
            "N": "JAKA MiniCobo",
            "F": "JAKA-MiniCobo.robot",
            "I": "JAKA-MiniCobo-robot.png",
            "IS": "JAKA-MiniCobo.png",
            "B": "JAKA",
            "M": "MiniCobo",
            "T": "6 DOF",
            "A": 6,
            "R": 580.0,
            "P": 1.0,
            "W": 9.4,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "JAKA-Pro-16": {
            "MT": "R",
            "N": "JAKA Pro 16",
            "F": "JAKA-Pro-16.robot",
            "I": "JAKA-Pro-16-robot.png",
            "IS": "JAKA-Pro-16.png",
            "B": "JAKA",
            "M": "Pro 16",
            "T": "6 DOF",
            "A": 6,
            "R": 1713,
            "P": 16,
            "W": 74,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "JAKA-Zu3": {
            "MT": "R",
            "N": "JAKA Zu3",
            "F": "JAKA-Zu3.robot",
            "I": "JAKA-Zu3-robot.png",
            "IS": "JAKA-Zu3.png",
            "B": "JAKA",
            "M": "Zu3",
            "T": "6 DOF",
            "A": 6,
            "R": 626,
            "P": 3,
            "W": 12,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "JAKA-Zu5": {
            "MT": "R",
            "N": "JAKA Zu5",
            "F": "JAKA-Zu5.robot",
            "I": "JAKA-Zu5-robot.png",
            "IS": "JAKA-Zu5.png",
            "B": "JAKA",
            "M": "Zu5",
            "T": "6 DOF",
            "A": 6,
            "R": 954,
            "P": 5,
            "W": 23,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "JAKA-Zu7": {
            "MT": "R",
            "N": "JAKA Zu7",
            "F": "JAKA-Zu7.robot",
            "I": "JAKA-Zu7-robot.png",
            "IS": "JAKA-Zu7.png",
            "B": "JAKA",
            "M": "Zu7",
            "T": "6 DOF",
            "A": 6,
            "R": 819,
            "P": 7,
            "W": 22,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "JAKA-Zu12": {
            "MT": "R",
            "N": "JAKA Zu12",
            "F": "JAKA-Zu12.robot",
            "I": "JAKA-Zu12-robot.png",
            "IS": "JAKA-Zu12.png",
            "B": "JAKA",
            "M": "Zu12",
            "T": "6 DOF",
            "A": 6,
            "R": 1327,
            "P": 12,
            "W": 41,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "JAKA-Zu18": {
            "MT": "R",
            "N": "JAKA Zu18",
            "F": "JAKA-Zu18.robot",
            "I": "JAKA-Zu18-robot.png",
            "IS": "JAKA-Zu18.png",
            "B": "JAKA",
            "M": "Zu18",
            "T": "6 DOF",
            "A": 6,
            "R": 1073,
            "P": 18,
            "W": 35,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "JAKA-Zu20": {
            "MT": "R",
            "N": "JAKA Zu20",
            "F": "JAKA-Zu20.robot",
            "I": "JAKA-Zu20-robot.png",
            "IS": "JAKA-Zu20.png",
            "B": "JAKA",
            "M": "Zu20",
            "T": "6 DOF",
            "A": 6,
            "R": 1780,
            "P": 20.0,
            "W": 38,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "JAKA-Zu30": {
            "MT": "R",
            "N": "JAKA Zu30",
            "F": "JAKA-Zu30.robot",
            "I": "JAKA-Zu30-robot.png",
            "IS": "JAKA-Zu30.png",
            "B": "JAKA",
            "M": "Zu30",
            "T": "6 DOF",
            "A": 6,
            "R": 1350,
            "P": 30.0,
            "W": 65,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "JAKA-Zu35": {
            "MT": "R",
            "N": "JAKA Zu35",
            "F": "JAKA-Zu35.robot",
            "I": "JAKA-Zu35-robot.png",
            "IS": "JAKA-Zu35.png",
            "B": "JAKA",
            "M": "Zu35",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 35.0,
            "W": 105,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "JAKA-K1-Left": {
            "MT": "R",
            "N": "JAKA K1 Left",
            "F": "JAKA-K1-Left.robot",
            "I": "JAKA-K1-Left-robot.png",
            "IS": "JAKA-K1-Left.png",
            "B": "JAKA",
            "M": "K1 Left",
            "T": "7 DOF",
            "A": 7,
            "R": 600,
            "P": 3,
            "W": 18,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "JAKA-K1-Right": {
            "MT": "R",
            "N": "JAKA K1 Right",
            "F": "JAKA-K1-Right.robot",
            "I": "JAKA-K1-Right-robot.png",
            "IS": "JAKA-K1-Right.png",
            "B": "JAKA",
            "M": "K1 Right",
            "T": "7 DOF",
            "A": 7,
            "R": 600,
            "P": 3,
            "W": 18,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kassow-Robots-KR0810": {
            "MT": "R",
            "N": "Kassow Robots KR0810",
            "F": "Kassow-Robots-KR0810.robot",
            "I": "Kassow-Robots-KR0810-robot.png",
            "IS": "Kassow-Robots-KR0810.png",
            "B": "Kassow Robots",
            "M": "KR0810",
            "T": "7 DOF",
            "A": 7,
            "R": 850,
            "P": 10,
            "W": 23.5,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kassow-Robots-KR1018": {
            "MT": "R",
            "N": "Kassow Robots KR1018",
            "F": "Kassow-Robots-KR1018.robot",
            "I": "Kassow-Robots-KR1018-robot.png",
            "IS": "Kassow-Robots-KR1018.png",
            "B": "Kassow Robots",
            "M": "KR1018",
            "T": "7 DOF",
            "A": 7,
            "R": 1000,
            "P": 18,
            "W": 34,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Kassow-Robots-KR1205": {
            "MT": "R",
            "N": "Kassow Robots KR1205",
            "F": "Kassow-Robots-KR1205.robot",
            "I": "Kassow-Robots-KR1205-robot.png",
            "IS": "Kassow-Robots-KR1205.png",
            "B": "Kassow Robots",
            "M": "KR1205",
            "T": "7 DOF",
            "A": 7,
            "R": 1200,
            "P": 5,
            "W": 25,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kassow-Robots-KR1240": {
            "MT": "R",
            "N": "Kassow Robots KR1240",
            "F": "Kassow-Robots-KR1240.robot",
            "I": "Kassow-Robots-KR1240-robot.png",
            "IS": "Kassow-Robots-KR1240.png",
            "B": "Kassow Robots",
            "M": "KR1240",
            "T": "7 DOF",
            "A": 7,
            "R": 1200,
            "P": 40.0,
            "W": 80,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kassow-Robots-KR1410": {
            "MT": "R",
            "N": "Kassow Robots KR1410",
            "F": "Kassow-Robots-KR1410.robot",
            "I": "Kassow-Robots-KR1410-robot.png",
            "IS": "Kassow-Robots-KR1410.png",
            "B": "Kassow Robots",
            "M": "KR1410",
            "T": "7 DOF",
            "A": 7,
            "R": 1400,
            "P": 10,
            "W": 35,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Kassow-Robots-KR1416": {
            "MT": "R",
            "N": "Kassow Robots KR1416",
            "F": "Kassow-Robots-KR1416.robot",
            "I": "Kassow-Robots-KR1416-robot.png",
            "IS": "Kassow-Robots-KR1416.png",
            "B": "Kassow Robots",
            "M": "KR1416",
            "T": "7 DOF",
            "A": 7,
            "R": 1400,
            "P": 16.0,
            "W": 76,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Kassow-Robots-KR1805": {
            "MT": "R",
            "N": "Kassow Robots KR1805",
            "F": "Kassow-Robots-KR1805.robot",
            "I": "Kassow-Robots-KR1805-robot.png",
            "IS": "Kassow-Robots-KR1805.png",
            "B": "Kassow Robots",
            "M": "KR1805",
            "T": "7 DOF",
            "A": 7,
            "R": 1800,
            "P": 5,
            "W": 38,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kassow-Robots-KR1824": {
            "MT": "R",
            "N": "Kassow Robots KR1824",
            "F": "Kassow-Robots-KR1824.robot",
            "I": "Kassow-Robots-KR1824-robot.png",
            "IS": "Kassow-Robots-KR1824.png",
            "B": "Kassow Robots",
            "M": "KR1824",
            "T": "7 DOF",
            "A": 7,
            "R": 1800,
            "P": 24.0,
            "W": 76,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kawada-NEXTAGE-Dual-Arm": {
            "MT": "R",
            "N": "Kawada NEXTAGE Dual-Arm",
            "F": "Kawada-NEXTAGE-Dual-Arm.rdka",
            "I": "Kawada-NEXTAGE-Dual-Arm-robot.png",
            "IS": "Kawada-NEXTAGE-Dual-Arm.png",
            "B": "Kawada",
            "M": "NEXTAGE Dual-Arm",
            "T": "6 DOF",
            "A": 6,
            "R": 625,
            "P": 2.5,
            "W": 152,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kawada-NEXTAGE-Fillie-Dual-Arm": {
            "MT": "R",
            "N": "Kawada NEXTAGE Fillie Dual-Arm",
            "F": "Kawada-NEXTAGE-Fillie-Dual-Arm.rdka",
            "I": "Kawada-NEXTAGE-Fillie-Dual-Arm-robot.png",
            "IS": "Kawada-NEXTAGE-Fillie-Dual-Arm.png",
            "B": "Kawada",
            "M": "NEXTAGE Fillie Dual-Arm",
            "T": "6 DOF",
            "A": 6,
            "R": 576,
            "P": 2,
            "W": 146,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kawasaki-RD80N": {
            "MT": "R",
            "N": "Kawasaki RD80N",
            "F": "Kawasaki-RD80N.robot",
            "I": "Kawasaki-RD80N-robot.png",
            "IS": "Kawasaki-RD80N.png",
            "B": "Kawasaki",
            "M": "RD80N",
            "T": "5 DOF",
            "A": 5,
            "R": 2100,
            "P": 80,
            "W": 555,
            "E": 0.07,
            "AP": [
                "Material Handling"
            ]
        },
        "Kawasaki-Astorino": {
            "MT": "R",
            "N": "Kawasaki Astorino",
            "F": "Kawasaki-Astorino.robot",
            "I": "Kawasaki-Astorino-robot.png",
            "IS": "Kawasaki-Astorino.png",
            "B": "Kawasaki",
            "M": "Astorino",
            "T": "6 DOF",
            "A": 6,
            "R": 578,
            "P": 1.0,
            "W": 11,
            "E": 0.2,
            "AP": [
                "Assembly",
                "Inspection",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kawasaki-BA006L": {
            "MT": "R",
            "N": "Kawasaki BA006L",
            "F": "Kawasaki-BA006L.robot",
            "I": "Kawasaki-BA006L-robot.png",
            "IS": "Kawasaki-BA006L.png",
            "B": "Kawasaki",
            "M": "BA006L",
            "T": "6 DOF",
            "A": 6,
            "R": 2036,
            "P": 6,
            "W": 160,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Kawasaki-BA013L": {
            "MT": "R",
            "N": "Kawasaki BA013L",
            "F": "Kawasaki-BA013L.robot",
            "I": "Kawasaki-BA013L-robot.png",
            "IS": "Kawasaki-BA013L.png",
            "B": "Kawasaki",
            "M": "BA013L",
            "T": "6 DOF",
            "A": 6,
            "R": 2093,
            "P": 13,
            "W": 280,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Kawasaki-BT200L": {
            "MT": "R",
            "N": "Kawasaki BT200L",
            "F": "Kawasaki-BT200L.robot",
            "I": "Kawasaki-BT200L-robot.png",
            "IS": "Kawasaki-BT200L.png",
            "B": "Kawasaki",
            "M": "BT200L",
            "T": "6 DOF",
            "A": 6,
            "R": 3151,
            "P": 200,
            "W": 1100,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-BTP210L": {
            "MT": "R",
            "N": "Kawasaki BTP210L",
            "F": "Kawasaki-BTP210L.robot",
            "I": "Kawasaki-BTP210L-robot.png",
            "IS": "Kawasaki-BTP210L.png",
            "B": "Kawasaki",
            "M": "BTP210L",
            "T": "6 DOF",
            "A": 6,
            "R": 3151,
            "P": 210,
            "W": 1030,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-BX100L": {
            "MT": "R",
            "N": "Kawasaki BX100L",
            "F": "Kawasaki-BX100L.robot",
            "I": "Kawasaki-BX100L-robot.png",
            "IS": "Kawasaki-BX100L.png",
            "B": "Kawasaki",
            "M": "BX100L",
            "T": "6 DOF",
            "A": 6,
            "R": 2597,
            "P": 100,
            "W": 740,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-BX100N": {
            "MT": "R",
            "N": "Kawasaki BX100N",
            "F": "Kawasaki-BX100N.robot",
            "I": "Kawasaki-BX100N-robot.png",
            "IS": "Kawasaki-BX100N.png",
            "B": "Kawasaki",
            "M": "BX100N",
            "T": "6 DOF",
            "A": 6,
            "R": 2200,
            "P": 100,
            "W": 740,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-BX100S": {
            "MT": "R",
            "N": "Kawasaki BX100S",
            "F": "Kawasaki-BX100S.robot",
            "I": "Kawasaki-BX100S-robot.png",
            "IS": "Kawasaki-BX100S.png",
            "B": "Kawasaki",
            "M": "BX100S",
            "T": "6 DOF",
            "A": 6,
            "R": 1634,
            "P": 100,
            "W": 720,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kawasaki-BX130X": {
            "MT": "R",
            "N": "Kawasaki BX130X",
            "F": "Kawasaki-BX130X.robot",
            "I": "Kawasaki-BX130X-robot.png",
            "IS": "Kawasaki-BX130X.png",
            "B": "Kawasaki",
            "M": "BX130X",
            "T": "6 DOF",
            "A": 6,
            "R": 2991,
            "P": 130,
            "W": 920,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-BX165L": {
            "MT": "R",
            "N": "Kawasaki BX165L",
            "F": "Kawasaki-BX165L.robot",
            "I": "Kawasaki-BX165L-robot.png",
            "IS": "Kawasaki-BX165L.png",
            "B": "Kawasaki",
            "M": "BX165L",
            "T": "6 DOF",
            "A": 6,
            "R": 2597,
            "P": 165,
            "W": 890,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-BX200L": {
            "MT": "R",
            "N": "Kawasaki BX200L",
            "F": "Kawasaki-BX200L.robot",
            "I": "Kawasaki-BX200L-robot.png",
            "IS": "Kawasaki-BX200L.png",
            "B": "Kawasaki",
            "M": "BX200L",
            "T": "6 DOF",
            "A": 6,
            "R": 2597,
            "P": 200,
            "W": 930,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-BX200X": {
            "MT": "R",
            "N": "Kawasaki BX200X",
            "F": "Kawasaki-BX200X.robot",
            "I": "Kawasaki-BX200X-robot.png",
            "IS": "Kawasaki-BX200X.png",
            "B": "Kawasaki",
            "M": "BX200X",
            "T": "6 DOF",
            "A": 6,
            "R": 2812,
            "P": 200,
            "W": 1460,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-BX300L": {
            "MT": "R",
            "N": "Kawasaki BX300L",
            "F": "Kawasaki-BX300L.robot",
            "I": "Kawasaki-BX300L-robot.png",
            "IS": "Kawasaki-BX300L.png",
            "B": "Kawasaki",
            "M": "BX300L",
            "T": "6 DOF",
            "A": 6,
            "R": 2812,
            "P": 300,
            "W": 930,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-BXP110L": {
            "MT": "R",
            "N": "Kawasaki BXP110L",
            "F": "Kawasaki-BXP110L.robot",
            "I": "Kawasaki-BXP110L-robot.png",
            "IS": "Kawasaki-BXP110L.png",
            "B": "Kawasaki",
            "M": "BXP110L",
            "T": "6 DOF",
            "A": 6,
            "R": 2597,
            "P": 110,
            "W": 870,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-BXP135X": {
            "MT": "R",
            "N": "Kawasaki BXP135X",
            "F": "Kawasaki-BXP135X.robot",
            "I": "Kawasaki-BXP135X-robot.png",
            "IS": "Kawasaki-BXP135X.png",
            "B": "Kawasaki",
            "M": "BXP135X",
            "T": "6 DOF",
            "A": 6,
            "R": 2991,
            "P": 135,
            "W": 880,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-BXP165N": {
            "MT": "R",
            "N": "Kawasaki BXP165N",
            "F": "Kawasaki-BXP165N.robot",
            "I": "Kawasaki-BXP165N-robot.png",
            "IS": "Kawasaki-BXP165N.png",
            "B": "Kawasaki",
            "M": "BXP165N",
            "T": "6 DOF",
            "A": 6,
            "R": 2325,
            "P": 165,
            "W": 855,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-CX165L": {
            "MT": "R",
            "N": "Kawasaki CX165L",
            "F": "Kawasaki-CX165L.robot",
            "I": "Kawasaki-CX165L-robot.png",
            "IS": "Kawasaki-CX165L.png",
            "B": "Kawasaki",
            "M": "CX165L",
            "T": "6 DOF",
            "A": 6,
            "R": 2597,
            "P": 165,
            "W": 890,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-CX210L": {
            "MT": "R",
            "N": "Kawasaki CX210L",
            "F": "Kawasaki-CX210L.robot",
            "I": "Kawasaki-CX210L-robot.png",
            "IS": "Kawasaki-CX210L.png",
            "B": "Kawasaki",
            "M": "CX210L",
            "T": "6 DOF",
            "A": 6,
            "R": 2699,
            "P": 210,
            "W": 870,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-FS03N": {
            "MT": "R",
            "N": "Kawasaki FS03N",
            "F": "Kawasaki-FS03N.robot",
            "I": "Kawasaki-FS03N-robot.png",
            "IS": "Kawasaki-FS03N.png",
            "B": "Kawasaki",
            "M": "FS03N",
            "T": "6 DOF",
            "A": 6,
            "R": 620,
            "P": 3,
            "W": 20,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kawasaki-FS06L": {
            "MT": "R",
            "N": "Kawasaki FS06L",
            "F": "Kawasaki-FS06L.robot",
            "I": "Kawasaki-FS06L-robot.png",
            "IS": "Kawasaki-FS06L.png",
            "B": "Kawasaki",
            "M": "FS06L",
            "T": "6 DOF",
            "A": 6,
            "R": 1551,
            "P": 6,
            "W": 170,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Kawasaki-FS10E": {
            "MT": "R",
            "N": "Kawasaki FS10E",
            "F": "Kawasaki-FS10E.robot",
            "I": "Kawasaki-FS10E-robot.png",
            "IS": "Kawasaki-FS10E.png",
            "B": "Kawasaki",
            "M": "FS10E",
            "T": "6 DOF",
            "A": 6,
            "R": 1451,
            "P": 10,
            "W": 170,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Kawasaki-FS10L": {
            "MT": "R",
            "N": "Kawasaki FS10L",
            "F": "Kawasaki-FS10L.robot",
            "I": "Kawasaki-FS10L-robot.png",
            "IS": "Kawasaki-FS10L.png",
            "B": "Kawasaki",
            "M": "FS10L",
            "T": "6 DOF",
            "A": 6,
            "R": 1852,
            "P": 10,
            "W": 280,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Kawasaki-FS10X": {
            "MT": "R",
            "N": "Kawasaki FS10X",
            "F": "Kawasaki-FS10X.robot",
            "I": "Kawasaki-FS10X-robot.png",
            "IS": "Kawasaki-FS10X.png",
            "B": "Kawasaki",
            "M": "FS10X",
            "T": "6 DOF",
            "A": 6,
            "R": 2952,
            "P": 10,
            "W": 580,
            "E": 0.23,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Inspection",
                "Material Handling",
                "Painting",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-FS20C": {
            "MT": "R",
            "N": "Kawasaki FS20C",
            "F": "Kawasaki-FS20C.robot",
            "I": "Kawasaki-FS20C-robot.png",
            "IS": "Kawasaki-FS20C.png",
            "B": "Kawasaki",
            "M": "FS20C",
            "T": "6 DOF",
            "A": 6,
            "R": 1303,
            "P": 20,
            "W": 275,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Kawasaki-FS20N": {
            "MT": "R",
            "N": "Kawasaki FS20N",
            "F": "Kawasaki-FS20N.robot",
            "I": "Kawasaki-FS20N-robot.png",
            "IS": "Kawasaki-FS20N.png",
            "B": "Kawasaki",
            "M": "FS20N",
            "T": "6 DOF",
            "A": 6,
            "R": 1653,
            "P": 20,
            "W": 280,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Kawasaki-FS30L": {
            "MT": "R",
            "N": "Kawasaki FS30L",
            "F": "Kawasaki-FS30L.robot",
            "I": "Kawasaki-FS30L-robot.png",
            "IS": "Kawasaki-FS30L.png",
            "B": "Kawasaki",
            "M": "FS30L",
            "T": "6 DOF",
            "A": 6,
            "R": 2104,
            "P": 30,
            "W": 555,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-FS30N": {
            "MT": "R",
            "N": "Kawasaki FS30N",
            "F": "Kawasaki-FS30N.robot",
            "I": "Kawasaki-FS30N-robot.png",
            "IS": "Kawasaki-FS30N.png",
            "B": "Kawasaki",
            "M": "FS30N",
            "T": "6 DOF",
            "A": 6,
            "R": 1676,
            "P": 30,
            "W": 575,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kawasaki-FS45N": {
            "MT": "R",
            "N": "Kawasaki FS45N",
            "F": "Kawasaki-FS45N.robot",
            "I": "Kawasaki-FS45N-robot.png",
            "IS": "Kawasaki-FS45N.png",
            "B": "Kawasaki",
            "M": "FS45N",
            "T": "6 DOF",
            "A": 6,
            "R": 1805,
            "P": 45,
            "W": 580,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kawasaki-KF263": {
            "MT": "R",
            "N": "Kawasaki KF263",
            "F": "Kawasaki-KF263.robot",
            "I": "Kawasaki-KF263-robot.png",
            "IS": "Kawasaki-KF263.png",
            "B": "Kawasaki",
            "M": "KF263",
            "T": "6 DOF",
            "A": 6,
            "R": 2665,
            "P": 12,
            "W": 530,
            "E": 0.5,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Inspection",
                "Material Handling",
                "Painting",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-KJ264J": {
            "MT": "R",
            "N": "Kawasaki KJ264J",
            "F": "Kawasaki-KJ264J.robot",
            "I": "Kawasaki-KJ264J-robot.png",
            "IS": "Kawasaki-KJ264J.png",
            "B": "Kawasaki",
            "M": "KJ264J",
            "T": "6 DOF",
            "A": 6,
            "R": 2640,
            "P": 15,
            "W": 540,
            "E": 0.5,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Inspection",
                "Material Handling",
                "Painting",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-MC04N": {
            "MT": "R",
            "N": "Kawasaki MC04N",
            "F": "Kawasaki-MC04N.robot",
            "I": "Kawasaki-MC04N-robot.png",
            "IS": "Kawasaki-MC04N.png",
            "B": "Kawasaki",
            "M": "MC04N",
            "T": "6 DOF",
            "A": 6,
            "R": 505.8,
            "P": 4,
            "W": 25,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kawasaki-MC006V": {
            "MT": "R",
            "N": "Kawasaki MC006V",
            "F": "Kawasaki-MC006V.robot",
            "I": "Kawasaki-MC006V-robot.png",
            "IS": "Kawasaki-MC006V.png",
            "B": "Kawasaki",
            "M": "MC006V",
            "T": "6 DOF",
            "A": 6,
            "R": 610,
            "P": 6.0,
            "W": 40.5,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kawasaki-MX350L": {
            "MT": "R",
            "N": "Kawasaki MX350L",
            "F": "Kawasaki-MX350L.robot",
            "I": "Kawasaki-MX350L-robot.png",
            "IS": "Kawasaki-MX350L.png",
            "B": "Kawasaki",
            "M": "MX350L",
            "T": "6 DOF",
            "A": 6,
            "R": 3360,
            "P": 350,
            "W": 2800,
            "E": 0.5,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-MX420L": {
            "MT": "R",
            "N": "Kawasaki MX420L",
            "F": "Kawasaki-MX420L.robot",
            "I": "Kawasaki-MX420L-robot.png",
            "IS": "Kawasaki-MX420L.png",
            "B": "Kawasaki",
            "M": "MX420L",
            "T": "6 DOF",
            "A": 6,
            "R": 3010,
            "P": 420,
            "W": 2800,
            "E": 0.5,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-MX500N": {
            "MT": "R",
            "N": "Kawasaki MX500N",
            "F": "Kawasaki-MX500N.robot",
            "I": "Kawasaki-MX500N-robot.png",
            "IS": "Kawasaki-MX500N.png",
            "B": "Kawasaki",
            "M": "MX500N",
            "T": "6 DOF",
            "A": 6,
            "R": 2540,
            "P": 500,
            "W": 2750,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-MX700N": {
            "MT": "R",
            "N": "Kawasaki MX700N",
            "F": "Kawasaki-MX700N.robot",
            "I": "Kawasaki-MX700N-robot.png",
            "IS": "Kawasaki-MX700N.png",
            "B": "Kawasaki",
            "M": "MX700N",
            "T": "6 DOF",
            "A": 6,
            "R": 2860,
            "P": 700,
            "W": 2750,
            "E": 0.5,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-MXP410X": {
            "MT": "R",
            "N": "Kawasaki MXP410X",
            "F": "Kawasaki-MXP410X.robot",
            "I": "Kawasaki-MXP410X-robot.png",
            "IS": "Kawasaki-MXP410X.png",
            "B": "Kawasaki",
            "M": "MXP410X",
            "T": "6 DOF",
            "A": 6,
            "R": 3763,
            "P": 410,
            "W": 2800,
            "E": 0.12,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-RS03N": {
            "MT": "R",
            "N": "Kawasaki RS03N",
            "F": "Kawasaki-RS03N.robot",
            "I": "Kawasaki-RS03N-robot.png",
            "IS": "Kawasaki-RS03N.png",
            "B": "Kawasaki",
            "M": "RS03N",
            "T": "6 DOF",
            "A": 6,
            "R": 620,
            "P": 3,
            "W": 20,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kawasaki-RS005L": {
            "MT": "R",
            "N": "Kawasaki RS005L",
            "F": "Kawasaki-RS005L.robot",
            "I": "Kawasaki-RS005L-robot.png",
            "IS": "Kawasaki-RS005L.png",
            "B": "Kawasaki",
            "M": "RS005L",
            "T": "6 DOF",
            "A": 6,
            "R": 903,
            "P": 5,
            "W": 37,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kawasaki-RS05N": {
            "MT": "R",
            "N": "Kawasaki RS05N",
            "F": "Kawasaki-RS05N.robot",
            "I": "Kawasaki-RS05N-robot.png",
            "IS": "Kawasaki-RS05N.png",
            "B": "Kawasaki",
            "M": "RS05N",
            "T": "6 DOF",
            "A": 6,
            "R": 705,
            "P": 5,
            "W": 34,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kawasaki-RS006L": {
            "MT": "R",
            "N": "Kawasaki RS006L",
            "F": "Kawasaki-RS006L.robot",
            "I": "Kawasaki-RS006L-robot.png",
            "IS": "Kawasaki-RS006L.png",
            "B": "Kawasaki",
            "M": "RS006L",
            "T": "6 DOF",
            "A": 6,
            "R": 1650,
            "P": 6,
            "W": 150,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Kawasaki-RS007L": {
            "MT": "R",
            "N": "Kawasaki RS007L",
            "F": "Kawasaki-RS007L.robot",
            "I": "Kawasaki-RS007L-robot.png",
            "IS": "Kawasaki-RS007L.png",
            "B": "Kawasaki",
            "M": "RS007L",
            "T": "6 DOF",
            "A": 6,
            "R": 930,
            "P": 7,
            "W": 36,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kawasaki-RS007N": {
            "MT": "R",
            "N": "Kawasaki RS007N",
            "F": "Kawasaki-RS007N.robot",
            "I": "Kawasaki-RS007N-robot.png",
            "IS": "Kawasaki-RS007N.png",
            "B": "Kawasaki",
            "M": "RS007N",
            "T": "6 DOF",
            "A": 6,
            "R": 730,
            "P": 7,
            "W": 35,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kawasaki-RS010L": {
            "MT": "R",
            "N": "Kawasaki RS010L",
            "F": "Kawasaki-RS010L.robot",
            "I": "Kawasaki-RS010L-robot.png",
            "IS": "Kawasaki-RS010L.png",
            "B": "Kawasaki",
            "M": "RS010L",
            "T": "6 DOF",
            "A": 6,
            "R": 1925,
            "P": 10,
            "W": 230,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Kawasaki-RS10": {
            "MT": "R",
            "N": "Kawasaki RS10",
            "F": "Kawasaki-RS10.robot",
            "I": "Kawasaki-RS10-robot.png",
            "IS": "Kawasaki-RS10.png",
            "B": "Kawasaki",
            "M": "RS10",
            "T": "6 DOF",
            "A": 6,
            "R": 1500,
            "P": 10,
            "W": 230,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Kawasaki-RS013N-A": {
            "MT": "R",
            "N": "Kawasaki RS013N-A",
            "F": "Kawasaki-RS013N-A.robot",
            "I": "Kawasaki-RS013N-A-robot.png",
            "IS": "Kawasaki-RS013N-A.png",
            "B": "Kawasaki",
            "M": "RS013N-A",
            "T": "6 DOF",
            "A": 6,
            "R": 1460,
            "P": 13,
            "W": 170,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Kawasaki-RS015X": {
            "MT": "R",
            "N": "Kawasaki RS015X",
            "F": "Kawasaki-RS015X.robot",
            "I": "Kawasaki-RS015X-robot.png",
            "IS": "Kawasaki-RS015X.png",
            "B": "Kawasaki",
            "M": "RS015X",
            "T": "6 DOF",
            "A": 6,
            "R": 3150,
            "P": 15,
            "W": 545,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Kawasaki-RS20N": {
            "MT": "R",
            "N": "Kawasaki RS20N",
            "F": "Kawasaki-RS20N.robot",
            "I": "Kawasaki-RS20N-robot.png",
            "IS": "Kawasaki-RS20N.png",
            "B": "Kawasaki",
            "M": "RS20N",
            "T": "6 DOF",
            "A": 6,
            "R": 1725,
            "P": 20,
            "W": 230,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Kawasaki-RS025N": {
            "MT": "R",
            "N": "Kawasaki RS025N",
            "F": "Kawasaki-RS025N.robot",
            "I": "Kawasaki-RS025N-robot.png",
            "IS": "Kawasaki-RS025N.png",
            "B": "Kawasaki",
            "M": "RS025N",
            "T": "6 DOF",
            "A": 6,
            "R": 1885,
            "P": 25,
            "W": 270,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kawasaki-RS50N": {
            "MT": "R",
            "N": "Kawasaki RS50N",
            "F": "Kawasaki-RS50N.robot",
            "I": "Kawasaki-RS50N-robot.png",
            "IS": "Kawasaki-RS50N.png",
            "B": "Kawasaki",
            "M": "RS50N",
            "T": "6 DOF",
            "A": 6,
            "R": 2100,
            "P": 50,
            "W": 555,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-RS80N": {
            "MT": "R",
            "N": "Kawasaki RS80N",
            "F": "Kawasaki-RS80N.robot",
            "I": "Kawasaki-RS80N-robot.png",
            "IS": "Kawasaki-RS80N.png",
            "B": "Kawasaki",
            "M": "RS80N",
            "T": "6 DOF",
            "A": 6,
            "R": 2100,
            "P": 80,
            "W": 555,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-ZX130L": {
            "MT": "R",
            "N": "Kawasaki ZX130L",
            "F": "Kawasaki-ZX130L.robot",
            "I": "Kawasaki-ZX130L-robot.png",
            "IS": "Kawasaki-ZX130L.png",
            "B": "Kawasaki",
            "M": "ZX130L",
            "T": "6 DOF",
            "A": 6,
            "R": 2951,
            "P": 130,
            "W": 1400,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-ZX165U": {
            "MT": "R",
            "N": "Kawasaki ZX165U",
            "F": "Kawasaki-ZX165U.robot",
            "I": "Kawasaki-ZX165U-robot.png",
            "IS": "Kawasaki-ZX165U.png",
            "B": "Kawasaki",
            "M": "ZX165U",
            "T": "6 DOF",
            "A": 6,
            "R": 2951,
            "P": 165,
            "W": 1350,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-ZX200S": {
            "MT": "R",
            "N": "Kawasaki ZX200S",
            "F": "Kawasaki-ZX200S.robot",
            "I": "Kawasaki-ZX200S-robot.png",
            "IS": "Kawasaki-ZX200S.png",
            "B": "Kawasaki",
            "M": "ZX200S",
            "T": "6 DOF",
            "A": 6,
            "R": 2651,
            "P": 200,
            "W": 1400,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-ZX300S": {
            "MT": "R",
            "N": "Kawasaki ZX300S",
            "F": "Kawasaki-ZX300S.robot",
            "I": "Kawasaki-ZX300S-robot.png",
            "IS": "Kawasaki-ZX300S.png",
            "B": "Kawasaki",
            "M": "ZX300S",
            "T": "6 DOF",
            "A": 6,
            "R": 2501,
            "P": 300,
            "W": 1400,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Kawasaki-YF002N": {
            "MT": "R",
            "N": "Kawasaki YF002N",
            "F": "Kawasaki-YF002N.robot",
            "I": "Kawasaki-YF002N-robot.png",
            "IS": "Kawasaki-YF002N.png",
            "B": "Kawasaki",
            "M": "YF002N",
            "T": "Delta",
            "A": 4,
            "R": 300,
            "P": 2,
            "W": 60,
            "E": 0.04,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Kawasaki-YF003N": {
            "MT": "R",
            "N": "Kawasaki YF003N",
            "F": "Kawasaki-YF003N.robot",
            "I": "Kawasaki-YF003N-robot.png",
            "IS": "Kawasaki-YF003N.png",
            "B": "Kawasaki",
            "M": "YF003N",
            "T": "Delta",
            "A": 4,
            "R": 650,
            "P": 3,
            "W": 145,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Kawasaki-duAro-1-A": {
            "MT": "R",
            "N": "Kawasaki duAro 1-A",
            "F": "Kawasaki-duAro-1-A.robot",
            "I": "Kawasaki-duAro-1-A-robot.png",
            "IS": "Kawasaki-duAro-1-A.png",
            "B": "Kawasaki",
            "M": "duAro 1-A",
            "T": "SCARA",
            "A": 4,
            "R": 760,
            "P": 2,
            "W": 200,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Kawasaki-duAro-1-B": {
            "MT": "R",
            "N": "Kawasaki duAro 1-B",
            "F": "Kawasaki-duAro-1-B.robot",
            "I": "Kawasaki-duAro-1-B-robot.png",
            "IS": "Kawasaki-duAro-1-B.png",
            "B": "Kawasaki",
            "M": "duAro 1-B",
            "T": "SCARA",
            "A": 4,
            "R": 760,
            "P": 2,
            "W": 200,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Kawasaki-duAro1-Dual-Arm": {
            "MT": "R",
            "N": "Kawasaki duAro1 Dual-Arm",
            "F": "Kawasaki-duAro1-Dual-Arm.rdka",
            "I": "Kawasaki-duAro1-Dual-Arm-robot.png",
            "IS": "Kawasaki-duAro1-Dual-Arm.png",
            "B": "Kawasaki",
            "M": "duAro1 Dual-Arm",
            "T": "SCARA",
            "A": 4,
            "R": 760,
            "P": 2,
            "W": 207,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Kinova-Gen3-6DOF-NoV": {
            "MT": "R",
            "N": "Kinova Gen3 6DOF NoV",
            "F": "Kinova-Gen3-6DOF-NoV.robot",
            "I": "Kinova-Gen3-6DOF-NoV-robot.png",
            "IS": "Kinova-Gen3-6DOF-NoV.png",
            "B": "Kinova",
            "M": "Gen3 6DOF NoV",
            "T": "6 DOF",
            "A": 6,
            "R": 735.1,
            "P": 4,
            "W": 7.2,
            "E": 0.15,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kinova-Gen3-6DOF": {
            "MT": "R",
            "N": "Kinova Gen3 6DOF",
            "F": "Kinova-Gen3-6DOF.robot",
            "I": "Kinova-Gen3-6DOF-robot.png",
            "IS": "Kinova-Gen3-6DOF.png",
            "B": "Kinova",
            "M": "Gen3 6DOF",
            "T": "6 DOF",
            "A": 6,
            "R": 735.1,
            "P": 4,
            "W": 7.2,
            "E": 0.15,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kinova-Gen3-lite": {
            "MT": "R",
            "N": "Kinova Gen3 lite",
            "F": "Kinova-Gen3-lite.robot",
            "I": "Kinova-Gen3-lite-robot.png",
            "IS": "Kinova-Gen3-lite.png",
            "B": "Kinova",
            "M": "Gen3 lite",
            "T": "6 DOF",
            "A": 6,
            "R": 735.1,
            "P": 4,
            "W": 7.2,
            "E": 0.15,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Kinova-Link-6": {
            "MT": "R",
            "N": "Kinova Link 6",
            "F": "Kinova-Link-6.robot",
            "I": "Kinova-Link-6-robot.png",
            "IS": "Kinova-Link-6.png",
            "B": "Kinova",
            "M": "Link 6",
            "T": "6 DOF",
            "A": 6,
            "R": 1000,
            "P": 6.0,
            "W": 23.45,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Kinova-Gen3": {
            "MT": "R",
            "N": "Kinova Gen3",
            "F": "Kinova-Gen3.robot",
            "I": "Kinova-Gen3-robot.png",
            "IS": "Kinova-Gen3.png",
            "B": "Kinova",
            "M": "Gen3",
            "T": "7 DOF",
            "A": 7,
            "R": 735.1,
            "P": 14,
            "W": 29.9,
            "E": 0.15,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-1000-L950-titan-PA": {
            "MT": "R",
            "N": "KUKA KR 1000 L950 titan PA",
            "F": "KUKA-KR-1000-L950-titan-PA.robot",
            "I": "KUKA-KR-1000-L950-titan-PA-robot.png",
            "IS": "KUKA-KR-1000-L950-titan-PA.png",
            "B": "KUKA",
            "M": "KR 1000 L950 titan PA",
            "T": "5 DOF",
            "A": 5,
            "R": 3601,
            "P": 950,
            "W": 4740,
            "E": 0.2,
            "AP": [
                "Material Handling"
            ]
        },
        "KUKA-KR-1000-L1300-titan-PA": {
            "MT": "R",
            "N": "KUKA KR 1000 L1300 titan PA",
            "F": "KUKA-KR-1000-L1300-titan-PA.robot",
            "I": "KUKA-KR-1000-L1300-titan-PA-robot.png",
            "IS": "KUKA-KR-1000-L1300-titan-PA.png",
            "B": "KUKA",
            "M": "KR 1000 L1300 titan PA",
            "T": "5 DOF",
            "A": 5,
            "R": 3202,
            "P": 1300,
            "W": 4690,
            "E": 0.2,
            "AP": [
                "Material Handling"
            ]
        },
        "KUKA-youBot": {
            "MT": "R",
            "N": "KUKA youBot",
            "F": "KUKA-youBot.robot",
            "I": "KUKA-youBot-robot.png",
            "IS": "KUKA-youBot.png",
            "B": "KUKA",
            "M": "youBot",
            "T": "5 DOF",
            "A": 5,
            "R": 901,
            "P": 10,
            "W": 52,
            "E": 0.03,
            "AP": [
                "Material Handling"
            ]
        },
        "KUKA-iisy-3-R760": {
            "MT": "R",
            "N": "KUKA iisy 3 R760",
            "F": "KUKA-iisy-3-R760.robot",
            "I": "KUKA-iisy-3-R760-robot.png",
            "IS": "KUKA-iisy-3-R760.png",
            "B": "KUKA",
            "M": "iisy 3 R760",
            "T": "6 DOF",
            "A": 6,
            "R": 760,
            "P": 3,
            "W": 22.8,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-iisy-11-R1300": {
            "MT": "R",
            "N": "KUKA iisy 11 R1300",
            "F": "KUKA-iisy-11-R1300.robot",
            "I": "KUKA-iisy-11-R1300-robot.png",
            "IS": "KUKA-iisy-11-R1300.png",
            "B": "KUKA",
            "M": "iisy 11 R1300",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 11.0,
            "W": 46.3,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-iisy-15-R930": {
            "MT": "R",
            "N": "KUKA iisy 15 R930",
            "F": "KUKA-iisy-15-R930.robot",
            "I": "KUKA-iisy-15-R930-robot.png",
            "IS": "KUKA-iisy-15-R930.png",
            "B": "KUKA",
            "M": "iisy 15 R930",
            "T": "6 DOF",
            "A": 6,
            "R": 930,
            "P": 15.0,
            "W": 43.2,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-IONTEC-ultra-KR-120-R2700": {
            "MT": "R",
            "N": "KUKA IONTEC ultra KR 120 R2700",
            "F": "KUKA-IONTEC-ultra-KR-120-R2700.robot",
            "I": "KUKA-IONTEC-ultra-KR-120-R2700-robot.png",
            "IS": "KUKA-IONTEC-ultra-KR-120-R2700.png",
            "B": "KUKA",
            "M": "IONTEC ultra KR 120 R2700",
            "T": "6 DOF",
            "A": 6,
            "R": 2702,
            "P": 120,
            "W": 773,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-3-R540": {
            "MT": "R",
            "N": "KUKA KR 3 R540",
            "F": "KUKA-KR-3-R540.robot",
            "I": "KUKA-KR-3-R540-robot.png",
            "IS": "KUKA-KR-3-R540.png",
            "B": "KUKA",
            "M": "KR 3 R540",
            "T": "6 DOF",
            "A": 6,
            "R": 541,
            "P": 3,
            "W": 26,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-3": {
            "MT": "R",
            "N": "KUKA KR 3",
            "F": "KUKA-KR-3.robot",
            "I": "KUKA-KR-3-robot.png",
            "IS": "KUKA-KR-3.png",
            "B": "KUKA",
            "M": "KR 3",
            "T": "6 DOF",
            "A": 6,
            "R": 635,
            "P": 3,
            "W": 53,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-4-R600": {
            "MT": "R",
            "N": "KUKA KR 4 R600",
            "F": "KUKA-KR-4-R600.robot",
            "I": "KUKA-KR-4-R600-robot.png",
            "IS": "KUKA-KR-4-R600.png",
            "B": "KUKA",
            "M": "KR 4 R600",
            "T": "6 DOF",
            "A": 6,
            "R": 601,
            "P": 4.63,
            "W": 24,
            "E": 0.015,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-5-arc-HW": {
            "MT": "R",
            "N": "KUKA KR 5 arc HW",
            "F": "KUKA-KR-5-arc-HW.robot",
            "I": "KUKA-KR-5-arc-HW-robot.png",
            "IS": "KUKA-KR-5-arc-HW.png",
            "B": "KUKA",
            "M": "KR 5 arc HW",
            "T": "6 DOF",
            "A": 6,
            "R": 1423,
            "P": 5,
            "W": 126,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-5-arc": {
            "MT": "R",
            "N": "KUKA KR 5 arc",
            "F": "KUKA-KR-5-arc.robot",
            "I": "KUKA-KR-5-arc-robot.png",
            "IS": "KUKA-KR-5-arc.png",
            "B": "KUKA",
            "M": "KR 5 arc",
            "T": "6 DOF",
            "A": 6,
            "R": 1411,
            "P": 5,
            "W": 127,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-5-sixx-R650": {
            "MT": "R",
            "N": "KUKA KR 5 sixx R650",
            "F": "KUKA-KR-5-sixx-R650.robot",
            "I": "KUKA-KR-5-sixx-R650-robot.png",
            "IS": "KUKA-KR-5-sixx-R650.png",
            "B": "KUKA",
            "M": "KR 5 sixx R650",
            "T": "6 DOF",
            "A": 6,
            "R": 653,
            "P": 5,
            "W": 28,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-5-sixx-R850": {
            "MT": "R",
            "N": "KUKA KR 5 sixx R850",
            "F": "KUKA-KR-5-sixx-R850.robot",
            "I": "KUKA-KR-5-sixx-R850-robot.png",
            "IS": "KUKA-KR-5-sixx-R850.png",
            "B": "KUKA",
            "M": "KR 5 sixx R850",
            "T": "6 DOF",
            "A": 6,
            "R": 855,
            "P": 5,
            "W": 29,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-6-2-KS": {
            "MT": "R",
            "N": "KUKA KR 6 2 KS",
            "F": "KUKA-KR-6-2-KS.robot",
            "I": "KUKA-KR-6-2-KS-robot.png",
            "IS": "KUKA-KR-6-2-KS.png",
            "B": "KUKA",
            "M": "KR 6 2 KS",
            "T": "6 DOF",
            "A": 6,
            "R": 1801,
            "P": 6,
            "W": 240,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-6-2": {
            "MT": "R",
            "N": "KUKA KR 6 2",
            "F": "KUKA-KR-6-2.robot",
            "I": "KUKA-KR-6-2-robot.png",
            "IS": "KUKA-KR-6-2.png",
            "B": "KUKA",
            "M": "KR 6 2",
            "T": "6 DOF",
            "A": 6,
            "R": 1611,
            "P": 6,
            "W": 235,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-6-arc": {
            "MT": "R",
            "N": "KUKA KR 6 arc",
            "F": "KUKA-KR-6-arc.robot",
            "I": "KUKA-KR-6-arc-robot.png",
            "IS": "KUKA-KR-6-arc.png",
            "B": "KUKA",
            "M": "KR 6 arc",
            "T": "6 DOF",
            "A": 6,
            "R": 1911,
            "P": 6,
            "W": 235,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-6-R700-sixx": {
            "MT": "R",
            "N": "KUKA KR 6 R700 sixx",
            "F": "KUKA-KR-6-R700-sixx.robot",
            "I": "KUKA-KR-6-R700-sixx-robot.png",
            "IS": "KUKA-KR-6-R700-sixx.png",
            "B": "KUKA",
            "M": "KR 6 R700 sixx",
            "T": "6 DOF",
            "A": 6,
            "R": 706.7,
            "P": 6,
            "W": 50,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-6-R700-2": {
            "MT": "R",
            "N": "KUKA KR 6 R700-2",
            "F": "KUKA-KR-6-R700-2.robot",
            "I": "KUKA-KR-6-R700-2-robot.png",
            "IS": "KUKA-KR-6-R700-2.png",
            "B": "KUKA",
            "M": "KR 6 R700-2",
            "T": "6 DOF",
            "A": 6,
            "R": 726,
            "P": 6.8,
            "W": 53,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-6-R900-sixx": {
            "MT": "R",
            "N": "KUKA KR 6 R900 sixx",
            "F": "KUKA-KR-6-R900-sixx.robot",
            "I": "KUKA-KR-6-R900-sixx-robot.png",
            "IS": "KUKA-KR-6-R900-sixx.png",
            "B": "KUKA",
            "M": "KR 6 R900 sixx",
            "T": "6 DOF",
            "A": 6,
            "R": 901,
            "P": 6,
            "W": 52,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-6-R900": {
            "MT": "R",
            "N": "KUKA KR 6 R900",
            "F": "KUKA-KR-6-R900.robot",
            "I": "KUKA-KR-6-R900-robot.png",
            "IS": "KUKA-KR-6-R900.png",
            "B": "KUKA",
            "M": "KR 6 R900",
            "T": "6 DOF",
            "A": 6,
            "R": 901,
            "P": 6.5,
            "W": 55,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-6-R900-2": {
            "MT": "R",
            "N": "KUKA KR 6 R900-2",
            "F": "KUKA-KR-6-R900-2.robot",
            "I": "KUKA-KR-6-R900-2-robot.png",
            "IS": "KUKA-KR-6-R900-2.png",
            "B": "KUKA",
            "M": "KR 6 R900-2",
            "T": "6 DOF",
            "A": 6,
            "R": 901,
            "P": 6.5,
            "W": 55,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-6-R1820-Cybertech": {
            "MT": "R",
            "N": "KUKA KR 6 R1820 Cybertech",
            "F": "KUKA-KR-6-R1820-Cybertech.robot",
            "I": "KUKA-KR-6-R1820-Cybertech-robot.png",
            "IS": "KUKA-KR-6-R1820-Cybertech.png",
            "B": "KUKA",
            "M": "KR 6 R1820 Cybertech",
            "T": "6 DOF",
            "A": 6,
            "R": 1820,
            "P": 6,
            "W": 168,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-6-R1840-2-Arc-HW": {
            "MT": "R",
            "N": "KUKA KR 6 R1840-2 Arc HW",
            "F": "KUKA-KR-6-R1840-2-Arc-HW.robot",
            "I": "KUKA-KR-6-R1840-2-Arc-HW-robot.png",
            "IS": "KUKA-KR-6-R1840-2-Arc-HW.png",
            "B": "KUKA",
            "M": "KR 6 R1840-2 Arc HW",
            "T": "6 DOF",
            "A": 6,
            "R": 1843,
            "P": 6,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-6-R2010-2-arc-HW-E": {
            "MT": "R",
            "N": "KUKA KR 6 R2010-2 arc HW E",
            "F": "KUKA-KR-6-R2010-2-arc-HW-E.robot",
            "I": "KUKA-KR-6-R2010-2-arc-HW-E-robot.png",
            "IS": "KUKA-KR-6-R2010-2-arc-HW-E.png",
            "B": "KUKA",
            "M": "KR 6 R2010-2 arc HW E",
            "T": "6 DOF",
            "A": 6,
            "R": 2010,
            "P": 6.0,
            "W": 204,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-8-R1420-arc-HW": {
            "MT": "R",
            "N": "KUKA KR 8 R1420 arc HW",
            "F": "KUKA-KR-8-R1420-arc-HW.robot",
            "I": "KUKA-KR-8-R1420-arc-HW-robot.png",
            "IS": "KUKA-KR-8-R1420-arc-HW.png",
            "B": "KUKA",
            "M": "KR 8 R1420 arc HW",
            "T": "6 DOF",
            "A": 6,
            "R": 1421,
            "P": 8,
            "W": 179,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-8-R1440-2-Arc-HW-E": {
            "MT": "R",
            "N": "KUKA KR 8 R1440-2 Arc HW E",
            "F": "KUKA-KR-8-R1440-2-Arc-HW-E.robot",
            "I": "KUKA-KR-8-R1440-2-Arc-HW-E-robot.png",
            "IS": "KUKA-KR-8-R1440-2-Arc-HW-E.png",
            "B": "KUKA",
            "M": "KR 8 R1440-2 Arc HW E",
            "T": "6 DOF",
            "A": 6,
            "R": 1441,
            "P": 8,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-8-R1440-2-Arc-HW": {
            "MT": "R",
            "N": "KUKA KR 8 R1440-2 Arc HW",
            "F": "KUKA-KR-8-R1440-2-Arc-HW.robot",
            "I": "KUKA-KR-8-R1440-2-Arc-HW-robot.png",
            "IS": "KUKA-KR-8-R1440-2-Arc-HW.png",
            "B": "KUKA",
            "M": "KR 8 R1440-2 Arc HW",
            "T": "6 DOF",
            "A": 6,
            "R": 1441,
            "P": 8,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-8-R1620-HP": {
            "MT": "R",
            "N": "KUKA KR 8 R1620 HP",
            "F": "KUKA-KR-8-R1620-HP.robot",
            "I": "KUKA-KR-8-R1620-HP-robot.png",
            "IS": "KUKA-KR-8-R1620-HP.png",
            "B": "KUKA",
            "M": "KR 8 R1620 HP",
            "T": "6 DOF",
            "A": 6,
            "R": 1620,
            "P": 6,
            "W": 165,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-8-R1640-2-Arc-HW": {
            "MT": "R",
            "N": "KUKA KR 8 R1640-2 Arc HW",
            "F": "KUKA-KR-8-R1640-2-Arc-HW.robot",
            "I": "KUKA-KR-8-R1640-2-Arc-HW-robot.png",
            "IS": "KUKA-KR-8-R1640-2-Arc-HW.png",
            "B": "KUKA",
            "M": "KR 8 R1640-2 Arc HW",
            "T": "6 DOF",
            "A": 6,
            "R": 1641,
            "P": 8,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-8-R2010": {
            "MT": "R",
            "N": "KUKA KR 8 R2010",
            "F": "KUKA-KR-8-R2010.robot",
            "I": "KUKA-KR-8-R2010-robot.png",
            "IS": "KUKA-KR-8-R2010.png",
            "B": "KUKA",
            "M": "KR 8 R2010",
            "T": "6 DOF",
            "A": 6,
            "R": 2013,
            "P": 16,
            "W": 255,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-8-R2100-2-Arc-HW": {
            "MT": "R",
            "N": "KUKA KR 8 R2100-2 Arc HW",
            "F": "KUKA-KR-8-R2100-2-Arc-HW.robot",
            "I": "KUKA-KR-8-R2100-2-Arc-HW-robot.png",
            "IS": "KUKA-KR-8-R2100-2-Arc-HW.png",
            "B": "KUKA",
            "M": "KR 8 R2100-2 Arc HW",
            "T": "6 DOF",
            "A": 6,
            "R": 2101,
            "P": 9.3,
            "W": 260,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-10-R900-sixx": {
            "MT": "R",
            "N": "KUKA KR 10 R900 sixx",
            "F": "KUKA-KR-10-R900-sixx.robot",
            "I": "KUKA-KR-10-R900-sixx-robot.png",
            "IS": "KUKA-KR-10-R900-sixx.png",
            "B": "KUKA",
            "M": "KR 10 R900 sixx",
            "T": "6 DOF",
            "A": 6,
            "R": 901,
            "P": 10,
            "W": 52,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-10-R900-2": {
            "MT": "R",
            "N": "KUKA KR 10 R900-2",
            "F": "KUKA-KR-10-R900-2.robot",
            "I": "KUKA-KR-10-R900-2-robot.png",
            "IS": "KUKA-KR-10-R900-2.png",
            "B": "KUKA",
            "M": "KR 10 R900-2",
            "T": "6 DOF",
            "A": 6,
            "R": 901,
            "P": 10,
            "W": 52,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-10-R1100-sixx": {
            "MT": "R",
            "N": "KUKA KR 10 R1100 sixx",
            "F": "KUKA-KR-10-R1100-sixx.robot",
            "I": "KUKA-KR-10-R1100-sixx-robot.png",
            "IS": "KUKA-KR-10-R1100-sixx.png",
            "B": "KUKA",
            "M": "KR 10 R1100 sixx",
            "T": "6 DOF",
            "A": 6,
            "R": 1101,
            "P": 10,
            "W": 54,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-10-R1100-2": {
            "MT": "R",
            "N": "KUKA KR 10 R1100-2",
            "F": "KUKA-KR-10-R1100-2.robot",
            "I": "KUKA-KR-10-R1100-2-robot.png",
            "IS": "KUKA-KR-10-R1100-2.png",
            "B": "KUKA",
            "M": "KR 10 R1100-2",
            "T": "6 DOF",
            "A": 6,
            "R": 1101,
            "P": 10.9,
            "W": 56.5,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-10-R1420": {
            "MT": "R",
            "N": "KUKA KR 10 R1420",
            "F": "KUKA-KR-10-R1420.robot",
            "I": "KUKA-KR-10-R1420-robot.png",
            "IS": "KUKA-KR-10-R1420.png",
            "B": "KUKA",
            "M": "KR 10 R1420",
            "T": "6 DOF",
            "A": 6,
            "R": 1420,
            "P": 10,
            "W": 160,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-10-R1440-2": {
            "MT": "R",
            "N": "KUKA KR 10 R1440-2",
            "F": "KUKA-KR-10-R1440-2.robot",
            "I": "KUKA-KR-10-R1440-2-robot.png",
            "IS": "KUKA-KR-10-R1440-2.png",
            "B": "KUKA",
            "M": "KR 10 R1440-2",
            "T": "6 DOF",
            "A": 6,
            "R": 1440,
            "P": 10,
            "W": 153,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-12-R1810-2": {
            "MT": "R",
            "N": "KUKA KR 12 R1810-2",
            "F": "KUKA-KR-12-R1810-2.robot",
            "I": "KUKA-KR-12-R1810-2-robot.png",
            "IS": "KUKA-KR-12-R1810-2.png",
            "B": "KUKA",
            "M": "KR 12 R1810-2",
            "T": "6 DOF",
            "A": 6,
            "R": 1813,
            "P": 12,
            "W": 255,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-13-R900-3": {
            "MT": "R",
            "N": "KUKA KR 13 R900-3",
            "F": "KUKA-KR-13-R900-3.robot",
            "I": "KUKA-KR-13-R900-3-robot.png",
            "IS": "KUKA-KR-13-R900-3.png",
            "B": "KUKA",
            "M": "KR 13 R900-3",
            "T": "6 DOF",
            "A": 6,
            "R": 901,
            "P": 13,
            "W": 55,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-16-2-KS": {
            "MT": "R",
            "N": "KUKA KR 16 2 KS",
            "F": "KUKA-KR-16-2-KS.robot",
            "I": "KUKA-KR-16-2-KS-robot.png",
            "IS": "KUKA-KR-16-2-KS.png",
            "B": "KUKA",
            "M": "KR 16 2 KS",
            "T": "6 DOF",
            "A": 6,
            "R": 1801,
            "P": 16,
            "W": 245,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-16-2": {
            "MT": "R",
            "N": "KUKA KR 16 2",
            "F": "KUKA-KR-16-2.robot",
            "I": "KUKA-KR-16-2-robot.png",
            "IS": "KUKA-KR-16-2.png",
            "B": "KUKA",
            "M": "KR 16 2",
            "T": "6 DOF",
            "A": 6,
            "R": 1611,
            "P": 16,
            "W": 235,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-16-3": {
            "MT": "R",
            "N": "KUKA KR 16 3",
            "F": "KUKA-KR-16-3.robot",
            "I": "KUKA-KR-16-3-robot.png",
            "IS": "KUKA-KR-16-3.png",
            "B": "KUKA",
            "M": "KR 16 3",
            "T": "6 DOF",
            "A": 6,
            "R": 1611,
            "P": 16,
            "W": 235,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-16-arc-HW": {
            "MT": "R",
            "N": "KUKA KR 16 arc HW",
            "F": "KUKA-KR-16-arc-HW.robot",
            "I": "KUKA-KR-16-arc-HW-robot.png",
            "IS": "KUKA-KR-16-arc-HW.png",
            "B": "KUKA",
            "M": "KR 16 arc HW",
            "T": "6 DOF",
            "A": 6,
            "R": 1636,
            "P": 16,
            "W": 245,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-16-AV300": {
            "MT": "R",
            "N": "KUKA KR 16 AV300",
            "F": "KUKA-KR-16-AV300.robot",
            "I": "KUKA-KR-16-AV300-robot.png",
            "IS": "KUKA-KR-16-AV300.png",
            "B": "KUKA",
            "M": "KR 16 AV300",
            "T": "6 DOF",
            "A": 6,
            "R": 1910,
            "P": 16,
            "W": 235,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-16-L6-2-KS": {
            "MT": "R",
            "N": "KUKA KR 16 L6 2 KS",
            "F": "KUKA-KR-16-L6-2-KS.robot",
            "I": "KUKA-KR-16-L6-2-KS-robot.png",
            "IS": "KUKA-KR-16-L6-2-KS.png",
            "B": "KUKA",
            "M": "KR 16 L6 2 KS",
            "T": "6 DOF",
            "A": 6,
            "R": 1801,
            "P": 16,
            "W": 245,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-16-L6": {
            "MT": "R",
            "N": "KUKA KR 16 L6",
            "F": "KUKA-KR-16-L6.robot",
            "I": "KUKA-KR-16-L6-robot.png",
            "IS": "KUKA-KR-16-L6.png",
            "B": "KUKA",
            "M": "KR 16 L6",
            "T": "6 DOF",
            "A": 6,
            "R": 1911,
            "P": 6.0,
            "W": 240,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-16-L8-arc-HW": {
            "MT": "R",
            "N": "KUKA KR 16 L8 arc HW",
            "F": "KUKA-KR-16-L8-arc-HW.robot",
            "I": "KUKA-KR-16-L8-arc-HW-robot.png",
            "IS": "KUKA-KR-16-L8-arc-HW.png",
            "B": "KUKA",
            "M": "KR 16 L8 arc HW",
            "T": "6 DOF",
            "A": 6,
            "R": 2015,
            "P": 8,
            "W": 238,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-16-R1610": {
            "MT": "R",
            "N": "KUKA KR 16 R1610",
            "F": "KUKA-KR-16-R1610.robot",
            "I": "KUKA-KR-16-R1610-robot.png",
            "IS": "KUKA-KR-16-R1610.png",
            "B": "KUKA",
            "M": "KR 16 R1610",
            "T": "6 DOF",
            "A": 6,
            "R": 1612,
            "P": 16,
            "W": 245,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-16-R2010": {
            "MT": "R",
            "N": "KUKA KR 16 R2010",
            "F": "KUKA-KR-16-R2010.robot",
            "I": "KUKA-KR-16-R2010-robot.png",
            "IS": "KUKA-KR-16-R2010.png",
            "B": "KUKA",
            "M": "KR 16 R2010",
            "T": "6 DOF",
            "A": 6,
            "R": 2013,
            "P": 16,
            "W": 255,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-20-R1810": {
            "MT": "R",
            "N": "KUKA KR 20 R1810",
            "F": "KUKA-KR-20-R1810.robot",
            "I": "KUKA-KR-20-R1810-robot.png",
            "IS": "KUKA-KR-20-R1810.png",
            "B": "KUKA",
            "M": "KR 20 R1810",
            "T": "6 DOF",
            "A": 6,
            "R": 1810,
            "P": 20,
            "W": 250,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-20-R1820-2-E": {
            "MT": "R",
            "N": "KUKA KR 20 R1820-2 E",
            "F": "KUKA-KR-20-R1820-2-E.robot",
            "I": "KUKA-KR-20-R1820-2-E-robot.png",
            "IS": "KUKA-KR-20-R1820-2-E.png",
            "B": "KUKA",
            "M": "KR 20 R1820-2 E",
            "T": "6 DOF",
            "A": 6,
            "R": 1820,
            "P": 20.0,
            "W": 240,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-20-R3100": {
            "MT": "R",
            "N": "KUKA KR 20 R3100",
            "F": "KUKA-KR-20-R3100.robot",
            "I": "KUKA-KR-20-R3100-robot.png",
            "IS": "KUKA-KR-20-R3100.png",
            "B": "KUKA",
            "M": "KR 20 R3100",
            "T": "6 DOF",
            "A": 6,
            "R": 3101,
            "P": 20,
            "W": 559,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-22-R1610": {
            "MT": "R",
            "N": "KUKA KR 22 R1610",
            "F": "KUKA-KR-22-R1610.robot",
            "I": "KUKA-KR-22-R1610-robot.png",
            "IS": "KUKA-KR-22-R1610.png",
            "B": "KUKA",
            "M": "KR 22 R1610",
            "T": "6 DOF",
            "A": 6,
            "R": 1612,
            "P": 22,
            "W": 245,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-30-4-KS": {
            "MT": "R",
            "N": "KUKA KR 30 4 KS",
            "F": "KUKA-KR-30-4-KS.robot",
            "I": "KUKA-KR-30-4-KS-robot.png",
            "IS": "KUKA-KR-30-4-KS.png",
            "B": "KUKA",
            "M": "KR 30 4 KS",
            "T": "6 DOF",
            "A": 6,
            "R": 2233,
            "P": 30,
            "W": 600,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-30-HA": {
            "MT": "R",
            "N": "KUKA KR 30 HA",
            "F": "KUKA-KR-30-HA.robot",
            "I": "KUKA-KR-30-HA-robot.png",
            "IS": "KUKA-KR-30-HA.png",
            "B": "KUKA",
            "M": "KR 30 HA",
            "T": "6 DOF",
            "A": 6,
            "R": 2033,
            "P": 30,
            "W": 665,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-30-L16": {
            "MT": "R",
            "N": "KUKA KR 30 L16",
            "F": "KUKA-KR-30-L16.robot",
            "I": "KUKA-KR-30-L16-robot.png",
            "IS": "KUKA-KR-30-L16.png",
            "B": "KUKA",
            "M": "KR 30 L16",
            "T": "6 DOF",
            "A": 6,
            "R": 3102,
            "P": 16,
            "W": 700,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-30-R2100": {
            "MT": "R",
            "N": "KUKA KR 30 R2100",
            "F": "KUKA-KR-30-R2100.robot",
            "I": "KUKA-KR-30-R2100-robot.png",
            "IS": "KUKA-KR-30-R2100.png",
            "B": "KUKA",
            "M": "KR 30 R2100",
            "T": "6 DOF",
            "A": 6,
            "R": 2100,
            "P": 30,
            "W": 533,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-30-3": {
            "MT": "R",
            "N": "KUKA KR 30-3",
            "F": "KUKA-KR-30-3.robot",
            "I": "KUKA-KR-30-3-robot.png",
            "IS": "KUKA-KR-30-3.png",
            "B": "KUKA",
            "M": "KR 30-3",
            "T": "6 DOF",
            "A": 6,
            "R": 2033,
            "P": 30,
            "W": 665,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-50-R2100": {
            "MT": "R",
            "N": "KUKA KR 50 R2100",
            "F": "KUKA-KR-50-R2100.robot",
            "I": "KUKA-KR-50-R2100-robot.png",
            "IS": "KUKA-KR-50-R2100.png",
            "B": "KUKA",
            "M": "KR 50 R2100",
            "T": "6 DOF",
            "A": 6,
            "R": 2101,
            "P": 61,
            "W": 665,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-50-R2500": {
            "MT": "R",
            "N": "KUKA KR 50 R2500",
            "F": "KUKA-KR-50-R2500.robot",
            "I": "KUKA-KR-50-R2500-robot.png",
            "IS": "KUKA-KR-50-R2500.png",
            "B": "KUKA",
            "M": "KR 50 R2500",
            "T": "6 DOF",
            "A": 6,
            "R": 2500,
            "P": 50,
            "W": 559,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-60-4-KS": {
            "MT": "R",
            "N": "KUKA KR 60 4 KS",
            "F": "KUKA-KR-60-4-KS.robot",
            "I": "KUKA-KR-60-4-KS-robot.png",
            "IS": "KUKA-KR-60-4-KS.png",
            "B": "KUKA",
            "M": "KR 60 4 KS",
            "T": "6 DOF",
            "A": 6,
            "R": 2233,
            "P": 60,
            "W": 600,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-60-HA": {
            "MT": "R",
            "N": "KUKA KR 60 HA",
            "F": "KUKA-KR-60-HA.robot",
            "I": "KUKA-KR-60-HA-robot.png",
            "IS": "KUKA-KR-60-HA.png",
            "B": "KUKA",
            "M": "KR 60 HA",
            "T": "6 DOF",
            "A": 6,
            "R": 2033,
            "P": 30,
            "W": 665,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-60-L16-KS": {
            "MT": "R",
            "N": "KUKA KR 60 L16 KS",
            "F": "KUKA-KR-60-L16-KS.robot",
            "I": "KUKA-KR-60-L16-KS-robot.png",
            "IS": "KUKA-KR-60-L16-KS.png",
            "B": "KUKA",
            "M": "KR 60 L16 KS",
            "T": "6 DOF",
            "A": 6,
            "R": 2952,
            "P": 16,
            "W": 650,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-KR-60-L30-HA": {
            "MT": "R",
            "N": "KUKA KR 60 L30 HA",
            "F": "KUKA-KR-60-L30-HA.robot",
            "I": "KUKA-KR-60-L30-HA-robot.png",
            "IS": "KUKA-KR-60-L30-HA.png",
            "B": "KUKA",
            "M": "KR 60 L30 HA",
            "T": "6 DOF",
            "A": 6,
            "R": 2429,
            "P": 30,
            "W": 679,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-60-L45-HA": {
            "MT": "R",
            "N": "KUKA KR 60 L45 HA",
            "F": "KUKA-KR-60-L45-HA.robot",
            "I": "KUKA-KR-60-L45-HA-robot.png",
            "IS": "KUKA-KR-60-L45-HA.png",
            "B": "KUKA",
            "M": "KR 60 L45 HA",
            "T": "6 DOF",
            "A": 6,
            "R": 2230,
            "P": 45,
            "W": 671,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-60-3": {
            "MT": "R",
            "N": "KUKA KR 60-3",
            "F": "KUKA-KR-60-3.robot",
            "I": "KUKA-KR-60-3-robot.png",
            "IS": "KUKA-KR-60-3.png",
            "B": "KUKA",
            "M": "KR 60-3",
            "T": "6 DOF",
            "A": 6,
            "R": 2033,
            "P": 60,
            "W": 665,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-70-R2100": {
            "MT": "R",
            "N": "KUKA KR 70 R2100",
            "F": "KUKA-KR-70-R2100.robot",
            "I": "KUKA-KR-70-R2100-robot.png",
            "IS": "KUKA-KR-70-R2100.png",
            "B": "KUKA",
            "M": "KR 70 R2100",
            "T": "6 DOF",
            "A": 6,
            "R": 2101,
            "P": 70,
            "W": 536,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-90-R2700-pro": {
            "MT": "R",
            "N": "KUKA KR 90 R2700 pro",
            "F": "KUKA-KR-90-R2700-pro.robot",
            "I": "KUKA-KR-90-R2700-pro-robot.png",
            "IS": "KUKA-KR-90-R2700-pro.png",
            "B": "KUKA",
            "M": "KR 90 R2700 pro",
            "T": "6 DOF",
            "A": 6,
            "R": 2700,
            "P": 90,
            "W": 1058,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-90-R2900-extra-HA": {
            "MT": "R",
            "N": "KUKA KR 90 R2900 extra HA",
            "F": "KUKA-KR-90-R2900-extra-HA.robot",
            "I": "KUKA-KR-90-R2900-extra-HA-robot.png",
            "IS": "KUKA-KR-90-R2900-extra-HA.png",
            "B": "KUKA",
            "M": "KR 90 R2900 extra HA",
            "T": "6 DOF",
            "A": 6,
            "R": 2896,
            "P": 90,
            "W": 1121,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-90-R3100-extra-HA": {
            "MT": "R",
            "N": "KUKA KR 90 R3100 extra HA",
            "F": "KUKA-KR-90-R3100-extra-HA.robot",
            "I": "KUKA-KR-90-R3100-extra-HA-robot.png",
            "IS": "KUKA-KR-90-R3100-extra-HA.png",
            "B": "KUKA",
            "M": "KR 90 R3100 extra HA",
            "T": "6 DOF",
            "A": 6,
            "R": 3095,
            "P": 90,
            "W": 1129,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-90-R3100-extra": {
            "MT": "R",
            "N": "KUKA KR 90 R3100 extra",
            "F": "KUKA-KR-90-R3100-extra.robot",
            "I": "KUKA-KR-90-R3100-extra-robot.png",
            "IS": "KUKA-KR-90-R3100-extra.png",
            "B": "KUKA",
            "M": "KR 90 R3100 extra",
            "T": "6 DOF",
            "A": 6,
            "R": 3095,
            "P": 90,
            "W": 1092,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-90-R3700-K-prime": {
            "MT": "R",
            "N": "KUKA KR 90 R3700 K prime",
            "F": "KUKA-KR-90-R3700-K-prime.robot",
            "I": "KUKA-KR-90-R3700-K-prime-robot.png",
            "IS": "KUKA-KR-90-R3700-K-prime.png",
            "B": "KUKA",
            "M": "KR 90 R3700 K prime",
            "T": "6 DOF",
            "A": 6,
            "R": 3700,
            "P": 90,
            "W": 1204,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-100-R3500-press": {
            "MT": "R",
            "N": "KUKA KR 100 R3500 press",
            "F": "KUKA-KR-100-R3500-press.robot",
            "I": "KUKA-KR-100-R3500-press-robot.png",
            "IS": "KUKA-KR-100-R3500-press.png",
            "B": "KUKA",
            "M": "KR 100 R3500 press",
            "T": "6 DOF",
            "A": 6,
            "R": 3501,
            "P": 100,
            "W": 1240,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-100-2-P": {
            "MT": "R",
            "N": "KUKA KR 100-2 P",
            "F": "KUKA-KR-100-2-P.robot",
            "I": "KUKA-KR-100-2-P-robot.png",
            "IS": "KUKA-KR-100-2-P.png",
            "B": "KUKA",
            "M": "KR 100-2 P",
            "T": "6 DOF",
            "A": 6,
            "R": 3500,
            "P": 100,
            "W": 1245,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-120-R1800-nano": {
            "MT": "R",
            "N": "KUKA KR 120 R1800 nano",
            "F": "KUKA-KR-120-R1800-nano.robot",
            "I": "KUKA-KR-120-R1800-nano-robot.png",
            "IS": "KUKA-KR-120-R1800-nano.png",
            "B": "KUKA",
            "M": "KR 120 R1800 nano",
            "T": "6 DOF",
            "A": 6,
            "R": 1803,
            "P": 120,
            "W": 684,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-120-R2500-pro": {
            "MT": "R",
            "N": "KUKA KR 120 R2500 pro",
            "F": "KUKA-KR-120-R2500-pro.robot",
            "I": "KUKA-KR-120-R2500-pro-robot.png",
            "IS": "KUKA-KR-120-R2500-pro.png",
            "B": "KUKA",
            "M": "KR 120 R2500 pro",
            "T": "6 DOF",
            "A": 6,
            "R": 2500,
            "P": 120,
            "W": 1049,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-120-R2700-extra-HA": {
            "MT": "R",
            "N": "KUKA KR 120 R2700 extra HA",
            "F": "KUKA-KR-120-R2700-extra-HA.robot",
            "I": "KUKA-KR-120-R2700-extra-HA-robot.png",
            "IS": "KUKA-KR-120-R2700-extra-HA.png",
            "B": "KUKA",
            "M": "KR 120 R2700 extra HA",
            "T": "6 DOF",
            "A": 6,
            "R": 2696,
            "P": 120,
            "W": 1104,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-120-R2700-HA": {
            "MT": "R",
            "N": "KUKA KR 120 R2700 HA",
            "F": "KUKA-KR-120-R2700-HA.robot",
            "I": "KUKA-KR-120-R2700-HA-robot.png",
            "IS": "KUKA-KR-120-R2700-HA.png",
            "B": "KUKA",
            "M": "KR 120 R2700 HA",
            "T": "6 DOF",
            "A": 6,
            "R": 2696,
            "P": 120,
            "W": 1104,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-120-R2700-2": {
            "MT": "R",
            "N": "KUKA KR 120 R2700-2",
            "F": "KUKA-KR-120-R2700-2.robot",
            "I": "KUKA-KR-120-R2700-2-robot.png",
            "IS": "KUKA-KR-120-R2700-2.png",
            "B": "KUKA",
            "M": "KR 120 R2700-2",
            "T": "6 DOF",
            "A": 6,
            "R": 2701,
            "P": 120,
            "W": 1069,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-120-R2900-extra": {
            "MT": "R",
            "N": "KUKA KR 120 R2900 extra",
            "F": "KUKA-KR-120-R2900-extra.robot",
            "I": "KUKA-KR-120-R2900-extra-robot.png",
            "IS": "KUKA-KR-120-R2900-extra.png",
            "B": "KUKA",
            "M": "KR 120 R2900 extra",
            "T": "6 DOF",
            "A": 6,
            "R": 2896,
            "P": 120,
            "W": 1084,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-120-R3100-2": {
            "MT": "R",
            "N": "KUKA KR 120 R3100-2",
            "F": "KUKA-KR-120-R3100-2.robot",
            "I": "KUKA-KR-120-R3100-2-robot.png",
            "IS": "KUKA-KR-120-R3100-2.png",
            "B": "KUKA",
            "M": "KR 120 R3100-2",
            "T": "6 DOF",
            "A": 6,
            "R": 3100,
            "P": 120,
            "W": 1105,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-120-R3500-K-prime": {
            "MT": "R",
            "N": "KUKA KR 120 R3500 K prime",
            "F": "KUKA-KR-120-R3500-K-prime.robot",
            "I": "KUKA-KR-120-R3500-K-prime-robot.png",
            "IS": "KUKA-KR-120-R3500-K-prime.png",
            "B": "KUKA",
            "M": "KR 120 R3500 K prime",
            "T": "6 DOF",
            "A": 6,
            "R": 3501,
            "P": 120,
            "W": 1192,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-120-R3500-press": {
            "MT": "R",
            "N": "KUKA KR 120 R3500 press",
            "F": "KUKA-KR-120-R3500-press.robot",
            "I": "KUKA-KR-120-R3500-press-robot.png",
            "IS": "KUKA-KR-120-R3500-press.png",
            "B": "KUKA",
            "M": "KR 120 R3500 press",
            "T": "6 DOF",
            "A": 6,
            "R": 3501,
            "P": 120,
            "W": 1240,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-120-R3900-K-ultra": {
            "MT": "R",
            "N": "KUKA KR 120 R3900 K ultra",
            "F": "KUKA-KR-120-R3900-K-ultra.robot",
            "I": "KUKA-KR-120-R3900-K-ultra-robot.png",
            "IS": "KUKA-KR-120-R3900-K-ultra.png",
            "B": "KUKA",
            "M": "KR 120 R3900 K ultra",
            "T": "6 DOF",
            "A": 6,
            "R": 3901,
            "P": 120,
            "W": 1221,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-120-R3900-2-K-ultra": {
            "MT": "R",
            "N": "KUKA KR 120 R3900-2 K ultra",
            "F": "KUKA-KR-120-R3900-2-K-ultra.robot",
            "I": "KUKA-KR-120-R3900-2-K-ultra-robot.png",
            "IS": "KUKA-KR-120-R3900-2-K-ultra.png",
            "B": "KUKA",
            "M": "KR 120 R3900-2 K ultra",
            "T": "6 DOF",
            "A": 6,
            "R": 3904,
            "P": 120,
            "W": 1280,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-125-2": {
            "MT": "R",
            "N": "KUKA KR 125-2",
            "F": "KUKA-KR-125-2.robot",
            "I": "KUKA-KR-125-2-robot.png",
            "IS": "KUKA-KR-125-2.png",
            "B": "KUKA",
            "M": "KR 125-2",
            "T": "6 DOF",
            "A": 6,
            "R": 2410,
            "P": 125,
            "W": 975,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-140-comp": {
            "MT": "R",
            "N": "KUKA KR 140 comp",
            "F": "KUKA-KR-140-comp.robot",
            "I": "KUKA-KR-140-comp-robot.png",
            "IS": "KUKA-KR-140-comp.png",
            "B": "KUKA",
            "M": "KR 140 comp",
            "T": "6 DOF",
            "A": 6,
            "R": 2400,
            "P": 140,
            "W": 540,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-150-3": {
            "MT": "R",
            "N": "KUKA KR 150/3",
            "F": "KUKA-KR-150-3.robot",
            "I": "KUKA-KR-150-3-robot.png",
            "IS": "KUKA-KR-150-3.png",
            "B": "KUKA",
            "M": "KR 150/3",
            "T": "6 DOF",
            "A": 6,
            "R": 2700,
            "P": 150.0,
            "W": 1120,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-150-L110": {
            "MT": "R",
            "N": "KUKA KR 150 L110",
            "F": "KUKA-KR-150-L110.robot",
            "I": "KUKA-KR-150-L110-robot.png",
            "IS": "KUKA-KR-150-L110.png",
            "B": "KUKA",
            "M": "KR 150 L110",
            "T": "6 DOF",
            "A": 6,
            "R": 3100,
            "P": 110,
            "W": 1263,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-150-L120-2": {
            "MT": "R",
            "N": "KUKA KR 150 L120/2",
            "F": "KUKA-KR-150-L120-2.robot",
            "I": "KUKA-KR-150-L120-2-robot.png",
            "IS": "KUKA-KR-150-L120-2.png",
            "B": "KUKA",
            "M": "KR 150 L120/2",
            "T": "6 DOF",
            "A": 6,
            "R": 2810,
            "P": 120,
            "W": 1140,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-150-R2700-extra": {
            "MT": "R",
            "N": "KUKA KR 150 R2700 extra",
            "F": "KUKA-KR-150-R2700-extra.robot",
            "I": "KUKA-KR-150-R2700-extra-robot.png",
            "IS": "KUKA-KR-150-R2700-extra.png",
            "B": "KUKA",
            "M": "KR 150 R2700 extra",
            "T": "6 DOF",
            "A": 6,
            "R": 2696,
            "P": 150,
            "W": 1068,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-150-R3100-prime": {
            "MT": "R",
            "N": "KUKA KR 150 R3100 prime",
            "F": "KUKA-KR-150-R3100-prime.robot",
            "I": "KUKA-KR-150-R3100-prime-robot.png",
            "IS": "KUKA-KR-150-R3100-prime.png",
            "B": "KUKA",
            "M": "KR 150 R3100 prime",
            "T": "6 DOF",
            "A": 6,
            "R": 3095,
            "P": 150,
            "W": 1114,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-150-R3100-2": {
            "MT": "R",
            "N": "KUKA KR 150 R3100-2",
            "F": "KUKA-KR-150-R3100-2.robot",
            "I": "KUKA-KR-150-R3100-2-robot.png",
            "IS": "KUKA-KR-150-R3100-2.png",
            "B": "KUKA",
            "M": "KR 150 R3100-2",
            "T": "6 DOF",
            "A": 6,
            "R": 3100,
            "P": 150,
            "W": 1105,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-150-R3300-K-prime": {
            "MT": "R",
            "N": "KUKA KR 150 R3300 K prime",
            "F": "KUKA-KR-150-R3300-K-prime.robot",
            "I": "KUKA-KR-150-R3300-K-prime-robot.png",
            "IS": "KUKA-KR-150-R3300-K-prime.png",
            "B": "KUKA",
            "M": "KR 150 R3300 K prime",
            "T": "6 DOF",
            "A": 6,
            "R": 3301,
            "P": 150,
            "W": 1184,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-150-R3700-K-ultra": {
            "MT": "R",
            "N": "KUKA KR 150 R3700 K ultra",
            "F": "KUKA-KR-150-R3700-K-ultra.robot",
            "I": "KUKA-KR-150-R3700-K-ultra-robot.png",
            "IS": "KUKA-KR-150-R3700-K-ultra.png",
            "B": "KUKA",
            "M": "KR 150 R3700 K ultra",
            "T": "6 DOF",
            "A": 6,
            "R": 3701,
            "P": 150,
            "W": 1215,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-150-2": {
            "MT": "R",
            "N": "KUKA KR 150-2",
            "F": "KUKA-KR-150-2.robot",
            "I": "KUKA-KR-150-2-robot.png",
            "IS": "KUKA-KR-150-2.png",
            "B": "KUKA",
            "M": "KR 150-2",
            "T": "6 DOF",
            "A": 6,
            "R": 2700,
            "P": 150,
            "W": 1245,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-160-R1570-nano": {
            "MT": "R",
            "N": "KUKA KR 160 R1570 nano",
            "F": "KUKA-KR-160-R1570-nano.robot",
            "I": "KUKA-KR-160-R1570-nano-robot.png",
            "IS": "KUKA-KR-160-R1570-nano.png",
            "B": "KUKA",
            "M": "KR 160 R1570 nano",
            "T": "6 DOF",
            "A": 6,
            "R": 1573,
            "P": 160,
            "W": 677,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-180-R2100-nano-F-exclusive": {
            "MT": "R",
            "N": "KUKA KR 180 R2100 nano F exclusive",
            "F": "KUKA-KR-180-R2100-nano-F-exclusive.robot",
            "I": "KUKA-KR-180-R2100-nano-F-exclusive-robot.png",
            "IS": "KUKA-KR-180-R2100-nano-F-exclusive.png",
            "B": "KUKA",
            "M": "KR 180 R2100 nano F exclusive",
            "T": "6 DOF",
            "A": 6,
            "R": 2100,
            "P": 180,
            "W": 998,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-180-R2500-extra": {
            "MT": "R",
            "N": "KUKA KR 180 R2500 extra",
            "F": "KUKA-KR-180-R2500-extra.robot",
            "I": "KUKA-KR-180-R2500-extra-robot.png",
            "IS": "KUKA-KR-180-R2500-extra.png",
            "B": "KUKA",
            "M": "KR 180 R2500 extra",
            "T": "6 DOF",
            "A": 6,
            "R": 2496,
            "P": 180,
            "W": 1059,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-180-R2900-prime": {
            "MT": "R",
            "N": "KUKA KR 180 R2900 prime",
            "F": "KUKA-KR-180-R2900-prime.robot",
            "I": "KUKA-KR-180-R2900-prime-robot.png",
            "IS": "KUKA-KR-180-R2900-prime.png",
            "B": "KUKA",
            "M": "KR 180 R2900 prime",
            "T": "6 DOF",
            "A": 6,
            "R": 2896,
            "P": 180,
            "W": 1106,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-180-R3100-K-prime": {
            "MT": "R",
            "N": "KUKA KR 180 R3100 K prime",
            "F": "KUKA-KR-180-R3100-K-prime.robot",
            "I": "KUKA-KR-180-R3100-K-prime-robot.png",
            "IS": "KUKA-KR-180-R3100-K-prime.png",
            "B": "KUKA",
            "M": "KR 180 R3100 K prime",
            "T": "6 DOF",
            "A": 6,
            "R": 3101,
            "P": 180,
            "W": 1168,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-180-R3500-K-ultra": {
            "MT": "R",
            "N": "KUKA KR 180 R3500 K ultra",
            "F": "KUKA-KR-180-R3500-K-ultra.robot",
            "I": "KUKA-KR-180-R3500-K-ultra-robot.png",
            "IS": "KUKA-KR-180-R3500-K-ultra.png",
            "B": "KUKA",
            "M": "KR 180 R3500 K ultra",
            "T": "6 DOF",
            "A": 6,
            "R": 3500,
            "P": 180,
            "W": 1201,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-180-R3500-2-K": {
            "MT": "R",
            "N": "KUKA KR 180 R3500-2 K",
            "F": "KUKA-KR-180-R3500-2-K.robot",
            "I": "KUKA-KR-180-R3500-2-K-robot.png",
            "IS": "KUKA-KR-180-R3500-2-K.png",
            "B": "KUKA",
            "M": "KR 180 R3500-2 K",
            "T": "6 DOF",
            "A": 6,
            "R": 3505,
            "P": 180,
            "W": 1256,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-200-comp": {
            "MT": "R",
            "N": "KUKA KR 200 comp",
            "F": "KUKA-KR-200-comp.robot",
            "I": "KUKA-KR-200-comp-robot.png",
            "IS": "KUKA-KR-200-comp.png",
            "B": "KUKA",
            "M": "KR 200 comp",
            "T": "6 DOF",
            "A": 6,
            "R": 2400,
            "P": 200,
            "W": 1155,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-200-L140-comp": {
            "MT": "R",
            "N": "KUKA KR 200 L140 comp",
            "F": "KUKA-KR-200-L140-comp.robot",
            "I": "KUKA-KR-200-L140-comp-robot.png",
            "IS": "KUKA-KR-200-L140-comp.png",
            "B": "KUKA",
            "M": "KR 200 L140 comp",
            "T": "6 DOF",
            "A": 6,
            "R": 2800,
            "P": 140,
            "W": 1170,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-200-2": {
            "MT": "R",
            "N": "KUKA KR 200-2",
            "F": "KUKA-KR-200-2.robot",
            "I": "KUKA-KR-200-2-robot.png",
            "IS": "KUKA-KR-200-2.png",
            "B": "KUKA",
            "M": "KR 200-2",
            "T": "6 DOF",
            "A": 6,
            "R": 2700,
            "P": 210,
            "W": 1267,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-210-L100-2-K": {
            "MT": "R",
            "N": "KUKA KR 210 L100-2 K",
            "F": "KUKA-KR-210-L100-2-K.robot",
            "I": "KUKA-KR-210-L100-2-K-robot.png",
            "IS": "KUKA-KR-210-L100-2-K.png",
            "B": "KUKA",
            "M": "KR 210 L100-2 K",
            "T": "6 DOF",
            "A": 6,
            "R": 3100,
            "P": 100,
            "W": 1285,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-210-L150-2": {
            "MT": "R",
            "N": "KUKA KR 210 L150-2",
            "F": "KUKA-KR-210-L150-2.robot",
            "I": "KUKA-KR-210-L150-2-robot.png",
            "IS": "KUKA-KR-210-L150-2.png",
            "B": "KUKA",
            "M": "KR 210 L150-2",
            "T": "6 DOF",
            "A": 6,
            "R": 3100,
            "P": 150,
            "W": 1285,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-210-L180-2": {
            "MT": "R",
            "N": "KUKA KR 210 L180-2",
            "F": "KUKA-KR-210-L180-2.robot",
            "I": "KUKA-KR-210-L180-2-robot.png",
            "IS": "KUKA-KR-210-L180-2.png",
            "B": "KUKA",
            "M": "KR 210 L180-2",
            "T": "6 DOF",
            "A": 6,
            "R": 2900,
            "P": 180,
            "W": 1277,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-210-R2700-extra": {
            "MT": "R",
            "N": "KUKA KR 210 R2700 extra",
            "F": "KUKA-KR-210-R2700-extra.robot",
            "I": "KUKA-KR-210-R2700-extra-robot.png",
            "IS": "KUKA-KR-210-R2700-extra.png",
            "B": "KUKA",
            "M": "KR 210 R2700 extra",
            "T": "6 DOF",
            "A": 6,
            "R": 2696,
            "P": 210,
            "W": 1068,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-210-R2700-prime": {
            "MT": "R",
            "N": "KUKA KR 210 R2700 prime",
            "F": "KUKA-KR-210-R2700-prime.robot",
            "I": "KUKA-KR-210-R2700-prime-robot.png",
            "IS": "KUKA-KR-210-R2700-prime.png",
            "B": "KUKA",
            "M": "KR 210 R2700 prime",
            "T": "6 DOF",
            "A": 6,
            "R": 2696,
            "P": 210,
            "W": 1111,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-210-R2700-2": {
            "MT": "R",
            "N": "KUKA KR 210 R2700-2",
            "F": "KUKA-KR-210-R2700-2.robot",
            "I": "KUKA-KR-210-R2700-2-robot.png",
            "IS": "KUKA-KR-210-R2700-2.png",
            "B": "KUKA",
            "M": "KR 210 R2700-2",
            "T": "6 DOF",
            "A": 6,
            "R": 2701,
            "P": 210,
            "W": 1077,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-210-R2900-K-prime": {
            "MT": "R",
            "N": "KUKA KR 210 R2900 K prime",
            "F": "KUKA-KR-210-R2900-K-prime.robot",
            "I": "KUKA-KR-210-R2900-K-prime-robot.png",
            "IS": "KUKA-KR-210-R2900-K-prime.png",
            "B": "KUKA",
            "M": "KR 210 R2900 K prime",
            "T": "6 DOF",
            "A": 6,
            "R": 2901,
            "P": 210,
            "W": 1180,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-210-R3100-ultra": {
            "MT": "R",
            "N": "KUKA KR 210 R3100 ultra",
            "F": "KUKA-KR-210-R3100-ultra.robot",
            "I": "KUKA-KR-210-R3100-ultra-robot.png",
            "IS": "KUKA-KR-210-R3100-ultra.png",
            "B": "KUKA",
            "M": "KR 210 R3100 ultra",
            "T": "6 DOF",
            "A": 6,
            "R": 3095,
            "P": 210,
            "W": 1154,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-210-R3300-K-ultra": {
            "MT": "R",
            "N": "KUKA KR 210 R3300 K ultra",
            "F": "KUKA-KR-210-R3300-K-ultra.robot",
            "I": "KUKA-KR-210-R3300-K-ultra-robot.png",
            "IS": "KUKA-KR-210-R3300-K-ultra.png",
            "B": "KUKA",
            "M": "KR 210 R3300 K ultra",
            "T": "6 DOF",
            "A": 6,
            "R": 3301,
            "P": 210,
            "W": 1214,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-210-2-3100": {
            "MT": "R",
            "N": "KUKA KR 210-2 3100",
            "F": "KUKA-KR-210-2-3100.robot",
            "I": "KUKA-KR-210-2-3100-robot.png",
            "IS": "KUKA-KR-210-2-3100.png",
            "B": "KUKA",
            "M": "KR 210-2 3100",
            "T": "6 DOF",
            "A": 6,
            "R": 3100,
            "P": 210,
            "W": 1267,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-210-2": {
            "MT": "R",
            "N": "KUKA KR 210-2",
            "F": "KUKA-KR-210-2.robot",
            "I": "KUKA-KR-210-2-robot.png",
            "IS": "KUKA-KR-210-2.png",
            "B": "KUKA",
            "M": "KR 210-2",
            "T": "6 DOF",
            "A": 6,
            "R": 2700,
            "P": 210,
            "W": 1267,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-240-L180-2": {
            "MT": "R",
            "N": "KUKA KR 240 L180-2",
            "F": "KUKA-KR-240-L180-2.robot",
            "I": "KUKA-KR-240-L180-2-robot.png",
            "IS": "KUKA-KR-240-L180-2.png",
            "B": "KUKA",
            "M": "KR 240 L180-2",
            "T": "6 DOF",
            "A": 6,
            "R": 3100,
            "P": 180,
            "W": 1277,
            "E": 0.12,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-240-L210-2": {
            "MT": "R",
            "N": "KUKA KR 240 L210-2",
            "F": "KUKA-KR-240-L210-2.robot",
            "I": "KUKA-KR-240-L210-2-robot.png",
            "IS": "KUKA-KR-240-L210-2.png",
            "B": "KUKA",
            "M": "KR 240 L210-2",
            "T": "6 DOF",
            "A": 6,
            "R": 2900,
            "P": 210,
            "W": 1277,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-240-R2500-prime": {
            "MT": "R",
            "N": "KUKA KR 240 R2500 prime",
            "F": "KUKA-KR-240-R2500-prime.robot",
            "I": "KUKA-KR-240-R2500-prime-robot.png",
            "IS": "KUKA-KR-240-R2500-prime.png",
            "B": "KUKA",
            "M": "KR 240 R2500 prime",
            "T": "6 DOF",
            "A": 6,
            "R": 2496,
            "P": 240,
            "W": 1102,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-240-R2700-prime": {
            "MT": "R",
            "N": "KUKA KR 240 R2700 prime",
            "F": "KUKA-KR-240-R2700-prime.robot",
            "I": "KUKA-KR-240-R2700-prime-robot.png",
            "IS": "KUKA-KR-240-R2700-prime.png",
            "B": "KUKA",
            "M": "KR 240 R2700 prime",
            "T": "6 DOF",
            "A": 6,
            "R": 2696,
            "P": 240,
            "W": 1111,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-240-R2900-ultra": {
            "MT": "R",
            "N": "KUKA KR 240 R2900 ultra",
            "F": "KUKA-KR-240-R2900-ultra.robot",
            "I": "KUKA-KR-240-R2900-ultra-robot.png",
            "IS": "KUKA-KR-240-R2900-ultra.png",
            "B": "KUKA",
            "M": "KR 240 R2900 ultra",
            "T": "6 DOF",
            "A": 6,
            "R": 2896,
            "P": 240,
            "W": 1145,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-240-R2900-2-F": {
            "MT": "R",
            "N": "KUKA KR 240 R2900-2 F",
            "F": "KUKA-KR-240-R2900-2-F.robot",
            "I": "KUKA-KR-240-R2900-2-F-robot.png",
            "IS": "KUKA-KR-240-R2900-2-F.png",
            "B": "KUKA",
            "M": "KR 240 R2900-2 F",
            "T": "6 DOF",
            "A": 6,
            "R": 2900,
            "P": 240,
            "W": 1120,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-240-R3100-K-ultra": {
            "MT": "R",
            "N": "KUKA KR 240 R3100 K ultra",
            "F": "KUKA-KR-240-R3100-K-ultra.robot",
            "I": "KUKA-KR-240-R3100-K-ultra-robot.png",
            "IS": "KUKA-KR-240-R3100-K-ultra.png",
            "B": "KUKA",
            "M": "KR 240 R3100 K ultra",
            "T": "6 DOF",
            "A": 6,
            "R": 3101,
            "P": 240,
            "W": 1198,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-240-R3330": {
            "MT": "R",
            "N": "KUKA KR 240 R3330",
            "F": "KUKA-KR-240-R3330.robot",
            "I": "KUKA-KR-240-R3330-robot.png",
            "IS": "KUKA-KR-240-R3330.png",
            "B": "KUKA",
            "M": "KR 240 R3330",
            "T": "6 DOF",
            "A": 6,
            "R": 3326,
            "P": 240,
            "W": 2421,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-240-R3700-2": {
            "MT": "R",
            "N": "KUKA KR 240 R3700-2",
            "F": "KUKA-KR-240-R3700-2.robot",
            "I": "KUKA-KR-240-R3700-2-robot.png",
            "IS": "KUKA-KR-240-R3700-2.png",
            "B": "KUKA",
            "M": "KR 240 R3700-2",
            "T": "6 DOF",
            "A": 6,
            "R": 3750,
            "P": 300,
            "W": 1620,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-240-2": {
            "MT": "R",
            "N": "KUKA KR 240-2",
            "F": "KUKA-KR-240-2.robot",
            "I": "KUKA-KR-240-2-robot.png",
            "IS": "KUKA-KR-240-2.png",
            "B": "KUKA",
            "M": "KR 240-2",
            "T": "6 DOF",
            "A": 6,
            "R": 2700,
            "P": 240,
            "W": 1267,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-250-R2700-2": {
            "MT": "R",
            "N": "KUKA KR 250 R2700-2",
            "F": "KUKA-KR-250-R2700-2.robot",
            "I": "KUKA-KR-250-R2700-2-robot.png",
            "IS": "KUKA-KR-250-R2700-2.png",
            "B": "KUKA",
            "M": "KR 250 R2700-2",
            "T": "6 DOF",
            "A": 6,
            "R": 2701,
            "P": 250,
            "W": 1300,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-270-R2700-ultra": {
            "MT": "R",
            "N": "KUKA KR 270 R2700 ultra",
            "F": "KUKA-KR-270-R2700-ultra.robot",
            "I": "KUKA-KR-270-R2700-ultra-robot.png",
            "IS": "KUKA-KR-270-R2700-ultra.png",
            "B": "KUKA",
            "M": "KR 270 R2700 ultra",
            "T": "6 DOF",
            "A": 6,
            "R": 2696,
            "P": 270,
            "W": 1129,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-270-R2900-K-ultra": {
            "MT": "R",
            "N": "KUKA KR 270 R2900 K ultra",
            "F": "KUKA-KR-270-R2900-K-ultra.robot",
            "I": "KUKA-KR-270-R2900-K-ultra-robot.png",
            "IS": "KUKA-KR-270-R2900-K-ultra.png",
            "B": "KUKA",
            "M": "KR 270 R2900 K ultra",
            "T": "6 DOF",
            "A": 6,
            "R": 2901,
            "P": 270,
            "W": 1189,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-280-R3080": {
            "MT": "R",
            "N": "KUKA KR 280 R3080",
            "F": "KUKA-KR-280-R3080.robot",
            "I": "KUKA-KR-280-R3080-robot.png",
            "IS": "KUKA-KR-280-R3080.png",
            "B": "KUKA",
            "M": "KR 280 R3080",
            "T": "6 DOF",
            "A": 6,
            "R": 3076,
            "P": 280,
            "W": 2415,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-300-R2500-ultra": {
            "MT": "R",
            "N": "KUKA KR 300 R2500 ultra",
            "F": "KUKA-KR-300-R2500-ultra.robot",
            "I": "KUKA-KR-300-R2500-ultra-robot.png",
            "IS": "KUKA-KR-300-R2500-ultra.png",
            "B": "KUKA",
            "M": "KR 300 R2500 ultra",
            "T": "6 DOF",
            "A": 6,
            "R": 2496,
            "P": 300,
            "W": 1120,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-300-R2700-2": {
            "MT": "R",
            "N": "KUKA KR 300 R2700-2",
            "F": "KUKA-KR-300-R2700-2.robot",
            "I": "KUKA-KR-300-R2700-2-robot.png",
            "IS": "KUKA-KR-300-R2700-2.png",
            "B": "KUKA",
            "M": "KR 300 R2700-2",
            "T": "6 DOF",
            "A": 6,
            "R": 2701,
            "P": 300,
            "W": 1101,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-340-R3330": {
            "MT": "R",
            "N": "KUKA KR 340 R3330",
            "F": "KUKA-KR-340-R3330.robot",
            "I": "KUKA-KR-340-R3330-robot.png",
            "IS": "KUKA-KR-340-R3330.png",
            "B": "KUKA",
            "M": "KR 340 R3330",
            "T": "6 DOF",
            "A": 6,
            "R": 2496,
            "P": 340,
            "W": 1120,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-340-R3400-2": {
            "MT": "R",
            "N": "KUKA KR 340 R3400-2",
            "F": "KUKA-KR-340-R3400-2.robot",
            "I": "KUKA-KR-340-R3400-2-robot.png",
            "IS": "KUKA-KR-340-R3400-2.png",
            "B": "KUKA",
            "M": "KR 340 R3400-2",
            "T": "6 DOF",
            "A": 6,
            "R": 3400,
            "P": 340,
            "W": 1728,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-360-2": {
            "MT": "R",
            "N": "KUKA KR 360 2",
            "F": "KUKA-KR-360-2.robot",
            "I": "KUKA-KR-360-2-robot.png",
            "IS": "KUKA-KR-360-2.png",
            "B": "KUKA",
            "M": "KR 360 2",
            "T": "6 DOF",
            "A": 6,
            "R": 2826,
            "P": 360,
            "W": 2350,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-360-3": {
            "MT": "R",
            "N": "KUKA KR 360 3",
            "F": "KUKA-KR-360-3.robot",
            "I": "KUKA-KR-360-3-robot.png",
            "IS": "KUKA-KR-360-3.png",
            "B": "KUKA",
            "M": "KR 360 3",
            "T": "6 DOF",
            "A": 6,
            "R": 2825,
            "P": 240,
            "W": 2375,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-360-L240-3": {
            "MT": "R",
            "N": "KUKA KR 360 L240 3",
            "F": "KUKA-KR-360-L240-3.robot",
            "I": "KUKA-KR-360-L240-3-robot.png",
            "IS": "KUKA-KR-360-L240-3.png",
            "B": "KUKA",
            "M": "KR 360 L240 3",
            "T": "6 DOF",
            "A": 6,
            "R": 3326,
            "P": 240,
            "W": 2411,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-360-L280-3": {
            "MT": "R",
            "N": "KUKA KR 360 L280 3",
            "F": "KUKA-KR-360-L280-3.robot",
            "I": "KUKA-KR-360-L280-3-robot.png",
            "IS": "KUKA-KR-360-L280-3.png",
            "B": "KUKA",
            "M": "KR 360 L280 3",
            "T": "6 DOF",
            "A": 6,
            "R": 3076,
            "P": 280,
            "W": 2405,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-360-R2830": {
            "MT": "R",
            "N": "KUKA KR 360 R2830",
            "F": "KUKA-KR-360-R2830.robot",
            "I": "KUKA-KR-360-R2830-robot.png",
            "IS": "KUKA-KR-360-R2830.png",
            "B": "KUKA",
            "M": "KR 360 R2830",
            "T": "6 DOF",
            "A": 6,
            "R": 2826,
            "P": 360,
            "W": 2385,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-420-R3080": {
            "MT": "R",
            "N": "KUKA KR 420 R3080",
            "F": "KUKA-KR-420-R3080.robot",
            "I": "KUKA-KR-420-R3080-robot.png",
            "IS": "KUKA-KR-420-R3080.png",
            "B": "KUKA",
            "M": "KR 420 R3080",
            "T": "6 DOF",
            "A": 6,
            "R": 3076,
            "P": 420,
            "W": 2415,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-480-R3330-MT-F-K": {
            "MT": "R",
            "N": "KUKA KR 480 R3330 MT-F K",
            "F": "KUKA-KR-480-R3330-MT-F-K.robot",
            "I": "KUKA-KR-480-R3330-MT-F-K-robot.png",
            "IS": "KUKA-KR-480-R3330-MT-F-K.png",
            "B": "KUKA",
            "M": "KR 480 R3330 MT-F K",
            "T": "6 DOF",
            "A": 6,
            "R": 3326,
            "P": 480,
            "W": 2475,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-480-R3330-MT-F": {
            "MT": "R",
            "N": "KUKA KR 480 R3330 MT-F",
            "F": "KUKA-KR-480-R3330-MT-F.robot",
            "I": "KUKA-KR-480-R3330-MT-F-robot.png",
            "IS": "KUKA-KR-480-R3330-MT-F.png",
            "B": "KUKA",
            "M": "KR 480 R3330 MT-F",
            "T": "6 DOF",
            "A": 6,
            "R": 3326,
            "P": 480,
            "W": 2475,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-480-R3400-2": {
            "MT": "R",
            "N": "KUKA KR 480 R3400-2",
            "F": "KUKA-KR-480-R3400-2.robot",
            "I": "KUKA-KR-480-R3400-2-robot.png",
            "IS": "KUKA-KR-480-R3400-2.png",
            "B": "KUKA",
            "M": "KR 480 R3400-2",
            "T": "6 DOF",
            "A": 6,
            "R": 3400,
            "P": 480,
            "W": 2200,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-500-3": {
            "MT": "R",
            "N": "KUKA KR 500 3",
            "F": "KUKA-KR-500-3.robot",
            "I": "KUKA-KR-500-3-robot.png",
            "IS": "KUKA-KR-500-3.png",
            "B": "KUKA",
            "M": "KR 500 3",
            "T": "6 DOF",
            "A": 6,
            "R": 2825,
            "P": 500,
            "W": 2375,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-500-L340-2": {
            "MT": "R",
            "N": "KUKA KR 500 L340-2",
            "F": "KUKA-KR-500-L340-2.robot",
            "I": "KUKA-KR-500-L340-2-robot.png",
            "IS": "KUKA-KR-500-L340-2.png",
            "B": "KUKA",
            "M": "KR 500 L340-2",
            "T": "6 DOF",
            "A": 6,
            "R": 3326,
            "P": 340,
            "W": 2385,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-500-L340-3": {
            "MT": "R",
            "N": "KUKA KR 500 L340-3",
            "F": "KUKA-KR-500-L340-3.robot",
            "I": "KUKA-KR-500-L340-3-robot.png",
            "IS": "KUKA-KR-500-L340-3.png",
            "B": "KUKA",
            "M": "KR 500 L340-3",
            "T": "6 DOF",
            "A": 6,
            "R": 3326,
            "P": 340,
            "W": 2411,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-500-L420-3": {
            "MT": "R",
            "N": "KUKA KR 500 L420 3",
            "F": "KUKA-KR-500-L420-3.robot",
            "I": "KUKA-KR-500-L420-3-robot.png",
            "IS": "KUKA-KR-500-L420-3.png",
            "B": "KUKA",
            "M": "KR 500 L420 3",
            "T": "6 DOF",
            "A": 6,
            "R": 3076,
            "P": 420,
            "W": 2405,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-500-L420-2": {
            "MT": "R",
            "N": "KUKA KR 500 L420-2",
            "F": "KUKA-KR-500-L420-2.robot",
            "I": "KUKA-KR-500-L420-2-robot.png",
            "IS": "KUKA-KR-500-L420-2.png",
            "B": "KUKA",
            "M": "KR 500 L420-2",
            "T": "6 DOF",
            "A": 6,
            "R": 3076,
            "P": 420,
            "W": 2405,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-500-R2800-2": {
            "MT": "R",
            "N": "KUKA KR 500 R2800-2",
            "F": "KUKA-KR-500-R2800-2.robot",
            "I": "KUKA-KR-500-R2800-2-robot.png",
            "IS": "KUKA-KR-500-R2800-2.png",
            "B": "KUKA",
            "M": "KR 500 R2800-2",
            "T": "6 DOF",
            "A": 6,
            "R": 2800,
            "P": 500,
            "W": 1671,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-500-R2830": {
            "MT": "R",
            "N": "KUKA KR 500 R2830",
            "F": "KUKA-KR-500-R2830.robot",
            "I": "KUKA-KR-500-R2830-robot.png",
            "IS": "KUKA-KR-500-R2830.png",
            "B": "KUKA",
            "M": "KR 500 R2830",
            "T": "6 DOF",
            "A": 6,
            "R": 2826,
            "P": 500,
            "W": 2385,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-510-R3080": {
            "MT": "R",
            "N": "KUKA KR 510 R3080",
            "F": "KUKA-KR-510-R3080.robot",
            "I": "KUKA-KR-510-R3080-robot.png",
            "IS": "KUKA-KR-510-R3080.png",
            "B": "KUKA",
            "M": "KR 510 R3080",
            "T": "6 DOF",
            "A": 6,
            "R": 3076,
            "P": 510,
            "W": 2375,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-560-R3100-2": {
            "MT": "R",
            "N": "KUKA KR 560 R3100-2",
            "F": "KUKA-KR-560-R3100-2.robot",
            "I": "KUKA-KR-560-R3100-2-robot.png",
            "IS": "KUKA-KR-560-R3100-2.png",
            "B": "KUKA",
            "M": "KR 560 R3100-2",
            "T": "6 DOF",
            "A": 6,
            "R": 3100,
            "P": 560,
            "W": 2170,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-600-R2830": {
            "MT": "R",
            "N": "KUKA KR 600 R2830",
            "F": "KUKA-KR-600-R2830.robot",
            "I": "KUKA-KR-600-R2830-robot.png",
            "IS": "KUKA-KR-600-R2830.png",
            "B": "KUKA",
            "M": "KR 600 R2830",
            "T": "6 DOF",
            "A": 6,
            "R": 2830,
            "P": 600,
            "W": 2650,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-800-R2800-2": {
            "MT": "R",
            "N": "KUKA KR 800 R2800-2",
            "F": "KUKA-KR-800-R2800-2.robot",
            "I": "KUKA-KR-800-R2800-2-robot.png",
            "IS": "KUKA-KR-800-R2800-2.png",
            "B": "KUKA",
            "M": "KR 800 R2800-2",
            "T": "6 DOF",
            "A": 6,
            "R": 2800,
            "P": 800,
            "W": 2400,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-800-R3200-2-PA": {
            "MT": "R",
            "N": "KUKA KR 800 R3200-2 PA",
            "F": "KUKA-KR-800-R3200-2-PA.robot",
            "I": "KUKA-KR-800-R3200-2-PA-robot.png",
            "IS": "KUKA-KR-800-R3200-2-PA.png",
            "B": "KUKA",
            "M": "KR 800 R3200-2 PA",
            "T": "6 DOF",
            "A": 6,
            "R": 3200,
            "P": 800,
            "W": 2400,
            "E": 0.08,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-1000-L750-titan": {
            "MT": "R",
            "N": "KUKA KR 1000 L750 titan",
            "F": "KUKA-KR-1000-L750-titan.robot",
            "I": "KUKA-KR-1000-L750-titan-robot.png",
            "IS": "KUKA-KR-1000-L750-titan.png",
            "B": "KUKA",
            "M": "KR 1000 L750 titan",
            "T": "6 DOF",
            "A": 6,
            "R": 3601,
            "P": 750,
            "W": 4740,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR-1000-titan": {
            "MT": "R",
            "N": "KUKA KR 1000 titan",
            "F": "KUKA-KR-1000-titan.robot",
            "I": "KUKA-KR-1000-titan-robot.png",
            "IS": "KUKA-KR-1000-titan.png",
            "B": "KUKA",
            "M": "KR 1000 titan",
            "T": "6 DOF",
            "A": 6,
            "R": 3202,
            "P": 1000,
            "W": 4690,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "KUKA-KR6-R1840-2": {
            "MT": "R",
            "N": "KUKA KR6 R1840-2",
            "F": "KUKA-KR6-R1840-2.robot",
            "I": "KUKA-KR6-R1840-2-robot.png",
            "IS": "KUKA-KR6-R1840-2.png",
            "B": "KUKA",
            "M": "KR6 R1840-2",
            "T": "6 DOF",
            "A": 6,
            "R": 1840,
            "P": 6,
            "W": 162,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "KUKA-LBR-iiwa-7-R800-MF": {
            "MT": "R",
            "N": "KUKA LBR iiwa 7 R800 MF",
            "F": "KUKA-LBR-iiwa-7-R800-MF.robot",
            "I": "KUKA-LBR-iiwa-7-R800-MF-robot.png",
            "IS": "KUKA-LBR-iiwa-7-R800-MF.png",
            "B": "KUKA",
            "M": "LBR iiwa 7 R800 MF",
            "T": "7 DOF",
            "A": 7,
            "R": 800,
            "P": 7,
            "W": 23.9,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-LBR-iiwa-7-R800": {
            "MT": "R",
            "N": "KUKA LBR iiwa 7 R800",
            "F": "KUKA-LBR-iiwa-7-R800.robot",
            "I": "KUKA-LBR-iiwa-7-R800-robot.png",
            "IS": "KUKA-LBR-iiwa-7-R800.png",
            "B": "KUKA",
            "M": "LBR iiwa 7 R800",
            "T": "7 DOF",
            "A": 7,
            "R": 800,
            "P": 7,
            "W": 23.9,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-LBR-iiwa-14-R820": {
            "MT": "R",
            "N": "KUKA LBR iiwa 14 R820",
            "F": "KUKA-LBR-iiwa-14-R820.robot",
            "I": "KUKA-LBR-iiwa-14-R820-robot.png",
            "IS": "KUKA-LBR-iiwa-14-R820.png",
            "B": "KUKA",
            "M": "LBR iiwa 14 R820",
            "T": "7 DOF",
            "A": 7,
            "R": 820,
            "P": 14,
            "W": 29.9,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "KUKA-KR-40-PA": {
            "MT": "R",
            "N": "KUKA KR 40 PA",
            "F": "KUKA-KR-40-PA.robot",
            "I": "KUKA-KR-40-PA-robot.png",
            "IS": "KUKA-KR-40-PA.png",
            "B": "KUKA",
            "M": "KR 40 PA",
            "T": "Palletizing",
            "A": 4,
            "R": 1700,
            "P": 40,
            "W": 695,
            "E": 0.05,
            "AP": [
                "Palletizing"
            ]
        },
        "KUKA-KR-100-2-PA": {
            "MT": "R",
            "N": "KUKA KR 100-2 PA",
            "F": "KUKA-KR-100-2-PA.robot",
            "I": "KUKA-KR-100-2-PA-robot.png",
            "IS": "KUKA-KR-100-2-PA.png",
            "B": "KUKA",
            "M": "KR 100-2 PA",
            "T": "Palletizing",
            "A": 4,
            "R": 3200,
            "P": 100,
            "W": 1200,
            "E": 0.05,
            "AP": [
                "Palletizing"
            ]
        },
        "KUKA-KR-120-R3200-PA": {
            "MT": "R",
            "N": "KUKA KR 120 R3200 PA",
            "F": "KUKA-KR-120-R3200-PA.robot",
            "I": "KUKA-KR-120-R3200-PA-robot.png",
            "IS": "KUKA-KR-120-R3200-PA.png",
            "B": "KUKA",
            "M": "KR 120 R3200 PA",
            "T": "Palletizing",
            "A": 4,
            "R": 3195,
            "P": 120,
            "W": 1075,
            "E": 0.06,
            "AP": [
                "Palletizing"
            ]
        },
        "KUKA-KR-140-R3200-2-PA": {
            "MT": "R",
            "N": "KUKA KR 140 R3200-2 PA",
            "F": "KUKA-KR-140-R3200-2-PA.robot",
            "I": "KUKA-KR-140-R3200-2-PA-robot.png",
            "IS": "KUKA-KR-140-R3200-2-PA.png",
            "B": "KUKA",
            "M": "KR 140 R3200-2 PA",
            "T": "Palletizing",
            "A": 4,
            "R": 3195,
            "P": 140,
            "W": 1017,
            "E": 0.07,
            "AP": [
                "Palletizing"
            ]
        },
        "KUKA-KR-180-R3200-PA": {
            "MT": "R",
            "N": "KUKA KR 180 R3200 PA",
            "F": "KUKA-KR-180-R3200-PA.robot",
            "I": "KUKA-KR-180-R3200-PA-robot.png",
            "IS": "KUKA-KR-180-R3200-PA.png",
            "B": "KUKA",
            "M": "KR 180 R3200 PA",
            "T": "Palletizing",
            "A": 4,
            "R": 3195,
            "P": 180,
            "W": 1093,
            "E": 0.06,
            "AP": [
                "Palletizing"
            ]
        },
        "KUKA-KR-180-R3200-2-PA": {
            "MT": "R",
            "N": "KUKA KR 180 R3200-2 PA",
            "F": "KUKA-KR-180-R3200-2-PA.robot",
            "I": "KUKA-KR-180-R3200-2-PA-robot.png",
            "IS": "KUKA-KR-180-R3200-2-PA.png",
            "B": "KUKA",
            "M": "KR 180 R3200-2 PA",
            "T": "Palletizing",
            "A": 4,
            "R": 3195,
            "P": 140,
            "W": 1017,
            "E": 0.07,
            "AP": [
                "Palletizing"
            ]
        },
        "KUKA-KR-180-2-PA": {
            "MT": "R",
            "N": "KUKA KR 180-2 PA",
            "F": "KUKA-KR-180-2-PA.robot",
            "I": "KUKA-KR-180-2-PA-robot.png",
            "IS": "KUKA-KR-180-2-PA.png",
            "B": "KUKA",
            "M": "KR 180-2 PA",
            "T": "Palletizing",
            "A": 4,
            "R": 3200,
            "P": 180,
            "W": 1200,
            "E": 0.05,
            "AP": [
                "Palletizing"
            ]
        },
        "KUKA-KR-240-PA": {
            "MT": "R",
            "N": "KUKA KR 240 PA",
            "F": "KUKA-KR-240-PA.robot",
            "I": "KUKA-KR-240-PA-robot.png",
            "IS": "KUKA-KR-240-PA.png",
            "B": "KUKA",
            "M": "KR 240 PA",
            "T": "Palletizing",
            "A": 4,
            "R": 3195,
            "P": 240,
            "W": 1103,
            "E": 0.06,
            "AP": [
                "Palletizing"
            ]
        },
        "KUKA-KR-240-R3200-PA": {
            "MT": "R",
            "N": "KUKA KR 240 R3200 PA",
            "F": "KUKA-KR-240-R3200-PA.robot",
            "I": "KUKA-KR-240-R3200-PA-robot.png",
            "IS": "KUKA-KR-240-R3200-PA.png",
            "B": "KUKA",
            "M": "KR 240 R3200 PA",
            "T": "Palletizing",
            "A": 4,
            "R": 3195,
            "P": 240,
            "W": 1103,
            "E": 0.06,
            "AP": [
                "Palletizing"
            ]
        },
        "KUKA-KR-700-PA": {
            "MT": "R",
            "N": "KUKA KR 700 PA",
            "F": "KUKA-KR-700-PA.robot",
            "I": "KUKA-KR-700-PA-robot.png",
            "IS": "KUKA-KR-700-PA.png",
            "B": "KUKA",
            "M": "KR 700 PA",
            "T": "Palletizing",
            "A": 4,
            "R": 3320,
            "P": 700,
            "W": 2850,
            "E": 0.08,
            "AP": [
                "Palletizing"
            ]
        },
        "KUKA-KR-6-R700-Z200": {
            "MT": "R",
            "N": "KUKA KR 6 R700 Z200",
            "F": "KUKA-KR-6-R700-Z200.robot",
            "I": "KUKA-KR-6-R700-Z200-robot.png",
            "IS": "KUKA-KR-6-R700-Z200.png",
            "B": "KUKA",
            "M": "KR 6 R700 Z200",
            "T": "SCARA",
            "A": 4,
            "R": 700,
            "P": 6,
            "W": 21,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "KUKA-KR5-scara-R350-Z200": {
            "MT": "R",
            "N": "KUKA KR5 scara R350 Z200",
            "F": "KUKA-KR5-scara-R350-Z200.robot",
            "I": "KUKA-KR5-scara-R350-Z200-robot.png",
            "IS": "KUKA-KR5-scara-R350-Z200.png",
            "B": "KUKA",
            "M": "KR5 scara R350 Z200",
            "T": "SCARA",
            "A": 4,
            "R": 350,
            "P": 5,
            "W": 20,
            "E": 0.015,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "KUKA-KR5-scara-R350-Z320": {
            "MT": "R",
            "N": "KUKA KR5 scara R350 Z320",
            "F": "KUKA-KR5-scara-R350-Z320.robot",
            "I": "KUKA-KR5-scara-R350-Z320-robot.png",
            "IS": "KUKA-KR5-scara-R350-Z320.png",
            "B": "KUKA",
            "M": "KR5 scara R350 Z320",
            "T": "SCARA",
            "A": 4,
            "R": 350,
            "P": 5,
            "W": 20,
            "E": 0.015,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "KUKA-KR5-scara-R550-Z200": {
            "MT": "R",
            "N": "KUKA KR5 scara R550 Z200",
            "F": "KUKA-KR5-scara-R550-Z200.robot",
            "I": "KUKA-KR5-scara-R550-Z200-robot.png",
            "IS": "KUKA-KR5-scara-R550-Z200.png",
            "B": "KUKA",
            "M": "KR5 scara R550 Z200",
            "T": "SCARA",
            "A": 4,
            "R": 550,
            "P": 5,
            "W": 29,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "KUKA-KR5-scara-R550-Z320": {
            "MT": "R",
            "N": "KUKA KR5 scara R550 Z320",
            "F": "KUKA-KR5-scara-R550-Z320.robot",
            "I": "KUKA-KR5-scara-R550-Z320-robot.png",
            "IS": "KUKA-KR5-scara-R550-Z320.png",
            "B": "KUKA",
            "M": "KR5 scara R550 Z320",
            "T": "SCARA",
            "A": 4,
            "R": 550,
            "P": 5,
            "W": 29,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "KUKA-KR10-scara-R600-Z300": {
            "MT": "R",
            "N": "KUKA KR10 scara R600 Z300",
            "F": "KUKA-KR10-scara-R600-Z300.robot",
            "I": "KUKA-KR10-scara-R600-Z300-robot.png",
            "IS": "KUKA-KR10-scara-R600-Z300.png",
            "B": "KUKA",
            "M": "KR10 scara R600 Z300",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 10,
            "W": 50,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "KUKA-KR10-scara-R600-Z400": {
            "MT": "R",
            "N": "KUKA KR10 scara R600 Z400",
            "F": "KUKA-KR10-scara-R600-Z400.robot",
            "I": "KUKA-KR10-scara-R600-Z400-robot.png",
            "IS": "KUKA-KR10-scara-R600-Z400.png",
            "B": "KUKA",
            "M": "KR10 scara R600 Z400",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 10,
            "W": 50,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "KUKA-KR10-scara-R850-Z300": {
            "MT": "R",
            "N": "KUKA KR10 scara R850 Z300",
            "F": "KUKA-KR10-scara-R850-Z300.robot",
            "I": "KUKA-KR10-scara-R850-Z300-robot.png",
            "IS": "KUKA-KR10-scara-R850-Z300.png",
            "B": "KUKA",
            "M": "KR10 scara R850 Z300",
            "T": "SCARA",
            "A": 4,
            "R": 850,
            "P": 10,
            "W": 50,
            "E": 0.025,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "KUKA-KR10-scara-R850-Z400": {
            "MT": "R",
            "N": "KUKA KR10 scara R850 Z400",
            "F": "KUKA-KR10-scara-R850-Z400.robot",
            "I": "KUKA-KR10-scara-R850-Z400-robot.png",
            "IS": "KUKA-KR10-scara-R850-Z400.png",
            "B": "KUKA",
            "M": "KR10 scara R850 Z400",
            "T": "SCARA",
            "A": 4,
            "R": 850,
            "P": 10,
            "W": 50,
            "E": 0.025,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "KUKA-KR12-R850-Z340-CR": {
            "MT": "R",
            "N": "KUKA KR12 R850 Z340 CR",
            "F": "KUKA-KR12-R850-Z340-CR.robot",
            "I": "KUKA-KR12-R850-Z340-CR-robot.png",
            "IS": "KUKA-KR12-R850-Z340-CR.png",
            "B": "KUKA",
            "M": "KR12 R850 Z340 CR",
            "T": "SCARA",
            "A": 4,
            "R": 850,
            "P": 6.0,
            "W": 53,
            "E": 0.025,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "LBBBD-LT2100-E-6": {
            "MT": "R",
            "N": "LBBBD LT2100-E-6",
            "F": "LBBBD-LT2100-E-6.robot",
            "I": "LBBBD-LT2100-E-6-robot.png",
            "IS": "LBBBD-LT2100-E-6.png",
            "B": "LBBBD",
            "M": "LT2100-E-6",
            "T": "6 DOF",
            "A": 6,
            "R": 2100,
            "P": 50.0,
            "W": 528,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Leantec-LA596-4H-R": {
            "MT": "R",
            "N": "Leantec LA596-4H-R",
            "F": "Leantec-LA596-4H-R.robot",
            "I": "Leantec-LA596-4H-R-robot.png",
            "IS": "Leantec-LA596-4H-R.png",
            "B": "Leantec",
            "M": "LA596-4H-R",
            "T": "6 DOF",
            "A": 6,
            "R": 596,
            "P": 4,
            "W": 32,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Leantec-LA596-4-R": {
            "MT": "R",
            "N": "Leantec LA596-4-R",
            "F": "Leantec-LA596-4-R.robot",
            "I": "Leantec-LA596-4-R-robot.png",
            "IS": "Leantec-LA596-4-R.png",
            "B": "Leantec",
            "M": "LA596-4-R",
            "T": "6 DOF",
            "A": 6,
            "R": 596,
            "P": 4,
            "W": 32,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Leantec-LA707-7H-R": {
            "MT": "R",
            "N": "Leantec LA707-7H-R",
            "F": "Leantec-LA707-7H-R.robot",
            "I": "Leantec-LA707-7H-R-robot.png",
            "IS": "Leantec-LA707-7H-R.png",
            "B": "Leantec",
            "M": "LA707-7H-R",
            "T": "6 DOF",
            "A": 6,
            "R": 707,
            "P": 7,
            "W": 50,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Leantec-LA707-7-R": {
            "MT": "R",
            "N": "Leantec LA707-7-R",
            "F": "Leantec-LA707-7-R.robot",
            "I": "Leantec-LA707-7-R-robot.png",
            "IS": "Leantec-LA707-7-R.png",
            "B": "Leantec",
            "M": "LA707-7-R",
            "T": "6 DOF",
            "A": 6,
            "R": 707,
            "P": 7,
            "W": 50,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Leantec-LA906-7H-R": {
            "MT": "R",
            "N": "Leantec LA906-7H-R",
            "F": "Leantec-LA906-7H-R.robot",
            "I": "Leantec-LA906-7H-R-robot.png",
            "IS": "Leantec-LA906-7H-R.png",
            "B": "Leantec",
            "M": "LA906-7H-R",
            "T": "6 DOF",
            "A": 6,
            "R": 906,
            "P": 7,
            "W": 52,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Leantec-LA906-7-R": {
            "MT": "R",
            "N": "Leantec LA906-7-R",
            "F": "Leantec-LA906-7-R.robot",
            "I": "Leantec-LA906-7-R-robot.png",
            "IS": "Leantec-LA906-7-R.png",
            "B": "Leantec",
            "M": "LA906-7-R",
            "T": "6 DOF",
            "A": 6,
            "R": 906,
            "P": 7,
            "W": 52,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Leantec-LA917-6-Y": {
            "MT": "R",
            "N": "Leantec LA917-6-Y",
            "F": "Leantec-LA917-6-Y.robot",
            "I": "Leantec-LA917-6-Y-robot.png",
            "IS": "Leantec-LA917-6-Y.png",
            "B": "Leantec",
            "M": "LA917-6-Y",
            "T": "6 DOF",
            "A": 6,
            "R": 917,
            "P": 6,
            "W": 60,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Leantec-LA1206-10-R": {
            "MT": "R",
            "N": "Leantec LA1206-10-R",
            "F": "Leantec-LA1206-10-R.robot",
            "I": "Leantec-LA1206-10-R-robot.png",
            "IS": "Leantec-LA1206-10-R.png",
            "B": "Leantec",
            "M": "LA1206-10-R",
            "T": "6 DOF",
            "A": 6,
            "R": 1206,
            "P": 10.0,
            "W": 76,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Leantec-LA1460-13-K": {
            "MT": "R",
            "N": "Leantec LA1460-13-K",
            "F": "Leantec-LA1460-13-K.robot",
            "I": "Leantec-LA1460-13-K-robot.png",
            "IS": "Leantec-LA1460-13-K.png",
            "B": "Leantec",
            "M": "LA1460-13-K",
            "T": "6 DOF",
            "A": 6,
            "R": 1460,
            "P": 13.0,
            "W": 170,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Leantec-LA1468-10-C": {
            "MT": "R",
            "N": "Leantec LA1468-10-C",
            "F": "Leantec-LA1468-10-C.robot",
            "I": "Leantec-LA1468-10-C-robot.png",
            "IS": "Leantec-LA1468-10-C.png",
            "B": "Leantec",
            "M": "LA1468-10-C",
            "T": "6 DOF",
            "A": 6,
            "R": 1468,
            "P": 10,
            "W": 161,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Leantec-LA1598-10-C": {
            "MT": "R",
            "N": "Leantec LA1598-10-C",
            "F": "Leantec-LA1598-10-C.robot",
            "I": "Leantec-LA1598-10-C-robot.png",
            "IS": "Leantec-LA1598-10-C.png",
            "B": "Leantec",
            "M": "LA1598-10-C",
            "T": "6 DOF",
            "A": 6,
            "R": 1598,
            "P": 10,
            "W": 268,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Leantec-LA1717-20-C": {
            "MT": "R",
            "N": "Leantec LA1717-20-C",
            "F": "Leantec-LA1717-20-C.robot",
            "I": "Leantec-LA1717-20-C-robot.png",
            "IS": "Leantec-LA1717-20-C.png",
            "B": "Leantec",
            "M": "LA1717-20-C",
            "T": "6 DOF",
            "A": 6,
            "R": 1717,
            "P": 20,
            "W": 268,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Leantec-LA1725-20-K": {
            "MT": "R",
            "N": "Leantec LA1725-20-K",
            "F": "Leantec-LA1725-20-K.robot",
            "I": "Leantec-LA1725-20-K-robot.png",
            "IS": "Leantec-LA1725-20-K.png",
            "B": "Leantec",
            "M": "LA1725-20-K",
            "T": "6 DOF",
            "A": 6,
            "R": 1725,
            "P": 20.0,
            "W": 230,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Leantec-LA1758-5-C": {
            "MT": "R",
            "N": "Leantec LA1758-5-C",
            "F": "Leantec-LA1758-5-C.robot",
            "I": "Leantec-LA1758-5-C-robot.png",
            "IS": "Leantec-LA1758-5-C.png",
            "B": "Leantec",
            "M": "LA1758-5-C",
            "T": "6 DOF",
            "A": 6,
            "R": 1758,
            "P": 5,
            "W": 270,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Leantec-LA2000-8-C": {
            "MT": "R",
            "N": "Leantec LA2000-8-C",
            "F": "Leantec-LA2000-8-C.robot",
            "I": "Leantec-LA2000-8-C-robot.png",
            "IS": "Leantec-LA2000-8-C.png",
            "B": "Leantec",
            "M": "LA2000-8-C",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 8,
            "W": 270,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Leantec-LA2100-60-C": {
            "MT": "R",
            "N": "Leantec LA2100-60-C",
            "F": "Leantec-LA2100-60-C.robot",
            "I": "Leantec-LA2100-60-C-robot.png",
            "IS": "Leantec-LA2100-60-C.png",
            "B": "Leantec",
            "M": "LA2100-60-C",
            "T": "6 DOF",
            "A": 6,
            "R": 2100,
            "P": 60,
            "W": 780,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Leantec-LP1520-12-C": {
            "MT": "R",
            "N": "Leantec LP1520-12-C",
            "F": "Leantec-LP1520-12-C.robot",
            "I": "Leantec-LP1520-12-C-robot.png",
            "IS": "Leantec-LP1520-12-C.png",
            "B": "Leantec",
            "M": "LP1520-12-C",
            "T": "Palletizing",
            "A": 4,
            "R": 1520,
            "P": 12,
            "W": 175,
            "E": 0.1,
            "AP": [
                "Palletizing"
            ]
        },
        "Leantec-LS400-3-Y": {
            "MT": "R",
            "N": "Leantec LS400-3-Y",
            "F": "Leantec-LS400-3-Y.robot",
            "I": "Leantec-LS400-3-Y-robot.png",
            "IS": "Leantec-LS400-3-Y.png",
            "B": "Leantec",
            "M": "LS400-3-Y",
            "T": "SCARA",
            "A": 4,
            "R": 400,
            "P": 3,
            "W": 13,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Leantec-LS600-6-Y": {
            "MT": "R",
            "N": "Leantec LS600-6-Y",
            "F": "Leantec-LS600-6-Y.robot",
            "I": "Leantec-LS600-6-Y-robot.png",
            "IS": "Leantec-LS600-6-Y.png",
            "B": "Leantec",
            "M": "LS600-6-Y",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 6,
            "W": 17,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Leantec-LS900-10-Y": {
            "MT": "R",
            "N": "Leantec LS900-10-Y",
            "F": "Leantec-LS900-10-Y.robot",
            "I": "Leantec-LS900-10-Y-robot.png",
            "IS": "Leantec-LS900-10-Y.png",
            "B": "Leantec",
            "M": "LS900-10-Y",
            "T": "SCARA",
            "A": 4,
            "R": 900,
            "P": 5.0,
            "W": 41,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Ligent-SK12-2010": {
            "MT": "R",
            "N": "Ligent SK12-2010",
            "F": "Ligent-SK12-2010.robot",
            "I": "Ligent-SK12-2010-robot.png",
            "IS": "Ligent-SK12-2010.png",
            "B": "Ligent",
            "M": "SK12-2010",
            "T": "6 DOF",
            "A": 6,
            "R": 2010,
            "P": 12,
            "W": 313,
            "E": 0.05,
            "AP": [
                "Welding"
            ]
        },
        "MABI-Robotic-MAX-100-2-25-P": {
            "MT": "R",
            "N": "MABI Robotic MAX-100-2.25-P",
            "F": "MABI-Robotic-MAX-100-2-25-P.robot",
            "I": "MABI-Robotic-MAX-100-2-25-P-robot.png",
            "IS": "MABI-Robotic-MAX-100-2-25-P.png",
            "B": "MABI Robotic",
            "M": "MAX-100-2.25-P",
            "T": "6 DOF",
            "A": 6,
            "R": 2240,
            "P": 100,
            "W": 1150,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "MABI-Robotic-MAX-150-2-0-P": {
            "MT": "R",
            "N": "MABI Robotic MAX-150-2.0-P",
            "F": "MABI-Robotic-MAX-150-2-0-P.robot",
            "I": "MABI-Robotic-MAX-150-2-0-P-robot.png",
            "IS": "MABI-Robotic-MAX-150-2-0-P.png",
            "B": "MABI Robotic",
            "M": "MAX-150-2.0-P",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 150,
            "W": 1125,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "MABI-Robotic-MAX-200-2-5-P": {
            "MT": "R",
            "N": "MABI Robotic MAX-200-2.5-P",
            "F": "MABI-Robotic-MAX-200-2-5-P.robot",
            "I": "MABI-Robotic-MAX-200-2-5-P-robot.png",
            "IS": "MABI-Robotic-MAX-200-2-5-P.png",
            "B": "MABI Robotic",
            "M": "MAX-200-2.5-P",
            "T": "6 DOF",
            "A": 6,
            "R": 2500,
            "P": 200,
            "W": 1950,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "MCI-SR4-6-550": {
            "MT": "R",
            "N": "MCI SR4-6-550",
            "F": "MCI-SR4-6-550.robot",
            "I": "MCI-SR4-6-550-robot.png",
            "IS": "MCI-SR4-6-550.png",
            "B": "MCI",
            "M": "SR4-6-550",
            "T": "SCARA",
            "A": 4,
            "R": 550,
            "P": 0.5,
            "W": 80,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Mecademic-Meca500-R3": {
            "MT": "R",
            "N": "Mecademic Meca500 R3",
            "F": "Mecademic-Meca500-R3.robot",
            "I": "Mecademic-Meca500-R3-robot.png",
            "IS": "Mecademic-Meca500-R3.png",
            "B": "Mecademic",
            "M": "Meca500 R3",
            "T": "6 DOF",
            "A": 6,
            "R": 330,
            "P": 0.5,
            "W": 4.5,
            "E": 0.005,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mecademic-Meca500-R4": {
            "MT": "R",
            "N": "Mecademic Meca500 R4",
            "F": "Mecademic-Meca500-R4.robot",
            "I": "Mecademic-Meca500-R4-robot.png",
            "IS": "Mecademic-Meca500-R4.png",
            "B": "Mecademic",
            "M": "Meca500 R4",
            "T": "6 DOF",
            "A": 6,
            "R": 330,
            "P": 0.5,
            "W": 4.5,
            "E": 0.005,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mecademic-MCS500": {
            "MT": "R",
            "N": "Mecademic MCS500",
            "F": "Mecademic-MCS500.robot",
            "I": "Mecademic-MCS500-robot.png",
            "IS": "Mecademic-MCS500.png",
            "B": "Mecademic",
            "M": "MCS500",
            "T": "SCARA",
            "A": 4,
            "R": 225,
            "P": 0.5,
            "W": 4.3,
            "E": 0.005,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "MIP-Junior-300": {
            "MT": "R",
            "N": "MIP Junior 300",
            "F": "MIP-Junior-300.robot",
            "I": "MIP-Junior-300-robot.png",
            "IS": "MIP-Junior-300.png",
            "B": "MIP Robotics",
            "M": "Junior 300",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 5,
            "W": 13.5,
            "E": 0.4,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Mitsubishi-RV-2AJ": {
            "MT": "R",
            "N": "Mitsubishi RV-2AJ",
            "F": "Mitsubishi-RV-2AJ.robot",
            "I": "Mitsubishi-RV-2AJ-robot.png",
            "IS": "Mitsubishi-RV-2AJ.png",
            "B": "Mitsubishi",
            "M": "RV-2AJ",
            "T": "5 DOF",
            "A": 5,
            "R": 410,
            "P": 2,
            "W": 17,
            "E": 0.02,
            "AP": [
                "Material Handling"
            ]
        },
        "Mitsubishi-RV-2F": {
            "MT": "R",
            "N": "Mitsubishi RV-2F",
            "F": "Mitsubishi-RV-2F.robot",
            "I": "Mitsubishi-RV-2F-robot.png",
            "IS": "Mitsubishi-RV-2F.png",
            "B": "Mitsubishi",
            "M": "RV-2F",
            "T": "6 DOF",
            "A": 6,
            "R": 504,
            "P": 2,
            "W": 17,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-2FR": {
            "MT": "R",
            "N": "Mitsubishi RV-2FR",
            "F": "Mitsubishi-RV-2FR.robot",
            "I": "Mitsubishi-RV-2FR-robot.png",
            "IS": "Mitsubishi-RV-2FR.png",
            "B": "Mitsubishi",
            "M": "RV-2FR",
            "T": "6 DOF",
            "A": 6,
            "R": 504,
            "P": 2,
            "W": 19,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-2FRL": {
            "MT": "R",
            "N": "Mitsubishi RV-2FRL",
            "F": "Mitsubishi-RV-2FRL.robot",
            "I": "Mitsubishi-RV-2FRL-robot.png",
            "IS": "Mitsubishi-RV-2FRL.png",
            "B": "Mitsubishi",
            "M": "RV-2FRL",
            "T": "6 DOF",
            "A": 6,
            "R": 649,
            "P": 2,
            "W": 21,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-3S": {
            "MT": "R",
            "N": "Mitsubishi RV-3S",
            "F": "Mitsubishi-RV-3S.robot",
            "I": "Mitsubishi-RV-3S-robot.png",
            "IS": "Mitsubishi-RV-3S.png",
            "B": "Mitsubishi",
            "M": "RV-3S",
            "T": "6 DOF",
            "A": 6,
            "R": 642,
            "P": 3.5,
            "W": 33,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-4FL": {
            "MT": "R",
            "N": "Mitsubishi RV-4FL",
            "F": "Mitsubishi-RV-4FL.robot",
            "I": "Mitsubishi-RV-4FL-robot.png",
            "IS": "Mitsubishi-RV-4FL.png",
            "B": "Mitsubishi",
            "M": "RV-4FL",
            "T": "6 DOF",
            "A": 6,
            "R": 648.7,
            "P": 4,
            "W": 41,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-4FRL": {
            "MT": "R",
            "N": "Mitsubishi RV-4FRL",
            "F": "Mitsubishi-RV-4FRL.robot",
            "I": "Mitsubishi-RV-4FRL-robot.png",
            "IS": "Mitsubishi-RV-4FRL.png",
            "B": "Mitsubishi",
            "M": "RV-4FRL",
            "T": "6 DOF",
            "A": 6,
            "R": 649,
            "P": 4,
            "W": 41,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-4FRL-MC": {
            "MT": "R",
            "N": "Mitsubishi RV-4FRL-MC",
            "F": "Mitsubishi-RV-4FRL-MC.robot",
            "I": "Mitsubishi-RV-4FRL-MC-robot.png",
            "IS": "Mitsubishi-RV-4FRL-MC.png",
            "B": "Mitsubishi",
            "M": "RV-4FRL-MC",
            "T": "6 DOF",
            "A": 6,
            "R": 649,
            "P": 4,
            "W": 41,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-4FRL-SH": {
            "MT": "R",
            "N": "Mitsubishi RV-4FRL-SH",
            "F": "Mitsubishi-RV-4FRL-SH.robot",
            "I": "Mitsubishi-RV-4FRL-SH-robot.png",
            "IS": "Mitsubishi-RV-4FRL-SH.png",
            "B": "Mitsubishi",
            "M": "RV-4FRL-SH",
            "T": "6 DOF",
            "A": 6,
            "R": 649,
            "P": 4,
            "W": 41,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-4FR-MC": {
            "MT": "R",
            "N": "Mitsubishi RV-4FR-MC",
            "F": "Mitsubishi-RV-4FR-MC.robot",
            "I": "Mitsubishi-RV-4FR-MC-robot.png",
            "IS": "Mitsubishi-RV-4FR-MC.png",
            "B": "Mitsubishi",
            "M": "RV-4FR-MC",
            "T": "6 DOF",
            "A": 6,
            "R": 515,
            "P": 4,
            "W": 39,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-4FR-SH": {
            "MT": "R",
            "N": "Mitsubishi RV-4FR-SH",
            "F": "Mitsubishi-RV-4FR-SH.robot",
            "I": "Mitsubishi-RV-4FR-SH-robot.png",
            "IS": "Mitsubishi-RV-4FR-SH.png",
            "B": "Mitsubishi",
            "M": "RV-4FR-SH",
            "T": "6 DOF",
            "A": 6,
            "R": 515,
            "P": 4,
            "W": 39,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-5AS-D": {
            "MT": "R",
            "N": "Mitsubishi RV-5AS-D",
            "F": "Mitsubishi-RV-5AS-D.robot",
            "I": "Mitsubishi-RV-5AS-D-robot.png",
            "IS": "Mitsubishi-RV-5AS-D.png",
            "B": "Mitsubishi",
            "M": "RV-5AS-D",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 5,
            "W": 58,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-6SL": {
            "MT": "R",
            "N": "Mitsubishi RV-6SL",
            "F": "Mitsubishi-RV-6SL.robot",
            "I": "Mitsubishi-RV-6SL-robot.png",
            "IS": "Mitsubishi-RV-6SL.png",
            "B": "Mitsubishi",
            "M": "RV-6SL",
            "T": "6 DOF",
            "A": 6,
            "R": 902,
            "P": 5,
            "W": 60,
            "E": 0.2,
            "AP": [
                "Assembly",
                "Inspection",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-7FL": {
            "MT": "R",
            "N": "Mitsubishi RV-7FL",
            "F": "Mitsubishi-RV-7FL.robot",
            "I": "Mitsubishi-RV-7FL-robot.png",
            "IS": "Mitsubishi-RV-7FL.png",
            "B": "Mitsubishi",
            "M": "RV-7FL",
            "T": "6 DOF",
            "A": 6,
            "R": 908,
            "P": 7,
            "W": 67,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-7FR": {
            "MT": "R",
            "N": "Mitsubishi RV-7FR",
            "F": "Mitsubishi-RV-7FR.robot",
            "I": "Mitsubishi-RV-7FR-robot.png",
            "IS": "Mitsubishi-RV-7FR.png",
            "B": "Mitsubishi",
            "M": "RV-7FR",
            "T": "6 DOF",
            "A": 6,
            "R": 713,
            "P": 7,
            "W": 65,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-7FRL": {
            "MT": "R",
            "N": "Mitsubishi RV-7FRL",
            "F": "Mitsubishi-RV-7FRL.robot",
            "I": "Mitsubishi-RV-7FRL-robot.png",
            "IS": "Mitsubishi-RV-7FRL.png",
            "B": "Mitsubishi",
            "M": "RV-7FRL",
            "T": "6 DOF",
            "A": 6,
            "R": 908,
            "P": 7,
            "W": 67,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-7FRLL": {
            "MT": "R",
            "N": "Mitsubishi RV-7FRLL",
            "F": "Mitsubishi-RV-7FRLL.robot",
            "I": "Mitsubishi-RV-7FRLL-robot.png",
            "IS": "Mitsubishi-RV-7FRLL.png",
            "B": "Mitsubishi",
            "M": "RV-7FRLL",
            "T": "6 DOF",
            "A": 6,
            "R": 1503,
            "P": 7,
            "W": 130,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Mitsubishi-RV-7FRLL-MC": {
            "MT": "R",
            "N": "Mitsubishi RV-7FRLL-MC",
            "F": "Mitsubishi-RV-7FRLL-MC.robot",
            "I": "Mitsubishi-RV-7FRLL-MC-robot.png",
            "IS": "Mitsubishi-RV-7FRLL-MC.png",
            "B": "Mitsubishi",
            "M": "RV-7FRLL-MC",
            "T": "6 DOF",
            "A": 6,
            "R": 1503,
            "P": 7,
            "W": 130,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Mitsubishi-RV-7FRL-MC": {
            "MT": "R",
            "N": "Mitsubishi RV-7FRL-MC",
            "F": "Mitsubishi-RV-7FRL-MC.robot",
            "I": "Mitsubishi-RV-7FRL-MC-robot.png",
            "IS": "Mitsubishi-RV-7FRL-MC.png",
            "B": "Mitsubishi",
            "M": "RV-7FRL-MC",
            "T": "6 DOF",
            "A": 6,
            "R": 908,
            "P": 7,
            "W": 67,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-7FRL-SH": {
            "MT": "R",
            "N": "Mitsubishi RV-7FRL-SH",
            "F": "Mitsubishi-RV-7FRL-SH.robot",
            "I": "Mitsubishi-RV-7FRL-SH-robot.png",
            "IS": "Mitsubishi-RV-7FRL-SH.png",
            "B": "Mitsubishi",
            "M": "RV-7FRL-SH",
            "T": "6 DOF",
            "A": 6,
            "R": 908,
            "P": 7,
            "W": 67,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-7FR-MC": {
            "MT": "R",
            "N": "Mitsubishi RV-7FR-MC",
            "F": "Mitsubishi-RV-7FR-MC.robot",
            "I": "Mitsubishi-RV-7FR-MC-robot.png",
            "IS": "Mitsubishi-RV-7FR-MC.png",
            "B": "Mitsubishi",
            "M": "RV-7FR-MC",
            "T": "6 DOF",
            "A": 6,
            "R": 713,
            "P": 7,
            "W": 65,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-7FR-SH": {
            "MT": "R",
            "N": "Mitsubishi RV-7FR-SH",
            "F": "Mitsubishi-RV-7FR-SH.robot",
            "I": "Mitsubishi-RV-7FR-SH-robot.png",
            "IS": "Mitsubishi-RV-7FR-SH.png",
            "B": "Mitsubishi",
            "M": "RV-7FR-SH",
            "T": "6 DOF",
            "A": 6,
            "R": 713,
            "P": 7,
            "W": 65,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-8CRL": {
            "MT": "R",
            "N": "Mitsubishi RV-8CRL",
            "F": "Mitsubishi-RV-8CRL.robot",
            "I": "Mitsubishi-RV-8CRL-robot.png",
            "IS": "Mitsubishi-RV-8CRL.png",
            "B": "Mitsubishi",
            "M": "RV-8CRL",
            "T": "6 DOF",
            "A": 6,
            "R": 931,
            "P": 7,
            "W": 41,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-12CRL": {
            "MT": "R",
            "N": "Mitsubishi RV-12CRL",
            "F": "Mitsubishi-RV-12CRL.robot",
            "I": "Mitsubishi-RV-12CRL-robot.png",
            "IS": "Mitsubishi-RV-12CRL.png",
            "B": "Mitsubishi",
            "M": "RV-12CRL",
            "T": "6 DOF",
            "A": 6,
            "R": 1504,
            "P": 12,
            "W": 110,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Mitsubishi-RV-12CRL-D": {
            "MT": "R",
            "N": "Mitsubishi RV-12CRL-D",
            "F": "Mitsubishi-RV-12CRL-D.robot",
            "I": "Mitsubishi-RV-12CRL-D-robot.png",
            "IS": "Mitsubishi-RV-12CRL-D.png",
            "B": "Mitsubishi",
            "M": "RV-12CRL-D",
            "T": "6 DOF",
            "A": 6,
            "R": 1504,
            "P": 12.0,
            "W": 110,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Mitsubishi-RV-12S": {
            "MT": "R",
            "N": "Mitsubishi RV-12S",
            "F": "Mitsubishi-RV-12S.robot",
            "I": "Mitsubishi-RV-12S-robot.png",
            "IS": "Mitsubishi-RV-12S.png",
            "B": "Mitsubishi",
            "M": "RV-12S",
            "T": "6 DOF",
            "A": 6,
            "R": 936,
            "P": 12,
            "W": 93,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-13FL": {
            "MT": "R",
            "N": "Mitsubishi RV-13FL",
            "F": "Mitsubishi-RV-13FL.robot",
            "I": "Mitsubishi-RV-13FL-robot.png",
            "IS": "Mitsubishi-RV-13FL.png",
            "B": "Mitsubishi",
            "M": "RV-13FL",
            "T": "6 DOF",
            "A": 6,
            "R": 1388,
            "P": 13,
            "W": 120,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Mitsubishi-RV-13FR": {
            "MT": "R",
            "N": "Mitsubishi RV-13FR",
            "F": "Mitsubishi-RV-13FR.robot",
            "I": "Mitsubishi-RV-13FR-robot.png",
            "IS": "Mitsubishi-RV-13FR.png",
            "B": "Mitsubishi",
            "M": "RV-13FR",
            "T": "6 DOF",
            "A": 6,
            "R": 1094,
            "P": 13,
            "W": 120,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Mitsubishi-RV-13FRL": {
            "MT": "R",
            "N": "Mitsubishi RV-13FRL",
            "F": "Mitsubishi-RV-13FRL.robot",
            "I": "Mitsubishi-RV-13FRL-robot.png",
            "IS": "Mitsubishi-RV-13FRL.png",
            "B": "Mitsubishi",
            "M": "RV-13FRL",
            "T": "6 DOF",
            "A": 6,
            "R": 1388,
            "P": 13,
            "W": 120,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Mitsubishi-RV-13FRL-MC": {
            "MT": "R",
            "N": "Mitsubishi RV-13FRL-MC",
            "F": "Mitsubishi-RV-13FRL-MC.robot",
            "I": "Mitsubishi-RV-13FRL-MC-robot.png",
            "IS": "Mitsubishi-RV-13FRL-MC.png",
            "B": "Mitsubishi",
            "M": "RV-13FRL-MC",
            "T": "6 DOF",
            "A": 6,
            "R": 1388,
            "P": 13,
            "W": 120,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Mitsubishi-RV-13FRL-SH": {
            "MT": "R",
            "N": "Mitsubishi RV-13FRL-SH",
            "F": "Mitsubishi-RV-13FRL-SH.robot",
            "I": "Mitsubishi-RV-13FRL-SH-robot.png",
            "IS": "Mitsubishi-RV-13FRL-SH.png",
            "B": "Mitsubishi",
            "M": "RV-13FRL-SH",
            "T": "6 DOF",
            "A": 6,
            "R": 1388,
            "P": 13,
            "W": 120,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Mitsubishi-RV-20FR": {
            "MT": "R",
            "N": "Mitsubishi RV-20FR",
            "F": "Mitsubishi-RV-20FR.robot",
            "I": "Mitsubishi-RV-20FR-robot.png",
            "IS": "Mitsubishi-RV-20FR.png",
            "B": "Mitsubishi",
            "M": "RV-20FR",
            "T": "6 DOF",
            "A": 6,
            "R": 1094,
            "P": 20,
            "W": 120,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Mitsubishi-RV-35F": {
            "MT": "R",
            "N": "Mitsubishi RV-35F",
            "F": "Mitsubishi-RV-35F.robot",
            "I": "Mitsubishi-RV-35F-robot.png",
            "IS": "Mitsubishi-RV-35F.png",
            "B": "Mitsubishi",
            "M": "RV-35F",
            "T": "6 DOF",
            "A": 6,
            "R": 2050,
            "P": 35,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-50F": {
            "MT": "R",
            "N": "Mitsubishi RV-50F",
            "F": "Mitsubishi-RV-50F.robot",
            "I": "Mitsubishi-RV-50F-robot.png",
            "IS": "Mitsubishi-RV-50F.png",
            "B": "Mitsubishi",
            "M": "RV-50F",
            "T": "6 DOF",
            "A": 6,
            "R": 2050,
            "P": 50,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RV-70F": {
            "MT": "R",
            "N": "Mitsubishi RV-70F",
            "F": "Mitsubishi-RV-70F.robot",
            "I": "Mitsubishi-RV-70F-robot.png",
            "IS": "Mitsubishi-RV-70F.png",
            "B": "Mitsubishi",
            "M": "RV-70F",
            "T": "6 DOF",
            "A": 6,
            "R": 2050,
            "P": 70,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Mitsubishi-RH-3CH": {
            "MT": "R",
            "N": "Mitsubishi RH-3CH",
            "F": "Mitsubishi-RH-3CH.robot",
            "I": "Mitsubishi-RH-3CH-robot.png",
            "IS": "Mitsubishi-RH-3CH.png",
            "B": "Mitsubishi",
            "M": "RH-3CH",
            "T": "SCARA",
            "A": 4,
            "R": 400,
            "P": 3.0,
            "W": 14,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Mitsubishi-RH-3FRH3515": {
            "MT": "R",
            "N": "Mitsubishi RH-3FRH3515",
            "F": "Mitsubishi-RH-3FRH3515.robot",
            "I": "Mitsubishi-RH-3FRH3515-robot.png",
            "IS": "Mitsubishi-RH-3FRH3515.png",
            "B": "Mitsubishi",
            "M": "RH-3FRH3515",
            "T": "SCARA",
            "A": 4,
            "R": 350,
            "P": 3.0,
            "W": 29,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Mitsubishi-RH-3FRH4515": {
            "MT": "R",
            "N": "Mitsubishi RH-3FRH4515",
            "F": "Mitsubishi-RH-3FRH4515.robot",
            "I": "Mitsubishi-RH-3FRH4515-robot.png",
            "IS": "Mitsubishi-RH-3FRH4515.png",
            "B": "Mitsubishi",
            "M": "RH-3FRH4515",
            "T": "SCARA",
            "A": 4,
            "R": 225,
            "P": 3.0,
            "W": 29,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Mitsubishi-RH-3FRH5515": {
            "MT": "R",
            "N": "Mitsubishi RH-3FRH5515",
            "F": "Mitsubishi-RH-3FRH5515.robot",
            "I": "Mitsubishi-RH-3FRH5515-robot.png",
            "IS": "Mitsubishi-RH-3FRH5515.png",
            "B": "Mitsubishi",
            "M": "RH-3FRH5515",
            "T": "SCARA",
            "A": 4,
            "R": 550,
            "P": 3.0,
            "W": 32,
            "E": 0.012,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Mitsubishi-RH-6CH60": {
            "MT": "R",
            "N": "Mitsubishi RH-6CH60",
            "F": "Mitsubishi-RH-6CH60.robot",
            "I": "Mitsubishi-RH-6CH60-robot.png",
            "IS": "Mitsubishi-RH-6CH60.png",
            "B": "Mitsubishi",
            "M": "RH-6CH60",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 6,
            "W": 17,
            "E": 0.025,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Mitsubishi-RH-6CH70": {
            "MT": "R",
            "N": "Mitsubishi RH-6CH70",
            "F": "Mitsubishi-RH-6CH70.robot",
            "I": "Mitsubishi-RH-6CH70-robot.png",
            "IS": "Mitsubishi-RH-6CH70.png",
            "B": "Mitsubishi",
            "M": "RH-6CH70",
            "T": "SCARA",
            "A": 4,
            "R": 700,
            "P": 6,
            "W": 18,
            "E": 0.025,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Mitsubishi-RH-12FH7035": {
            "MT": "R",
            "N": "Mitsubishi RH-12FH7035",
            "F": "Mitsubishi-RH-12FH7035.robot",
            "I": "Mitsubishi-RH-12FH7035-robot.png",
            "IS": "Mitsubishi-RH-12FH7035.png",
            "B": "Mitsubishi",
            "M": "RH-12FH7035",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 12,
            "E": 0.025,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Mitsubishi-RH-12SH5535": {
            "MT": "R",
            "N": "Mitsubishi RH-12SH5535",
            "F": "Mitsubishi-RH-12SH5535.robot",
            "I": "Mitsubishi-RH-12SH5535-robot.png",
            "IS": "Mitsubishi-RH-12SH5535.png",
            "B": "Mitsubishi",
            "M": "RH-12SH5535",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 12,
            "W": 43,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Mitsubishi-RH-20FRH8535": {
            "MT": "R",
            "N": "Mitsubishi RH-20FRH8535",
            "F": "Mitsubishi-RH-20FRH8535.robot",
            "I": "Mitsubishi-RH-20FRH8535-robot.png",
            "IS": "Mitsubishi-RH-20FRH8535.png",
            "B": "Mitsubishi",
            "M": "RH-20FRH8535",
            "T": "SCARA",
            "A": 4,
            "R": 850,
            "P": 20,
            "E": 0.025,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Nachi-MC500P": {
            "MT": "R",
            "N": "Nachi MC500P",
            "F": "Nachi-MC500P.robot",
            "I": "Nachi-MC500P-robot.png",
            "IS": "Nachi-MC500P.png",
            "B": "Nachi",
            "M": "MC500P",
            "T": "5 DOF",
            "A": 5,
            "R": 3756,
            "P": 500,
            "W": 3000,
            "E": 0.3,
            "AP": [
                "Material Handling"
            ]
        },
        "Nachi-MC10L-01": {
            "MT": "R",
            "N": "Nachi MC10L-01",
            "F": "Nachi-MC10L-01.robot",
            "I": "Nachi-MC10L-01-robot.png",
            "IS": "Nachi-MC10L-01.png",
            "B": "Nachi",
            "M": "MC10L-01",
            "T": "6 DOF",
            "A": 6,
            "R": 2019,
            "P": 10,
            "W": 225,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Nachi-MC20": {
            "MT": "R",
            "N": "Nachi MC20",
            "F": "Nachi-MC20.robot",
            "I": "Nachi-MC20-robot.png",
            "IS": "Nachi-MC20.png",
            "B": "Nachi",
            "M": "MC20",
            "T": "6 DOF",
            "A": 6,
            "R": 1722,
            "P": 20,
            "W": 220,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Nachi-MC50": {
            "MT": "R",
            "N": "Nachi MC50",
            "F": "Nachi-MC50.robot",
            "I": "Nachi-MC50-robot.png",
            "IS": "Nachi-MC50.png",
            "B": "Nachi",
            "M": "MC50",
            "T": "6 DOF",
            "A": 6,
            "R": 2050,
            "P": 50,
            "W": 640,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Nachi-MZ01-01": {
            "MT": "R",
            "N": "Nachi MZ01-01",
            "F": "Nachi-MZ01-01.robot",
            "I": "Nachi-MZ01-01-robot.png",
            "IS": "Nachi-MZ01-01.png",
            "B": "Nachi",
            "M": "MZ01-01",
            "T": "6 DOF",
            "A": 6,
            "R": 350,
            "P": 1,
            "W": 10,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Nachi-MZ03EL": {
            "MT": "R",
            "N": "Nachi MZ03EL",
            "F": "Nachi-MZ03EL.robot",
            "I": "Nachi-MZ03EL-robot.png",
            "IS": "Nachi-MZ03EL.png",
            "B": "Nachi",
            "M": "MZ03EL",
            "T": "6 DOF",
            "A": 6,
            "R": 1102,
            "P": 3.5,
            "W": 39,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Nachi-MZ04-01": {
            "MT": "R",
            "N": "Nachi MZ04-01",
            "F": "Nachi-MZ04-01.robot",
            "I": "Nachi-MZ04-01-robot.png",
            "IS": "Nachi-MZ04-01.png",
            "B": "Nachi",
            "M": "MZ04-01",
            "T": "6 DOF",
            "A": 6,
            "R": 541,
            "P": 4,
            "W": 26,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Nachi-MZ04E-01": {
            "MT": "R",
            "N": "Nachi MZ04E-01",
            "F": "Nachi-MZ04E-01.robot",
            "I": "Nachi-MZ04E-01-robot.png",
            "IS": "Nachi-MZ04E-01.png",
            "B": "Nachi",
            "M": "MZ04E-01",
            "T": "6 DOF",
            "A": 6,
            "R": 541,
            "P": 4,
            "W": 25,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Nachi-MZ07": {
            "MT": "R",
            "N": "Nachi MZ07",
            "F": "Nachi-MZ07.robot",
            "I": "Nachi-MZ07-robot.png",
            "IS": "Nachi-MZ07.png",
            "B": "Nachi",
            "M": "MZ07",
            "T": "6 DOF",
            "A": 6,
            "R": 723,
            "P": 7,
            "W": 30,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Nachi-MZ07L": {
            "MT": "R",
            "N": "Nachi MZ07L",
            "F": "Nachi-MZ07L.robot",
            "I": "Nachi-MZ07L-robot.png",
            "IS": "Nachi-MZ07L.png",
            "B": "Nachi",
            "M": "MZ07L",
            "T": "6 DOF",
            "A": 6,
            "R": 912,
            "P": 7,
            "W": 32,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Nachi-MZ10": {
            "MT": "R",
            "N": "Nachi MZ10",
            "F": "Nachi-MZ10.robot",
            "I": "Nachi-MZ10-robot.png",
            "IS": "Nachi-MZ10.png",
            "B": "Nachi",
            "M": "MZ10",
            "T": "6 DOF",
            "A": 6,
            "R": 723,
            "P": 10,
            "W": 36,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Nachi-MZ10LF-01": {
            "MT": "R",
            "N": "Nachi MZ10LF-01",
            "F": "Nachi-MZ10LF-01.robot",
            "I": "Nachi-MZ10LF-01-robot.png",
            "IS": "Nachi-MZ10LF-01.png",
            "B": "Nachi",
            "M": "MZ10LF-01",
            "T": "6 DOF",
            "A": 6,
            "R": 1202,
            "P": 10,
            "W": 55,
            "E": 0.025,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Nachi-MZ12-01": {
            "MT": "R",
            "N": "Nachi MZ12-01",
            "F": "Nachi-MZ12-01.robot",
            "I": "Nachi-MZ12-01-robot.png",
            "IS": "Nachi-MZ12-01.png",
            "B": "Nachi",
            "M": "MZ12-01",
            "T": "6 DOF",
            "A": 6,
            "R": 1454,
            "P": 12,
            "W": 150,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Nachi-MZ25": {
            "MT": "R",
            "N": "Nachi MZ25",
            "F": "Nachi-MZ25.robot",
            "I": "Nachi-MZ25-robot.png",
            "IS": "Nachi-MZ25.png",
            "B": "Nachi",
            "M": "MZ25",
            "T": "6 DOF",
            "A": 6,
            "R": 1882,
            "P": 25,
            "W": 250,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Nachi-SC15F-02": {
            "MT": "R",
            "N": "Nachi SC15F-02",
            "F": "Nachi-SC15F-02.robot",
            "I": "Nachi-SC15F-02-robot.png",
            "IS": "Nachi-SC15F-02.png",
            "B": "Nachi",
            "M": "SC15F-02",
            "T": "6 DOF",
            "A": 6,
            "R": 1587,
            "P": 15,
            "W": 225,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Nachi-SRA100B-01": {
            "MT": "R",
            "N": "Nachi SRA100B-01",
            "F": "Nachi-SRA100B-01.robot",
            "I": "Nachi-SRA100B-01-robot.png",
            "IS": "Nachi-SRA100B-01.png",
            "B": "Nachi",
            "M": "SRA100B-01",
            "T": "6 DOF",
            "A": 6,
            "R": 2071,
            "P": 100,
            "W": 690,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Nachi-SRA100H": {
            "MT": "R",
            "N": "Nachi SRA100H",
            "F": "Nachi-SRA100H.robot",
            "I": "Nachi-SRA100H-robot.png",
            "IS": "Nachi-SRA100H.png",
            "B": "Nachi",
            "M": "SRA100H",
            "T": "6 DOF",
            "A": 6,
            "R": 2654,
            "P": 20.0,
            "W": 1040,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Nachi-SRA120EL": {
            "MT": "R",
            "N": "Nachi SRA120EL",
            "F": "Nachi-SRA120EL.robot",
            "I": "Nachi-SRA120EL-robot.png",
            "IS": "Nachi-SRA120EL.png",
            "B": "Nachi",
            "M": "SRA120EL",
            "T": "6 DOF",
            "A": 6,
            "R": 3099,
            "P": 120,
            "W": 985,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Nachi-SRA166": {
            "MT": "R",
            "N": "Nachi SRA166",
            "F": "Nachi-SRA166.robot",
            "I": "Nachi-SRA166-robot.png",
            "IS": "Nachi-SRA166.png",
            "B": "Nachi",
            "M": "SRA166",
            "T": "6 DOF",
            "A": 6,
            "R": 2654,
            "P": 166,
            "W": 960,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Nachi-SRA210": {
            "MT": "R",
            "N": "Nachi SRA210",
            "F": "Nachi-SRA210.robot",
            "I": "Nachi-SRA210-robot.png",
            "IS": "Nachi-SRA210.png",
            "B": "Nachi",
            "M": "SRA210",
            "T": "6 DOF",
            "A": 6,
            "R": 2674,
            "P": 210,
            "W": 990,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Nachi-SRA210H": {
            "MT": "R",
            "N": "Nachi SRA210H",
            "F": "Nachi-SRA210H.robot",
            "I": "Nachi-SRA210H-robot.png",
            "IS": "Nachi-SRA210H.png",
            "B": "Nachi",
            "M": "SRA210H",
            "T": "6 DOF",
            "A": 6,
            "R": 2654,
            "P": 120.0,
            "W": 1100,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Nachi-SRA240": {
            "MT": "R",
            "N": "Nachi SRA240",
            "F": "Nachi-SRA240.robot",
            "I": "Nachi-SRA240-robot.png",
            "IS": "Nachi-SRA240.png",
            "B": "Nachi",
            "M": "SRA240",
            "T": "6 DOF",
            "A": 6,
            "R": 2674,
            "P": 240,
            "W": 990,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Nachi-SRA250": {
            "MT": "R",
            "N": "Nachi SRA250",
            "F": "Nachi-SRA250.robot",
            "I": "Nachi-SRA250-robot.png",
            "IS": "Nachi-SRA250.png",
            "B": "Nachi",
            "M": "SRA250",
            "T": "6 DOF",
            "A": 6,
            "R": 2792,
            "P": 250,
            "W": 1030,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Nachi-ST166F": {
            "MT": "R",
            "N": "Nachi ST166F",
            "F": "Nachi-ST166F.robot",
            "I": "Nachi-ST166F-robot.png",
            "IS": "Nachi-ST166F.png",
            "B": "Nachi",
            "M": "ST166F",
            "T": "6 DOF",
            "A": 6,
            "R": 2654,
            "P": 166,
            "W": 1070,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Nachi-EZ03V4-02-4525": {
            "MT": "R",
            "N": "Nachi EZ03V4-02-4525",
            "F": "Nachi-EZ03V4-02-4525.robot",
            "I": "Nachi-EZ03V4-02-4525-robot.png",
            "IS": "Nachi-EZ03V4-02-4525.png",
            "B": "Nachi",
            "M": "EZ03V4-02-4525",
            "T": "SCARA",
            "A": 4,
            "R": 450,
            "P": 2,
            "W": 42,
            "E": 0.014,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Neura-LARA-3": {
            "MT": "R",
            "N": "Neura LARA 3",
            "F": "Neura-LARA-3.robot",
            "I": "Neura-LARA-3-robot.png",
            "IS": "Neura-LARA-3.png",
            "B": "Neura",
            "M": "LARA 3",
            "T": "6 DOF",
            "A": 6,
            "R": 590,
            "P": 3.0,
            "W": 17,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Neura-LARA-5": {
            "MT": "R",
            "N": "Neura LARA 5",
            "F": "Neura-LARA-5.robot",
            "I": "Neura-LARA-5-robot.png",
            "IS": "Neura-LARA-5.png",
            "B": "Neura",
            "M": "LARA 5",
            "T": "6 DOF",
            "A": 6,
            "R": 800,
            "P": 5.0,
            "W": 23,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Neura-LARA-8": {
            "MT": "R",
            "N": "Neura LARA 8",
            "F": "Neura-LARA-8.robot",
            "I": "Neura-LARA-8-robot.png",
            "IS": "Neura-LARA-8.png",
            "B": "Neura",
            "M": "LARA 8",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 8.0,
            "W": 47,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Neura-LARA-10": {
            "MT": "R",
            "N": "Neura LARA 10",
            "F": "Neura-LARA-10.robot",
            "I": "Neura-LARA-10-robot.png",
            "IS": "Neura-LARA-10.png",
            "B": "Neura",
            "M": "LARA 10",
            "T": "6 DOF",
            "A": 6,
            "R": 1000,
            "P": 10.0,
            "W": 40,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Neura-LARA-15": {
            "MT": "R",
            "N": "Neura LARA 15",
            "F": "Neura-LARA-15.robot",
            "I": "Neura-LARA-15-robot.png",
            "IS": "Neura-LARA-15.png",
            "B": "Neura",
            "M": "LARA 15",
            "T": "6 DOF",
            "A": 6,
            "R": 1600,
            "P": 15.0,
            "W": 67,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Neura-LARA-20": {
            "MT": "R",
            "N": "Neura LARA 20",
            "F": "Neura-LARA-20.robot",
            "I": "Neura-LARA-20-robot.png",
            "IS": "Neura-LARA-20.png",
            "B": "Neura",
            "M": "LARA 20",
            "T": "6 DOF",
            "A": 6,
            "R": 1800,
            "P": 20.0,
            "W": 98,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Neura-LARA-25": {
            "MT": "R",
            "N": "Neura LARA 25",
            "F": "Neura-LARA-25.robot",
            "I": "Neura-LARA-25-robot.png",
            "IS": "Neura-LARA-25.png",
            "B": "Neura",
            "M": "LARA 25",
            "T": "6 DOF",
            "A": 6,
            "R": 1800,
            "P": 25.0,
            "W": 101,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Neura-LARA-30": {
            "MT": "R",
            "N": "Neura LARA 30",
            "F": "Neura-LARA-30.robot",
            "I": "Neura-LARA-30-robot.png",
            "IS": "Neura-LARA-30.png",
            "B": "Neura",
            "M": "LARA 30",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 30.0,
            "W": 98,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Neura-LARA-30L": {
            "MT": "R",
            "N": "Neura LARA 30L",
            "F": "Neura-LARA-30L.robot",
            "I": "Neura-LARA-30L-robot.png",
            "IS": "Neura-LARA-30L.png",
            "B": "Neura",
            "M": "LARA 30L",
            "T": "6 DOF",
            "A": 6,
            "R": 1800,
            "P": 30.0,
            "W": 126,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Neura-MAiRA-L": {
            "MT": "R",
            "N": "Neura MAiRA L",
            "F": "Neura-MAiRA-L.robot",
            "I": "Neura-MAiRA-L-robot.png",
            "IS": "Neura-MAiRA-L.png",
            "B": "Neura",
            "M": "MAiRA L",
            "T": "7 DOF",
            "A": 7,
            "R": 1600,
            "P": 9.0,
            "W": 56,
            "E": 0.01,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Neura-MAiRA-M": {
            "MT": "R",
            "N": "Neura MAiRA M",
            "F": "Neura-MAiRA-M.robot",
            "I": "Neura-MAiRA-M-robot.png",
            "IS": "Neura-MAiRA-M.png",
            "B": "Neura",
            "M": "MAiRA M",
            "T": "7 DOF",
            "A": 7,
            "R": 1400,
            "P": 12.0,
            "W": 53,
            "E": 0.01,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Neura-MAiRA-Pro-M": {
            "MT": "R",
            "N": "Neura MAiRA Pro M",
            "F": "Neura-MAiRA-Pro-M.robot",
            "I": "Neura-MAiRA-Pro-M-robot.png",
            "IS": "Neura-MAiRA-Pro-M.png",
            "B": "Neura",
            "M": "MAiRA Pro M",
            "T": "7 DOF",
            "A": 7,
            "R": 1400,
            "P": 12.0,
            "W": 48,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Neura-MAiRA-Pro-S": {
            "MT": "R",
            "N": "Neura MAiRA Pro S",
            "F": "Neura-MAiRA-Pro-S.robot",
            "I": "Neura-MAiRA-Pro-S-robot.png",
            "IS": "Neura-MAiRA-Pro-S.png",
            "B": "Neura",
            "M": "MAiRA Pro S",
            "T": "7 DOF",
            "A": 7,
            "R": 1100,
            "P": 15,
            "W": 51,
            "E": 0.01,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Neura-MAiRA-S": {
            "MT": "R",
            "N": "Neura MAiRA S",
            "F": "Neura-MAiRA-S.robot",
            "I": "Neura-MAiRA-S-robot.png",
            "IS": "Neura-MAiRA-S.png",
            "B": "Neura",
            "M": "MAiRA S",
            "T": "7 DOF",
            "A": 7,
            "R": 1100,
            "P": 15,
            "W": 51,
            "E": 0.01,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Neuromeka-INDY7-V2": {
            "MT": "R",
            "N": "Neuromeka INDY7 V2",
            "F": "Neuromeka-INDY7-V2.robot",
            "I": "Neuromeka-INDY7-V2-robot.png",
            "IS": "Neuromeka-INDY7-V2.png",
            "B": "Neuromeka",
            "M": "INDY7 V2",
            "T": "6 DOF",
            "A": 6,
            "R": 905,
            "P": 7.0,
            "W": 28,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Neuromeka-INDY7": {
            "MT": "R",
            "N": "Neuromeka INDY7",
            "F": "Neuromeka-INDY7.robot",
            "I": "Neuromeka-INDY7-robot.png",
            "IS": "Neuromeka-INDY7.png",
            "B": "Neuromeka",
            "M": "INDY7",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 7.0,
            "W": 28,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Neuromeka-INDY12": {
            "MT": "R",
            "N": "Neuromeka INDY12",
            "F": "Neuromeka-INDY12.robot",
            "I": "Neuromeka-INDY12-robot.png",
            "IS": "Neuromeka-INDY12.png",
            "B": "Neuromeka",
            "M": "INDY12",
            "T": "6 DOF",
            "A": 6,
            "R": 1700,
            "P": 12.0,
            "W": 57,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Neuromeka-OPTi3": {
            "MT": "R",
            "N": "Neuromeka OPTi3",
            "F": "Neuromeka-OPTi3.robot",
            "I": "Neuromeka-OPTi3-robot.png",
            "IS": "Neuromeka-OPTi3.png",
            "B": "Neuromeka",
            "M": "OPTi3",
            "T": "6 DOF",
            "A": 6,
            "R": 940,
            "P": 3,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Neuromeka-OPTi5": {
            "MT": "R",
            "N": "Neuromeka OPTi5",
            "F": "Neuromeka-OPTi5.robot",
            "I": "Neuromeka-OPTi5-robot.png",
            "IS": "Neuromeka-OPTi5.png",
            "B": "Neuromeka",
            "M": "OPTi5",
            "T": "6 DOF",
            "A": 6,
            "R": 1350,
            "P": 5,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Neuromeka-INDY7-RP2": {
            "MT": "R",
            "N": "Neuromeka INDY7-RP2",
            "F": "Neuromeka-INDY7-RP2.robot",
            "I": "Neuromeka-INDY7-RP2-robot.png",
            "IS": "Neuromeka-INDY7-RP2.png",
            "B": "Neuromeka",
            "M": "INDY7-RP2",
            "T": "7 DOF",
            "A": 7,
            "R": 1300,
            "P": 5.0,
            "W": 30.5,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "NEWKer-NEW2006B": {
            "MT": "R",
            "N": "NEWKer NEW2006B",
            "F": "NEWKer-NEW2006B.robot",
            "I": "NEWKer-NEW2006B-robot.png",
            "IS": "NEWKer-NEW2006B.png",
            "B": "NEWKer",
            "M": "NEW2006B",
            "T": "6 DOF",
            "A": 6,
            "R": 2005,
            "P": 6,
            "W": 232,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Niryo-NED": {
            "MT": "R",
            "N": "Niryo NED",
            "F": "Niryo-NED.robot",
            "I": "Niryo-NED-robot.png",
            "IS": "Niryo-NED.png",
            "B": "Niryo",
            "M": "NED",
            "T": "6 DOF",
            "A": 6,
            "R": 440,
            "P": 0.3,
            "W": 6.5,
            "E": 0.5,
            "AP": [
                "Assembly",
                "Collaborative",
                "Inspection",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Niryo-Ned2": {
            "MT": "R",
            "N": "Niryo Ned2",
            "F": "Niryo-Ned2.robot",
            "I": "Niryo-Ned2-robot.png",
            "IS": "Niryo-Ned2.png",
            "B": "Niryo",
            "M": "Ned2",
            "T": "6 DOF",
            "A": 6,
            "R": 490,
            "P": 0.3,
            "W": 7.0,
            "E": 0.5,
            "AP": [
                "Assembly",
                "Collaborative",
                "Inspection",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Niryo-One": {
            "MT": "R",
            "N": "Niryo One",
            "F": "Niryo-One.robot",
            "I": "Niryo-One-robot.png",
            "IS": "Niryo-One.png",
            "B": "Niryo",
            "M": "One",
            "T": "6 DOF",
            "A": 6,
            "R": 440,
            "P": 0.3,
            "W": 3.2,
            "E": 1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Inspection",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Omron-TM5-700": {
            "MT": "R",
            "N": "Omron TM5-700",
            "F": "Omron-TM5-700.robot",
            "I": "Omron-TM5-700-robot.png",
            "IS": "Omron-TM5-700.png",
            "B": "Omron",
            "M": "TM5-700",
            "T": "6 DOF",
            "A": 6,
            "R": 700,
            "P": 6,
            "W": 22.1,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Omron-TM5-900": {
            "MT": "R",
            "N": "Omron TM5-900",
            "F": "Omron-TM5-900.robot",
            "I": "Omron-TM5-900-robot.png",
            "IS": "Omron-TM5-900.png",
            "B": "Omron",
            "M": "TM5-900",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 4,
            "W": 22.6,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Omron-TM5S": {
            "MT": "R",
            "N": "Omron TM5S",
            "F": "Omron-TM5S.robot",
            "I": "Omron-TM5S-robot.png",
            "IS": "Omron-TM5S.png",
            "B": "Omron",
            "M": "TM5S",
            "T": "6 DOF",
            "A": 6,
            "R": 946,
            "P": 5.0,
            "W": 23.9,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Omron-TM5S-X": {
            "MT": "R",
            "N": "Omron TM5S-X",
            "F": "Omron-TM5S-X.robot",
            "I": "Omron-TM5S-X-robot.png",
            "IS": "Omron-TM5S-X.png",
            "B": "Omron",
            "M": "TM5S-X",
            "T": "6 DOF",
            "A": 6,
            "R": 946,
            "P": 5.0,
            "W": 23.6,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Omron-TM5X-700": {
            "MT": "R",
            "N": "Omron TM5X-700",
            "F": "Omron-TM5X-700.robot",
            "I": "Omron-TM5X-700-robot.png",
            "IS": "Omron-TM5X-700.png",
            "B": "Omron",
            "M": "TM5X-700",
            "T": "6 DOF",
            "A": 6,
            "R": 700,
            "P": 6,
            "W": 21.8,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Omron-TM5X-900": {
            "MT": "R",
            "N": "Omron TM5X-900",
            "F": "Omron-TM5X-900.robot",
            "I": "Omron-TM5X-900-robot.png",
            "IS": "Omron-TM5X-900.png",
            "B": "Omron",
            "M": "TM5X-900",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 4,
            "W": 22.3,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Omron-TM7S": {
            "MT": "R",
            "N": "Omron TM7S",
            "F": "Omron-TM7S.robot",
            "I": "Omron-TM7S-robot.png",
            "IS": "Omron-TM7S.png",
            "B": "Omron",
            "M": "TM7S",
            "T": "6 DOF",
            "A": 6,
            "R": 758,
            "P": 7.0,
            "W": 22.9,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Omron-TM7S-X": {
            "MT": "R",
            "N": "Omron TM7S-X",
            "F": "Omron-TM7S-X.robot",
            "I": "Omron-TM7S-X-robot.png",
            "IS": "Omron-TM7S-X.png",
            "B": "Omron",
            "M": "TM7S-X",
            "T": "6 DOF",
            "A": 6,
            "R": 758,
            "P": 7.0,
            "W": 22.6,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Omron-TM12": {
            "MT": "R",
            "N": "Omron TM12",
            "F": "Omron-TM12.robot",
            "I": "Omron-TM12-robot.png",
            "IS": "Omron-TM12.png",
            "B": "Omron",
            "M": "TM12",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 12,
            "W": 32.8,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Omron-TM12S": {
            "MT": "R",
            "N": "Omron TM12S",
            "F": "Omron-TM12S.robot",
            "I": "Omron-TM12S-robot.png",
            "IS": "Omron-TM12S.png",
            "B": "Omron",
            "M": "TM12S",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 12.0,
            "W": 33.3,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Omron-TM12S-X": {
            "MT": "R",
            "N": "Omron TM12S-X",
            "F": "Omron-TM12S-X.robot",
            "I": "Omron-TM12S-X-robot.png",
            "IS": "Omron-TM12S-X.png",
            "B": "Omron",
            "M": "TM12S-X",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 12.0,
            "W": 33,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Omron-TM12X": {
            "MT": "R",
            "N": "Omron TM12X",
            "F": "Omron-TM12X.robot",
            "I": "Omron-TM12X-robot.png",
            "IS": "Omron-TM12X.png",
            "B": "Omron",
            "M": "TM12X",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 12,
            "W": 32.5,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Omron-TM14": {
            "MT": "R",
            "N": "Omron TM14",
            "F": "Omron-TM14.robot",
            "I": "Omron-TM14-robot.png",
            "IS": "Omron-TM14.png",
            "B": "Omron",
            "M": "TM14",
            "T": "6 DOF",
            "A": 6,
            "R": 1100,
            "P": 14,
            "W": 32.5,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Omron-TM14S": {
            "MT": "R",
            "N": "Omron TM14S",
            "F": "Omron-TM14S.robot",
            "I": "Omron-TM14S-robot.png",
            "IS": "Omron-TM14S.png",
            "B": "Omron",
            "M": "TM14S",
            "T": "6 DOF",
            "A": 6,
            "R": 1100,
            "P": 14.0,
            "W": 33,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Omron-TM14S-X": {
            "MT": "R",
            "N": "Omron TM14S-X",
            "F": "Omron-TM14S-X.robot",
            "I": "Omron-TM14S-X-robot.png",
            "IS": "Omron-TM14S-X.png",
            "B": "Omron",
            "M": "TM14S-X",
            "T": "6 DOF",
            "A": 6,
            "R": 1100,
            "P": 14.0,
            "W": 32.7,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Omron-TM14X": {
            "MT": "R",
            "N": "Omron TM14X",
            "F": "Omron-TM14X.robot",
            "I": "Omron-TM14X-robot.png",
            "IS": "Omron-TM14X.png",
            "B": "Omron",
            "M": "TM14X",
            "T": "6 DOF",
            "A": 6,
            "R": 1100,
            "P": 14,
            "W": 32.2,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Omron-TM25S": {
            "MT": "R",
            "N": "Omron TM25S",
            "F": "Omron-TM25S.robot",
            "I": "Omron-TM25S-robot.png",
            "IS": "Omron-TM25S.png",
            "B": "Omron",
            "M": "TM25S",
            "T": "6 DOF",
            "A": 6,
            "R": 1902,
            "P": 25.0,
            "W": 80.6,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Omron-TM25S-X": {
            "MT": "R",
            "N": "Omron TM25S-X",
            "F": "Omron-TM25S-X.robot",
            "I": "Omron-TM25S-X-robot.png",
            "IS": "Omron-TM25S-X.png",
            "B": "Omron",
            "M": "TM25S-X",
            "T": "6 DOF",
            "A": 6,
            "R": 1902,
            "P": 25.0,
            "W": 80.3,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Omron-TM30S": {
            "MT": "R",
            "N": "Omron TM30S",
            "F": "Omron-TM30S.robot",
            "I": "Omron-TM30S-robot.png",
            "IS": "Omron-TM30S.png",
            "B": "Omron",
            "M": "TM30S",
            "T": "6 DOF",
            "A": 6,
            "R": 1702,
            "P": 30,
            "W": 80.3,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Omron-iX3-565-RX3-2065600": {
            "MT": "R",
            "N": "Omron iX3-565 RX3 2065600",
            "F": "Omron-iX3-565-RX3-2065600.robot",
            "I": "Omron-iX3-565-RX3-2065600-robot.png",
            "IS": "Omron-iX3-565-RX3-2065600.png",
            "B": "Omron",
            "M": "iX3-565 RX3 2065600",
            "T": "Delta",
            "A": 3,
            "R": 565,
            "P": 8,
            "W": 52,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Omron-iX3-565-RX3-2065604": {
            "MT": "R",
            "N": "Omron iX3-565 RX3 2065604",
            "F": "Omron-iX3-565-RX3-2065604.robot",
            "I": "Omron-iX3-565-RX3-2065604-robot.png",
            "IS": "Omron-iX3-565-RX3-2065604.png",
            "B": "Omron",
            "M": "iX3-565 RX3 2065604",
            "T": "Delta",
            "A": 4,
            "R": 565,
            "P": 3,
            "W": 52,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Omron-eCobra-600": {
            "MT": "R",
            "N": "Omron eCobra 600",
            "F": "Omron-eCobra-600.robot",
            "I": "Omron-eCobra-600-robot.png",
            "IS": "Omron-eCobra-600.png",
            "B": "Omron",
            "M": "eCobra 600",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 5.5,
            "W": 41,
            "E": 0.017,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Omron-i4-350L": {
            "MT": "R",
            "N": "Omron i4-350L",
            "F": "Omron-i4-350L.robot",
            "I": "Omron-i4-350L-robot.png",
            "IS": "Omron-i4-350L.png",
            "B": "Omron",
            "M": "i4-350L",
            "T": "SCARA",
            "A": 4,
            "R": 350,
            "P": 5.0,
            "W": 15.08,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Omron-i4-450L": {
            "MT": "R",
            "N": "Omron i4-450L",
            "F": "Omron-i4-450L.robot",
            "I": "Omron-i4-450L-robot.png",
            "IS": "Omron-i4-450L.png",
            "B": "Omron",
            "M": "i4-450L",
            "T": "SCARA",
            "A": 4,
            "R": 450,
            "P": 5.0,
            "W": 15.9,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Omron-i4-550L": {
            "MT": "R",
            "N": "Omron i4-550L",
            "F": "Omron-i4-550L.robot",
            "I": "Omron-i4-550L-robot.png",
            "IS": "Omron-i4-550L.png",
            "B": "Omron",
            "M": "i4-550L",
            "T": "SCARA",
            "A": 4,
            "R": 550,
            "P": 5.0,
            "W": 16.38,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Omron-i4-650H": {
            "MT": "R",
            "N": "Omron i4-650H",
            "F": "Omron-i4-650H.robot",
            "I": "Omron-i4-650H-robot.png",
            "IS": "Omron-i4-650H.png",
            "B": "Omron",
            "M": "i4-650H",
            "T": "SCARA",
            "A": 4,
            "R": 650,
            "P": 15.0,
            "W": 50.4,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Omron-i4-750H": {
            "MT": "R",
            "N": "Omron i4-750H",
            "F": "Omron-i4-750H.robot",
            "I": "Omron-i4-750H-robot.png",
            "IS": "Omron-i4-750H.png",
            "B": "Omron",
            "M": "i4-750H",
            "T": "SCARA",
            "A": 4,
            "R": 750,
            "P": 15.0,
            "W": 50.9,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Omron-i4-850H": {
            "MT": "R",
            "N": "Omron i4-850H",
            "F": "Omron-i4-850H.robot",
            "I": "Omron-i4-850H-robot.png",
            "IS": "Omron-i4-850H.png",
            "B": "Omron",
            "M": "i4-850H",
            "T": "SCARA",
            "A": 4,
            "R": 850,
            "P": 15.0,
            "W": 51.6,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Daihen-OTC-AX-V4": {
            "MT": "R",
            "N": "Daihen OTC AX-V4",
            "F": "Daihen-OTC-AX-V4.robot",
            "I": "Daihen-OTC-AX-V4-robot.png",
            "IS": "Daihen-OTC-AX-V4.png",
            "B": "OTC Daihen",
            "M": "AX-V4",
            "T": "6 DOF",
            "A": 6,
            "R": 1410,
            "P": 4,
            "W": 160,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Daihen-OTC-AX-V6L": {
            "MT": "R",
            "N": "Daihen OTC AX-V6L",
            "F": "Daihen-OTC-AX-V6L.robot",
            "I": "Daihen-OTC-AX-V6L-robot.png",
            "IS": "Daihen-OTC-AX-V6L.png",
            "B": "OTC Daihen",
            "M": "AX-V6L",
            "T": "6 DOF",
            "A": 6,
            "R": 2006,
            "P": 6,
            "W": 250,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Daihen-OTC-FD19-H5": {
            "MT": "R",
            "N": "Daihen OTC FD19-H5",
            "F": "Daihen-OTC-FD19-H5.robot",
            "I": "Daihen-OTC-FD19-H5-robot.png",
            "IS": "Daihen-OTC-FD19-H5.png",
            "B": "OTC Daihen",
            "M": "FD19-H5",
            "T": "6 DOF",
            "A": 6,
            "R": 866,
            "P": 5.0,
            "W": 58,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Daihen-OTC-FD-B4": {
            "MT": "R",
            "N": "Daihen OTC FD-B4",
            "F": "Daihen-OTC-FD-B4.robot",
            "I": "Daihen-OTC-FD-B4-robot.png",
            "IS": "Daihen-OTC-FD-B4.png",
            "B": "OTC Daihen",
            "M": "FD-B4",
            "T": "6 DOF",
            "A": 6,
            "R": 1411,
            "P": 4,
            "W": 154,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Daihen-OTC-FD-B4L": {
            "MT": "R",
            "N": "Daihen OTC FD-B4L",
            "F": "Daihen-OTC-FD-B4L.robot",
            "I": "Daihen-OTC-FD-B4L-robot.png",
            "IS": "Daihen-OTC-FD-B4L.png",
            "B": "OTC Daihen",
            "M": "FD-B4L",
            "T": "6 DOF",
            "A": 6,
            "R": 1411,
            "P": 4,
            "W": 154,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Daihen-OTC-FD-B6L": {
            "MT": "R",
            "N": "Daihen OTC FD-B6L",
            "F": "Daihen-OTC-FD-B6L.robot",
            "I": "Daihen-OTC-FD-B6L-robot.png",
            "IS": "Daihen-OTC-FD-B6L.png",
            "B": "OTC Daihen",
            "M": "FD-B6L",
            "T": "6 DOF",
            "A": 6,
            "R": 2008,
            "P": 6.0,
            "W": 237,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Daihen-OTC-FD-B26": {
            "MT": "R",
            "N": "Daihen OTC FD-B26",
            "F": "Daihen-OTC-FD-B26.robot",
            "I": "Daihen-OTC-FD-B26-robot.png",
            "IS": "Daihen-OTC-FD-B26.png",
            "B": "OTC Daihen",
            "M": "FD-B26",
            "T": "6 DOF",
            "A": 6,
            "R": 1833,
            "P": 26,
            "W": 257,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Daihen-OTC-FD-V6": {
            "MT": "R",
            "N": "Daihen OTC FD-V6",
            "F": "Daihen-OTC-FD-V6.robot",
            "I": "Daihen-OTC-FD-V6-robot.png",
            "IS": "Daihen-OTC-FD-V6.png",
            "B": "OTC Daihen",
            "M": "FD-V6",
            "T": "6 DOF",
            "A": 6,
            "R": 1402,
            "P": 6,
            "W": 144,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Daihen-OTC-FD-V6L": {
            "MT": "R",
            "N": "Daihen OTC FD-V6L",
            "F": "Daihen-OTC-FD-V6L.robot",
            "I": "Daihen-OTC-FD-V6L-robot.png",
            "IS": "Daihen-OTC-FD-V6L.png",
            "B": "OTC Daihen",
            "M": "FD-V6L",
            "T": "6 DOF",
            "A": 6,
            "R": 2006,
            "P": 6,
            "W": 273,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Daihen-OTC-FD-V8": {
            "MT": "R",
            "N": "Daihen OTC FD-V8",
            "F": "Daihen-OTC-FD-V8.robot",
            "I": "Daihen-OTC-FD-V8-robot.png",
            "IS": "Daihen-OTC-FD-V8.png",
            "B": "OTC Daihen",
            "M": "FD-V8",
            "T": "6 DOF",
            "A": 6,
            "R": 1437,
            "P": 8,
            "W": 140,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Daihen-OTC-FD-V80": {
            "MT": "R",
            "N": "Daihen OTC FD-V80",
            "F": "Daihen-OTC-FD-V80.robot",
            "I": "Daihen-OTC-FD-V80-robot.png",
            "IS": "Daihen-OTC-FD-V80.png",
            "B": "OTC Daihen",
            "M": "FD-V80",
            "T": "6 DOF",
            "A": 6,
            "R": 2500,
            "P": 80.0,
            "W": 736,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Daihen-OTC-FD-V166": {
            "MT": "R",
            "N": "Daihen OTC FD-V166",
            "F": "Daihen-OTC-FD-V166.robot",
            "I": "Daihen-OTC-FD-V166-robot.png",
            "IS": "Daihen-OTC-FD-V166.png",
            "B": "OTC Daihen",
            "M": "FD-V166",
            "T": "6 DOF",
            "A": 6,
            "R": 2654,
            "P": 166,
            "W": 1010,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Daihen-OTC-NV8LS2": {
            "MT": "R",
            "N": "Daihen OTC NV8LS2",
            "F": "Daihen-OTC-NV8LS2.robot",
            "I": "Daihen-OTC-NV8LS2-robot.png",
            "IS": "Daihen-OTC-NV8LS2.png",
            "B": "OTC Daihen",
            "M": "NV8LS2",
            "T": "6 DOF",
            "A": 6,
            "R": 1910,
            "P": 8,
            "W": 273,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Daihen-OTC-FD-NV6Ls": {
            "MT": "R",
            "N": "Daihen OTC FD-NV6Ls",
            "F": "Daihen-OTC-FD-NV6Ls.robot",
            "I": "Daihen-OTC-FD-NV6Ls-robot.png",
            "IS": "Daihen-OTC-FD-NV6Ls.png",
            "B": "OTC Daihen",
            "M": "FD-NV6Ls",
            "T": "7 DOF",
            "A": 7,
            "R": 2006,
            "P": 6,
            "W": 350,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Daihen-OTC-FD-V6Ls": {
            "MT": "R",
            "N": "Daihen OTC FD-V6Ls",
            "F": "Daihen-OTC-FD-V6Ls.robot",
            "I": "Daihen-OTC-FD-V6Ls-robot.png",
            "IS": "Daihen-OTC-FD-V6Ls.png",
            "B": "OTC Daihen",
            "M": "FD-V6Ls",
            "T": "7 DOF",
            "A": 7,
            "R": 2006,
            "P": 6,
            "W": 316,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Daihen-OTC-FD-V6S": {
            "MT": "R",
            "N": "Daihen OTC FD-V6S",
            "F": "Daihen-OTC-FD-V6S.robot",
            "I": "Daihen-OTC-FD-V6S-robot.png",
            "IS": "Daihen-OTC-FD-V6S.png",
            "B": "OTC Daihen",
            "M": "FD-V6S",
            "T": "7 DOF",
            "A": 7,
            "R": 2006,
            "P": 6,
            "W": 178,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Panasonic-TA-1000": {
            "MT": "R",
            "N": "Panasonic TA-1000",
            "F": "Panasonic-TA-1000.robot",
            "I": "Panasonic-TA-1000-robot.png",
            "IS": "Panasonic-TA-1000.png",
            "B": "Panasonic",
            "M": "TA-1000",
            "T": "6 DOF",
            "A": 6,
            "R": 1068,
            "P": 6,
            "W": 145,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Panasonic-TA-1400": {
            "MT": "R",
            "N": "Panasonic TA-1400",
            "F": "Panasonic-TA-1400.robot",
            "I": "Panasonic-TA-1400-robot.png",
            "IS": "Panasonic-TA-1400.png",
            "B": "Panasonic",
            "M": "TA-1400",
            "T": "6 DOF",
            "A": 6,
            "R": 1374,
            "P": 6,
            "W": 161,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Panasonic-TA-1600": {
            "MT": "R",
            "N": "Panasonic TA-1600",
            "F": "Panasonic-TA-1600.robot",
            "I": "Panasonic-TA-1600-robot.png",
            "IS": "Panasonic-TA-1600.png",
            "B": "Panasonic",
            "M": "TA-1600",
            "T": "6 DOF",
            "A": 6,
            "R": 1598,
            "P": 8,
            "W": 203,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Panasonic-TM-1400": {
            "MT": "R",
            "N": "Panasonic TM-1400",
            "F": "Panasonic-TM-1400.robot",
            "I": "Panasonic-TM-1400-robot.png",
            "IS": "Panasonic-TM-1400.png",
            "B": "Panasonic",
            "M": "TM-1400",
            "T": "6 DOF",
            "A": 6,
            "R": 1437,
            "P": 6,
            "W": 170,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Panasonic-TM-1800": {
            "MT": "R",
            "N": "Panasonic TM-1800",
            "F": "Panasonic-TM-1800.robot",
            "I": "Panasonic-TM-1800-robot.png",
            "IS": "Panasonic-TM-1800.png",
            "B": "Panasonic",
            "M": "TM-1800",
            "T": "6 DOF",
            "A": 6,
            "R": 1809,
            "P": 8,
            "W": 215,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Panasonic-TM-2000": {
            "MT": "R",
            "N": "Panasonic TM-2000",
            "F": "Panasonic-TM-2000.robot",
            "I": "Panasonic-TM-2000-robot.png",
            "IS": "Panasonic-TM-2000.png",
            "B": "Panasonic",
            "M": "TM-2000",
            "T": "6 DOF",
            "A": 6,
            "R": 2011,
            "P": 6.0,
            "W": 217,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Peitian-AIR10-1210": {
            "MT": "R",
            "N": "Peitian AIR10-1210",
            "F": "Peitian-AIR10-1210.robot",
            "I": "Peitian-AIR10-1210-robot.png",
            "IS": "Peitian-AIR10-1210.png",
            "B": "Peitian",
            "M": "AIR10-1210",
            "T": "6 DOF",
            "A": 6,
            "R": 1210,
            "P": 10.0,
            "W": 87,
            "E": 0.035,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Productive-Robotics-OB7": {
            "MT": "R",
            "N": "Productive Robotics OB7",
            "F": "Productive-Robotics-OB7.robot",
            "I": "Productive-Robotics-OB7-robot.png",
            "IS": "Productive-Robotics-OB7.png",
            "B": "Productive Robotics",
            "M": "OB7",
            "T": "7 DOF",
            "A": 7,
            "R": 1000,
            "P": 5.0,
            "W": 22,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Productive-Robotics-OB7-Max-8": {
            "MT": "R",
            "N": "Productive Robotics OB7-Max 8",
            "F": "Productive-Robotics-OB7-Max-8.robot",
            "I": "Productive-Robotics-OB7-Max-8-robot.png",
            "IS": "Productive-Robotics-OB7-Max-8.png",
            "B": "Productive Robotics",
            "M": "OB7-Max 8",
            "T": "7 DOF",
            "A": 7,
            "R": 1700,
            "P": 8,
            "W": 58,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "PULOON-Symphony-5": {
            "MT": "R",
            "N": "PULOON Symphony 5",
            "F": "PULOON-Symphony-5.robot",
            "I": "PULOON-Symphony-5-robot.png",
            "IS": "PULOON-Symphony-5.png",
            "B": "PULOON",
            "M": "Symphony 5",
            "T": "6 DOF",
            "A": 6,
            "R": 850,
            "P": 5.0,
            "W": 21,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "PULOON-Symphony-10": {
            "MT": "R",
            "N": "PULOON Symphony 10",
            "F": "PULOON-Symphony-10.robot",
            "I": "PULOON-Symphony-10-robot.png",
            "IS": "PULOON-Symphony-10.png",
            "B": "PULOON",
            "M": "Symphony 10",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 10.0,
            "W": 33,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "PULOON-Symphony-15": {
            "MT": "R",
            "N": "PULOON Symphony 15",
            "F": "PULOON-Symphony-15.robot",
            "I": "PULOON-Symphony-15-robot.png",
            "IS": "PULOON-Symphony-15.png",
            "B": "PULOON",
            "M": "Symphony 15",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 15.0,
            "W": 50,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "PUMA-560": {
            "MT": "R",
            "N": "PUMA 560",
            "F": "PUMA-560.robot",
            "I": "PUMA-560-robot.png",
            "IS": "PUMA-560.png",
            "B": "PUMA",
            "M": "560",
            "T": "6 DOF",
            "A": 6,
            "R": 864,
            "P": 2.5,
            "W": 54.5,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "QJAR-QJR6-3": {
            "MT": "R",
            "N": "QJAR QJR6-3",
            "F": "QJAR-QJR6-3.robot",
            "I": "QJAR-QJR6-3-robot.png",
            "IS": "QJAR-QJR6-3.png",
            "B": "QJAR",
            "M": "QJR6-3",
            "T": "6 DOF",
            "A": 6,
            "R": 2001,
            "P": 6.0,
            "W": 255,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "QJAR-QJR6-1400H": {
            "MT": "R",
            "N": "QJAR QJR6-1400H",
            "F": "QJAR-QJR6-1400H.robot",
            "I": "QJAR-QJR6-1400H-robot.png",
            "IS": "QJAR-QJR6-1400H.png",
            "B": "QJAR",
            "M": "QJR6-1400H",
            "T": "6 DOF",
            "A": 6,
            "R": 1456,
            "P": 6.0,
            "W": 150,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "QJAR-QJR6-2000H": {
            "MT": "R",
            "N": "QJAR QJR6-2000H",
            "F": "QJAR-QJR6-2000H.robot",
            "I": "QJAR-QJR6-2000H-robot.png",
            "IS": "QJAR-QJR6-2000H.png",
            "B": "QJAR",
            "M": "QJR6-2000H",
            "T": "6 DOF",
            "A": 6,
            "R": 2014,
            "P": 6.0,
            "W": 230,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "QJAR-QJR20-1600": {
            "MT": "R",
            "N": "QJAR QJR20-1600",
            "F": "QJAR-QJR20-1600.robot",
            "I": "QJAR-QJR20-1600-robot.png",
            "IS": "QJAR-QJR20-1600.png",
            "B": "QJAR",
            "M": "QJR20-1600",
            "T": "6 DOF",
            "A": 6,
            "R": 1671,
            "P": 20,
            "W": 270,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "QJAR-QJR70-2000": {
            "MT": "R",
            "N": "QJAR QJR70-2000",
            "F": "QJAR-QJR70-2000.robot",
            "I": "QJAR-QJR70-2000-robot.png",
            "IS": "QJAR-QJR70-2000.png",
            "B": "QJAR",
            "M": "QJR70-2000",
            "T": "6 DOF",
            "A": 6,
            "R": 2012,
            "P": 70,
            "W": 590,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "QJAR-QJRH4-1A": {
            "MT": "R",
            "N": "QJAR QJRH4-1A",
            "F": "QJAR-QJRH4-1A.robot",
            "I": "QJAR-QJRH4-1A-robot.png",
            "IS": "QJAR-QJRH4-1A.png",
            "B": "QJAR",
            "M": "QJRH4-1A",
            "T": "6 DOF",
            "A": 6,
            "R": 1410.5,
            "P": 4.0,
            "W": 150,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "RB3-630ES": {
            "MT": "R",
            "N": "RB3-630ES",
            "F": "RB3-630ES.robot",
            "I": "RB3-630ES-robot.png",
            "IS": "RB3-630ES.png",
            "B": "Rainbow Robotics",
            "M": "RB3-630ES",
            "T": "6 DOF",
            "A": 6,
            "R": 630,
            "P": 3,
            "W": 11,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "RB3-1200": {
            "MT": "R",
            "N": "RB3-1200",
            "F": "RB3-1200.robot",
            "I": "RB3-1200-robot.png",
            "IS": "RB3-1200.png",
            "B": "Rainbow Robotics",
            "M": "RB3-1200",
            "T": "6 DOF",
            "A": 6,
            "R": 1200,
            "P": 3,
            "W": 40,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "RB5-850": {
            "MT": "R",
            "N": "RB5-850",
            "F": "RB5-850.robot",
            "I": "RB5-850-robot.png",
            "IS": "RB5-850.png",
            "B": "Rainbow Robotics",
            "M": "RB5-850",
            "T": "6 DOF",
            "A": 6,
            "R": 850,
            "P": 5,
            "W": 21,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "RB5-850A": {
            "MT": "R",
            "N": "RB5-850A",
            "F": "RB5-850A.robot",
            "I": "RB5-850A-robot.png",
            "IS": "RB5-850A.png",
            "B": "Rainbow Robotics",
            "M": "RB5-850A",
            "T": "6 DOF",
            "A": 6,
            "R": 850,
            "P": 5,
            "W": 21,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "RB6-920ES": {
            "MT": "R",
            "N": "RB6-920ES",
            "F": "RB6-920ES.robot",
            "I": "RB6-920ES-robot.png",
            "IS": "RB6-920ES.png",
            "B": "Rainbow Robotics",
            "M": "RB6-920ES",
            "T": "6 DOF",
            "A": 6,
            "R": 920,
            "P": 6,
            "W": 22,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "RB10-1300": {
            "MT": "R",
            "N": "RB10-1300",
            "F": "RB10-1300.robot",
            "I": "RB10-1300-robot.png",
            "IS": "RB10-1300.png",
            "B": "Rainbow Robotics",
            "M": "RB10-1300",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 10,
            "W": 32,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "RB16-900E": {
            "MT": "R",
            "N": "RB16-900E",
            "F": "RB16-900E.robot",
            "I": "RB16-900E-robot.png",
            "IS": "RB16-900E.png",
            "B": "Rainbow Robotics",
            "M": "RB16-900E",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 16.0,
            "W": 32,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "RB20-1900ES": {
            "MT": "R",
            "N": "RB20-1900ES",
            "F": "RB20-1900ES.robot",
            "I": "RB20-1900ES-robot.png",
            "IS": "RB20-1900ES.png",
            "B": "Rainbow Robotics",
            "M": "RB20-1900ES",
            "T": "6 DOF",
            "A": 6,
            "R": 1900,
            "P": 20,
            "W": 75,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "RealMan-ECO65-6F": {
            "MT": "R",
            "N": "RealMan ECO65-6F",
            "F": "RealMan-ECO65-6F.robot",
            "I": "RealMan-ECO65-6F-robot.png",
            "IS": "RealMan-ECO65-6F.png",
            "B": "RealMan",
            "M": "ECO65-6F",
            "T": "6 DOF",
            "A": 6,
            "R": 638.5,
            "P": 5.0,
            "W": 7.9,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "RealMan-ECO65-B": {
            "MT": "R",
            "N": "RealMan ECO65-B",
            "F": "RealMan-ECO65-B.robot",
            "I": "RealMan-ECO65-B-robot.png",
            "IS": "RealMan-ECO65-B.png",
            "B": "RealMan",
            "M": "ECO65-B",
            "T": "6 DOF",
            "A": 6,
            "R": 610,
            "P": 5.0,
            "W": 7.8,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "RealMan-RML63-6F": {
            "MT": "R",
            "N": "RealMan RML63-6F",
            "F": "RealMan-RML63-6F.robot",
            "I": "RealMan-RML63-6F-robot.png",
            "IS": "RealMan-RML63-6F.png",
            "B": "RealMan",
            "M": "RML63-6F",
            "T": "6 DOF",
            "A": 6,
            "R": 928.5,
            "P": 3.0,
            "W": 10.1,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "RealMan-RML63-B": {
            "MT": "R",
            "N": "RealMan RML63-B",
            "F": "RealMan-RML63-B.robot",
            "I": "RealMan-RML63-B-robot.png",
            "IS": "RealMan-RML63-B.png",
            "B": "RealMan",
            "M": "RML63-B",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 3.0,
            "W": 10,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "RealMan-GEN72-B": {
            "MT": "R",
            "N": "RealMan GEN72-B",
            "F": "RealMan-GEN72-B.robot",
            "I": "RealMan-GEN72-B-robot.png",
            "IS": "RealMan-GEN72-B.png",
            "B": "RealMan",
            "M": "GEN72-B",
            "T": "7 DOF",
            "A": 7,
            "R": 600,
            "P": 2.0,
            "W": 6.6,
            "E": 1.0,
            "AP": [
                "Assembly",
                "Collaborative",
                "Inspection",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "RealMan-RM65-6F": {
            "MT": "R",
            "N": "RealMan RM65-6F",
            "F": "RealMan-RM65-6F.robot",
            "I": "RealMan-RM65-6F-robot.png",
            "IS": "RealMan-RM65-6F.png",
            "B": "RealMan",
            "M": "RM65-6F",
            "T": "7 DOF",
            "A": 7,
            "R": 638.5,
            "P": 5.0,
            "W": 7.3,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "RealMan-RM65-B": {
            "MT": "R",
            "N": "RealMan RM65-B",
            "F": "RealMan-RM65-B.robot",
            "I": "RealMan-RM65-B-robot.png",
            "IS": "RealMan-RM65-B.png",
            "B": "RealMan",
            "M": "RM65-B",
            "T": "7 DOF",
            "A": 7,
            "R": 610,
            "P": 5.0,
            "W": 7.2,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "RealMan-RM75-6F": {
            "MT": "R",
            "N": "RealMan RM75-6F",
            "F": "RealMan-RM75-6F.robot",
            "I": "RealMan-RM75-6F-robot.png",
            "IS": "RealMan-RM75-6F.png",
            "B": "RealMan",
            "M": "RM75-6F",
            "T": "7 DOF",
            "A": 7,
            "R": 638.5,
            "P": 5.0,
            "W": 7.9,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Reis-RV10-6": {
            "MT": "R",
            "N": "Reis RV10-6",
            "F": "Reis-RV10-6.robot",
            "I": "Reis-RV10-6-robot.png",
            "IS": "Reis-RV10-6.png",
            "B": "Reis",
            "M": "RV10-6",
            "T": "6 DOF",
            "A": 6,
            "R": 1080,
            "P": 6,
            "W": 235,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Reis-RV130-60": {
            "MT": "R",
            "N": "Reis RV130-60",
            "F": "Reis-RV130-60.robot",
            "I": "Reis-RV130-60-robot.png",
            "IS": "Reis-RV130-60.png",
            "B": "Reis",
            "M": "RV130-60",
            "T": "6 DOF",
            "A": 6,
            "R": 2800,
            "P": 60,
            "W": 1340,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "RoboDK-RDK-1100": {
            "MT": "R",
            "N": "RoboDK RDK-1100",
            "F": "RoboDK-RDK-1100.robot",
            "I": "RoboDK-RDK-1100-robot.png",
            "IS": "RoboDK-RDK-1100.png",
            "B": "RoboDK",
            "M": "RDK-1100",
            "T": "6 DOF",
            "A": 6,
            "R": 1100,
            "P": 10,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "RoboDK-RDK-1440": {
            "MT": "R",
            "N": "RoboDK RDK-1440",
            "F": "RoboDK-RDK-1440.robot",
            "I": "RoboDK-RDK-1440-robot.png",
            "IS": "RoboDK-RDK-1440.png",
            "B": "RoboDK",
            "M": "RDK-1440",
            "T": "6 DOF",
            "A": 6,
            "R": 1440,
            "P": 10,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "RoboDK-RDK-2200": {
            "MT": "R",
            "N": "RoboDK RDK-2200",
            "F": "RoboDK-RDK-2200.robot",
            "I": "RoboDK-RDK-2200-robot.png",
            "IS": "RoboDK-RDK-2200.png",
            "B": "RoboDK",
            "M": "RDK-2200",
            "T": "6 DOF",
            "A": 6,
            "R": 2200,
            "P": 50,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "RoboDK-RDK-COBOT-1200": {
            "MT": "R",
            "N": "RoboDK RDK-COBOT-1200",
            "F": "RoboDK-RDK-COBOT-1200.robot",
            "I": "RoboDK-RDK-COBOT-1200-robot.png",
            "IS": "RoboDK-RDK-COBOT-1200.png",
            "B": "RoboDK",
            "M": "RDK-COBOT-1200",
            "T": "6 DOF",
            "A": 6,
            "R": 1200,
            "P": 10,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "RoboDK-RDK-2100-PA": {
            "MT": "R",
            "N": "RoboDK RDK-2100-PA",
            "F": "RoboDK-RDK-2100-PA.robot",
            "I": "RoboDK-RDK-2100-PA-robot.png",
            "IS": "RoboDK-RDK-2100-PA.png",
            "B": "RoboDK",
            "M": "RDK-2100-PA",
            "T": "Palletizing",
            "A": 4,
            "R": 2100,
            "P": 100,
            "E": 0.05,
            "AP": [
                "Palletizing"
            ]
        },
        "RoboDK-RDK-SCARA-750": {
            "MT": "R",
            "N": "RoboDK RDK-SCARA-750",
            "F": "RoboDK-RDK-SCARA-750.robot",
            "I": "RoboDK-RDK-SCARA-750-robot.png",
            "IS": "RoboDK-RDK-SCARA-750.png",
            "B": "RoboDK",
            "M": "RDK-SCARA-750",
            "T": "SCARA",
            "A": 4,
            "R": 750,
            "P": 2.0,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Robostar-RA004": {
            "MT": "R",
            "N": "Robostar RA004",
            "F": "Robostar-RA004.robot",
            "I": "Robostar-RA004-robot.png",
            "IS": "Robostar-RA004.png",
            "B": "Robostar",
            "M": "RA004",
            "T": "6 DOF",
            "A": 6,
            "R": 510,
            "P": 4,
            "W": 27,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Robostar-RA007": {
            "MT": "R",
            "N": "Robostar RA007",
            "F": "Robostar-RA007.robot",
            "I": "Robostar-RA007-robot.png",
            "IS": "Robostar-RA007.png",
            "B": "Robostar",
            "M": "RA007",
            "T": "6 DOF",
            "A": 6,
            "R": 930,
            "P": 7,
            "W": 38,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Robostar-RA012": {
            "MT": "R",
            "N": "Robostar RA012",
            "F": "Robostar-RA012.robot",
            "I": "Robostar-RA012-robot.png",
            "IS": "Robostar-RA012.png",
            "B": "Robostar",
            "M": "RA012",
            "T": "6 DOF",
            "A": 6,
            "R": 930,
            "P": 12,
            "W": 27,
            "E": 0.06,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Robotphoenix-BAT600M-E3": {
            "MT": "R",
            "N": "Robotphoenix BAT600M-E3",
            "F": "Robotphoenix-BAT600M-E3.robot",
            "I": "Robotphoenix-BAT600M-E3-robot.png",
            "IS": "Robotphoenix-BAT600M-E3.png",
            "B": "Robotphoenix",
            "M": "BAT600M-E3",
            "T": "Delta",
            "A": 4,
            "R": 600,
            "P": 3,
            "W": 60,
            "E": 0.08,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Robotphoenix-BAT800M-E3": {
            "MT": "R",
            "N": "Robotphoenix BAT800M-E3",
            "F": "Robotphoenix-BAT800M-E3.robot",
            "I": "Robotphoenix-BAT800M-E3-robot.png",
            "IS": "Robotphoenix-BAT800M-E3.png",
            "B": "Robotphoenix",
            "M": "BAT800M-E3",
            "T": "Delta",
            "A": 4,
            "R": 800,
            "P": 3,
            "W": 62,
            "E": 0.08,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Robotphoenix-BAT800-S3": {
            "MT": "R",
            "N": "Robotphoenix BAT800-S3",
            "F": "Robotphoenix-BAT800-S3.robot",
            "I": "Robotphoenix-BAT800-S3-robot.png",
            "IS": "Robotphoenix-BAT800-S3.png",
            "B": "Robotphoenix",
            "M": "BAT800-S3",
            "T": "Delta",
            "A": 4,
            "R": 800,
            "P": 3,
            "W": 70,
            "E": 0.08,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Robotphoenix-BAT1100M-E3": {
            "MT": "R",
            "N": "Robotphoenix BAT1100M-E3",
            "F": "Robotphoenix-BAT1100M-E3.robot",
            "I": "Robotphoenix-BAT1100M-E3-robot.png",
            "IS": "Robotphoenix-BAT1100M-E3.png",
            "B": "Robotphoenix",
            "M": "BAT1100M-E3",
            "T": "Delta",
            "A": 4,
            "R": 1100,
            "P": 3,
            "W": 63,
            "E": 0.08,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Robotphoenix-BAT1100-S3": {
            "MT": "R",
            "N": "Robotphoenix BAT1100-S3",
            "F": "Robotphoenix-BAT1100-S3.robot",
            "I": "Robotphoenix-BAT1100-S3-robot.png",
            "IS": "Robotphoenix-BAT1100-S3.png",
            "B": "Robotphoenix",
            "M": "BAT1100-S3",
            "T": "Delta",
            "A": 4,
            "R": 1100,
            "P": 3,
            "W": 60,
            "E": 0.08,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Robotphoenix-BAT1300-S6": {
            "MT": "R",
            "N": "Robotphoenix BAT1300-S6",
            "F": "Robotphoenix-BAT1300-S6.robot",
            "I": "Robotphoenix-BAT1300-S6-robot.png",
            "IS": "Robotphoenix-BAT1300-S6.png",
            "B": "Robotphoenix",
            "M": "BAT1300-S6",
            "T": "Delta",
            "A": 4,
            "R": 1300,
            "P": 6,
            "W": 100,
            "E": 0.08,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Robotphoenix-BAT1600-S6": {
            "MT": "R",
            "N": "Robotphoenix BAT1600-S6",
            "F": "Robotphoenix-BAT1600-S6.robot",
            "I": "Robotphoenix-BAT1600-S6-robot.png",
            "IS": "Robotphoenix-BAT1600-S6.png",
            "B": "Robotphoenix",
            "M": "BAT1600-S6",
            "T": "Delta",
            "A": 4,
            "R": 1600,
            "P": 6,
            "W": 155,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Robotphoenix-BAT2000M-S15": {
            "MT": "R",
            "N": "Robotphoenix BAT2000M-S15",
            "F": "Robotphoenix-BAT2000M-S15.robot",
            "I": "Robotphoenix-BAT2000M-S15-robot.png",
            "IS": "Robotphoenix-BAT2000M-S15.png",
            "B": "Robotphoenix",
            "M": "BAT2000M-S15",
            "T": "Delta",
            "A": 4,
            "R": 2000,
            "P": 15,
            "W": 220,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Robotphoenix-Python450-B6": {
            "MT": "R",
            "N": "Robotphoenix Python450-B6",
            "F": "Robotphoenix-Python450-B6.robot",
            "I": "Robotphoenix-Python450-B6-robot.png",
            "IS": "Robotphoenix-Python450-B6.png",
            "B": "Robotphoenix",
            "M": "Python450-B6",
            "T": "SCARA",
            "A": 4,
            "R": 450,
            "P": 6.0,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Robotphoenix-Python550-B6": {
            "MT": "R",
            "N": "Robotphoenix Python550-B6",
            "F": "Robotphoenix-Python550-B6.robot",
            "I": "Robotphoenix-Python550-B6-robot.png",
            "IS": "Robotphoenix-Python550-B6.png",
            "B": "Robotphoenix",
            "M": "Python550-B6",
            "T": "SCARA",
            "A": 4,
            "R": 550,
            "P": 6.0,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Robotphoenix-Python550F-B3": {
            "MT": "R",
            "N": "Robotphoenix Python550F-B3",
            "F": "Robotphoenix-Python550F-B3.robot",
            "I": "Robotphoenix-Python550F-B3-robot.png",
            "IS": "Robotphoenix-Python550F-B3.png",
            "B": "Robotphoenix",
            "M": "Python550F-B3",
            "T": "SCARA",
            "A": 4,
            "R": 550,
            "P": 3.0,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Robotphoenix-Python650-B6": {
            "MT": "R",
            "N": "Robotphoenix Python650-B6",
            "F": "Robotphoenix-Python650-B6.robot",
            "I": "Robotphoenix-Python650-B6-robot.png",
            "IS": "Robotphoenix-Python650-B6.png",
            "B": "Robotphoenix",
            "M": "Python650-B6",
            "T": "SCARA",
            "A": 4,
            "R": 650,
            "P": 6.0,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Robotphoenix-Python800-B10": {
            "MT": "R",
            "N": "Robotphoenix Python800-B10",
            "F": "Robotphoenix-Python800-B10.robot",
            "I": "Robotphoenix-Python800-B10-robot.png",
            "IS": "Robotphoenix-Python800-B10.png",
            "B": "Robotphoenix",
            "M": "Python800-B10",
            "T": "SCARA",
            "A": 4,
            "R": 800,
            "P": 10.0,
            "E": 0.025,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Rokae-CR7-C": {
            "MT": "R",
            "N": "Rokae CR7-C",
            "F": "Rokae-CR7-C.robot",
            "I": "Rokae-CR7-C-robot.png",
            "IS": "Rokae-CR7-C.png",
            "B": "Rokae",
            "M": "CR7-C",
            "T": "6 DOF",
            "A": 6,
            "R": 988,
            "P": 7,
            "W": 25,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Rokae-CR12": {
            "MT": "R",
            "N": "Rokae CR12",
            "F": "Rokae-CR12.robot",
            "I": "Rokae-CR12-robot.png",
            "IS": "Rokae-CR12.png",
            "B": "Rokae",
            "M": "CR12",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 12.0,
            "W": 43,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Rokae-CR12-C": {
            "MT": "R",
            "N": "Rokae CR12-C",
            "F": "Rokae-CR12-C.robot",
            "I": "Rokae-CR12-C-robot.png",
            "IS": "Rokae-CR12-C.png",
            "B": "Rokae",
            "M": "CR12-C",
            "T": "6 DOF",
            "A": 6,
            "R": 1434,
            "P": 12,
            "W": 41,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Rokae-CR18-C": {
            "MT": "R",
            "N": "Rokae CR18-C",
            "F": "Rokae-CR18-C.robot",
            "I": "Rokae-CR18-C-robot.png",
            "IS": "Rokae-CR18-C.png",
            "B": "Rokae",
            "M": "CR18-C",
            "T": "6 DOF",
            "A": 6,
            "R": 1062,
            "P": 18.0,
            "W": 38,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Rokae-CR20": {
            "MT": "R",
            "N": "Rokae CR20",
            "F": "Rokae-CR20.robot",
            "I": "Rokae-CR20-robot.png",
            "IS": "Rokae-CR20.png",
            "B": "Rokae",
            "M": "CR20",
            "T": "6 DOF",
            "A": 6,
            "R": 1798,
            "P": 20,
            "W": 75,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Rokae-CR20-17-2-0C-5": {
            "MT": "R",
            "N": "Rokae CR20-17/2.0C-5",
            "F": "Rokae-CR20-17-2-0C-5.robot",
            "I": "Rokae-CR20-17-2-0C-5-robot.png",
            "IS": "Rokae-CR20-17-2-0C-5.png",
            "B": "Rokae",
            "M": "CR20-17/2.0C-5",
            "T": "6 DOF",
            "A": 6,
            "R": 2047,
            "P": 17.0,
            "W": 71,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Rokae-CR20-25-1-8C-5": {
            "MT": "R",
            "N": "Rokae CR20-25/1.8C-5",
            "F": "Rokae-CR20-25-1-8C-5.robot",
            "I": "Rokae-CR20-25-1-8C-5-robot.png",
            "IS": "Rokae-CR20-25-1-8C-5.png",
            "B": "Rokae",
            "M": "CR20-25/1.8C-5",
            "T": "6 DOF",
            "A": 6,
            "R": 1798,
            "P": 25.0,
            "W": 69,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Rokae-CR20-C": {
            "MT": "R",
            "N": "Rokae CR20-C",
            "F": "Rokae-CR20-C.robot",
            "I": "Rokae-CR20-C-robot.png",
            "IS": "Rokae-CR20-C.png",
            "B": "Rokae",
            "M": "CR20-C",
            "T": "6 DOF",
            "A": 6,
            "R": 1798,
            "P": 20.0,
            "W": 71,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Rokae-CR35-35-2-2C": {
            "MT": "R",
            "N": "Rokae CR35-35/2.2C",
            "F": "Rokae-CR35-35-2-2C.robot",
            "I": "Rokae-CR35-35-2-2C-robot.png",
            "IS": "Rokae-CR35-35-2-2C.png",
            "B": "Rokae",
            "M": "CR35-35/2.2C",
            "T": "6 DOF",
            "A": 6,
            "R": 2246,
            "P": 35.0,
            "W": 165,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Rokae-CR35-45-1-9C": {
            "MT": "R",
            "N": "Rokae CR35-45/1.9C",
            "F": "Rokae-CR35-45-1-9C.robot",
            "I": "Rokae-CR35-45-1-9C-robot.png",
            "IS": "Rokae-CR35-45-1-9C.png",
            "B": "Rokae",
            "M": "CR35-45/1.9C",
            "T": "6 DOF",
            "A": 6,
            "R": 1947,
            "P": 45.0,
            "W": 161,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Rokae-NB12-12-1-4": {
            "MT": "R",
            "N": "Rokae NB12-12/1.4",
            "F": "Rokae-NB12-12-1-4.robot",
            "I": "Rokae-NB12-12-1-4-robot.png",
            "IS": "Rokae-NB12-12-1-4.png",
            "B": "Rokae",
            "M": "NB12-12/1.4",
            "T": "6 DOF",
            "A": 6,
            "R": 1442,
            "P": 12,
            "W": 115,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Rokae-NB25-20-2-0": {
            "MT": "R",
            "N": "Rokae NB25-20/2.0",
            "F": "Rokae-NB25-20-2-0.robot",
            "I": "Rokae-NB25-20-2-0-robot.png",
            "IS": "Rokae-NB25-20-2-0.png",
            "B": "Rokae",
            "M": "NB25-20/2.0",
            "T": "6 DOF",
            "A": 6,
            "R": 2013,
            "P": 20.0,
            "W": 264,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Rokae-SR3C": {
            "MT": "R",
            "N": "Rokae SR3C",
            "F": "Rokae-SR3C.robot",
            "I": "Rokae-SR3C-robot.png",
            "IS": "Rokae-SR3C.png",
            "B": "Rokae",
            "M": "SR3C",
            "T": "6 DOF",
            "A": 6,
            "R": 705,
            "P": 3,
            "W": 13.8,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Rokae-SR4-C": {
            "MT": "R",
            "N": "Rokae SR4-C",
            "F": "Rokae-SR4-C.robot",
            "I": "Rokae-SR4-C-robot.png",
            "IS": "Rokae-SR4-C.png",
            "B": "Rokae",
            "M": "SR4-C",
            "T": "6 DOF",
            "A": 6,
            "R": 919,
            "P": 4.0,
            "W": 16.5,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Rokae-XB4": {
            "MT": "R",
            "N": "Rokae XB4",
            "F": "Rokae-XB4.robot",
            "I": "Rokae-XB4-robot.png",
            "IS": "Rokae-XB4.png",
            "B": "Rokae",
            "M": "XB4",
            "T": "6 DOF",
            "A": 6,
            "R": 596,
            "P": 4,
            "W": 32,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Rokae-XB6": {
            "MT": "R",
            "N": "Rokae XB6",
            "F": "Rokae-XB6.robot",
            "I": "Rokae-XB6-robot.png",
            "IS": "Rokae-XB6.png",
            "B": "Rokae",
            "M": "XB6",
            "T": "6 DOF",
            "A": 6,
            "R": 716.8,
            "P": 6,
            "W": 40,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Rokae-XB7": {
            "MT": "R",
            "N": "Rokae XB7",
            "F": "Rokae-XB7.robot",
            "I": "Rokae-XB7-robot.png",
            "IS": "Rokae-XB7.png",
            "B": "Rokae",
            "M": "XB7",
            "T": "6 DOF",
            "A": 6,
            "R": 707,
            "P": 7,
            "W": 50,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Rokae-XB7L": {
            "MT": "R",
            "N": "Rokae XB7L",
            "F": "Rokae-XB7L.robot",
            "I": "Rokae-XB7L-robot.png",
            "IS": "Rokae-XB7L.png",
            "B": "Rokae",
            "M": "XB7L",
            "T": "6 DOF",
            "A": 6,
            "R": 906,
            "P": 7,
            "W": 52,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Rokae-XB7Lh": {
            "MT": "R",
            "N": "Rokae XB7Lh",
            "F": "Rokae-XB7Lh.robot",
            "I": "Rokae-XB7Lh-robot.png",
            "IS": "Rokae-XB7Lh.png",
            "B": "Rokae",
            "M": "XB7Lh",
            "T": "6 DOF",
            "A": 6,
            "R": 906,
            "P": 7,
            "W": 52,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Rokae-XB7Ls": {
            "MT": "R",
            "N": "Rokae XB7Ls",
            "F": "Rokae-XB7Ls.robot",
            "I": "Rokae-XB7Ls-robot.png",
            "IS": "Rokae-XB7Ls.png",
            "B": "Rokae",
            "M": "XB7Ls",
            "T": "6 DOF",
            "A": 6,
            "R": 906,
            "P": 7,
            "W": 52,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Rokae-XB7s": {
            "MT": "R",
            "N": "Rokae XB7s",
            "F": "Rokae-XB7s.robot",
            "I": "Rokae-XB7s-robot.png",
            "IS": "Rokae-XB7s.png",
            "B": "Rokae",
            "M": "XB7s",
            "T": "6 DOF",
            "A": 6,
            "R": 707,
            "P": 7,
            "W": 50,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Rokae-XB7XL": {
            "MT": "R",
            "N": "Rokae XB7XL",
            "F": "Rokae-XB7XL.robot",
            "I": "Rokae-XB7XL-robot.png",
            "IS": "Rokae-XB7XL.png",
            "B": "Rokae",
            "M": "XB7XL",
            "T": "6 DOF",
            "A": 6,
            "R": 1206,
            "P": 7,
            "W": 76,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Rokae-XB25": {
            "MT": "R",
            "N": "Rokae XB25",
            "F": "Rokae-XB25.robot",
            "I": "Rokae-XB25-robot.png",
            "IS": "Rokae-XB25.png",
            "B": "Rokae",
            "M": "XB25",
            "T": "6 DOF",
            "A": 6,
            "R": 1617,
            "P": 25.0,
            "W": 252,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Rokae-RS3-4515": {
            "MT": "R",
            "N": "Rokae RS3-4515",
            "F": "Rokae-RS3-4515.robot",
            "I": "Rokae-RS3-4515-robot.png",
            "IS": "Rokae-RS3-4515.png",
            "B": "Rokae",
            "M": "RS3-4515",
            "T": "SCARA",
            "A": 4,
            "R": 450,
            "P": 2,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Rokae-RS3-5515": {
            "MT": "R",
            "N": "Rokae RS3-5515",
            "F": "Rokae-RS3-5515.robot",
            "I": "Rokae-RS3-5515-robot.png",
            "IS": "Rokae-RS3-5515.png",
            "B": "Rokae",
            "M": "RS3-5515",
            "T": "SCARA",
            "A": 4,
            "R": 550,
            "P": 2,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Rozum-RC5": {
            "MT": "R",
            "N": "Rozum RC5",
            "F": "Rozum-RC5.robot",
            "I": "Rozum-RC5-robot.png",
            "IS": "Rozum-RC5.png",
            "B": "Rozum",
            "M": "RC5",
            "T": "6 DOF",
            "A": 6,
            "R": 850,
            "P": 5.0,
            "W": 25,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Rozum-RC10": {
            "MT": "R",
            "N": "Rozum RC10",
            "F": "Rozum-RC10.robot",
            "I": "Rozum-RC10-robot.png",
            "IS": "Rozum-RC10.png",
            "B": "Rozum",
            "M": "RC10",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 10.0,
            "W": 36,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Rozum-RC16": {
            "MT": "R",
            "N": "Rozum RC16",
            "F": "Rozum-RC16.robot",
            "I": "Rozum-RC16-robot.png",
            "IS": "Rozum-RC16.png",
            "B": "Rozum",
            "M": "RC16",
            "T": "6 DOF",
            "A": 6,
            "R": 850,
            "P": 16.0,
            "W": 42,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "RRRobotica-Atom-50": {
            "MT": "R",
            "N": "RRRobotica Atom 50",
            "F": "RRRobotica-Atom-50.robot",
            "I": "RRRobotica-Atom-50-robot.png",
            "IS": "RRRobotica-Atom-50.png",
            "B": "RRRobotica",
            "M": "Atom 50",
            "T": "6 DOF",
            "A": 6,
            "R": 1932,
            "P": 50.0,
            "W": 420,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Schneider-Electric-Lexium-Cobot-LXMRL03S0000": {
            "MT": "R",
            "N": "Schneider Electric Lexium Cobot LXMRL03S0000",
            "F": "Schneider-Electric-Lexium-Cobot-LXMRL03S0000.robot",
            "I": "Schneider-Electric-Lexium-Cobot-LXMRL03S0000-robot.png",
            "IS": "Schneider-Electric-Lexium-Cobot-LXMRL03S0000.png",
            "B": "Schneider Electric",
            "M": "Lexium Cobot LXMRL03S0000",
            "T": "6 DOF",
            "A": 6,
            "R": 626,
            "P": 3.0,
            "W": 12,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Schneider-Electric-Lexium-Cobot-LXMRL05S0000": {
            "MT": "R",
            "N": "Schneider Electric Lexium Cobot LXMRL05S0000",
            "F": "Schneider-Electric-Lexium-Cobot-LXMRL05S0000.robot",
            "I": "Schneider-Electric-Lexium-Cobot-LXMRL05S0000-robot.png",
            "IS": "Schneider-Electric-Lexium-Cobot-LXMRL05S0000.png",
            "B": "Schneider Electric",
            "M": "Lexium Cobot LXMRL05S0000",
            "T": "6 DOF",
            "A": 6,
            "R": 954,
            "P": 5.0,
            "W": 23,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Schneider-Electric-Lexium-Cobot-LXMRL07S0000": {
            "MT": "R",
            "N": "Schneider Electric Lexium Cobot LXMRL07S0000",
            "F": "Schneider-Electric-Lexium-Cobot-LXMRL07S0000.robot",
            "I": "Schneider-Electric-Lexium-Cobot-LXMRL07S0000-robot.png",
            "IS": "Schneider-Electric-Lexium-Cobot-LXMRL07S0000.png",
            "B": "Schneider Electric",
            "M": "Lexium Cobot LXMRL07S0000",
            "T": "6 DOF",
            "A": 6,
            "R": 819,
            "P": 7.0,
            "W": 22,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Schneider-Electric-Lexium-Cobot-LXMRL12S0000": {
            "MT": "R",
            "N": "Schneider Electric Lexium Cobot LXMRL12S0000",
            "F": "Schneider-Electric-Lexium-Cobot-LXMRL12S0000.robot",
            "I": "Schneider-Electric-Lexium-Cobot-LXMRL12S0000-robot.png",
            "IS": "Schneider-Electric-Lexium-Cobot-LXMRL12S0000.png",
            "B": "Schneider Electric",
            "M": "Lexium Cobot LXMRL12S0000",
            "T": "6 DOF",
            "A": 6,
            "R": 1327,
            "P": 12.0,
            "W": 41,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Schneider-Electric-Lexium-Cobot-LXMRL18S0000": {
            "MT": "R",
            "N": "Schneider Electric Lexium Cobot LXMRL18S0000",
            "F": "Schneider-Electric-Lexium-Cobot-LXMRL18S0000.robot",
            "I": "Schneider-Electric-Lexium-Cobot-LXMRL18S0000-robot.png",
            "IS": "Schneider-Electric-Lexium-Cobot-LXMRL18S0000.png",
            "B": "Schneider Electric",
            "M": "Lexium Cobot LXMRL18S0000",
            "T": "6 DOF",
            "A": 6,
            "R": 1073,
            "P": 18.0,
            "W": 35,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Schneider-Electric-Lexium-SCARA-LXMRSP0650200": {
            "MT": "R",
            "N": "Schneider Electric Lexium SCARA LXMRSP0650200",
            "F": "Schneider-Electric-Lexium-SCARA-LXMRSP0650200.robot",
            "I": "Schneider-Electric-Lexium-SCARA-LXMRSP0650200-robot.png",
            "IS": "Schneider-Electric-Lexium-SCARA-LXMRSP0650200.png",
            "B": "Schneider Electric",
            "M": "Lexium SCARA LXMRSP0650200",
            "T": "SCARA",
            "A": 4,
            "R": 500,
            "P": 6,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Schneider-Electric-Lexium-SCARA-LXMRSP0650300": {
            "MT": "R",
            "N": "Schneider Electric Lexium SCARA LXMRSP0650300",
            "F": "Schneider-Electric-Lexium-SCARA-LXMRSP0650300.robot",
            "I": "Schneider-Electric-Lexium-SCARA-LXMRSP0650300-robot.png",
            "IS": "Schneider-Electric-Lexium-SCARA-LXMRSP0650300.png",
            "B": "Schneider Electric",
            "M": "Lexium SCARA LXMRSP0650300",
            "T": "SCARA",
            "A": 4,
            "R": 500,
            "P": 6,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Schneider-Electric-Lexium-SCARA-LXMRSP0660200": {
            "MT": "R",
            "N": "Schneider Electric Lexium SCARA LXMRSP0660200",
            "F": "Schneider-Electric-Lexium-SCARA-LXMRSP0660200.robot",
            "I": "Schneider-Electric-Lexium-SCARA-LXMRSP0660200-robot.png",
            "IS": "Schneider-Electric-Lexium-SCARA-LXMRSP0660200.png",
            "B": "Schneider Electric",
            "M": "Lexium SCARA LXMRSP0660200",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 6,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Schneider-Electric-Lexium-SCARA-LXMRSP0660300": {
            "MT": "R",
            "N": "Schneider Electric Lexium SCARA LXMRSP0660300",
            "F": "Schneider-Electric-Lexium-SCARA-LXMRSP0660300.robot",
            "I": "Schneider-Electric-Lexium-SCARA-LXMRSP0660300-robot.png",
            "IS": "Schneider-Electric-Lexium-SCARA-LXMRSP0660300.png",
            "B": "Schneider Electric",
            "M": "Lexium SCARA LXMRSP0660300",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 6,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Schneider-Electric-Lexium-SCARA-LXMRSP0670200": {
            "MT": "R",
            "N": "Schneider Electric Lexium SCARA LXMRSP0670200",
            "F": "Schneider-Electric-Lexium-SCARA-LXMRSP0670200.robot",
            "I": "Schneider-Electric-Lexium-SCARA-LXMRSP0670200-robot.png",
            "IS": "Schneider-Electric-Lexium-SCARA-LXMRSP0670200.png",
            "B": "Schneider Electric",
            "M": "Lexium SCARA LXMRSP0670200",
            "T": "SCARA",
            "A": 4,
            "R": 700,
            "P": 6,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Schneider-Electric-Lexium-SCARA-LXMRSP0670300": {
            "MT": "R",
            "N": "Schneider Electric Lexium SCARA LXMRSP0670300",
            "F": "Schneider-Electric-Lexium-SCARA-LXMRSP0670300.robot",
            "I": "Schneider-Electric-Lexium-SCARA-LXMRSP0670300-robot.png",
            "IS": "Schneider-Electric-Lexium-SCARA-LXMRSP0670300.png",
            "B": "Schneider Electric",
            "M": "Lexium SCARA LXMRSP0670300",
            "T": "SCARA",
            "A": 4,
            "R": 700,
            "P": 6,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Servotronix-Delta": {
            "MT": "R",
            "N": "Servotronix Delta",
            "F": "Servotronix-Delta.robot",
            "I": "Servotronix-Delta-robot.png",
            "IS": "Servotronix-Delta.png",
            "B": "Servotronix",
            "M": "Delta",
            "T": "Delta",
            "A": 3,
            "R": 155,
            "P": 0.25,
            "W": 10,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Shibaura-Machine-TV800": {
            "MT": "R",
            "N": "Shibaura Machine TV800",
            "F": "Shibaura-Machine-TV800.robot",
            "I": "Shibaura-Machine-TV800-robot.png",
            "IS": "Shibaura-Machine-TV800.png",
            "B": "Shibaura Machine",
            "M": "TV800",
            "T": "6 DOF",
            "A": 6,
            "R": 892,
            "P": 3,
            "W": 20,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Shibaura-Machine-TVM900": {
            "MT": "R",
            "N": "Shibaura Machine TVM900",
            "F": "Shibaura-Machine-TVM900.robot",
            "I": "Shibaura-Machine-TVM900-robot.png",
            "IS": "Shibaura-Machine-TVM900.png",
            "B": "Shibaura Machine",
            "M": "TVM900",
            "T": "6 DOF",
            "A": 6,
            "R": 1142,
            "P": 20,
            "W": 655,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Shibaura-Machine-TVM1200": {
            "MT": "R",
            "N": "Shibaura Machine TVM1200",
            "F": "Shibaura-Machine-TVM1200.robot",
            "I": "Shibaura-Machine-TVM1200-robot.png",
            "IS": "Shibaura-Machine-TVM1200.png",
            "B": "Shibaura Machine",
            "M": "TVM1200",
            "T": "6 DOF",
            "A": 6,
            "R": 1432,
            "P": 5,
            "W": 125,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Shibaura-Machine-TVM1500": {
            "MT": "R",
            "N": "Shibaura Machine TVM1500",
            "F": "Shibaura-Machine-TVM1500.robot",
            "I": "Shibaura-Machine-TVM1500-robot.png",
            "IS": "Shibaura-Machine-TVM1500.png",
            "B": "Shibaura Machine",
            "M": "TVM1500",
            "T": "6 DOF",
            "A": 6,
            "R": 1726,
            "P": 5,
            "W": 131,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Shibaura-Machine-THE400": {
            "MT": "R",
            "N": "Shibaura Machine THE400",
            "F": "Shibaura-Machine-THE400.robot",
            "I": "Shibaura-Machine-THE400-robot.png",
            "IS": "Shibaura-Machine-THE400.png",
            "B": "Shibaura Machine",
            "M": "THE400",
            "T": "SCARA",
            "A": 4,
            "R": 400,
            "P": 5.0,
            "W": 15,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Shibaura-Machine-THE400T": {
            "MT": "R",
            "N": "Shibaura Machine THE400T",
            "F": "Shibaura-Machine-THE400T.robot",
            "I": "Shibaura-Machine-THE400T-robot.png",
            "IS": "Shibaura-Machine-THE400T.png",
            "B": "Shibaura Machine",
            "M": "THE400T",
            "T": "SCARA",
            "A": 4,
            "R": 400,
            "P": 5.0,
            "W": 15,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Shibaura-Machine-THE600": {
            "MT": "R",
            "N": "Shibaura Machine THE600",
            "F": "Shibaura-Machine-THE600.robot",
            "I": "Shibaura-Machine-THE600-robot.png",
            "IS": "Shibaura-Machine-THE600.png",
            "B": "Shibaura Machine",
            "M": "THE600",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 12.0,
            "W": 31,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Shibaura-Machine-THE600T": {
            "MT": "R",
            "N": "Shibaura Machine THE600T",
            "F": "Shibaura-Machine-THE600T.robot",
            "I": "Shibaura-Machine-THE600T-robot.png",
            "IS": "Shibaura-Machine-THE600T.png",
            "B": "Shibaura Machine",
            "M": "THE600T",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 12.0,
            "W": 31,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Shibaura-Machine-THE800": {
            "MT": "R",
            "N": "Shibaura Machine THE800",
            "F": "Shibaura-Machine-THE800.robot",
            "I": "Shibaura-Machine-THE800-robot.png",
            "IS": "Shibaura-Machine-THE800.png",
            "B": "Shibaura Machine",
            "M": "THE800",
            "T": "SCARA",
            "A": 4,
            "R": 800,
            "P": 20.0,
            "W": 46,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Shibaura-Machine-THE1000": {
            "MT": "R",
            "N": "Shibaura Machine THE1000",
            "F": "Shibaura-Machine-THE1000.robot",
            "I": "Shibaura-Machine-THE1000-robot.png",
            "IS": "Shibaura-Machine-THE1000.png",
            "B": "Shibaura Machine",
            "M": "THE1000",
            "T": "SCARA",
            "A": 4,
            "R": 1000,
            "P": 20.0,
            "W": 49,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Shibaura-Machine-THL-1200": {
            "MT": "R",
            "N": "Shibaura Machine THL 1200",
            "F": "Shibaura-Machine-THL-1200.robot",
            "I": "Shibaura-Machine-THL-1200-robot.png",
            "IS": "Shibaura-Machine-THL-1200.png",
            "B": "Shibaura Machine",
            "M": "THL 1200",
            "T": "SCARA",
            "A": 4,
            "R": 1200,
            "P": 10.0,
            "W": 40,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Shibaura-Machine-THL400": {
            "MT": "R",
            "N": "Shibaura Machine THL400",
            "F": "Shibaura-Machine-THL400.robot",
            "I": "Shibaura-Machine-THL400-robot.png",
            "IS": "Shibaura-Machine-THL400.png",
            "B": "Shibaura Machine",
            "M": "THL400",
            "T": "SCARA",
            "A": 4,
            "R": 400,
            "P": 5,
            "W": 13,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Shibaura-Machine-THL600": {
            "MT": "R",
            "N": "Shibaura Machine THL600",
            "F": "Shibaura-Machine-THL600.robot",
            "I": "Shibaura-Machine-THL600-robot.png",
            "IS": "Shibaura-Machine-THL600.png",
            "B": "Shibaura Machine",
            "M": "THL600",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 10,
            "W": 23,
            "E": 0.021,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Shibaura-Machine-THL700-Ceiling": {
            "MT": "R",
            "N": "Shibaura Machine THL700 Ceiling",
            "F": "Shibaura-Machine-THL700-Ceiling.robot",
            "I": "Shibaura-Machine-THL700-Ceiling-robot.png",
            "IS": "Shibaura-Machine-THL700-Ceiling.png",
            "B": "Shibaura Machine",
            "M": "THL700 Ceiling",
            "T": "SCARA",
            "A": 4,
            "R": 700,
            "P": 10,
            "W": 24,
            "E": 0.021,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Shibaura-Machine-THL700": {
            "MT": "R",
            "N": "Shibaura Machine THL700",
            "F": "Shibaura-Machine-THL700.robot",
            "I": "Shibaura-Machine-THL700-robot.png",
            "IS": "Shibaura-Machine-THL700.png",
            "B": "Shibaura Machine",
            "M": "THL700",
            "T": "SCARA",
            "A": 4,
            "R": 700,
            "P": 10,
            "W": 24,
            "E": 0.021,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Shibaura-Machine-THL800-Ceiling": {
            "MT": "R",
            "N": "Shibaura Machine THL800 Ceiling",
            "F": "Shibaura-Machine-THL800-Ceiling.robot",
            "I": "Shibaura-Machine-THL800-Ceiling-robot.png",
            "IS": "Shibaura-Machine-THL800-Ceiling.png",
            "B": "Shibaura Machine",
            "M": "THL800 Ceiling",
            "T": "SCARA",
            "A": 4,
            "R": 800,
            "P": 10,
            "W": 33,
            "E": 0.032,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Shibaura-Machine-THL800": {
            "MT": "R",
            "N": "Shibaura Machine THL800",
            "F": "Shibaura-Machine-THL800.robot",
            "I": "Shibaura-Machine-THL800-robot.png",
            "IS": "Shibaura-Machine-THL800.png",
            "B": "Shibaura Machine",
            "M": "THL800",
            "T": "SCARA",
            "A": 4,
            "R": 800,
            "P": 10,
            "W": 33,
            "E": 0.032,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Siasun-GCR3-618": {
            "MT": "R",
            "N": "Siasun GCR3-618",
            "F": "Siasun-GCR3-618.robot",
            "I": "Siasun-GCR3-618-robot.png",
            "IS": "Siasun-GCR3-618.png",
            "B": "Siasun",
            "M": "GCR3-618",
            "T": "6 DOF",
            "A": 6,
            "R": 618,
            "P": 3.0,
            "W": 13,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Siasun-GCR5-910": {
            "MT": "R",
            "N": "Siasun GCR5-910",
            "F": "Siasun-GCR5-910.robot",
            "I": "Siasun-GCR5-910-robot.png",
            "IS": "Siasun-GCR5-910.png",
            "B": "Siasun",
            "M": "GCR5-910",
            "T": "6 DOF",
            "A": 6,
            "R": 917,
            "P": 5.0,
            "W": 22,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Siasun-GCR7-910": {
            "MT": "R",
            "N": "Siasun GCR7-910",
            "F": "Siasun-GCR7-910.robot",
            "I": "Siasun-GCR7-910-robot.png",
            "IS": "Siasun-GCR7-910.png",
            "B": "Siasun",
            "M": "GCR7-910",
            "T": "6 DOF",
            "A": 6,
            "R": 917,
            "P": 7.0,
            "W": 22,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Siasun-GCR10-1300": {
            "MT": "R",
            "N": "Siasun GCR10-1300",
            "F": "Siasun-GCR10-1300.robot",
            "I": "Siasun-GCR10-1300-robot.png",
            "IS": "Siasun-GCR10-1300.png",
            "B": "Siasun",
            "M": "GCR10-1300",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 10.0,
            "W": 37.8,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Siasun-GCR12-1300": {
            "MT": "R",
            "N": "Siasun GCR12-1300",
            "F": "Siasun-GCR12-1300.robot",
            "I": "Siasun-GCR12-1300-robot.png",
            "IS": "Siasun-GCR12-1300.png",
            "B": "Siasun",
            "M": "GCR12-1300",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 12.0,
            "W": 37.8,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Siasun-GCR14-1400": {
            "MT": "R",
            "N": "Siasun GCR14-1400",
            "F": "Siasun-GCR14-1400.robot",
            "I": "Siasun-GCR14-1400-robot.png",
            "IS": "Siasun-GCR14-1400.png",
            "B": "Siasun",
            "M": "GCR14-1400",
            "T": "6 DOF",
            "A": 6,
            "R": 1400,
            "P": 14,
            "W": 50,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Siasun-GCR16-960": {
            "MT": "R",
            "N": "Siasun GCR16-960",
            "F": "Siasun-GCR16-960.robot",
            "I": "Siasun-GCR16-960-robot.png",
            "IS": "Siasun-GCR16-960.png",
            "B": "Siasun",
            "M": "GCR16-960",
            "T": "6 DOF",
            "A": 6,
            "R": 960,
            "P": 16.0,
            "W": 37,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Siasun-GCR20-1100": {
            "MT": "R",
            "N": "Siasun GCR20-1100",
            "F": "Siasun-GCR20-1100.robot",
            "I": "Siasun-GCR20-1100-robot.png",
            "IS": "Siasun-GCR20-1100.png",
            "B": "Siasun",
            "M": "GCR20-1100",
            "T": "6 DOF",
            "A": 6,
            "R": 1100,
            "P": 20,
            "W": 50,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Siasun-GCR20-1400": {
            "MT": "R",
            "N": "Siasun GCR20-1400",
            "F": "Siasun-GCR20-1400.robot",
            "I": "Siasun-GCR20-1400-robot.png",
            "IS": "Siasun-GCR20-1400.png",
            "B": "Siasun",
            "M": "GCR20-1400",
            "T": "6 DOF",
            "A": 6,
            "R": 1400,
            "P": 20.0,
            "W": 66,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Siasun-GCR25-1800": {
            "MT": "R",
            "N": "Siasun GCR25-1800",
            "F": "Siasun-GCR25-1800.robot",
            "I": "Siasun-GCR25-1800-robot.png",
            "IS": "Siasun-GCR25-1800.png",
            "B": "Siasun",
            "M": "GCR25-1800",
            "T": "6 DOF",
            "A": 6,
            "R": 1800,
            "P": 25.0,
            "W": 61.6,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Siasun-GCR30-1100": {
            "MT": "R",
            "N": "Siasun GCR30-1100",
            "F": "Siasun-GCR30-1100.robot",
            "I": "Siasun-GCR30-1100-robot.png",
            "IS": "Siasun-GCR30-1100.png",
            "B": "Siasun",
            "M": "GCR30-1100",
            "T": "6 DOF",
            "A": 6,
            "R": 1100,
            "P": 30.0,
            "W": 64,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Siasun-SR20A": {
            "MT": "R",
            "N": "Siasun SR20A",
            "F": "Siasun-SR20A.robot",
            "I": "Siasun-SR20A-robot.png",
            "IS": "Siasun-SR20A.png",
            "B": "Siasun",
            "M": "SR20A",
            "T": "6 DOF",
            "A": 6,
            "R": 1745,
            "P": 20,
            "W": 500,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Siasun-SR80B": {
            "MT": "R",
            "N": "Siasun SR80B",
            "F": "Siasun-SR80B.robot",
            "I": "Siasun-SR80B-robot.png",
            "IS": "Siasun-SR80B.png",
            "B": "Siasun",
            "M": "SR80B",
            "T": "6 DOF",
            "A": 6,
            "R": 1379.5,
            "P": 80,
            "W": 500,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Siasun-SCR3": {
            "MT": "R",
            "N": "Siasun SCR3",
            "F": "Siasun-SCR3.robot",
            "I": "Siasun-SCR3-robot.png",
            "IS": "Siasun-SCR3.png",
            "B": "Siasun",
            "M": "SCR3",
            "T": "7 DOF",
            "A": 7,
            "R": 600,
            "P": 3,
            "W": 21.8,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Siasun-SCR5": {
            "MT": "R",
            "N": "Siasun SCR5",
            "F": "Siasun-SCR5.robot",
            "I": "Siasun-SCR5-robot.png",
            "IS": "Siasun-SCR5.png",
            "B": "Siasun",
            "M": "SCR5",
            "T": "7 DOF",
            "A": 7,
            "R": 800,
            "P": 5,
            "W": 33.8,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Standard-Bots-Core": {
            "MT": "R",
            "N": "Standard Bots Core",
            "F": "Standard-Bots-Core.robot",
            "I": "Standard-Bots-Core-robot.png",
            "IS": "Standard-Bots-Core.png",
            "B": "Standard Bots",
            "M": "Core",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 18,
            "W": 32.5,
            "E": 0.025,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Standard-Bots-Thor": {
            "MT": "R",
            "N": "Standard Bots Thor",
            "F": "Standard-Bots-Thor.robot",
            "I": "Standard-Bots-Thor-robot.png",
            "IS": "Standard-Bots-Thor.png",
            "B": "Standard Bots",
            "M": "Thor",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 30,
            "E": 0.025,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Staubli-RX170HSM": {
            "MT": "R",
            "N": "Staubli RX170HSM",
            "F": "Staubli-RX170HSM.robot",
            "I": "Staubli-RX170HSM-robot.png",
            "IS": "Staubli-RX170HSM.png",
            "B": "Staubli",
            "M": "RX170HSM",
            "T": "5 DOF",
            "A": 5,
            "R": 1720,
            "P": 60,
            "W": 726,
            "E": 0.04,
            "AP": [
                "Material Handling"
            ]
        },
        "Staubli-RX60B": {
            "MT": "R",
            "N": "Staubli RX60B",
            "F": "Staubli-RX60B.robot",
            "I": "Staubli-RX60B-robot.png",
            "IS": "Staubli-RX60B.png",
            "B": "Staubli",
            "M": "RX60B",
            "T": "6 DOF",
            "A": 6,
            "R": 600,
            "P": 3.5,
            "W": 51.4,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Staubli-RX60BL": {
            "MT": "R",
            "N": "Staubli RX60BL",
            "F": "Staubli-RX60BL.robot",
            "I": "Staubli-RX60BL-robot.png",
            "IS": "Staubli-RX60BL.png",
            "B": "Staubli",
            "M": "RX60BL",
            "T": "6 DOF",
            "A": 6,
            "R": 800,
            "P": 2.5,
            "W": 51.4,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Staubli-RX90B": {
            "MT": "R",
            "N": "Staubli RX90B",
            "F": "Staubli-RX90B.robot",
            "I": "Staubli-RX90B-robot.png",
            "IS": "Staubli-RX90B.png",
            "B": "Staubli",
            "M": "RX90B",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 6,
            "W": 111,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Staubli-RX90BL": {
            "MT": "R",
            "N": "Staubli RX90BL",
            "F": "Staubli-RX90BL.robot",
            "I": "Staubli-RX90BL-robot.png",
            "IS": "Staubli-RX90BL.png",
            "B": "Staubli",
            "M": "RX90BL",
            "T": "6 DOF",
            "A": 6,
            "R": 1100,
            "P": 6,
            "W": 113,
            "E": 0.025,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Staubli-RX130B": {
            "MT": "R",
            "N": "Staubli RX130B",
            "F": "Staubli-RX130B.robot",
            "I": "Staubli-RX130B-robot.png",
            "IS": "Staubli-RX130B.png",
            "B": "Staubli",
            "M": "RX130B",
            "T": "6 DOF",
            "A": 6,
            "R": 1250,
            "P": 12,
            "W": 245,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Staubli-RX130XL": {
            "MT": "R",
            "N": "Staubli RX130XL",
            "F": "Staubli-RX130XL.robot",
            "I": "Staubli-RX130XL-robot.png",
            "IS": "Staubli-RX130XL.png",
            "B": "Staubli",
            "M": "RX130XL",
            "T": "6 DOF",
            "A": 6,
            "R": 2100,
            "P": 6,
            "W": 245,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Staubli-RX160": {
            "MT": "R",
            "N": "Staubli RX160",
            "F": "Staubli-RX160.robot",
            "I": "Staubli-RX160-robot.png",
            "IS": "Staubli-RX160.png",
            "B": "Staubli",
            "M": "RX160",
            "T": "6 DOF",
            "A": 6,
            "R": 1600,
            "P": 20,
            "W": 248,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Staubli-RX160L": {
            "MT": "R",
            "N": "Staubli RX160L",
            "F": "Staubli-RX160L.robot",
            "I": "Staubli-RX160L-robot.png",
            "IS": "Staubli-RX160L.png",
            "B": "Staubli",
            "M": "RX160L",
            "T": "6 DOF",
            "A": 6,
            "R": 1900,
            "P": 14,
            "W": 250,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Staubli-RX170": {
            "MT": "R",
            "N": "Staubli RX170",
            "F": "Staubli-RX170.robot",
            "I": "Staubli-RX170-robot.png",
            "IS": "Staubli-RX170.png",
            "B": "Staubli",
            "M": "RX170",
            "T": "6 DOF",
            "A": 6,
            "R": 1700,
            "P": 30,
            "W": 721,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Staubli-RX170HP": {
            "MT": "R",
            "N": "Staubli RX170HP",
            "F": "Staubli-RX170HP.robot",
            "I": "Staubli-RX170HP-robot.png",
            "IS": "Staubli-RX170HP.png",
            "B": "Staubli",
            "M": "RX170HP",
            "T": "6 DOF",
            "A": 6,
            "R": 1700,
            "P": 60,
            "W": 726,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Machining",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Staubli-RX170L": {
            "MT": "R",
            "N": "Staubli RX170L",
            "F": "Staubli-RX170L.robot",
            "I": "Staubli-RX170L-robot.png",
            "IS": "Staubli-RX170L.png",
            "B": "Staubli",
            "M": "RX170L",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 20,
            "W": 726,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Staubli-RX260": {
            "MT": "R",
            "N": "Staubli RX260",
            "F": "Staubli-RX260.robot",
            "I": "Staubli-RX260-robot.png",
            "IS": "Staubli-RX260.png",
            "B": "Staubli",
            "M": "RX260",
            "T": "6 DOF",
            "A": 6,
            "R": 2621,
            "P": 130,
            "W": 1900,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Staubli-RX260L": {
            "MT": "R",
            "N": "Staubli RX260L",
            "F": "Staubli-RX260L.robot",
            "I": "Staubli-RX260L-robot.png",
            "IS": "Staubli-RX260L.png",
            "B": "Staubli",
            "M": "RX260L",
            "T": "6 DOF",
            "A": 6,
            "R": 3007,
            "P": 130,
            "W": 1900,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Staubli-RX270": {
            "MT": "R",
            "N": "Staubli RX270",
            "F": "Staubli-RX270.robot",
            "I": "Staubli-RX270-robot.png",
            "IS": "Staubli-RX270.png",
            "B": "Staubli",
            "M": "RX270",
            "T": "6 DOF",
            "A": 6,
            "R": 2710,
            "P": 220,
            "W": 2000,
            "E": 0.09,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Staubli-TX2-40": {
            "MT": "R",
            "N": "Staubli TX2-40",
            "F": "Staubli-TX2-40.robot",
            "I": "Staubli-TX2-40-robot.png",
            "IS": "Staubli-TX2-40.png",
            "B": "Staubli",
            "M": "TX2-40",
            "T": "6 DOF",
            "A": 6,
            "R": 515,
            "P": 2,
            "W": 29,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Staubli-TX2-60": {
            "MT": "R",
            "N": "Staubli TX2-60",
            "F": "Staubli-TX2-60.robot",
            "I": "Staubli-TX2-60-robot.png",
            "IS": "Staubli-TX2-60.png",
            "B": "Staubli",
            "M": "TX2-60",
            "T": "6 DOF",
            "A": 6,
            "R": 670,
            "P": 3.5,
            "W": 52.2,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Staubli-TX2-60L": {
            "MT": "R",
            "N": "Staubli TX2-60L",
            "F": "Staubli-TX2-60L.robot",
            "I": "Staubli-TX2-60L-robot.png",
            "IS": "Staubli-TX2-60L.png",
            "B": "Staubli",
            "M": "TX2-60L",
            "T": "6 DOF",
            "A": 6,
            "R": 920,
            "P": 2,
            "W": 52.5,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Staubli-TX2-90": {
            "MT": "R",
            "N": "Staubli TX2-90",
            "F": "Staubli-TX2-90.robot",
            "I": "Staubli-TX2-90-robot.png",
            "IS": "Staubli-TX2-90.png",
            "B": "Staubli",
            "M": "TX2-90",
            "T": "6 DOF",
            "A": 6,
            "R": 1000,
            "P": 6,
            "W": 114,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Staubli-TX2-90L": {
            "MT": "R",
            "N": "Staubli TX2-90L",
            "F": "Staubli-TX2-90L.robot",
            "I": "Staubli-TX2-90L-robot.png",
            "IS": "Staubli-TX2-90L.png",
            "B": "Staubli",
            "M": "TX2-90L",
            "T": "6 DOF",
            "A": 6,
            "R": 1200,
            "P": 5,
            "W": 117,
            "E": 0.035,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Staubli-TX2-90XL": {
            "MT": "R",
            "N": "Staubli TX2-90XL",
            "F": "Staubli-TX2-90XL.robot",
            "I": "Staubli-TX2-90XL-robot.png",
            "IS": "Staubli-TX2-90XL.png",
            "B": "Staubli",
            "M": "TX2-90XL",
            "T": "6 DOF",
            "A": 6,
            "R": 1450,
            "P": 4,
            "W": 119,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Staubli-TX2-140": {
            "MT": "R",
            "N": "Staubli TX2-140",
            "F": "Staubli-TX2-140.robot",
            "I": "Staubli-TX2-140-robot.png",
            "IS": "Staubli-TX2-140.png",
            "B": "Staubli",
            "M": "TX2-140",
            "T": "6 DOF",
            "A": 6,
            "R": 1510,
            "P": 40,
            "W": 250,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Staubli-TX2-160": {
            "MT": "R",
            "N": "Staubli TX2-160",
            "F": "Staubli-TX2-160.robot",
            "I": "Staubli-TX2-160-robot.png",
            "IS": "Staubli-TX2-160.png",
            "B": "Staubli",
            "M": "TX2-160",
            "T": "6 DOF",
            "A": 6,
            "R": 1710,
            "P": 40.0,
            "W": 260,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Staubli-TX2-160L": {
            "MT": "R",
            "N": "Staubli TX2-160L",
            "F": "Staubli-TX2-160L.robot",
            "I": "Staubli-TX2-160L-robot.png",
            "IS": "Staubli-TX2-160L.png",
            "B": "Staubli",
            "M": "TX2-160L",
            "T": "6 DOF",
            "A": 6,
            "R": 2010,
            "P": 25,
            "W": 265,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Staubli-TX40": {
            "MT": "R",
            "N": "Staubli TX40",
            "F": "Staubli-TX40.robot",
            "I": "Staubli-TX40-robot.png",
            "IS": "Staubli-TX40.png",
            "B": "Staubli",
            "M": "TX40",
            "T": "6 DOF",
            "A": 6,
            "R": 450,
            "P": 1.7,
            "W": 27,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Staubli-TX60": {
            "MT": "R",
            "N": "Staubli TX60",
            "F": "Staubli-TX60.robot",
            "I": "Staubli-TX60-robot.png",
            "IS": "Staubli-TX60.png",
            "B": "Staubli",
            "M": "TX60",
            "T": "6 DOF",
            "A": 6,
            "R": 600,
            "P": 3.5,
            "W": 51.4,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Staubli-TX60L": {
            "MT": "R",
            "N": "Staubli TX60L",
            "F": "Staubli-TX60L.robot",
            "I": "Staubli-TX60L-robot.png",
            "IS": "Staubli-TX60L.png",
            "B": "Staubli",
            "M": "TX60L",
            "T": "6 DOF",
            "A": 6,
            "R": 850,
            "P": 2,
            "W": 52.5,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Staubli-TX90": {
            "MT": "R",
            "N": "Staubli TX90",
            "F": "Staubli-TX90.robot",
            "I": "Staubli-TX90-robot.png",
            "IS": "Staubli-TX90.png",
            "B": "Staubli",
            "M": "TX90",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 7,
            "W": 111,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Staubli-TX90L": {
            "MT": "R",
            "N": "Staubli TX90L",
            "F": "Staubli-TX90L.robot",
            "I": "Staubli-TX90L-robot.png",
            "IS": "Staubli-TX90L.png",
            "B": "Staubli",
            "M": "TX90L",
            "T": "6 DOF",
            "A": 6,
            "R": 1100,
            "P": 6,
            "W": 114,
            "E": 0.035,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Staubli-TX90XL": {
            "MT": "R",
            "N": "Staubli TX90XL",
            "F": "Staubli-TX90XL.robot",
            "I": "Staubli-TX90XL-robot.png",
            "IS": "Staubli-TX90XL.png",
            "B": "Staubli",
            "M": "TX90XL",
            "T": "6 DOF",
            "A": 6,
            "R": 1350,
            "P": 5,
            "W": 116,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Staubli-TX200": {
            "MT": "R",
            "N": "Staubli TX200",
            "F": "Staubli-TX200.robot",
            "I": "Staubli-TX200-robot.png",
            "IS": "Staubli-TX200.png",
            "B": "Staubli",
            "M": "TX200",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 100,
            "W": 1000,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Staubli-TX200L": {
            "MT": "R",
            "N": "Staubli TX200L",
            "F": "Staubli-TX200L.robot",
            "I": "Staubli-TX200L-robot.png",
            "IS": "Staubli-TX200L.png",
            "B": "Staubli",
            "M": "TX200L",
            "T": "6 DOF",
            "A": 6,
            "R": 2400,
            "P": 60,
            "W": 1020,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Staubli-TX200PV": {
            "MT": "R",
            "N": "Staubli TX200PV",
            "F": "Staubli-TX200PV.robot",
            "I": "Staubli-TX200PV-robot.png",
            "IS": "Staubli-TX200PV.png",
            "B": "Staubli",
            "M": "TX200PV",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 100,
            "W": 1000,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Staubli-TX200PVL": {
            "MT": "R",
            "N": "Staubli TX200PVL",
            "F": "Staubli-TX200PVL.robot",
            "I": "Staubli-TX200PVL-robot.png",
            "IS": "Staubli-TX200PVL.png",
            "B": "Staubli",
            "M": "TX200PVL",
            "T": "6 DOF",
            "A": 6,
            "R": 2400,
            "P": 60,
            "W": 1020,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Staubli-TP80": {
            "MT": "R",
            "N": "Staubli TP80",
            "F": "Staubli-TP80.robot",
            "I": "Staubli-TP80-robot.png",
            "IS": "Staubli-TP80.png",
            "B": "Staubli",
            "M": "TP80",
            "T": "SCARA",
            "A": 4,
            "R": 800,
            "P": 0.5,
            "W": 71,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Staubli-TS2-100-HB-FL400L-WS-FLA": {
            "MT": "R",
            "N": "Staubli TS2 100 HB FL400L WS FLA",
            "F": "Staubli-TS2-100-HB-FL400L-WS-FLA.robot",
            "I": "Staubli-TS2-100-HB-FL400L-WS-FLA-robot.png",
            "IS": "Staubli-TS2-100-HB-FL400L-WS-FLA.png",
            "B": "Staubli",
            "M": "TS2 100 HB FL400L WS FLA",
            "T": "SCARA",
            "A": 4,
            "R": 1000,
            "P": 8.4,
            "W": 41,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Staubli-TS2-40-FL-200": {
            "MT": "R",
            "N": "Staubli TS2-40 FL 200",
            "F": "Staubli-TS2-40-FL-200.robot",
            "I": "Staubli-TS2-40-FL-200-robot.png",
            "IS": "Staubli-TS2-40-FL-200.png",
            "B": "Staubli",
            "M": "TS2-40 FL 200",
            "T": "SCARA",
            "A": 4,
            "R": 460,
            "P": 2.4,
            "W": 38,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Staubli-TS2-60-FL-200": {
            "MT": "R",
            "N": "Staubli TS2-60 FL 200",
            "F": "Staubli-TS2-60-FL-200.robot",
            "I": "Staubli-TS2-60-FL-200-robot.png",
            "IS": "Staubli-TS2-60-FL-200.png",
            "B": "Staubli",
            "M": "TS2-60 FL 200",
            "T": "SCARA",
            "A": 4,
            "R": 620,
            "P": 2.4,
            "W": 39,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Staubli-TS2-80-FL-200": {
            "MT": "R",
            "N": "Staubli TS2-80 FL 200",
            "F": "Staubli-TS2-80-FL-200.robot",
            "I": "Staubli-TS2-80-FL-200-robot.png",
            "IS": "Staubli-TS2-80-FL-200.png",
            "B": "Staubli",
            "M": "TS2-80 FL 200",
            "T": "SCARA",
            "A": 4,
            "R": 800,
            "P": 2.4,
            "W": 40,
            "E": 0.015,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Staubli-TS2-100-FL-200": {
            "MT": "R",
            "N": "Staubli TS2-100 FL 200",
            "F": "Staubli-TS2-100-FL-200.robot",
            "I": "Staubli-TS2-100-FL-200-robot.png",
            "IS": "Staubli-TS2-100-FL-200.png",
            "B": "Staubli",
            "M": "TS2-100 FL 200",
            "T": "SCARA",
            "A": 4,
            "R": 1000,
            "P": 2.4,
            "W": 40,
            "E": 0.015,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Staubli-TS20-FL-100-TC": {
            "MT": "R",
            "N": "Staubli TS20 FL 100 TC",
            "F": "Staubli-TS20-FL-100-TC.robot",
            "I": "Staubli-TS20-FL-100-TC-robot.png",
            "IS": "Staubli-TS20-FL-100-TC.png",
            "B": "Staubli",
            "M": "TS20 FL 100 TC",
            "T": "SCARA",
            "A": 4,
            "R": 220,
            "P": 0.5,
            "W": 14,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Staubli-TS40-FL-200": {
            "MT": "R",
            "N": "Staubli TS40 FL 200",
            "F": "Staubli-TS40-FL-200.robot",
            "I": "Staubli-TS40-FL-200-robot.png",
            "IS": "Staubli-TS40-FL-200.png",
            "B": "Staubli",
            "M": "TS40 FL 200",
            "T": "SCARA",
            "A": 4,
            "R": 400,
            "P": 2,
            "W": 46,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Staubli-TS60-FL-400": {
            "MT": "R",
            "N": "Staubli TS60 FL 400",
            "F": "Staubli-TS60-FL-400.robot",
            "I": "Staubli-TS60-FL-400-robot.png",
            "IS": "Staubli-TS60-FL-400.png",
            "B": "Staubli",
            "M": "TS60 FL 400",
            "T": "SCARA",
            "A": 4,
            "R": 600,
            "P": 2,
            "W": 55,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Staubli-TS80-FL-400": {
            "MT": "R",
            "N": "Staubli TS80 FL 400",
            "F": "Staubli-TS80-FL-400.robot",
            "I": "Staubli-TS80-FL-400-robot.png",
            "IS": "Staubli-TS80-FL-400.png",
            "B": "Staubli",
            "M": "TS80 FL 400",
            "T": "SCARA",
            "A": 4,
            "R": 800,
            "P": 2,
            "W": 56.8,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "TANGCHENG-TC-06-2010A": {
            "MT": "R",
            "N": "TANGCHENG TC-06-2010A",
            "F": "TANGCHENG-TC-06-2010A.robot",
            "I": "TANGCHENG-TC-06-2010A-robot.png",
            "IS": "TANGCHENG-TC-06-2010A.png",
            "B": "TANGCHENG",
            "M": "TC-06-2010A",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 6,
            "W": 350,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Techman-TM5-700": {
            "MT": "R",
            "N": "Techman TM5-700",
            "F": "Techman-TM5-700.robot",
            "I": "Techman-TM5-700-robot.png",
            "IS": "Techman-TM5-700.png",
            "B": "Techman Robot",
            "M": "Techman TM5-700",
            "T": "6 DOF",
            "A": 6,
            "R": 700,
            "P": 6,
            "W": 25,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Techman-TM5-900": {
            "MT": "R",
            "N": "Techman TM5-900",
            "F": "Techman-TM5-900.robot",
            "I": "Techman-TM5-900-robot.png",
            "IS": "Techman-TM5-900.png",
            "B": "Techman Robot",
            "M": "Techman TM5-900",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 4,
            "W": 30,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Techman-TM5S": {
            "MT": "R",
            "N": "Techman TM5S",
            "F": "Techman-TM5S.robot",
            "I": "Techman-TM5S-robot.png",
            "IS": "Techman-TM5S.png",
            "B": "Techman Robot",
            "M": "Techman TM5S",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 5.0,
            "W": 23.9,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Techman-TM5S-X": {
            "MT": "R",
            "N": "Techman TM5S-X",
            "F": "Techman-TM5S-X.robot",
            "I": "Techman-TM5S-X-robot.png",
            "IS": "Techman-TM5S-X.png",
            "B": "Techman Robot",
            "M": "Techman TM5S-X",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 5.0,
            "W": 23.9,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Techman-TM5X-700": {
            "MT": "R",
            "N": "Techman TM5X-700",
            "F": "Techman-TM5X-700.robot",
            "I": "Techman-TM5X-700-robot.png",
            "IS": "Techman-TM5X-700.png",
            "B": "Techman Robot",
            "M": "Techman TM5X-700",
            "T": "6 DOF",
            "A": 6,
            "R": 700,
            "P": 6,
            "W": 25,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Techman-TM5X-900": {
            "MT": "R",
            "N": "Techman TM5X-900",
            "F": "Techman-TM5X-900.robot",
            "I": "Techman-TM5X-900-robot.png",
            "IS": "Techman-TM5X-900.png",
            "B": "Techman Robot",
            "M": "Techman TM5X-900",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 4,
            "W": 30,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Techman-TM6S": {
            "MT": "R",
            "N": "Techman TM6S",
            "F": "Techman-TM6S.robot",
            "I": "Techman-TM6S-robot.png",
            "IS": "Techman-TM6S.png",
            "B": "Techman Robot",
            "M": "Techman TM6S",
            "T": "6 DOF",
            "A": 6,
            "R": 1800,
            "P": 6.0,
            "W": 80,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Techman-TM6S-X": {
            "MT": "R",
            "N": "Techman TM6S-X",
            "F": "Techman-TM6S-X.robot",
            "I": "Techman-TM6S-X-robot.png",
            "IS": "Techman-TM6S-X.png",
            "B": "Techman Robot",
            "M": "Techman TM6S-X",
            "T": "6 DOF",
            "A": 6,
            "R": 1800,
            "P": 6.0,
            "W": 80,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Techman-TM7S": {
            "MT": "R",
            "N": "Techman TM7S",
            "F": "Techman-TM7S.robot",
            "I": "Techman-TM7S-robot.png",
            "IS": "Techman-TM7S.png",
            "B": "Techman Robot",
            "M": "Techman TM7S",
            "T": "6 DOF",
            "A": 6,
            "R": 700,
            "P": 7.0,
            "W": 22.9,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Techman-TM7S-X": {
            "MT": "R",
            "N": "Techman TM7S-X",
            "F": "Techman-TM7S-X.robot",
            "I": "Techman-TM7S-X-robot.png",
            "IS": "Techman-TM7S-X.png",
            "B": "Techman Robot",
            "M": "Techman TM7S-X",
            "T": "6 DOF",
            "A": 6,
            "R": 700,
            "P": 7.0,
            "W": 22.9,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Techman-TM12": {
            "MT": "R",
            "N": "Techman TM12",
            "F": "Techman-TM12.robot",
            "I": "Techman-TM12-robot.png",
            "IS": "Techman-TM12.png",
            "B": "Techman Robot",
            "M": "Techman TM12",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 12,
            "W": 33.3,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Techman-TM12S": {
            "MT": "R",
            "N": "Techman TM12S",
            "F": "Techman-TM12S.robot",
            "I": "Techman-TM12S-robot.png",
            "IS": "Techman-TM12S.png",
            "B": "Techman Robot",
            "M": "Techman TM12S",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 12.0,
            "W": 33.3,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Techman-TM12S-X": {
            "MT": "R",
            "N": "Techman TM12S-X",
            "F": "Techman-TM12S-X.robot",
            "I": "Techman-TM12S-X-robot.png",
            "IS": "Techman-TM12S-X.png",
            "B": "Techman Robot",
            "M": "Techman TM12S-X",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 12.0,
            "W": 33.3,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Techman-TM12X": {
            "MT": "R",
            "N": "Techman TM12X",
            "F": "Techman-TM12X.robot",
            "I": "Techman-TM12X-robot.png",
            "IS": "Techman-TM12X.png",
            "B": "Techman Robot",
            "M": "Techman TM12X",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 12,
            "W": 33.3,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Techman-TM14": {
            "MT": "R",
            "N": "Techman TM14",
            "F": "Techman-TM14.robot",
            "I": "Techman-TM14-robot.png",
            "IS": "Techman-TM14.png",
            "B": "Techman Robot",
            "M": "Techman TM14",
            "T": "6 DOF",
            "A": 6,
            "R": 1100,
            "P": 14,
            "W": 32.5,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Techman-TM14S": {
            "MT": "R",
            "N": "Techman TM14S",
            "F": "Techman-TM14S.robot",
            "I": "Techman-TM14S-robot.png",
            "IS": "Techman-TM14S.png",
            "B": "Techman Robot",
            "M": "Techman TM14S",
            "T": "6 DOF",
            "A": 6,
            "R": 1100,
            "P": 14.0,
            "W": 33,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Techman-TM14S-X": {
            "MT": "R",
            "N": "Techman TM14S-X",
            "F": "Techman-TM14S-X.robot",
            "I": "Techman-TM14S-X-robot.png",
            "IS": "Techman-TM14S-X.png",
            "B": "Techman Robot",
            "M": "Techman TM14S-X",
            "T": "6 DOF",
            "A": 6,
            "R": 1100,
            "P": 14.0,
            "W": 33,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Techman-TM14X": {
            "MT": "R",
            "N": "Techman TM14X",
            "F": "Techman-TM14X.robot",
            "I": "Techman-TM14X-robot.png",
            "IS": "Techman-TM14X.png",
            "B": "Techman Robot",
            "M": "Techman TM14X",
            "T": "6 DOF",
            "A": 6,
            "R": 1100,
            "P": 14,
            "W": 32.2,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Techman-TM16": {
            "MT": "R",
            "N": "Techman TM16",
            "F": "Techman-TM16.robot",
            "I": "Techman-TM16-robot.png",
            "IS": "Techman-TM16.png",
            "B": "Techman Robot",
            "M": "Techman TM16",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 16,
            "W": 32,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Techman-TM16X": {
            "MT": "R",
            "N": "Techman TM16X",
            "F": "Techman-TM16X.robot",
            "I": "Techman-TM16X-robot.png",
            "IS": "Techman-TM16X.png",
            "B": "Techman Robot",
            "M": "Techman TM16X",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 16,
            "W": 31.7,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Techman-TM20": {
            "MT": "R",
            "N": "Techman TM20",
            "F": "Techman-TM20.robot",
            "I": "Techman-TM20-robot.png",
            "IS": "Techman-TM20.png",
            "B": "Techman Robot",
            "M": "Techman TM20",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 20.0,
            "W": 32.8,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Techman-TM20S": {
            "MT": "R",
            "N": "Techman TM20S",
            "F": "Techman-TM20S.robot",
            "I": "Techman-TM20S-robot.png",
            "IS": "Techman-TM20S.png",
            "B": "Techman Robot",
            "M": "Techman TM20S",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 20.0,
            "W": 32.8,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Techman-TM20S-X": {
            "MT": "R",
            "N": "Techman TM20S-X",
            "F": "Techman-TM20S-X.robot",
            "I": "Techman-TM20S-X-robot.png",
            "IS": "Techman-TM20S-X.png",
            "B": "Techman Robot",
            "M": "Techman TM20S-X",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 20.0,
            "W": 33,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Techman-TM20X": {
            "MT": "R",
            "N": "Techman TM20X",
            "F": "Techman-TM20X.robot",
            "I": "Techman-TM20X-robot.png",
            "IS": "Techman-TM20X.png",
            "B": "Techman Robot",
            "M": "Techman TM20X",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 20,
            "W": 32.5,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Techman-TM25S": {
            "MT": "R",
            "N": "Techman TM25S",
            "F": "Techman-TM25S.robot",
            "I": "Techman-TM25S-robot.png",
            "IS": "Techman-TM25S.png",
            "B": "Techman Robot",
            "M": "Techman TM25S",
            "T": "6 DOF",
            "A": 6,
            "R": 1902,
            "P": 25.0,
            "W": 80.6,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Techman-TM25S-X": {
            "MT": "R",
            "N": "Techman TM25S-X",
            "F": "Techman-TM25S-X.robot",
            "I": "Techman-TM25S-X-robot.png",
            "IS": "Techman-TM25S-X.png",
            "B": "Techman Robot",
            "M": "Techman TM25S-X",
            "T": "6 DOF",
            "A": 6,
            "R": 1902,
            "P": 25.0,
            "W": 80.6,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Techman-TM30S": {
            "MT": "R",
            "N": "Techman TM30S",
            "F": "Techman-TM30S.robot",
            "I": "Techman-TM30S-robot.png",
            "IS": "Techman-TM30S.png",
            "B": "Techman Robot",
            "M": "Techman TM30S",
            "T": "6 DOF",
            "A": 6,
            "R": 1702,
            "P": 30.0,
            "W": 80.6,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Techman-TM30SC": {
            "MT": "R",
            "N": "Techman TM30SC",
            "F": "Techman-TM30SC.robot",
            "I": "Techman-TM30SC-robot.png",
            "IS": "Techman-TM30SC.png",
            "B": "Techman Robot",
            "M": "Techman TM30SC",
            "T": "6 DOF",
            "A": 6,
            "R": 1502,
            "P": 30.0,
            "W": 79.2,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Techman-TM30SC-X": {
            "MT": "R",
            "N": "Techman TM30SC-X",
            "F": "Techman-TM30SC-X.robot",
            "I": "Techman-TM30SC-X-robot.png",
            "IS": "Techman-TM30SC-X.png",
            "B": "Techman Robot",
            "M": "Techman TM30SC-X",
            "T": "6 DOF",
            "A": 6,
            "R": 1502,
            "P": 30.0,
            "W": 78.9,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Techman-TM30S-X": {
            "MT": "R",
            "N": "Techman TM30S-X",
            "F": "Techman-TM30S-X.robot",
            "I": "Techman-TM30S-X-robot.png",
            "IS": "Techman-TM30S-X.png",
            "B": "Techman Robot",
            "M": "Techman TM30S-X",
            "T": "6 DOF",
            "A": 6,
            "R": 1702,
            "P": 30.0,
            "W": 80.3,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Toney-M10": {
            "MT": "R",
            "N": "Toney M10",
            "F": "Toney-M10.robot",
            "I": "Toney-M10-robot.png",
            "IS": "Toney-M10.png",
            "B": "Toney",
            "M": "M10",
            "T": "6 DOF",
            "A": 6,
            "R": 1400,
            "P": 10.0,
            "W": 40.0,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Turin-TKB5800": {
            "MT": "R",
            "N": "Turin TKB5800",
            "F": "Turin-TKB5800.robot",
            "I": "Turin-TKB5800-robot.png",
            "IS": "Turin-TKB5800.png",
            "B": "Turin",
            "M": "TKB5800",
            "T": "6 DOF",
            "A": 6,
            "R": 2448,
            "P": 50,
            "W": 650,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "uFactory-xArm5": {
            "MT": "R",
            "N": "uFactory xArm5",
            "F": "uFactory-xArm5.robot",
            "I": "uFactory-xArm5-robot.png",
            "IS": "uFactory-xArm5.png",
            "B": "uFactory",
            "M": "xArm5",
            "T": "5 DOF",
            "A": 5,
            "R": 700,
            "P": 3,
            "W": 11.2,
            "E": 0.1,
            "AP": [
                "Material Handling"
            ]
        },
        "uFactory-850": {
            "MT": "R",
            "N": "uFactory 850",
            "F": "uFactory-850.robot",
            "I": "uFactory-850-robot.png",
            "IS": "uFactory-850.png",
            "B": "uFactory",
            "M": "850",
            "T": "6 DOF",
            "A": 6,
            "R": 850,
            "P": 5.0,
            "W": 20,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "uFactory-Lite6": {
            "MT": "R",
            "N": "uFactory Lite6",
            "F": "uFactory-Lite6.robot",
            "I": "uFactory-Lite6-robot.png",
            "IS": "uFactory-Lite6.png",
            "B": "uFactory",
            "M": "Lite6",
            "T": "6 DOF",
            "A": 6,
            "R": 440,
            "P": 0.6,
            "W": 8,
            "E": 0.5,
            "AP": [
                "Assembly",
                "Collaborative",
                "Inspection",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "uFactory-xArm6": {
            "MT": "R",
            "N": "uFactory xArm6",
            "F": "uFactory-xArm6.robot",
            "I": "uFactory-xArm6-robot.png",
            "IS": "uFactory-xArm6.png",
            "B": "uFactory",
            "M": "xArm6",
            "T": "6 DOF",
            "A": 6,
            "R": 700,
            "P": 5,
            "W": 12.2,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "uFactory-xArm7": {
            "MT": "R",
            "N": "uFactory xArm7",
            "F": "uFactory-xArm7.robot",
            "I": "uFactory-xArm7-robot.png",
            "IS": "uFactory-xArm7.png",
            "B": "uFactory",
            "M": "xArm7",
            "T": "7 DOF",
            "A": 7,
            "R": 700,
            "P": 3.5,
            "W": 13.7,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "uFactory-uArm": {
            "MT": "R",
            "N": "uFactory uArm",
            "F": "uFactory-uArm.robot",
            "I": "uFactory-uArm-robot.png",
            "IS": "uFactory-uArm.png",
            "B": "uFactory",
            "M": "uArm",
            "T": "Palletizing",
            "A": 4,
            "R": 100,
            "P": 0.5,
            "W": 2.2,
            "E": 0.2,
            "AP": [
                "Palletizing"
            ]
        },
        "UR3": {
            "MT": "R",
            "N": "UR3",
            "F": "UR3.robot",
            "I": "UR3-robot.png",
            "IS": "UR3.png",
            "B": "Universal Robots",
            "M": "UR3",
            "T": "6 DOF",
            "A": 6,
            "R": 500,
            "P": 3,
            "W": 11,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "UR3e": {
            "MT": "R",
            "N": "UR3e",
            "F": "UR3e.robot",
            "I": "UR3e-robot.png",
            "IS": "UR3e.png",
            "B": "Universal Robots",
            "M": "UR3e",
            "T": "6 DOF",
            "A": 6,
            "R": 500,
            "P": 3,
            "W": 11,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "UR5": {
            "MT": "R",
            "N": "UR5",
            "F": "UR5.robot",
            "I": "UR5-robot.png",
            "IS": "UR5.png",
            "B": "Universal Robots",
            "M": "UR5",
            "T": "6 DOF",
            "A": 6,
            "R": 850,
            "P": 5,
            "W": 18.4,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "UR5e": {
            "MT": "R",
            "N": "UR5e",
            "F": "UR5e.robot",
            "I": "UR5e-robot.png",
            "IS": "UR5e.png",
            "B": "Universal Robots",
            "M": "UR5e",
            "T": "6 DOF",
            "A": 6,
            "R": 850,
            "P": 5,
            "W": 18.4,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "UR7e": {
            "MT": "R",
            "N": "UR7e",
            "F": "UR7e.robot",
            "I": "UR7e-robot.png",
            "IS": "UR7e.png",
            "B": "Universal Robots",
            "M": "UR7e",
            "T": "6 DOF",
            "A": 6,
            "R": 850,
            "P": 5,
            "W": 18.4,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "UR8-Long": {
            "MT": "R",
            "N": "UR8 Long",
            "F": "UR8-Long.robot",
            "I": "UR8-Long-robot.png",
            "IS": "UR8-Long.png",
            "B": "Universal Robots",
            "M": "UR8 Long",
            "T": "6 DOF",
            "A": 6,
            "R": 1750,
            "P": 10.0,
            "W": 44.7,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "UR10": {
            "MT": "R",
            "N": "UR10",
            "F": "UR10.robot",
            "I": "UR10-robot.png",
            "IS": "UR10.png",
            "B": "Universal Robots",
            "M": "UR10",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 10,
            "W": 28.9,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "UR10e": {
            "MT": "R",
            "N": "UR10e",
            "F": "UR10e.robot",
            "I": "UR10e-robot.png",
            "IS": "UR10e.png",
            "B": "Universal Robots",
            "M": "UR10e",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 10,
            "W": 28.9,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "UR12e": {
            "MT": "R",
            "N": "UR12e",
            "F": "UR12e.robot",
            "I": "UR12e-robot.png",
            "IS": "UR12e.png",
            "B": "Universal Robots",
            "M": "UR12e",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 10,
            "W": 28.9,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "UR15": {
            "MT": "R",
            "N": "UR15",
            "F": "UR15.robot",
            "I": "UR15-robot.png",
            "IS": "UR15.png",
            "B": "Universal Robots",
            "M": "UR15",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 15.0,
            "W": 40.7,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "UR16e": {
            "MT": "R",
            "N": "UR16e",
            "F": "UR16e.robot",
            "I": "UR16e-robot.png",
            "IS": "UR16e.png",
            "B": "Universal Robots",
            "M": "UR16e",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 16,
            "W": 33.1,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "UR18": {
            "MT": "R",
            "N": "UR18",
            "F": "UR18.robot",
            "I": "UR18-robot.png",
            "IS": "UR18.png",
            "B": "Universal Robots",
            "M": "UR18",
            "T": "6 DOF",
            "A": 6,
            "R": 950,
            "P": 18,
            "W": 39.2,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "UR20": {
            "MT": "R",
            "N": "UR20",
            "F": "UR20.robot",
            "I": "UR20-robot.png",
            "IS": "UR20.png",
            "B": "Universal Robots",
            "M": "UR20",
            "T": "6 DOF",
            "A": 6,
            "R": 1750,
            "P": 20,
            "W": 64,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "UR30": {
            "MT": "R",
            "N": "UR30",
            "F": "UR30.robot",
            "I": "UR30-robot.png",
            "IS": "UR30.png",
            "B": "Universal Robots",
            "M": "UR30",
            "T": "6 DOF",
            "A": 6,
            "R": 1300,
            "P": 30.0,
            "W": 63.5,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Wlkata-Haro380": {
            "MT": "R",
            "N": "Wlkata Haro380",
            "F": "Wlkata-Haro380.robot",
            "I": "Wlkata-Haro380-robot.png",
            "IS": "Wlkata-Haro380.png",
            "B": "Wlkata",
            "M": "Haro380",
            "T": "6 DOF",
            "A": 6,
            "R": 380,
            "P": 0.5,
            "W": 3.5,
            "E": 0.05,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Wlkata-Mirobot": {
            "MT": "R",
            "N": "Wlkata Mirobot",
            "F": "Wlkata-Mirobot.robot",
            "I": "Wlkata-Mirobot-robot.png",
            "IS": "Wlkata-Mirobot.png",
            "B": "Wlkata",
            "M": "Mirobot",
            "T": "6 DOF",
            "A": 6,
            "R": 315,
            "P": 0.25,
            "W": 1.5,
            "E": 0.2,
            "AP": [
                "Assembly",
                "Inspection",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Wlkata-MT4": {
            "MT": "R",
            "N": "Wlkata MT4",
            "F": "Wlkata-MT4.robot",
            "I": "Wlkata-MT4-robot.png",
            "IS": "Wlkata-MT4.png",
            "B": "Wlkata",
            "M": "MT4",
            "T": "Palletizing",
            "A": 4,
            "R": 320,
            "P": 0.6,
            "W": 4,
            "E": 0.1,
            "AP": [
                "Palletizing"
            ]
        },
        "Yamaha-YCO1300": {
            "MT": "R",
            "N": "Yamaha YCO1300",
            "F": "Yamaha-YCO1300.robot",
            "I": "Yamaha-YCO1300-robot.png",
            "IS": "Yamaha-YCO1300.png",
            "B": "Yamaha",
            "M": "YCO1300",
            "T": "7 DOF",
            "A": 7,
            "R": 1300,
            "P": 10.0,
            "W": 45,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yamaha-YK400XR-S-150": {
            "MT": "R",
            "N": "Yamaha YK400XR-S-150",
            "F": "Yamaha-YK400XR-S-150.robot",
            "I": "Yamaha-YK400XR-S-150-robot.png",
            "IS": "Yamaha-YK400XR-S-150.png",
            "B": "Yamaha",
            "M": "YK400XR-S-150",
            "T": "SCARA",
            "A": 4,
            "R": 400,
            "P": 3,
            "W": 17,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Yamaha-YK700XGP-200": {
            "MT": "R",
            "N": "Yamaha YK700XGP-200",
            "F": "Yamaha-YK700XGP-200.robot",
            "I": "Yamaha-YK700XGP-200-robot.png",
            "IS": "Yamaha-YK700XGP-200.png",
            "B": "Yamaha",
            "M": "YK700XGP-200",
            "T": "SCARA",
            "A": 4,
            "R": 700,
            "P": 20,
            "W": 50,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Yamaha-YK800XGP-200": {
            "MT": "R",
            "N": "Yamaha YK800XGP-200",
            "F": "Yamaha-YK800XGP-200.robot",
            "I": "Yamaha-YK800XGP-200-robot.png",
            "IS": "Yamaha-YK800XGP-200.png",
            "B": "Yamaha",
            "M": "YK800XGP-200",
            "T": "SCARA",
            "A": 4,
            "R": 800,
            "P": 20,
            "W": 52,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Yaskawa-Motoman-MPL80": {
            "MT": "R",
            "N": "Yaskawa Motoman MPL80",
            "F": "Yaskawa-Motoman-MPL80.robot",
            "I": "Yaskawa-Motoman-MPL80-robot.png",
            "IS": "Yaskawa-Motoman-MPL80.png",
            "B": "Yaskawa Motoman",
            "M": "MPL80",
            "T": "5 DOF",
            "A": 5,
            "R": 2061,
            "P": 80,
            "W": 550,
            "E": 0.07,
            "AP": [
                "Material Handling"
            ]
        },
        "Yaskawa-Motoman-MPL100II": {
            "MT": "R",
            "N": "Yaskawa Motoman MPL100II",
            "F": "Yaskawa-Motoman-MPL100II.robot",
            "I": "Yaskawa-Motoman-MPL100II-robot.png",
            "IS": "Yaskawa-Motoman-MPL100II.png",
            "B": "Yaskawa Motoman",
            "M": "MPL100II",
            "T": "5 DOF",
            "A": 5,
            "R": 2061,
            "P": 80,
            "W": 550,
            "E": 0.07,
            "AP": [
                "Material Handling"
            ]
        },
        "Yaskawa-Motoman-AR1440": {
            "MT": "R",
            "N": "Yaskawa Motoman AR1440",
            "F": "Yaskawa-Motoman-AR1440.robot",
            "I": "Yaskawa-Motoman-AR1440-robot.png",
            "IS": "Yaskawa-Motoman-AR1440.png",
            "B": "Yaskawa Motoman",
            "M": "AR1440",
            "T": "6 DOF",
            "A": 6,
            "R": 1440,
            "P": 12.0,
            "W": 150,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-AR2010": {
            "MT": "R",
            "N": "Yaskawa Motoman AR2010",
            "F": "Yaskawa-Motoman-AR2010.robot",
            "I": "Yaskawa-Motoman-AR2010-robot.png",
            "IS": "Yaskawa-Motoman-AR2010.png",
            "B": "Yaskawa Motoman",
            "M": "AR2010",
            "T": "6 DOF",
            "A": 6,
            "R": 2010,
            "P": 6,
            "W": 260,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-AR3120": {
            "MT": "R",
            "N": "Yaskawa Motoman AR3120",
            "F": "Yaskawa-Motoman-AR3120.robot",
            "I": "Yaskawa-Motoman-AR3120-robot.png",
            "IS": "Yaskawa-Motoman-AR3120.png",
            "B": "Yaskawa Motoman",
            "M": "AR3120",
            "T": "6 DOF",
            "A": 6,
            "R": 3120,
            "P": 20,
            "W": 560,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-DX1350D": {
            "MT": "R",
            "N": "Yaskawa Motoman DX1350D",
            "F": "Yaskawa-Motoman-DX1350D.robot",
            "I": "Yaskawa-Motoman-DX1350D-robot.png",
            "IS": "Yaskawa-Motoman-DX1350D.png",
            "B": "Yaskawa Motoman",
            "M": "DX1350D",
            "T": "6 DOF",
            "A": 6,
            "R": 1355,
            "P": 35,
            "W": 275,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-EA1400": {
            "MT": "R",
            "N": "Yaskawa Motoman EA1400",
            "F": "Yaskawa-Motoman-EA1400.robot",
            "I": "Yaskawa-Motoman-EA1400-robot.png",
            "IS": "Yaskawa-Motoman-EA1400.png",
            "B": "Yaskawa Motoman",
            "M": "EA1400",
            "T": "6 DOF",
            "A": 6,
            "R": 1388,
            "P": 3,
            "W": 130,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-EH80": {
            "MT": "R",
            "N": "Yaskawa Motoman EH80",
            "F": "Yaskawa-Motoman-EH80.robot",
            "I": "Yaskawa-Motoman-EH80-robot.png",
            "IS": "Yaskawa-Motoman-EH80.png",
            "B": "Yaskawa Motoman",
            "M": "EH80",
            "T": "6 DOF",
            "A": 6,
            "R": 2051,
            "P": 80.0,
            "W": 570,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-EPX2050": {
            "MT": "R",
            "N": "Yaskawa Motoman EPX2050",
            "F": "Yaskawa-Motoman-EPX2050.robot",
            "I": "Yaskawa-Motoman-EPX2050-robot.png",
            "IS": "Yaskawa-Motoman-EPX2050.png",
            "B": "Yaskawa Motoman",
            "M": "EPX2050",
            "T": "6 DOF",
            "A": 6,
            "R": 2054,
            "P": 15,
            "W": 540,
            "E": 0.5,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Inspection",
                "Material Handling",
                "Painting",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-EPX2800R": {
            "MT": "R",
            "N": "Yaskawa Motoman EPX2800R",
            "F": "Yaskawa-Motoman-EPX2800R.robot",
            "I": "Yaskawa-Motoman-EPX2800R-robot.png",
            "IS": "Yaskawa-Motoman-EPX2800R.png",
            "B": "Yaskawa Motoman",
            "M": "EPX2800R",
            "T": "6 DOF",
            "A": 6,
            "R": 2779,
            "P": 20,
            "W": 650,
            "E": 0.5,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Inspection",
                "Material Handling",
                "Painting",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-ES165D": {
            "MT": "R",
            "N": "Yaskawa Motoman ES165D",
            "F": "Yaskawa-Motoman-ES165D.robot",
            "I": "Yaskawa-Motoman-ES165D-robot.png",
            "IS": "Yaskawa-Motoman-ES165D.png",
            "B": "Yaskawa Motoman",
            "M": "ES165D",
            "T": "6 DOF",
            "A": 6,
            "R": 2651,
            "P": 165,
            "W": 1100,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-ES165D-100": {
            "MT": "R",
            "N": "Yaskawa Motoman ES165D-100",
            "F": "Yaskawa-Motoman-ES165D-100.robot",
            "I": "Yaskawa-Motoman-ES165D-100-robot.png",
            "IS": "Yaskawa-Motoman-ES165D-100.png",
            "B": "Yaskawa Motoman",
            "M": "ES165D-100",
            "T": "6 DOF",
            "A": 6,
            "R": 3010,
            "P": 100,
            "W": 1120,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-ES165RD": {
            "MT": "R",
            "N": "Yaskawa Motoman ES165RD",
            "F": "Yaskawa-Motoman-ES165RD.robot",
            "I": "Yaskawa-Motoman-ES165RD-robot.png",
            "IS": "Yaskawa-Motoman-ES165RD.png",
            "B": "Yaskawa Motoman",
            "M": "ES165RD",
            "T": "6 DOF",
            "A": 6,
            "R": 3140,
            "P": 165,
            "W": 1540,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-ES200D": {
            "MT": "R",
            "N": "Yaskawa Motoman ES200D",
            "F": "Yaskawa-Motoman-ES200D.robot",
            "I": "Yaskawa-Motoman-ES200D-robot.png",
            "IS": "Yaskawa-Motoman-ES200D.png",
            "B": "Yaskawa Motoman",
            "M": "ES200D",
            "T": "6 DOF",
            "A": 6,
            "R": 2651,
            "P": 200,
            "W": 1130,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-ES200N": {
            "MT": "R",
            "N": "Yaskawa Motoman ES200N",
            "F": "Yaskawa-Motoman-ES200N.robot",
            "I": "Yaskawa-Motoman-ES200N-robot.png",
            "IS": "Yaskawa-Motoman-ES200N.png",
            "B": "Yaskawa Motoman",
            "M": "ES200N",
            "T": "6 DOF",
            "A": 6,
            "R": 2651,
            "P": 200,
            "W": 1230,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-GA50": {
            "MT": "R",
            "N": "Yaskawa Motoman GA50",
            "F": "Yaskawa-Motoman-GA50.robot",
            "I": "Yaskawa-Motoman-GA50-robot.png",
            "IS": "Yaskawa-Motoman-GA50.png",
            "B": "Yaskawa Motoman",
            "M": "GA50",
            "T": "6 DOF",
            "A": 6,
            "R": 2038,
            "P": 50.0,
            "W": 855,
            "E": 0.015,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-GP4": {
            "MT": "R",
            "N": "Yaskawa Motoman GP4",
            "F": "Yaskawa-Motoman-GP4.robot",
            "I": "Yaskawa-Motoman-GP4-robot.png",
            "IS": "Yaskawa-Motoman-GP4.png",
            "B": "Yaskawa Motoman",
            "M": "GP4",
            "T": "6 DOF",
            "A": 6,
            "R": 550,
            "P": 4,
            "W": 28,
            "E": 0.01,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-GP7": {
            "MT": "R",
            "N": "Yaskawa Motoman GP7",
            "F": "Yaskawa-Motoman-GP7.robot",
            "I": "Yaskawa-Motoman-GP7-robot.png",
            "IS": "Yaskawa-Motoman-GP7.png",
            "B": "Yaskawa Motoman",
            "M": "GP7",
            "T": "6 DOF",
            "A": 6,
            "R": 927,
            "P": 7,
            "W": 34,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-GP8": {
            "MT": "R",
            "N": "Yaskawa Motoman GP8",
            "F": "Yaskawa-Motoman-GP8.robot",
            "I": "Yaskawa-Motoman-GP8-robot.png",
            "IS": "Yaskawa-Motoman-GP8.png",
            "B": "Yaskawa Motoman",
            "M": "GP8",
            "T": "6 DOF",
            "A": 6,
            "R": 727,
            "P": 8,
            "W": 32,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-GP10": {
            "MT": "R",
            "N": "Yaskawa Motoman GP10",
            "F": "Yaskawa-Motoman-GP10.robot",
            "I": "Yaskawa-Motoman-GP10-robot.png",
            "IS": "Yaskawa-Motoman-GP10.png",
            "B": "Yaskawa Motoman",
            "M": "GP10",
            "T": "6 DOF",
            "A": 6,
            "R": 1101,
            "P": 10.0,
            "W": 59,
            "E": 0.015,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-GP12": {
            "MT": "R",
            "N": "Yaskawa Motoman GP12",
            "F": "Yaskawa-Motoman-GP12.robot",
            "I": "Yaskawa-Motoman-GP12-robot.png",
            "IS": "Yaskawa-Motoman-GP12.png",
            "B": "Yaskawa Motoman",
            "M": "GP12",
            "T": "6 DOF",
            "A": 6,
            "R": 1440,
            "P": 12,
            "W": 150,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-GP20": {
            "MT": "R",
            "N": "Yaskawa Motoman GP20",
            "F": "Yaskawa-Motoman-GP20.robot",
            "I": "Yaskawa-Motoman-GP20-robot.png",
            "IS": "Yaskawa-Motoman-GP20.png",
            "B": "Yaskawa Motoman",
            "M": "GP20",
            "T": "6 DOF",
            "A": 6,
            "R": 1802,
            "P": 20,
            "W": 250,
            "E": 0.02,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-GP20HL": {
            "MT": "R",
            "N": "Yaskawa Motoman GP20HL",
            "F": "Yaskawa-Motoman-GP20HL.robot",
            "I": "Yaskawa-Motoman-GP20HL-robot.png",
            "IS": "Yaskawa-Motoman-GP20HL.png",
            "B": "Yaskawa Motoman",
            "M": "GP20HL",
            "T": "6 DOF",
            "A": 6,
            "R": 3124,
            "P": 20,
            "W": 560,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-GP25": {
            "MT": "R",
            "N": "Yaskawa Motoman GP25",
            "F": "Yaskawa-Motoman-GP25.robot",
            "I": "Yaskawa-Motoman-GP25-robot.png",
            "IS": "Yaskawa-Motoman-GP25.png",
            "B": "Yaskawa Motoman",
            "M": "GP25",
            "T": "6 DOF",
            "A": 6,
            "R": 1730,
            "P": 25,
            "W": 250,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-GP25-12": {
            "MT": "R",
            "N": "Yaskawa Motoman GP25-12",
            "F": "Yaskawa-Motoman-GP25-12.robot",
            "I": "Yaskawa-Motoman-GP25-12-robot.png",
            "IS": "Yaskawa-Motoman-GP25-12.png",
            "B": "Yaskawa Motoman",
            "M": "GP25-12",
            "T": "6 DOF",
            "A": 6,
            "R": 2010,
            "P": 12,
            "W": 260,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-GP35L": {
            "MT": "R",
            "N": "Yaskawa Motoman GP35L",
            "F": "Yaskawa-Motoman-GP35L.robot",
            "I": "Yaskawa-Motoman-GP35L-robot.png",
            "IS": "Yaskawa-Motoman-GP35L.png",
            "B": "Yaskawa Motoman",
            "M": "GP35L",
            "T": "6 DOF",
            "A": 6,
            "R": 2538,
            "P": 35,
            "W": 600,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-GP50": {
            "MT": "R",
            "N": "Yaskawa Motoman GP50",
            "F": "Yaskawa-Motoman-GP50.robot",
            "I": "Yaskawa-Motoman-GP50-robot.png",
            "IS": "Yaskawa-Motoman-GP50.png",
            "B": "Yaskawa Motoman",
            "M": "GP50",
            "T": "6 DOF",
            "A": 6,
            "R": 2061,
            "P": 50,
            "W": 570,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-GP70L": {
            "MT": "R",
            "N": "Yaskawa Motoman GP70L",
            "F": "Yaskawa-Motoman-GP70L.robot",
            "I": "Yaskawa-Motoman-GP70L-robot.png",
            "IS": "Yaskawa-Motoman-GP70L.png",
            "B": "Yaskawa Motoman",
            "M": "GP70L",
            "T": "6 DOF",
            "A": 6,
            "R": 2732,
            "P": 70.0,
            "W": 650,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-GP88": {
            "MT": "R",
            "N": "Yaskawa Motoman GP88",
            "F": "Yaskawa-Motoman-GP88.robot",
            "I": "Yaskawa-Motoman-GP88-robot.png",
            "IS": "Yaskawa-Motoman-GP88.png",
            "B": "Yaskawa Motoman",
            "M": "GP88",
            "T": "6 DOF",
            "A": 6,
            "R": 2236,
            "P": 88,
            "W": 630,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-GP110": {
            "MT": "R",
            "N": "Yaskawa Motoman GP110",
            "F": "Yaskawa-Motoman-GP110.robot",
            "I": "Yaskawa-Motoman-GP110-robot.png",
            "IS": "Yaskawa-Motoman-GP110.png",
            "B": "Yaskawa Motoman",
            "M": "GP110",
            "T": "6 DOF",
            "A": 6,
            "R": 2236,
            "P": 110,
            "W": 660,
            "E": 0.03,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-GP165R": {
            "MT": "R",
            "N": "Yaskawa Motoman GP165R",
            "F": "Yaskawa-Motoman-GP165R.robot",
            "I": "Yaskawa-Motoman-GP165R-robot.png",
            "IS": "Yaskawa-Motoman-GP165R.png",
            "B": "Yaskawa Motoman",
            "M": "GP165R",
            "T": "6 DOF",
            "A": 6,
            "R": 3140,
            "P": 165,
            "W": 1760,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-GP180": {
            "MT": "R",
            "N": "Yaskawa Motoman GP180",
            "F": "Yaskawa-Motoman-GP180.robot",
            "I": "Yaskawa-Motoman-GP180-robot.png",
            "IS": "Yaskawa-Motoman-GP180.png",
            "B": "Yaskawa Motoman",
            "M": "GP180",
            "T": "6 DOF",
            "A": 6,
            "R": 2702,
            "P": 180,
            "W": 1020,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-GP180-120": {
            "MT": "R",
            "N": "Yaskawa Motoman GP180-120",
            "F": "Yaskawa-Motoman-GP180-120.robot",
            "I": "Yaskawa-Motoman-GP180-120-robot.png",
            "IS": "Yaskawa-Motoman-GP180-120.png",
            "B": "Yaskawa Motoman",
            "M": "GP180-120",
            "T": "6 DOF",
            "A": 6,
            "R": 3058,
            "P": 120.0,
            "W": 1090,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-GP200R": {
            "MT": "R",
            "N": "Yaskawa Motoman GP200R",
            "F": "Yaskawa-Motoman-GP200R.robot",
            "I": "Yaskawa-Motoman-GP200R-robot.png",
            "IS": "Yaskawa-Motoman-GP200R.png",
            "B": "Yaskawa Motoman",
            "M": "GP200R",
            "T": "6 DOF",
            "A": 6,
            "R": 3935,
            "P": 200,
            "W": 1830,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-GP225": {
            "MT": "R",
            "N": "Yaskawa Motoman GP225",
            "F": "Yaskawa-Motoman-GP225.robot",
            "I": "Yaskawa-Motoman-GP225-robot.png",
            "IS": "Yaskawa-Motoman-GP225.png",
            "B": "Yaskawa Motoman",
            "M": "GP225",
            "T": "6 DOF",
            "A": 6,
            "R": 3935,
            "P": 225,
            "W": 2702,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-GP250": {
            "MT": "R",
            "N": "Yaskawa Motoman GP250",
            "F": "Yaskawa-Motoman-GP250.robot",
            "I": "Yaskawa-Motoman-GP250-robot.png",
            "IS": "Yaskawa-Motoman-GP250.png",
            "B": "Yaskawa Motoman",
            "M": "GP250",
            "T": "6 DOF",
            "A": 6,
            "R": 2710,
            "P": 250,
            "W": 1345,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-GP280L": {
            "MT": "R",
            "N": "Yaskawa Motoman GP280L",
            "F": "Yaskawa-Motoman-GP280L.robot",
            "I": "Yaskawa-Motoman-GP280L-robot.png",
            "IS": "Yaskawa-Motoman-GP280L.png",
            "B": "Yaskawa Motoman",
            "M": "GP280L",
            "T": "6 DOF",
            "A": 6,
            "R": 3552,
            "P": 280,
            "W": 2380,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Cutting",
                "Dispensing",
                "Drilling",
                "Engraving",
                "Finishing",
                "Machining",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-HC10": {
            "MT": "R",
            "N": "Yaskawa Motoman HC10",
            "F": "Yaskawa-Motoman-HC10.robot",
            "I": "Yaskawa-Motoman-HC10-robot.png",
            "IS": "Yaskawa-Motoman-HC10.png",
            "B": "Yaskawa Motoman",
            "M": "HC10",
            "T": "6 DOF",
            "A": 6,
            "R": 1200,
            "P": 10,
            "W": 47,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-HC10DTP": {
            "MT": "R",
            "N": "Yaskawa Motoman HC10DTP",
            "F": "Yaskawa-Motoman-HC10DTP.robot",
            "I": "Yaskawa-Motoman-HC10DTP-robot.png",
            "IS": "Yaskawa-Motoman-HC10DTP.png",
            "B": "Yaskawa Motoman",
            "M": "HC10DTP",
            "T": "6 DOF",
            "A": 6,
            "R": 1200,
            "P": 10,
            "W": 58,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-HC10SDTP": {
            "MT": "R",
            "N": "Yaskawa Motoman HC10SDTP",
            "F": "Yaskawa-Motoman-HC10SDTP.robot",
            "I": "Yaskawa-Motoman-HC10SDTP-robot.png",
            "IS": "Yaskawa-Motoman-HC10SDTP.png",
            "B": "Yaskawa Motoman",
            "M": "HC10SDTP",
            "T": "6 DOF",
            "A": 6,
            "R": 1200,
            "P": 10.0,
            "W": 58,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-HC20DTP": {
            "MT": "R",
            "N": "Yaskawa Motoman HC20DTP",
            "F": "Yaskawa-Motoman-HC20DTP.robot",
            "I": "Yaskawa-Motoman-HC20DTP-robot.png",
            "IS": "Yaskawa-Motoman-HC20DTP.png",
            "B": "Yaskawa Motoman",
            "M": "HC20DTP",
            "T": "6 DOF",
            "A": 6,
            "R": 1700,
            "P": 20.0,
            "W": 140,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-HC20SDTP": {
            "MT": "R",
            "N": "Yaskawa Motoman HC20SDTP",
            "F": "Yaskawa-Motoman-HC20SDTP.robot",
            "I": "Yaskawa-Motoman-HC20SDTP-robot.png",
            "IS": "Yaskawa-Motoman-HC20SDTP.png",
            "B": "Yaskawa Motoman",
            "M": "HC20SDTP",
            "T": "6 DOF",
            "A": 6,
            "R": 1400,
            "P": 20.0,
            "W": 97,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Collaborative",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-HC30PL": {
            "MT": "R",
            "N": "Yaskawa Motoman HC30PL",
            "F": "Yaskawa-Motoman-HC30PL.robot",
            "I": "Yaskawa-Motoman-HC30PL-robot.png",
            "IS": "Yaskawa-Motoman-HC30PL.png",
            "B": "Yaskawa Motoman",
            "M": "HC30PL",
            "T": "6 DOF",
            "A": 6,
            "R": 1700,
            "P": 30.0,
            "W": 140,
            "E": 0.05,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-HC35": {
            "MT": "R",
            "N": "Yaskawa Motoman HC35",
            "F": "Yaskawa-Motoman-HC35.robot",
            "I": "Yaskawa-Motoman-HC35-robot.png",
            "IS": "Yaskawa-Motoman-HC35.png",
            "B": "Yaskawa Motoman",
            "M": "HC35",
            "T": "6 DOF",
            "A": 6,
            "R": 2030,
            "P": 35.0,
            "W": 115,
            "E": 0.04,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-HP3L": {
            "MT": "R",
            "N": "Yaskawa Motoman HP3L",
            "F": "Yaskawa-Motoman-HP3L.robot",
            "I": "Yaskawa-Motoman-HP3L-robot.png",
            "IS": "Yaskawa-Motoman-HP3L.png",
            "B": "Yaskawa Motoman",
            "M": "HP3L",
            "T": "6 DOF",
            "A": 6,
            "R": 859,
            "P": 3,
            "W": 49,
            "E": 0.04,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-HP6": {
            "MT": "R",
            "N": "Yaskawa Motoman HP6",
            "F": "Yaskawa-Motoman-HP6.robot",
            "I": "Yaskawa-Motoman-HP6-robot.png",
            "IS": "Yaskawa-Motoman-HP6.png",
            "B": "Yaskawa Motoman",
            "M": "HP6",
            "T": "6 DOF",
            "A": 6,
            "R": 1378,
            "P": 6,
            "W": 130,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-HP20D": {
            "MT": "R",
            "N": "Yaskawa Motoman HP20D",
            "F": "Yaskawa-Motoman-HP20D.robot",
            "I": "Yaskawa-Motoman-HP20D-robot.png",
            "IS": "Yaskawa-Motoman-HP20D.png",
            "B": "Yaskawa Motoman",
            "M": "HP20D",
            "T": "6 DOF",
            "A": 6,
            "R": 1717,
            "P": 20,
            "W": 268,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-HP20D-6": {
            "MT": "R",
            "N": "Yaskawa Motoman HP20D-6",
            "F": "Yaskawa-Motoman-HP20D-6.robot",
            "I": "Yaskawa-Motoman-HP20D-6-robot.png",
            "IS": "Yaskawa-Motoman-HP20D-6.png",
            "B": "Yaskawa Motoman",
            "M": "HP20D-6",
            "T": "6 DOF",
            "A": 6,
            "R": 1915,
            "P": 6,
            "W": 273,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-HP20RD": {
            "MT": "R",
            "N": "Yaskawa Motoman HP20RD",
            "F": "Yaskawa-Motoman-HP20RD.robot",
            "I": "Yaskawa-Motoman-HP20RD-robot.png",
            "IS": "Yaskawa-Motoman-HP20RD.png",
            "B": "Yaskawa Motoman",
            "M": "HP20RD",
            "T": "6 DOF",
            "A": 6,
            "R": 2017,
            "P": 20,
            "W": 293,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-K6SB": {
            "MT": "R",
            "N": "Yaskawa Motoman K6SB",
            "F": "Yaskawa-Motoman-K6SB.robot",
            "I": "Yaskawa-Motoman-K6SB-robot.png",
            "IS": "Yaskawa-Motoman-K6SB.png",
            "B": "Yaskawa Motoman",
            "M": "K6SB",
            "T": "6 DOF",
            "A": 6,
            "R": 1322,
            "P": 6,
            "W": 180,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-MA1400": {
            "MT": "R",
            "N": "Yaskawa Motoman MA1400",
            "F": "Yaskawa-Motoman-MA1400.robot",
            "I": "Yaskawa-Motoman-MA1400-robot.png",
            "IS": "Yaskawa-Motoman-MA1400.png",
            "B": "Yaskawa Motoman",
            "M": "MA1400",
            "T": "6 DOF",
            "A": 6,
            "R": 1434,
            "P": 3,
            "W": 130,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MA1440": {
            "MT": "R",
            "N": "Yaskawa Motoman MA1440",
            "F": "Yaskawa-Motoman-MA1440.robot",
            "I": "Yaskawa-Motoman-MA1440-robot.png",
            "IS": "Yaskawa-Motoman-MA1440.png",
            "B": "Yaskawa Motoman",
            "M": "MA1440",
            "T": "6 DOF",
            "A": 6,
            "R": 1440,
            "P": 6,
            "W": 130,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-MA1800": {
            "MT": "R",
            "N": "Yaskawa Motoman MA1800",
            "F": "Yaskawa-Motoman-MA1800.robot",
            "I": "Yaskawa-Motoman-MA1800-robot.png",
            "IS": "Yaskawa-Motoman-MA1800.png",
            "B": "Yaskawa Motoman",
            "M": "MA1800",
            "T": "6 DOF",
            "A": 6,
            "R": 1807,
            "P": 15,
            "W": 380,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-MA1900": {
            "MT": "R",
            "N": "Yaskawa Motoman MA1900",
            "F": "Yaskawa-Motoman-MA1900.robot",
            "I": "Yaskawa-Motoman-MA1900-robot.png",
            "IS": "Yaskawa-Motoman-MA1900.png",
            "B": "Yaskawa Motoman",
            "M": "MA1900",
            "T": "6 DOF",
            "A": 6,
            "R": 1904,
            "P": 3,
            "W": 280,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MA2010": {
            "MT": "R",
            "N": "Yaskawa Motoman MA2010",
            "F": "Yaskawa-Motoman-MA2010.robot",
            "I": "Yaskawa-Motoman-MA2010-robot.png",
            "IS": "Yaskawa-Motoman-MA2010.png",
            "B": "Yaskawa Motoman",
            "M": "MA2010",
            "T": "6 DOF",
            "A": 6,
            "R": 2010,
            "P": 6,
            "W": 280,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-MA3100": {
            "MT": "R",
            "N": "Yaskawa Motoman MA3100",
            "F": "Yaskawa-Motoman-MA3100.robot",
            "I": "Yaskawa-Motoman-MA3100-robot.png",
            "IS": "Yaskawa-Motoman-MA3100.png",
            "B": "Yaskawa Motoman",
            "M": "MA3100",
            "T": "6 DOF",
            "A": 6,
            "R": 3121,
            "P": 3,
            "W": 501,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MH3F": {
            "MT": "R",
            "N": "Yaskawa Motoman MH3F",
            "F": "Yaskawa-Motoman-MH3F.robot",
            "I": "Yaskawa-Motoman-MH3F-robot.png",
            "IS": "Yaskawa-Motoman-MH3F.png",
            "B": "Yaskawa Motoman",
            "M": "MH3F",
            "T": "6 DOF",
            "A": 6,
            "R": 531,
            "P": 3,
            "W": 27,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MH5": {
            "MT": "R",
            "N": "Yaskawa Motoman MH5",
            "F": "Yaskawa-Motoman-MH5.robot",
            "I": "Yaskawa-Motoman-MH5-robot.png",
            "IS": "Yaskawa-Motoman-MH5.png",
            "B": "Yaskawa Motoman",
            "M": "MH5",
            "T": "6 DOF",
            "A": 6,
            "R": 706,
            "P": 5,
            "W": 27,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MH5F": {
            "MT": "R",
            "N": "Yaskawa Motoman MH5F",
            "F": "Yaskawa-Motoman-MH5F.robot",
            "I": "Yaskawa-Motoman-MH5F-robot.png",
            "IS": "Yaskawa-Motoman-MH5F.png",
            "B": "Yaskawa Motoman",
            "M": "MH5F",
            "T": "6 DOF",
            "A": 6,
            "R": 706,
            "P": 5,
            "W": 27,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MH5LF": {
            "MT": "R",
            "N": "Yaskawa Motoman MH5LF",
            "F": "Yaskawa-Motoman-MH5LF.robot",
            "I": "Yaskawa-Motoman-MH5LF-robot.png",
            "IS": "Yaskawa-Motoman-MH5LF.png",
            "B": "Yaskawa Motoman",
            "M": "MH5LF",
            "T": "6 DOF",
            "A": 6,
            "R": 895,
            "P": 5,
            "W": 29,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MH5S": {
            "MT": "R",
            "N": "Yaskawa Motoman MH5S",
            "F": "Yaskawa-Motoman-MH5S.robot",
            "I": "Yaskawa-Motoman-MH5S-robot.png",
            "IS": "Yaskawa-Motoman-MH5S.png",
            "B": "Yaskawa Motoman",
            "M": "MH5S",
            "T": "6 DOF",
            "A": 6,
            "R": 706,
            "P": 5,
            "W": 27,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MH6": {
            "MT": "R",
            "N": "Yaskawa Motoman MH6",
            "F": "Yaskawa-Motoman-MH6.robot",
            "I": "Yaskawa-Motoman-MH6-robot.png",
            "IS": "Yaskawa-Motoman-MH6.png",
            "B": "Yaskawa Motoman",
            "M": "MH6",
            "T": "6 DOF",
            "A": 6,
            "R": 1422,
            "P": 6,
            "W": 130,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-MH6S": {
            "MT": "R",
            "N": "Yaskawa Motoman MH6S",
            "F": "Yaskawa-Motoman-MH6S.robot",
            "I": "Yaskawa-Motoman-MH6S-robot.png",
            "IS": "Yaskawa-Motoman-MH6S.png",
            "B": "Yaskawa Motoman",
            "M": "MH6S",
            "T": "6 DOF",
            "A": 6,
            "R": 997,
            "P": 6,
            "W": 120,
            "E": 0.08,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MH6S-10": {
            "MT": "R",
            "N": "Yaskawa Motoman MH6S-10",
            "F": "Yaskawa-Motoman-MH6S-10.robot",
            "I": "Yaskawa-Motoman-MH6S-10-robot.png",
            "IS": "Yaskawa-Motoman-MH6S-10.png",
            "B": "Yaskawa Motoman",
            "M": "MH6S-10",
            "T": "6 DOF",
            "A": 6,
            "R": 997,
            "P": 10,
            "W": 120,
            "E": 0.08,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MH12": {
            "MT": "R",
            "N": "Yaskawa Motoman MH12",
            "F": "Yaskawa-Motoman-MH12.robot",
            "I": "Yaskawa-Motoman-MH12-robot.png",
            "IS": "Yaskawa-Motoman-MH12.png",
            "B": "Yaskawa Motoman",
            "M": "MH12",
            "T": "6 DOF",
            "A": 6,
            "R": 1440,
            "P": 12,
            "W": 130,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-MH24": {
            "MT": "R",
            "N": "Yaskawa Motoman MH24",
            "F": "Yaskawa-Motoman-MH24.robot",
            "I": "Yaskawa-Motoman-MH24-robot.png",
            "IS": "Yaskawa-Motoman-MH24.png",
            "B": "Yaskawa Motoman",
            "M": "MH24",
            "T": "6 DOF",
            "A": 6,
            "R": 1730,
            "P": 24,
            "W": 268,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MH50": {
            "MT": "R",
            "N": "Yaskawa Motoman MH50",
            "F": "Yaskawa-Motoman-MH50.robot",
            "I": "Yaskawa-Motoman-MH50-robot.png",
            "IS": "Yaskawa-Motoman-MH50.png",
            "B": "Yaskawa Motoman",
            "M": "MH50",
            "T": "6 DOF",
            "A": 6,
            "R": 2061,
            "P": 50,
            "W": 550,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MH50-20": {
            "MT": "R",
            "N": "Yaskawa Motoman MH50-20",
            "F": "Yaskawa-Motoman-MH50-20.robot",
            "I": "Yaskawa-Motoman-MH50-20-robot.png",
            "IS": "Yaskawa-Motoman-MH50-20.png",
            "B": "Yaskawa Motoman",
            "M": "MH50-20",
            "T": "6 DOF",
            "A": 6,
            "R": 3106,
            "P": 20,
            "W": 495,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-MH50-35": {
            "MT": "R",
            "N": "Yaskawa Motoman MH50-35",
            "F": "Yaskawa-Motoman-MH50-35.robot",
            "I": "Yaskawa-Motoman-MH50-35-robot.png",
            "IS": "Yaskawa-Motoman-MH50-35.png",
            "B": "Yaskawa Motoman",
            "M": "MH50-35",
            "T": "6 DOF",
            "A": 6,
            "R": 2538,
            "P": 35,
            "W": 570,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MH80": {
            "MT": "R",
            "N": "Yaskawa Motoman MH80",
            "F": "Yaskawa-Motoman-MH80.robot",
            "I": "Yaskawa-Motoman-MH80-robot.png",
            "IS": "Yaskawa-Motoman-MH80.png",
            "B": "Yaskawa Motoman",
            "M": "MH80",
            "T": "6 DOF",
            "A": 6,
            "R": 2061,
            "P": 80,
            "W": 550,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MH165": {
            "MT": "R",
            "N": "Yaskawa Motoman MH165",
            "F": "Yaskawa-Motoman-MH165.robot",
            "I": "Yaskawa-Motoman-MH165-robot.png",
            "IS": "Yaskawa-Motoman-MH165.png",
            "B": "Yaskawa Motoman",
            "M": "MH165",
            "T": "6 DOF",
            "A": 6,
            "R": 2651,
            "P": 165,
            "W": 1130,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MH180": {
            "MT": "R",
            "N": "Yaskawa Motoman MH180",
            "F": "Yaskawa-Motoman-MH180.robot",
            "I": "Yaskawa-Motoman-MH180-robot.png",
            "IS": "Yaskawa-Motoman-MH180.png",
            "B": "Yaskawa Motoman",
            "M": "MH180",
            "T": "6 DOF",
            "A": 6,
            "R": 2702,
            "P": 180,
            "W": 970,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MH180-120": {
            "MT": "R",
            "N": "Yaskawa Motoman MH180-120",
            "F": "Yaskawa-Motoman-MH180-120.robot",
            "I": "Yaskawa-Motoman-MH180-120-robot.png",
            "IS": "Yaskawa-Motoman-MH180-120.png",
            "B": "Yaskawa Motoman",
            "M": "MH180-120",
            "T": "6 DOF",
            "A": 6,
            "R": 3058,
            "P": 120,
            "W": 1010,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MH200": {
            "MT": "R",
            "N": "Yaskawa Motoman MH200",
            "F": "Yaskawa-Motoman-MH200.robot",
            "I": "Yaskawa-Motoman-MH200-robot.png",
            "IS": "Yaskawa-Motoman-MH200.png",
            "B": "Yaskawa Motoman",
            "M": "MH200",
            "T": "6 DOF",
            "A": 6,
            "R": 2651,
            "P": 200,
            "W": 1130,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MH280": {
            "MT": "R",
            "N": "Yaskawa Motoman MH280",
            "F": "Yaskawa-Motoman-MH280.robot",
            "I": "Yaskawa-Motoman-MH280-robot.png",
            "IS": "Yaskawa-Motoman-MH280.png",
            "B": "Yaskawa Motoman",
            "M": "MH280",
            "T": "6 DOF",
            "A": 6,
            "R": 2446,
            "P": 280,
            "W": 1120,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MH600": {
            "MT": "R",
            "N": "Yaskawa Motoman MH600",
            "F": "Yaskawa-Motoman-MH600.robot",
            "I": "Yaskawa-Motoman-MH600-robot.png",
            "IS": "Yaskawa-Motoman-MH600.png",
            "B": "Yaskawa Motoman",
            "M": "MH600",
            "T": "6 DOF",
            "A": 6,
            "R": 2942,
            "P": 600,
            "W": 3050,
            "E": 0.3,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MotoMini": {
            "MT": "R",
            "N": "Yaskawa Motoman MotoMini",
            "F": "Yaskawa-Motoman-MotoMini.robot",
            "I": "Yaskawa-Motoman-MotoMini-robot.png",
            "IS": "Yaskawa-Motoman-MotoMini.png",
            "B": "Yaskawa Motoman",
            "M": "MotoMini",
            "T": "6 DOF",
            "A": 6,
            "R": 350,
            "P": 0.5,
            "W": 7,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MPK2": {
            "MT": "R",
            "N": "Yaskawa Motoman MPK2",
            "F": "Yaskawa-Motoman-MPK2.robot",
            "I": "Yaskawa-Motoman-MPK2-robot.png",
            "IS": "Yaskawa-Motoman-MPK2.png",
            "B": "Yaskawa Motoman",
            "M": "MPK2",
            "T": "6 DOF",
            "A": 6,
            "R": 900,
            "P": 3,
            "W": 130,
            "E": 0.08,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MPX1150": {
            "MT": "R",
            "N": "Yaskawa Motoman MPX1150",
            "F": "Yaskawa-Motoman-MPX1150.robot",
            "I": "Yaskawa-Motoman-MPX1150-robot.png",
            "IS": "Yaskawa-Motoman-MPX1150.png",
            "B": "Yaskawa Motoman",
            "M": "MPX1150",
            "T": "6 DOF",
            "A": 6,
            "R": 727,
            "P": 5,
            "W": 57,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MPX1950": {
            "MT": "R",
            "N": "Yaskawa Motoman MPX1950",
            "F": "Yaskawa-Motoman-MPX1950.robot",
            "I": "Yaskawa-Motoman-MPX1950-robot.png",
            "IS": "Yaskawa-Motoman-MPX1950.png",
            "B": "Yaskawa Motoman",
            "M": "MPX1950",
            "T": "6 DOF",
            "A": 6,
            "R": 1450,
            "P": 7.0,
            "W": 265,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-MPX2600": {
            "MT": "R",
            "N": "Yaskawa Motoman MPX2600",
            "F": "Yaskawa-Motoman-MPX2600.robot",
            "I": "Yaskawa-Motoman-MPX2600-robot.png",
            "IS": "Yaskawa-Motoman-MPX2600.png",
            "B": "Yaskawa Motoman",
            "M": "MPX2600",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 15,
            "W": 485,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Inspection",
                "Material Handling",
                "Painting",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MPX3500": {
            "MT": "R",
            "N": "Yaskawa Motoman MPX3500",
            "F": "Yaskawa-Motoman-MPX3500.robot",
            "I": "Yaskawa-Motoman-MPX3500-robot.png",
            "IS": "Yaskawa-Motoman-MPX3500.png",
            "B": "Yaskawa Motoman",
            "M": "MPX3500",
            "T": "6 DOF",
            "A": 6,
            "R": 2000,
            "P": 15,
            "W": 485,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Inspection",
                "Material Handling",
                "Painting",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MS80W-II": {
            "MT": "R",
            "N": "Yaskawa Motoman MS80W II",
            "F": "Yaskawa-Motoman-MS80W-II.robot",
            "I": "Yaskawa-Motoman-MS80W-II-robot.png",
            "IS": "Yaskawa-Motoman-MS80W-II.png",
            "B": "Yaskawa Motoman",
            "M": "MS80W II",
            "T": "6 DOF",
            "A": 6,
            "R": 2236,
            "P": 80,
            "W": 550,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MS120": {
            "MT": "R",
            "N": "Yaskawa Motoman MS120",
            "F": "Yaskawa-Motoman-MS120.robot",
            "I": "Yaskawa-Motoman-MS120-robot.png",
            "IS": "Yaskawa-Motoman-MS120.png",
            "B": "Yaskawa Motoman",
            "M": "MS120",
            "T": "6 DOF",
            "A": 6,
            "R": 1750,
            "P": 120,
            "W": 950,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-NEX10": {
            "MT": "R",
            "N": "Yaskawa Motoman NEX10",
            "F": "Yaskawa-Motoman-NEX10.robot",
            "I": "Yaskawa-Motoman-NEX10-robot.png",
            "IS": "Yaskawa-Motoman-NEX10.png",
            "B": "Yaskawa Motoman",
            "M": "NEX10",
            "T": "6 DOF",
            "A": 6,
            "R": 1101,
            "P": 10,
            "W": 58,
            "E": 0.015,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-SV3": {
            "MT": "R",
            "N": "Yaskawa Motoman SV3",
            "F": "Yaskawa-Motoman-SV3.robot",
            "I": "Yaskawa-Motoman-SV3-robot.png",
            "IS": "Yaskawa-Motoman-SV3.png",
            "B": "Yaskawa Motoman",
            "M": "SV3",
            "T": "6 DOF",
            "A": 6,
            "R": 677,
            "P": 3,
            "W": 130,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-SV3X": {
            "MT": "R",
            "N": "Yaskawa Motoman SV3X",
            "F": "Yaskawa-Motoman-SV3X.robot",
            "I": "Yaskawa-Motoman-SV3X-robot.png",
            "IS": "Yaskawa-Motoman-SV3X.png",
            "B": "Yaskawa Motoman",
            "M": "SV3X",
            "T": "6 DOF",
            "A": 6,
            "R": 677,
            "P": 3,
            "W": 30,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-UP6": {
            "MT": "R",
            "N": "Yaskawa Motoman UP6",
            "F": "Yaskawa-Motoman-UP6.robot",
            "I": "Yaskawa-Motoman-UP6-robot.png",
            "IS": "Yaskawa-Motoman-UP6.png",
            "B": "Yaskawa Motoman",
            "M": "UP6",
            "T": "6 DOF",
            "A": 6,
            "R": 1373,
            "P": 6,
            "W": 130,
            "E": 0.08,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-UP20": {
            "MT": "R",
            "N": "Yaskawa Motoman UP20",
            "F": "Yaskawa-Motoman-UP20.robot",
            "I": "Yaskawa-Motoman-UP20-robot.png",
            "IS": "Yaskawa-Motoman-UP20.png",
            "B": "Yaskawa Motoman",
            "M": "UP20",
            "T": "6 DOF",
            "A": 6,
            "R": 1658,
            "P": 20,
            "W": 280,
            "E": 0.06,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-UP20M": {
            "MT": "R",
            "N": "Yaskawa Motoman UP20M",
            "F": "Yaskawa-Motoman-UP20M.robot",
            "I": "Yaskawa-Motoman-UP20M-robot.png",
            "IS": "Yaskawa-Motoman-UP20M.png",
            "B": "Yaskawa Motoman",
            "M": "UP20M",
            "T": "6 DOF",
            "A": 6,
            "R": 3106,
            "P": 20,
            "W": 495,
            "E": 0.15,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP",
                "Welding"
            ]
        },
        "Yaskawa-Motoman-UP50N": {
            "MT": "R",
            "N": "Yaskawa Motoman UP50N",
            "F": "Yaskawa-Motoman-UP50N.robot",
            "I": "Yaskawa-Motoman-UP50N-robot.png",
            "IS": "Yaskawa-Motoman-UP50N.png",
            "B": "Yaskawa Motoman",
            "M": "UP50N",
            "T": "6 DOF",
            "A": 6,
            "R": 2046,
            "P": 50,
            "W": 550,
            "E": 0.07,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Finishing",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-UP200": {
            "MT": "R",
            "N": "Yaskawa Motoman UP200",
            "F": "Yaskawa-Motoman-UP200.robot",
            "I": "Yaskawa-Motoman-UP200-robot.png",
            "IS": "Yaskawa-Motoman-UP200.png",
            "B": "Yaskawa Motoman",
            "M": "UP200",
            "T": "6 DOF",
            "A": 6,
            "R": 2446,
            "P": 200,
            "W": 1350,
            "E": 0.2,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-UP350": {
            "MT": "R",
            "N": "Yaskawa Motoman UP350",
            "F": "Yaskawa-Motoman-UP350.robot",
            "I": "Yaskawa-Motoman-UP350-robot.png",
            "IS": "Yaskawa-Motoman-UP350.png",
            "B": "Yaskawa Motoman",
            "M": "UP350",
            "T": "6 DOF",
            "A": 6,
            "R": 2542,
            "P": 350,
            "W": 1350,
            "E": 0.5,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Material Handling",
                "Palletizing",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-CSDA10F": {
            "MT": "R",
            "N": "Yaskawa Motoman CSDA10F",
            "F": "Yaskawa-Motoman-CSDA10F.robot",
            "I": "Yaskawa-Motoman-CSDA10F-robot.png",
            "IS": "Yaskawa-Motoman-CSDA10F.png",
            "B": "Yaskawa Motoman",
            "M": "CSDA10F",
            "T": "7 DOF",
            "A": 7,
            "R": 720,
            "P": 10,
            "W": 60,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-SIA10D": {
            "MT": "R",
            "N": "Yaskawa Motoman SIA10D",
            "F": "Yaskawa-Motoman-SIA10D.robot",
            "I": "Yaskawa-Motoman-SIA10D-robot.png",
            "IS": "Yaskawa-Motoman-SIA10D.png",
            "B": "Yaskawa Motoman",
            "M": "SIA10D",
            "T": "7 DOF",
            "A": 7,
            "R": 720,
            "P": 10,
            "W": 60,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-SIA20D": {
            "MT": "R",
            "N": "Yaskawa Motoman SIA20D",
            "F": "Yaskawa-Motoman-SIA20D.robot",
            "I": "Yaskawa-Motoman-SIA20D-robot.png",
            "IS": "Yaskawa-Motoman-SIA20D.png",
            "B": "Yaskawa Motoman",
            "M": "SIA20D",
            "T": "7 DOF",
            "A": 7,
            "R": 910,
            "P": 10,
            "W": 60,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-SIA50D": {
            "MT": "R",
            "N": "Yaskawa Motoman SIA50D",
            "F": "Yaskawa-Motoman-SIA50D.robot",
            "I": "Yaskawa-Motoman-SIA50D-robot.png",
            "IS": "Yaskawa-Motoman-SIA50D.png",
            "B": "Yaskawa Motoman",
            "M": "SIA50D",
            "T": "7 DOF",
            "A": 7,
            "R": 1630,
            "P": 50,
            "W": 640,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-VS50": {
            "MT": "R",
            "N": "Yaskawa Motoman VS50",
            "F": "Yaskawa-Motoman-VS50.robot",
            "I": "Yaskawa-Motoman-VS50-robot.png",
            "IS": "Yaskawa-Motoman-VS50.png",
            "B": "Yaskawa Motoman",
            "M": "VS50",
            "T": "7 DOF",
            "A": 7,
            "R": 1630,
            "P": 50.0,
            "W": 640,
            "E": 0.1,
            "AP": [
                "Additive Manufacturing",
                "Assembly",
                "Dispensing",
                "Material Handling",
                "Remote TCP"
            ]
        },
        "Yaskawa-Motoman-MPP3": {
            "MT": "R",
            "N": "Yaskawa Motoman MPP3",
            "F": "Yaskawa-Motoman-MPP3.robot",
            "I": "Yaskawa-Motoman-MPP3-robot.png",
            "IS": "Yaskawa-Motoman-MPP3.png",
            "B": "Yaskawa Motoman",
            "M": "MPP3",
            "T": "Delta",
            "A": 4,
            "R": 650,
            "P": 1,
            "W": 115,
            "E": 0.1,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Yaskawa-Motoman-EPL160": {
            "MT": "R",
            "N": "Yaskawa Motoman EPL160",
            "F": "Yaskawa-Motoman-EPL160.robot",
            "I": "Yaskawa-Motoman-EPL160-robot.png",
            "IS": "Yaskawa-Motoman-EPL160.png",
            "B": "Yaskawa Motoman",
            "M": "EPL160",
            "T": "Palletizing",
            "A": 4,
            "R": 3159,
            "P": 160,
            "W": 1700,
            "E": 0.5,
            "AP": [
                "Palletizing"
            ]
        },
        "Yaskawa-Motoman-MPK50": {
            "MT": "R",
            "N": "Yaskawa Motoman MPK50",
            "F": "Yaskawa-Motoman-MPK50.robot",
            "I": "Yaskawa-Motoman-MPK50-robot.png",
            "IS": "Yaskawa-Motoman-MPK50.png",
            "B": "Yaskawa Motoman",
            "M": "MPK50",
            "T": "Palletizing",
            "A": 4,
            "R": 1917,
            "P": 50,
            "W": 670,
            "E": 0.5,
            "AP": [
                "Palletizing"
            ]
        },
        "Yaskawa-Motoman-MPL300": {
            "MT": "R",
            "N": "Yaskawa Motoman MPL300",
            "F": "Yaskawa-Motoman-MPL300.robot",
            "I": "Yaskawa-Motoman-MPL300-robot.png",
            "IS": "Yaskawa-Motoman-MPL300.png",
            "B": "Yaskawa Motoman",
            "M": "MPL300",
            "T": "Palletizing",
            "A": 4,
            "R": 3024,
            "P": 300,
            "W": 1820,
            "E": 0.5,
            "AP": [
                "Palletizing"
            ]
        },
        "Yaskawa-Motoman-MPL800": {
            "MT": "R",
            "N": "Yaskawa Motoman MPL800",
            "F": "Yaskawa-Motoman-MPL800.robot",
            "I": "Yaskawa-Motoman-MPL800-robot.png",
            "IS": "Yaskawa-Motoman-MPL800.png",
            "B": "Yaskawa Motoman",
            "M": "MPL800",
            "T": "Palletizing",
            "A": 4,
            "R": 3159,
            "P": 800,
            "W": 2550,
            "E": 0.5,
            "AP": [
                "Palletizing"
            ]
        },
        "Yaskawa-Motoman-MPL800II": {
            "MT": "R",
            "N": "Yaskawa Motoman MPL800II",
            "F": "Yaskawa-Motoman-MPL800II.robot",
            "I": "Yaskawa-Motoman-MPL800II-robot.png",
            "IS": "Yaskawa-Motoman-MPL800II.png",
            "B": "Yaskawa Motoman",
            "M": "MPL800II",
            "T": "Palletizing",
            "A": 4,
            "R": 3159,
            "P": 800,
            "W": 2550,
            "E": 0.5,
            "AP": [
                "Palletizing"
            ]
        },
        "Yaskawa-Motoman-PL190": {
            "MT": "R",
            "N": "Yaskawa Motoman PL190",
            "F": "Yaskawa-Motoman-PL190.robot",
            "I": "Yaskawa-Motoman-PL190-robot.png",
            "IS": "Yaskawa-Motoman-PL190.png",
            "B": "Yaskawa Motoman",
            "M": "PL190",
            "T": "Palletizing",
            "A": 4,
            "R": 3159,
            "P": 190,
            "W": 1680,
            "E": 0.05,
            "AP": [
                "Palletizing"
            ]
        },
        "Yaskawa-Motoman-MYS650L": {
            "MT": "R",
            "N": "Yaskawa Motoman MYS650L",
            "F": "Yaskawa-Motoman-MYS650L.robot",
            "I": "Yaskawa-Motoman-MYS650L-robot.png",
            "IS": "Yaskawa-Motoman-MYS650L.png",
            "B": "Yaskawa Motoman",
            "M": "MYS650L",
            "T": "SCARA",
            "A": 4,
            "R": 650,
            "P": 6,
            "W": 28,
            "E": 0.02,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Yaskawa-Motoman-MYS850L": {
            "MT": "R",
            "N": "Yaskawa Motoman MYS850L",
            "F": "Yaskawa-Motoman-MYS850L.robot",
            "I": "Yaskawa-Motoman-MYS850L-robot.png",
            "IS": "Yaskawa-Motoman-MYS850L.png",
            "B": "Yaskawa Motoman",
            "M": "MYS850L",
            "T": "SCARA",
            "A": 4,
            "R": 850,
            "P": 10,
            "W": 48,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        },
        "Yaskawa-Motoman-MYS1000": {
            "MT": "R",
            "N": "Yaskawa Motoman MYS1000",
            "F": "Yaskawa-Motoman-MYS1000.robot",
            "I": "Yaskawa-Motoman-MYS1000-robot.png",
            "IS": "Yaskawa-Motoman-MYS1000.png",
            "B": "Yaskawa Motoman",
            "M": "MYS1000",
            "T": "SCARA",
            "A": 4,
            "R": 1000,
            "P": 20,
            "W": 48,
            "E": 0.03,
            "AP": [
                "Assembly",
                "Material Handling"
            ]
        }
    }
}